/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axiosClient";
import type { AddressAutocompleteControllerSuggestQueryResponse, AddressAutocompleteControllerSuggestQueryParams, AikanControllerGetAikanAssetsQueryResponse, AikanControllerGetAikanAssetsQueryParams, AikanControllerGetAikanDocumentByIdQueryResponse, AikanControllerGetAikanDocumentByIdQueryParams, AppControllerIndexQueryResponse, AssetControllerGetAssetQueryResponse, AssetControllerGetAssetPathParams, AssetControllerGetAssetQueryParams, AssetControllerGetAsset403, AssetControllerGetAsset404, AssetControllerGetAssetExternalQuoteQueryResponse, AssetControllerGetAssetExternalQuotePathParams, AssetControllerGetAssetExternalQuoteQueryParams, AssetControllerGetAssetExternalQuote404, BillingControllerGetInvoicesQueryResponse, BillingControllerGetInvoicesQueryParams, BillingControllerListInvoiceEventsQueryResponse, BillingControllerListInvoiceEventsPathParams, BillingControllerListInvoiceEvents404, PolicyControllerListBranchesQueryResponse, PolicyControllerListBranchesPathParams, PolicyControllerListBranchesQueryParams, PolicyControllerListBranches403, PolicyControllerListBranches404, BranchControllerGetBranchEffectiveDateQueryResponse, BranchControllerGetBranchEffectiveDatePathParams, BranchControllerGetBranchEffectiveDateQueryParams, BrokerControllerAtMeQueryResponse, BrokerControllerListBrokersQueryResponse, BrokerControllerListBrokersPathParams, BrokerControllerListBrokersQueryParams, BrokerControllerListBrokers404, BrokerControllerListDescendantBrokersQueryResponse, BrokerControllerListDescendantBrokersPathParams, BrokerControllerListDescendantBrokersQueryParams, BrokerControllerListDescendantBrokers404, BrokerControllerGetBrokerQueryResponse, BrokerControllerGetBrokerPathParams, BrokerControllerGetBroker404, EmailAccountControllerListMineQueryResponse, EmailControllerGetAttachmentDownloadUrlQueryResponse, EmailControllerGetAttachmentDownloadUrlPathParams, EmailControllerGetAttachmentDownloadUrl401, EmailControllerGetAttachmentDownloadUrl409, EmailControllerGetEmailQueryResponse, EmailControllerGetEmailPathParams, EmailControllerGetEmail400, EmailControllerGetEmail401, EmailThreadControllerListThreadsQueryResponse, EmailThreadControllerListThreadsQueryParams, EmailThreadControllerListThreads400, EmailThreadControllerListThreads401, EmailThreadControllerGetThreadQueryResponse, EmailThreadControllerGetThreadPathParams, EmailThreadControllerGetThread400, EmailThreadControllerGetThread401, GeneralInboxControllerGetSummaryQueryResponse, ClaimManagementControllerListQueryResponse, ClaimManagementControllerListQueryParams, ClaimManagementControllerList400, ClaimManagementControllerListMyClaimsQueryResponse, ClaimManagementControllerListMyClaimsQueryParams, ClaimManagementControllerListMyClaims400, ClaimManagementControllerGetQueryResponse, ClaimManagementControllerGetPathParams, ClaimManagementControllerGet400, ClaimManagementControllerGet404, ClaimManagementControllerGetClaimsExportStatusQueryResponse, ClaimManagementControllerGetClaimsExportStatusPathParams, ClaimManagementControllerGetClaimsExportStatus400, ClaimManagementControllerAvailableTransitionsQueryResponse, ClaimManagementControllerAvailableTransitionsPathParams, ClaimManagementControllerAvailableTransitions400, ClaimManagementControllerAvailableTransitions404, ClaimManagementControllerGetClaimExtractionsQueryResponse, ClaimManagementControllerGetClaimExtractionsPathParams, ClaimManagementControllerGetClaimExtractions400, ClaimManagementControllerGetClaimExtractions404, ClaimManagementControllerStatusHistoryQueryResponse, ClaimManagementControllerStatusHistoryPathParams, ClaimManagementControllerStatusHistory400, ClaimManagementControllerStatusHistory404, ClaimManagementControllerDocumentFraudScoresQueryResponse, ClaimManagementControllerDocumentFraudScoresPathParams, ClaimManagementControllerDocumentFraudScores400, ClaimManagementControllerFraudNarrativeQueryResponse, ClaimManagementControllerFraudNarrativePathParams, ClaimManagementControllerFraudNarrative400, ClaimManagementControllerTimelineQueryResponse, ClaimManagementControllerTimelinePathParams, ClaimManagementControllerTimeline400, ClaimManagementControllerTimeline404, ClaimsControllerListQueryResponse, ClaimsControllerListQueryParams, ClaimsControllerList400, ClaimsControllerGetQueryResponse, ClaimsControllerGetPathParams, ClaimsControllerGet400, ClaimsControllerGet404, ConfigControllerListTenantsQueryResponse, ConfigControllerGetTenantConfigQueryResponse, ConfigControllerGetTenantConfig400, ConfigControllerGetProductConfigQueryResponse, ConfigControllerGetProductConfigPathParams, ConfigControllerGetProductConfig400, ConfigControllerGetPublicTenantConfigByDomainQueryResponse, ConfigControllerGetPublicTenantConfigByDomainQueryParams, ConfigControllerGetPublicTenantConfigByDomain400, ConfigControllerGetPublicProductConfigQueryResponse, ConfigControllerGetPublicProductConfigPathParams, ConfigControllerGetPublicProductConfig400, ConfigControllerGetPublicTenantConfigQueryResponse, ConfigControllerGetPublicTenantConfig400, ConfigControllerGetProductsForTenantQueryResponse, ConfigControllerGetProductsForTenant400, ConfigControllerGetBusinessRolePermissionsQueryResponse, ConfigControllerGetBusinessRolePermissionsQueryParams, ConfigControllerGetBusinessRolePermissions400, FeatureFlagControllerAtMeQueryResponse, FeatureFlagControllerAtMeQueryParams, FeatureFlagControllerFindAllQueryResponse, CustomerControllerGetCustomerQueryResponse, CustomerControllerGetCustomerPathParams, CustomerControllerGetCustomerQueryParams, CustomerControllerGetCustomer404, CustomerControllerGetCustomerPaymentMethodsQueryResponse, CustomerControllerGetCustomerPaymentMethodsPathParams, CustomerControllerGetCustomerPaymentMethodsQueryParams, CustomerControllerGetCustomerPaymentMethods404, CustomerControllerGetPaymentMethodSetupSecretQueryResponse, CustomerControllerGetPaymentMethodSetupSecretPathParams, CustomerControllerGetPaymentMethodSetupSecretQueryParams, CustomerControllerGetPaymentMethodSetupSecret400, CustomerControllerGetPaymentMethodSetupSecret404, CustomerControllerGetPaymentMethodSetupSecret409, CustomerControllerListCustomersQueryResponse, CustomerControllerListCustomersQueryParams, CustomerControllerGetInvoicingScheduleQueryResponse, CustomerControllerGetInvoicingSchedulePathParams, CustomerControllerGetInvoicingScheduleQueryParams, CustomerControllerGetInvoicingSchedule400, CustomerControllerGetInvoicingSchedule404, CustomerControllerGetBankTransferAccountQueryResponse, CustomerControllerGetBankTransferAccountPathParams, CustomerControllerGetBankTransferAccount400, CustomerControllerGetBankTransferAccount404, CustomerControllerGetBankTransferAccount409, CustomerControllerGetCustomerBalanceQueryResponse, CustomerControllerGetCustomerBalancePathParams, CustomerControllerGetCustomerBalance404, CustomerControllerGetMigratedBillingTakeoverQueryResponse, CustomerControllerGetMigratedBillingTakeoverPathParams, DebugControllerGetProjectionsQueryResponse, DebugControllerGetProjectionsPathParams, DebugControllerGetProjectionsQueryParams, DebugControllerCountCoreEventsQueryResponse, DebugControllerCountCoreEventsPathParams, DebugControllerCountCoreEventsQueryParams, DocumentsControllerValidateAndProcessDocumentQueryResponse, DocumentsControllerValidateAndProcessDocumentQueryParams, DocumentsControllerGetDocumentsQueryResponse, DocumentsControllerGetDocumentsQueryParams, HealthControllerIndexQueryResponse, HealthControllerCheckQueryResponse, HealthControllerCheckPathParams, InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, JobSchedulersControllerGetJobSchedulersQueryResponse, JobSchedulersControllerGetQueryResponse, JobSchedulersControllerGetPathParams, JobSchedulersControllerGet404, JobsControllerGetJobQueryResponse, JobsControllerGetJobPathParams, JobsControllerListJobsMutationRequest, JobsControllerListJobsMutationResponse, JobsControllerCountJobsMutationRequest, JobsControllerCountJobsMutationResponse, QueueManagementControllerGetStatusQueryResponse, LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, LegacyDocumentsControllerGetOnDemandDocumentsQueryParams, LegacyDocumentsControllerGetOnDemandDocuments400, LegacyDocumentsControllerGetOnDemandDocuments404, LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams, LegacyDocumentsControllerGetExpectedGeneratedDocuments400, LegacyDocumentsControllerGetExpectedGeneratedDocuments404, LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams, LegacyDocumentsControllerGetExpectedUploadedDocuments400, LegacyDocumentsControllerGetExpectedUploadedDocuments404, LegacyDocumentsControllerGetExpectedUploadedDocuments501, LockControllerListLocksQueryResponse, LockControllerListLocksQueryParams, LockControllerGetLockQueryResponse, LockControllerGetLockPathParams, NotificationControllerListEmailTemplatesQueryResponse, NotificationControllerListEmailTemplatesQueryParams, NotificationControllerListNotificationsQueryResponse, NotificationControllerListNotificationsQueryParams, NotificationControllerGetNotificationQueryResponse, NotificationControllerGetNotificationPathParams, NotificationControllerGetNotification404, PaymentsControllerGetPaymentsQueryResponse, PaymentsControllerGetPaymentsQueryParams, PaymentsControllerGetCustomersPaymentMethodsQueryResponse, PaymentsControllerGetCustomersPaymentMethodsQueryParams, PaymentsControllerGetCustomerPaymentsQueryResponse, PaymentsControllerGetCustomerPaymentsPathParams, PaymentsControllerGetCustomerPaymentsQueryParams, PolicyControllerGetPolicyQueryResponse, PolicyControllerGetPolicyPathParams, PolicyControllerGetPolicyQueryParams, PolicyControllerGetPolicy403, PolicyControllerGetPolicy404, PolicyControllerListPolicyDocumentsQueryResponse, PolicyControllerListPolicyDocumentsPathParams, PolicyControllerListPolicyDocumentsQueryParams, PolicyControllerListPolicyDocuments403, PolicyControllerListPolicyDocuments404, PolicyControllerGetPremiumScheduleQueryResponse, PolicyControllerGetPremiumSchedulePathParams, PolicyControllerGetPremiumScheduleQueryParams, PolicyControllerGetPremiumSchedule403, PolicyControllerGetPremiumSchedule404, PolicyControllerListPolicyDocumentsAdminQueryResponse, PolicyControllerListPolicyDocumentsAdminPathParams, PolicyControllerListPolicyDocumentsAdminQueryParams, PolicyControllerListPolicyDocumentsAdmin403, PolicyControllerListPolicyDocumentsAdmin404, PolicyControllerListPolicyEventsQueryResponse, PolicyControllerListPolicyEventsPathParams, PolicyControllerListPolicyEvents404, PolicyControllerPlanTasksQueryResponse, PolicyControllerPlanTasksPathParams, PolicyControllerPlanTasksQueryParams, PolicyControllerPlanTasks403, PolicyControllerPlanTasks404, PolicyControllerGetAggregateQueryResponse, PolicyControllerGetAggregateQueryParams, PolicyControllerGetAggregate404, PolicyControllerCalculatePolicyQuoteMutationRequest, PolicyControllerCalculatePolicyQuoteMutationResponse, PolicyControllerCalculatePolicyQuotePathParams, PolicyControllerCalculatePolicyQuoteQueryParams, PolicyControllerCalculatePolicyQuote400, PolicyControllerCalculatePolicyQuote404, PolicyControllerCalculatePolicyQuote409, PricingControllerComputePricingQueryResponse, PricingControllerComputePricingPathParams, PricingControllerComputePricingQueryParams, PricingControllerComputePricing400, PricingControllerComputePricing404, PricingControllerGetPriceQueryResponse, PricingControllerGetPricePathParams, PricingControllerGetPriceQueryParams, PricingControllerGetPrice404, QuoteControllerGetExternalQuoteQueryResponse, QuoteControllerGetExternalQuoteQueryParams, QuoteControllerGetExternalQuote404, MonitoringControllerGetReportsQueryResponse, MonitoringControllerGetChecksQueryResponse, ReportingControllerGetReportConfigQueryResponse, ReportingControllerGetReportConfigPathParams, ReportingControllerGetReportsMutationRequest, ReportingControllerGetReportsMutationResponse, SearchControllerSearchMutationRequest, SearchControllerSearchMutationResponse, SearchControllerSearchQueryParams, SearchControllerGenericSearchMutationRequest, SearchControllerGenericSearchMutationResponse, SearchControllerGenericSearchPathParams, SearchControllerGenericSearchQueryParams, SearchControllerCountMutationRequest, SearchControllerCountMutationResponse, SearchControllerReindexMutationRequest, SearchControllerReindexMutationResponse, SearchControllerReindexAllMutationRequest, SearchControllerReindexAllMutationResponse, SignatureControllerYousignSecurityCheckQueryResponse, SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, SignatureControllerGetSignatureRequestsByExternalIdPathParams, SignatureControllerGetSignerLinkQueryResponse, SignatureControllerGetSignerLinkPathParams, SirenControllerSearchSirenQueryResponse, SirenControllerSearchSirenQueryParams, SirenControllerSearchSiren400, SivControllerSearchSivQueryResponse, SivControllerSearchSivQueryParams, SivControllerSearchSiv404, SivControllerSearchSivAtLegacyPathQueryResponse, SivControllerSearchSivAtLegacyPathQueryParams, SivControllerSearchSivAtLegacyPath404, DerogationControllerCheckDerogationRequirementMutationRequest, DerogationControllerCheckDerogationRequirementMutationResponse, DerogationControllerCheckDerogationRequirementPathParams, DerogationControllerCheckDerogationRequirementQueryParams, AiAdminControllerListConversationsQueryResponse, AiAdminControllerListConversationsQueryParams, AiAdminControllerGetConversationMessagesQueryResponse, AiAdminControllerGetConversationMessagesPathParams, CommentsControllerGetCommentQueryResponse, CommentsControllerGetCommentPathParams, CommentsControllerGetComment404, CommentsControllerListCommentsQueryResponse, CommentsControllerListCommentsPathParams, CommentsControllerListCommentsQueryParams, InternalNotesControllerListQueryResponse, InternalNotesControllerListPathParams, InternalNotesControllerListQueryParams, InternalNotesControllerGetQueryResponse, InternalNotesControllerGetPathParams, InternalNotesControllerGet404, ClaimInternalNotesControllerListQueryResponse, ClaimInternalNotesControllerListPathParams, ClaimInternalNotesControllerListQueryParams, ClaimInternalNotesControllerGetQueryResponse, ClaimInternalNotesControllerGetPathParams, ClaimInternalNotesControllerGet404, ConversationControllerListConversationsQueryResponse, ConversationControllerGetConversationQueryResponse, ConversationControllerGetConversationPathParams, ConversationControllerGetConversation404, ConversationControllerGetConversationMessagesQueryResponse, ConversationControllerGetConversationMessagesPathParams, ConversationControllerGetConversationMessages404, SraControllerGetFacetQueryResponse, SraControllerGetFacetQueryParams, SraControllerGetVehicleDetailsQueryResponse, SraControllerGetVehicleDetailsQueryParams, SraControllerGetVersionInformationFromBrandAndModelQueryResponse, SraControllerGetVersionInformationFromBrandAndModelQueryParams, HiscoxControllerGetActivitiesBySectorQueryResponse, HiscoxControllerGetActivitiesBySectorQueryParams, UserControllerGetMyUserWithDrivequantDataQueryResponse, UserControllerGetMyUserWithDrivequantDataQueryParams, UserControllerGetMyUserWithDrivequantData404, WorkflowsControllerListWorkflowRunsMutationRequest, WorkflowsControllerListWorkflowRunsMutationResponse, WorkflowsControllerGetWorkflowRunQueryResponse, WorkflowsControllerGetWorkflowRunPathParams, WorkflowsControllerListWorkflowRunNodesQueryResponse, WorkflowsControllerListWorkflowRunNodesPathParams, WorkflowsControllerListWorkflowRunNodesQueryParams, YeetControllerListDrivequantAverageScoresQueryResponse, YeetControllerListDrivequantAverageScoresPathParams, YeetControllerListDrivequantAverageScoresQueryParams, YeetControllerListPossibleDrivequantUsersQueryResponse, YeetControllerListPossibleDrivequantUsersPathParams, YeetControllerListPossibleDrivequantUsersQueryParams, YeetControllerListDrivequantHistoricalUsersQueryResponse, YeetControllerListDrivequantHistoricalUsersPathParams, AxeceControllerListDrivequantAverageScoresQueryResponse, AxeceControllerListDrivequantAverageScoresPathParams, AxeceControllerListDrivequantAverageScoresQueryParams, AxeceControllerListPossibleDrivequantUsersQueryResponse, AxeceControllerListPossibleDrivequantUsersPathParams, AxeceControllerListPossibleDrivequantUsersQueryParams, AxeceControllerListDrivequantHistoricalUsersQueryResponse, AxeceControllerListDrivequantHistoricalUsersPathParams, AdminAr24ControllerListUsersQueryResponse, AdminAr24ControllerGetUserQueryResponse, AdminAr24ControllerGetUserPathParams, ViewSpecificControllerAccountingSummaryQueryResponse, ViewSpecificControllerAccountingSummaryQueryParams, ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, ViewSpecificControllerListComplianceChecksOnPolicyPathParams, ViewSpecificControllerListComplianceChecksOnPolicyQueryParams, ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, ViewSpecificControllerListPolicyComplianceAlertsPathParams, ViewSpecificControllerListPolicyComplianceAlertsQueryParams, ViewSpecificControllerListChildBrokerageFirmsQueryResponse, ViewSpecificControllerListChildBrokerageFirmsPathParams, ViewSpecificControllerListChildBrokerageFirmsQueryParams, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams, ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams, ViewSpecificControllerListPolicyAssetsQueryResponse, ViewSpecificControllerListPolicyAssetsPathParams, ViewSpecificControllerListPolicyAssetsQueryParams, ViewSpecificControllerListPolicyAssets403, ViewSpecificControllerListPolicyAssets404, ViewSpecificControllerGetAvailablePricingQueryResponse, ViewSpecificControllerGetAvailablePricingPathParams, ViewSpecificControllerGetAvailablePricingQueryParams, ViewSpecificControllerGetAvailablePricing400, ViewSpecificControllerGetAvailablePricing404, ViewSpecificControllerListPolicyCustomersQueryResponse, ViewSpecificControllerListPolicyCustomersPathParams, ViewSpecificControllerListPolicyCustomersQueryParams, ViewSpecificControllerListPolicyCustomers403, ViewSpecificControllerListPolicyCustomers404, ViewSpecificControllerListCustomerInvoicesQueryResponse, ViewSpecificControllerListCustomerInvoicesPathParams, ViewSpecificControllerListCustomerInvoicesQueryParams, ViewSpecificControllerListCustomerInvoices404, ViewSpecificControllerListCustomerPaymentsQueryResponse, ViewSpecificControllerListCustomerPaymentsPathParams, ViewSpecificControllerListCustomerPaymentsQueryParams, ViewSpecificControllerListCustomerPayments404, ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, ViewSpecificControllerListCustomerPaymentMethodsPathParams, ViewSpecificControllerListCustomerPaymentMethodsQueryParams, ViewSpecificControllerListCustomerPaymentMethods404, ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams, ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams, ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest, ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, ViewSpecificControllerListBrokerageFirmPoliciesPathParams, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams, ViewSpecificControllerListCustomerRelationsQueryResponse, ViewSpecificControllerListCustomerRelationsPathParams, ViewSpecificControllerListCustomerRelationsQueryParams, ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest, ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, ViewSpecificControllerListBrokerageFirmDerogationsPathParams, ViewSpecificControllerListBrokerageFirmDerogationsQueryParams, ViewSpecificControllerListProductCommonDocumentsQueryResponse, ViewSpecificControllerListProductCommonDocumentsPathParams, ViewSpecificControllerListProductCommonDocumentsQueryParams, BillingReadsControllerGetAccountingSummaryQueryResponse, BillingReadsControllerGetAccountingSummaryQueryParams, BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams, BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams, BillingReadsControllerListCustomerInvoicesQueryResponse, BillingReadsControllerListCustomerInvoicesPathParams, BillingReadsControllerListCustomerInvoicesQueryParams, BillingReadsControllerListCustomerInvoices404, PaymentsReadsControllerListCustomerPaymentsQueryResponse, PaymentsReadsControllerListCustomerPaymentsPathParams, PaymentsReadsControllerListCustomerPaymentsQueryParams, PaymentsReadsControllerListCustomerPayments404, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams, PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams, CustomerReadsControllerListCustomerRelationsQueryResponse, CustomerReadsControllerListCustomerRelationsPathParams, CustomerReadsControllerListCustomerRelationsQueryParams, CustomerReadsControllerListPolicyCustomersQueryResponse, CustomerReadsControllerListPolicyCustomersPathParams, CustomerReadsControllerListPolicyCustomersQueryParams, CustomerReadsControllerListPolicyCustomers403, CustomerReadsControllerListPolicyCustomers404, AssetReadsControllerListPolicyAssetsQueryResponse, AssetReadsControllerListPolicyAssetsPathParams, AssetReadsControllerListPolicyAssetsQueryParams, AssetReadsControllerListPolicyAssets403, AssetReadsControllerListPolicyAssets404, PricingReadsControllerGetAvailablePricingQueryResponse, PricingReadsControllerGetAvailablePricingPathParams, PricingReadsControllerGetAvailablePricingQueryParams, PricingReadsControllerGetAvailablePricing400, PricingReadsControllerGetAvailablePricing404, DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest, DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams, DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams, ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, ComplianceReadsControllerListPolicyComplianceAlertsPathParams, ComplianceReadsControllerListPolicyComplianceAlertsQueryParams, ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, ComplianceReadsControllerListPolicyComplianceChecksPathParams, ComplianceReadsControllerListPolicyComplianceChecksQueryParams, BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams, BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams, PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest, PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, DocumentsReadsControllerListProductCommonDocumentsQueryResponse, DocumentsReadsControllerListProductCommonDocumentsPathParams, DocumentsReadsControllerListProductCommonDocumentsQueryParams, McpServerControllerHandleServerSentEventsQueryResponse, ComplianceControllerListChecksQueryResponse, ComplianceControllerListChecksQueryParams, ComplianceControllerGetCheckQueryResponse, ComplianceControllerGetCheckPathParams, ComplianceControllerGetCheck404, ComplianceControllerListAlertsQueryResponse, ComplianceControllerListAlertsQueryParams, ComplianceControllerGetAlertQueryResponse, ComplianceControllerGetAlertPathParams, ComplianceControllerGetAlert404, RelationsControllerGetPermissionRelationsForUserQueryResponse, RelationsControllerGetPermissionRelationsForUserQueryParams, RelationsControllerListTenantUsersQueryResponse, RelationsControllerListTenantUsersQueryParams, RelationsControllerListRelationsQueryResponse, RelationsControllerListRelationsQueryParams, LegacyPermissionsControllerAtMeQueryResponse, LegacyPermissionsControllerAtMe404, BrokerageFirmControllerListBrokerageFirmsQueryResponse, BrokerageFirmControllerListBrokerageFirmsQueryParams, BrokerageFirmControllerGetBrokerageFirmQueryResponse, BrokerageFirmControllerGetBrokerageFirmPathParams, BrokerageFirmControllerGetBrokerageFirm404, BrokerageFirmControllerListDocumentsQueryResponse, BrokerageFirmControllerListDocumentsPathParams, BrokerageFirmControllerListDocumentsQueryParams, BrokerageFirmControllerListDocuments400, BrokerageFirmControllerListDocuments403, BrokerageFirmControllerListDocuments404, BrokerageFirmControllerListReportsQueryResponse, BrokerageFirmControllerListReportsPathParams, BrokerageFirmControllerListReportsQueryParams, BrokerageFirmControllerGetReportConfigQueryResponse, BrokerageFirmControllerGetReportConfigPathParams, BrokerageFirmControllerListCommissionStatementsQueryResponse, BrokerageFirmControllerListCommissionStatementsPathParams, BrokerageFirmControllerListCommissionStatementsQueryParams, BrokerageFirmControllerListCommissionStatements403, BrokerageFirmControllerListCommissionStatements404, BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams, BrokerageFirmControllerGetPaymentMethodSetupSecret404, BrokerageFirmControllerGetPaymentMethodsQueryResponse, BrokerageFirmControllerGetPaymentMethodsPathParams, BrokerageFirmControllerGetPaymentMethods404, DistributionRequestControllerGetDistributionRequestQueryResponse, DistributionRequestControllerGetDistributionRequestPathParams, DistributionRequestControllerGetDistributionRequest404, DistributionRequestControllerListDistributionRequestsMutationRequest, DistributionRequestControllerListDistributionRequestsMutationResponse, DistributionRequestControllerListDistributionRequestsQueryParams, BrokerageFeeControllerGetBrokerFeesQueryResponse, BrokerageFeeControllerGetBrokerFeesQueryParams, BrokerageFeeControllerGetBrokerFees404, EfficialeControllerCheckComplianceQueryResponse, EfficialeControllerCheckComplianceQueryParams, EfficialeControllerGetAlertsQueryResponse, EfficialeControllerGetAlertsQueryParams, MetabaseControllerGetIframeUrlQueryResponse, MetabaseControllerGetIframeUrlQueryParams, FvaControllerRetrieveReportOutcomeQueryResponse, FvaControllerRetrieveReportOutcomeQueryParams, DocumentValidityControllerGetPolicyValidityQueryResponse, DocumentValidityControllerGetPolicyValidityPathParams, DocumentValidityControllerGetPolicyValidityQueryParams, DocumentValidityControllerGetPolicyValidity404, DocumentValidityControllerGetDocumentValidityQueryResponse, DocumentValidityControllerGetDocumentValidityPathParams, DocumentValidityControllerGetDocumentValidity500, BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams, DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, DocumentCoherenceControllerGetDocumentCoherencePathParams, DocumentCoherenceControllerGetDocumentCoherenceQueryParams, DocumentCoherenceControllerGetDocumentCoherence400, DocumentCoherenceControllerGetDocumentCoherence404, PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, PolicyDocumentControllerGetPolicyDocumentConformityPathParams, PolicyDocumentControllerGetPolicyDocumentConformityQueryParams, PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams, PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams, PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, PolicyDocumentControllerGetPolicyDocumentFraudPathParams, PolicyDocumentControllerGetPolicyDocumentFraudQueryParams, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams, PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, PolicyDocumentCollectionControllerGetCollectionStatePathParams, PolicyDocumentCollectionControllerGetCollectionStateQueryParams, PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams, PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams, PolicyDocumentExtractionControllerGetPolicyExtractions404, DocumentExtractionControllerGetDocumentExtractionQueryResponse, DocumentExtractionControllerGetDocumentExtractionPathParams, DocumentExtractionControllerGetDocumentExtraction404, DocumentExtractionControllerGetExtractionFeedbackQueryResponse, DocumentExtractionControllerGetExtractionFeedbackPathParams, BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams, JwksControllerGetJwksQueryResponse, ImpersonationControllerListSessionsQueryResponse, ImpersonationControllerListSessionsQueryParams, FcbWidgetControllerMintTokenQueryResponse, AuthControllerCheckEmailMutationRequest, AuthControllerCheckEmailMutationResponse, AssetControllerBatchCreateAssetsMutationRequest, AssetControllerBatchCreateAssetsMutationResponse, AssetControllerBatchCreateAssetsQueryParams, AssetControllerBatchEditAssetsMutationRequest, AssetControllerBatchEditAssetsMutationResponse, AssetControllerBatchEditAssetsQueryParams, AssetControllerBatchRemoveAssetsMutationRequest, AssetControllerBatchRemoveAssetsMutationResponse, AssetControllerBatchRemoveAssetsQueryParams, AssetControllerCreateAssetMutationRequest, AssetControllerCreateAssetMutationResponse, AssetControllerCreateAssetQueryParams, AssetControllerCreateAsset400, AssetControllerCreateAsset403, AssetControllerCreateAsset404, AssetControllerCreateAsset409, AssetControllerReplaceAssetMutationRequest, AssetControllerReplaceAssetMutationResponse, AssetControllerReplaceAssetPathParams, AssetControllerReplaceAssetQueryParams, AssetControllerReplaceAsset400, AssetControllerReplaceAsset404, AssetControllerReplaceAsset409, AssetControllerEditAssetMutationRequest, AssetControllerEditAssetMutationResponse, AssetControllerEditAssetPathParams, AssetControllerEditAssetQueryParams, AssetControllerEditAsset400, AssetControllerEditAsset403, AssetControllerEditAsset404, AssetControllerEditAsset409, AssetControllerRemoveAssetMutationResponse, AssetControllerRemoveAssetPathParams, AssetControllerRemoveAssetQueryParams, AssetControllerRemoveAsset400, AssetControllerRemoveAsset403, AssetControllerRemoveAsset404, AssetControllerRemoveAsset409, AssetControllerPushAssetEventMutationRequest, AssetControllerPushAssetEventMutationResponse, AssetControllerPushAssetEventPathParams, AssetControllerPushAssetEventQueryParams, AssetControllerPushAssetEvent400, AssetControllerPushAssetEvent404, BillingControllerListInvoicesMutationRequest, BillingControllerListInvoicesMutationResponse, BillingControllerCreateManualInvoiceMutationRequest, BillingControllerCreateManualInvoiceMutationResponse, BillingControllerSetInvoiceCleanupMutationRequest, BillingControllerSetInvoiceCleanupMutationResponse, BillingControllerIssueInvoicesMutationRequest, BillingControllerIssueInvoicesMutationResponse, BillingControllerDeleteInvoicesMutationRequest, BillingControllerDeleteInvoicesMutationResponse, BranchControllerEditBranchMutationRequest, BranchControllerEditBranchMutationResponse, BranchControllerEditBranchPathParams, BranchControllerEditBranch400, BranchControllerEditBranch404, BranchControllerEditBranch409, BranchControllerCreateBranchMutationRequest, BranchControllerCreateBranchMutationResponse, BranchControllerCreateBranchPathParams, BranchControllerCreateBranchQueryParams, BranchControllerCreateBranch400, BranchControllerCreateBranch404, BranchControllerCreateBranch409, BranchControllerForkBranchMutationRequest, BranchControllerForkBranchMutationResponse, BranchControllerForkBranchPathParams, BranchControllerForkBranchQueryParams, BranchControllerForkBranch400, BranchControllerForkBranch404, BranchControllerForkBranch409, BranchControllerForkBranchWithoutPolicyMutationRequest, BranchControllerForkBranchWithoutPolicyMutationResponse, BranchControllerForkBranchWithoutPolicyPathParams, BranchControllerForkBranchWithoutPolicyQueryParams, BranchControllerForkBranchWithoutPolicy400, BranchControllerForkBranchWithoutPolicy404, BranchControllerForkBranchWithoutPolicy409, BranchControllerInvalidateBranchMutationRequest, BranchControllerInvalidateBranchMutationResponse, BranchControllerInvalidateBranchPathParams, BranchControllerInvalidateBranchQueryParams, BranchControllerInvalidateBranch403, BranchControllerInvalidateBranch404, BranchControllerInvalidateBranch409, BrokerControllerCreateBrokerMutationRequest, BrokerControllerCreateBrokerMutationResponse, BrokerControllerCreateBrokerPathParams, BrokerControllerCreateBroker404, BrokerControllerUpdateBrokerMutationRequest, BrokerControllerUpdateBrokerMutationResponse, BrokerControllerUpdateBrokerPathParams, BrokerControllerUpdateBroker404, BrokerControllerDeleteBrokerMutationResponse, BrokerControllerDeleteBrokerPathParams, BrokerControllerDeleteBroker404, EmailAccountControllerConnectMutationRequest, EmailAccountControllerConnectMutationResponse, EmailAccountControllerReconnectMutationRequest, EmailAccountControllerReconnectMutationResponse, EmailAccountControllerReconnectPathParams, EmailAccountControllerDisconnectMutationResponse, EmailAccountControllerDisconnectPathParams, EmailControllerAttachPoliciesMutationRequest, EmailControllerAttachPoliciesMutationResponse, EmailControllerAttachPoliciesPathParams, EmailControllerAttachPolicies400, EmailControllerAttachPolicies401, EmailControllerAttachPolicies403, EmailControllerDetachPoliciesMutationRequest, EmailControllerDetachPoliciesMutationResponse, EmailControllerDetachPolicies400, EmailControllerDetachPolicies401, EmailControllerDetachPolicies403, EmailControllerDetachPolicyMutationResponse, EmailControllerDetachPolicyPathParams, EmailControllerDetachPolicy400, EmailControllerDetachPolicy401, EmailControllerDetachPolicy403, EmailControllerMovePolicyMutationRequest, EmailControllerMovePolicyMutationResponse, EmailControllerMovePolicyPathParams, EmailControllerMovePolicy400, EmailControllerMovePolicy401, EmailControllerMovePolicy403, EmailThreadControllerSetThreadsArchivedMutationRequest, EmailThreadControllerSetThreadsArchivedMutationResponse, EmailThreadControllerSetThreadsArchived400, EmailThreadControllerSetThreadsArchived401, EmailThreadControllerAttachThreadsPoliciesMutationRequest, EmailThreadControllerAttachThreadsPoliciesMutationResponse, EmailThreadControllerAttachThreadsPolicies400, EmailThreadControllerAttachThreadsPolicies401, EmailThreadControllerAttachThreadsPolicies403, ClaimManagementControllerLookupCustomerMutationRequest, ClaimManagementControllerLookupCustomerMutationResponse, ClaimManagementControllerLookupCustomer400, ClaimManagementControllerLookupCustomer404, ClaimManagementControllerCheckCoverageMutationRequest, ClaimManagementControllerCheckCoverageMutationResponse, ClaimManagementControllerCheckCoverage400, ClaimManagementControllerCheckCoverage422, ClaimManagementControllerGenerateFnolUploadUrlMutationRequest, ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ClaimManagementControllerGenerateFnolUploadUrl400, ClaimManagementControllerGenerateFnolUploadUrl413, ClaimManagementControllerBootstrapMutationRequest, ClaimManagementControllerBootstrapMutationResponse, ClaimManagementControllerBootstrap400, ClaimManagementControllerBootstrap422, ClaimManagementControllerUpdateDraftMutationRequest, ClaimManagementControllerUpdateDraftMutationResponse, ClaimManagementControllerUpdateDraftPathParams, ClaimManagementControllerUpdateDraft400, ClaimManagementControllerUpdateDraft404, ClaimManagementControllerUpdateDraft409, ClaimManagementControllerUpdateCustomFieldsMutationRequest, ClaimManagementControllerUpdateCustomFieldsMutationResponse, ClaimManagementControllerUpdateCustomFieldsPathParams, ClaimManagementControllerUpdateCustomFields400, ClaimManagementControllerUpdateCustomFields404, ClaimManagementControllerUpdateCustomFields409, ClaimManagementControllerAttachDocumentMutationRequest, ClaimManagementControllerAttachDocumentMutationResponse, ClaimManagementControllerAttachDocumentPathParams, ClaimManagementControllerAttachDocument400, ClaimManagementControllerAttachDocument404, ClaimManagementControllerAttachDocument409, ClaimManagementControllerGenerateDocumentMutationRequest, ClaimManagementControllerGenerateDocumentMutationResponse, ClaimManagementControllerGenerateDocumentPathParams, ClaimManagementControllerGenerateDocument400, ClaimManagementControllerGenerateDocument404, ClaimManagementControllerGenerateDocument409, ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest, ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ClaimManagementControllerGetDocumentGenerationPayload400, ClaimManagementControllerGetDocumentGenerationPayload404, ClaimManagementControllerGetDocumentGenerationPayload409, ClaimManagementControllerDetachDocumentMutationResponse, ClaimManagementControllerDetachDocumentPathParams, ClaimManagementControllerDetachDocument400, ClaimManagementControllerDetachDocument404, ClaimManagementControllerDetachDocument409, ClaimManagementControllerTransitionMutationRequest, ClaimManagementControllerTransitionMutationResponse, ClaimManagementControllerTransitionPathParams, ClaimManagementControllerTransition400, ClaimManagementControllerTransition404, ClaimManagementControllerTransition409, ClaimManagementControllerRetryForwardMutationResponse, ClaimManagementControllerRetryForwardPathParams, ClaimManagementControllerRetryForward400, ClaimManagementControllerRetryForward404, ClaimManagementControllerAddNoteMutationRequest, ClaimManagementControllerAddNoteMutationResponse, ClaimManagementControllerAddNotePathParams, ClaimManagementControllerAddNote400, ClaimManagementControllerAddNote404, ClaimManagementControllerStartClaimsExportMutationResponse, ClaimManagementControllerStartClaimsExportQueryParams, ClaimManagementControllerStartClaimsExport400, ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest, ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ClaimManagementControllerCorrectDocumentFraudVerdictPathParams, ClaimManagementControllerCorrectDocumentFraudVerdict400, ExternalClaimsControllerCreateMutationRequest, ExternalClaimsControllerCreateMutationResponse, ExternalClaimsControllerResyncMutationResponse, ExternalClaimsControllerResyncPathParams, ClaimsControllerCreateMutationRequest, ClaimsControllerCreateMutationResponse, ClaimsControllerCreate400, ClaimsControllerCreate409, ClaimsControllerUpdateMutationRequest, ClaimsControllerUpdateMutationResponse, ClaimsControllerUpdatePathParams, ClaimsControllerUpdate400, ClaimsControllerUpdate404, ClaimsControllerUpdate409, ClaimsControllerDeleteMutationResponse, ClaimsControllerDeletePathParams, ClaimsControllerDelete400, ClaimsControllerDelete404, FeatureFlagControllerUpdateMutationRequest, FeatureFlagControllerUpdateMutationResponse, CustomerControllerEditCustomerMutationRequest, CustomerControllerEditCustomerMutationResponse, CustomerControllerEditCustomerPathParams, CustomerControllerEditCustomerQueryParams, CustomerControllerEditCustomer400, CustomerControllerEditCustomer404, CustomerControllerEditCustomer409, CustomerControllerInitializeCustomerMutationRequest, CustomerControllerInitializeCustomerMutationResponse, CustomerControllerInitializeCustomerQueryParams, CustomerControllerInitializeCustomer400, CustomerControllerInitializeCustomer404, CustomerControllerInitializeCustomer409, CustomerControllerPushCustomerEventMutationRequest, CustomerControllerPushCustomerEventMutationResponse, CustomerControllerPushCustomerEventPathParams, CustomerControllerPushCustomerEventQueryParams, CustomerControllerPushCustomerEvent400, CustomerControllerPushCustomerEvent404, CustomerControllerGenerateMandateSignatureRequestMutationRequest, CustomerControllerGenerateMandateSignatureRequestMutationResponse, CustomerControllerGenerateMandateSignatureRequestPathParams, CustomerControllerGenerateMandateSignatureRequestQueryParams, CustomerControllerGenerateMandateSignatureRequest400, CustomerControllerGenerateMandateSignatureRequest404, CustomerControllerGenerateMandateSignatureRequest409, CustomerControllerGenerateMandateSignatureRequest425, CustomerControllerUpdatePreferredPaymentMethodMutationResponse, CustomerControllerUpdatePreferredPaymentMethodPathParams, CustomerControllerUpdatePreferredPaymentMethodQueryParams, CustomerControllerUpdatePreferredPaymentMethod400, CustomerControllerUpdatePreferredPaymentMethod404, CustomerControllerUpdatePreferredPaymentMethod409, CustomerControllerDeletePaymentMethodMutationResponse, CustomerControllerDeletePaymentMethodPathParams, CustomerControllerDeletePaymentMethod404, CustomerControllerDeletePaymentMethod409, CustomerControllerUpdatePaymentModeMutationRequest, CustomerControllerUpdatePaymentModeMutationResponse, CustomerControllerUpdatePaymentModePathParams, CustomerControllerUpdatePaymentModeQueryParams, CustomerControllerUpdatePaymentMode400, CustomerControllerUpdatePaymentMode404, CustomerControllerUpdatePaymentMode409, CustomerControllerChargeMutationRequest, CustomerControllerChargeMutationResponse, CustomerControllerChargePathParams, CustomerControllerChargeQueryParams, CustomerControllerCharge400, CustomerControllerCharge404, CustomerControllerManuallyMarkInvoiceMutationRequest, CustomerControllerManuallyMarkInvoiceMutationResponse, CustomerControllerManuallyMarkInvoicePathParams, CustomerControllerManuallyMarkInvoice400, CustomerControllerManuallyMarkInvoice404, CustomerControllerManuallyMarkInvoice409, CustomerControllerManuallyMarkInvoice500, CustomerControllerSetMigratedBillingTakeoverMutationRequest, CustomerControllerSetMigratedBillingTakeoverMutationResponse, CustomerControllerSetMigratedBillingTakeoverPathParams, CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, CustomerControllerUnlockMigratedBillingTakeoverPathParams, CustomerControllerCreateCustomerForPolicyMutationRequest, CustomerControllerCreateCustomerForPolicyMutationResponse, CustomerControllerCreateCustomerForPolicyPathParams, CustomerControllerCreateCustomerForPolicyQueryParams, CustomerControllerCreateCustomerForPolicy404, CustomerControllerDeleteCustomerFromPolicyMutationResponse, CustomerControllerDeleteCustomerFromPolicyPathParams, CustomerControllerDeleteCustomerFromPolicyQueryParams, CustomerControllerDeleteCustomerFromPolicy403, CustomerControllerDeleteCustomerFromPolicy404, CustomerControllerDeleteCustomerFromPolicy409, DebugControllerClearTestDataMutationResponse, DebugControllerClearProjectionsDataMutationResponse, DebugControllerClearProjectionsDataQueryParams, DebugControllerClearLegacyCacheMutationResponse, DebugControllerClearLegacyCacheQueryParams, DebugControllerToggleIgnoreCoreEventsMutationRequest, DebugControllerToggleIgnoreCoreEventsMutationResponse, DebugControllerBillCustomerMutationResponse, DebugControllerBillCustomerPathParams, DebugControllerBillCustomerQueryParams, DebugControllerBatchBillCustomersMutationRequest, DebugControllerBatchBillCustomersMutationResponse, DebugControllerBatchBillCustomersQueryParams, DebugControllerBatchChargeInvoicesMutationRequest, DebugControllerBatchChargeInvoicesMutationResponse, DebugControllerStartDailyStagingCleanupMutationResponse, DebugControllerCreateDistributionRequestsAndFeesMutationRequest, DebugControllerCreateDistributionRequestsAndFeesMutationResponse, DebugControllerCreatePaymentFromStripeMutationRequest, DebugControllerCreatePaymentFromStripeMutationResponse, DebugControllerUpdatePaymentStatusMutationRequest, DebugControllerUpdatePaymentStatusMutationResponse, DebugControllerRefreshInvoiceStatusMutationRequest, DebugControllerRefreshInvoiceStatusMutationResponse, DebugControllerBatchGenerateDocumentsMutationRequest, DebugControllerBatchGenerateDocumentsMutationResponse, DebugControllerBatchCreateUserRelationsMutationRequest, DebugControllerBatchCreateUserRelationsMutationResponse, DebugControllerCheckAllDocumentsMutationRequest, DebugControllerCheckAllDocumentsMutationResponse, DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest, DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, DebugControllerSuperDeletePoliciesMutationResponse, DebugControllerSuperDeletePoliciesPathParams, DocumentsControllerGenerateDocumentUploadUrlsMutationRequest, DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, DocumentsControllerDeleteDocumentsMutationResponse, DocumentsControllerDeleteDocumentsQueryParams, DocumentsControllerArchiveDocumentsMutationRequest, DocumentsControllerArchiveDocumentsMutationResponse, DocumentsControllerArchiveDocuments403, DocumentsControllerArchiveDocuments404, DocumentsControllerRestoreDocumentsMutationRequest, DocumentsControllerRestoreDocumentsMutationResponse, DocumentsControllerRestoreDocuments403, DocumentsControllerRestoreDocuments404, DocumentsControllerSetDocumentCategoryMutationRequest, DocumentsControllerSetDocumentCategoryMutationResponse, DocumentsControllerSetDocumentCategoryPathParams, DocumentsControllerSetDocumentCategory400, DocumentsControllerSetDocumentCategory403, DocumentsControllerSetDocumentCategory404, DocumentsControllerListDocumentsWithPresignedUrlMutationRequest, DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, DocumentsControllerCreatePdfMutationRequest, DocumentsControllerCreatePdfMutationResponse, DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest, DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, InvitationControllerInviteMutationRequest, InvitationControllerInviteMutationResponse, InvitationControllerInvite400, InvitationControllerAdminInviteMutationRequest, InvitationControllerAdminInviteMutationResponse, InvitationControllerAdminInvite400, InvitationControllerBrokerInviteMutationRequest, InvitationControllerBrokerInviteMutationResponse, InvitationControllerBrokerInvite400, InvitationControllerCreateAnonymousSessionMutationResponse, InvitationControllerCreateAnonymousSessionQueryParams, InvitationControllerHandoffAnonymousSessionMutationRequest, InvitationControllerHandoffAnonymousSessionMutationResponse, JobSchedulersControllerListMutationRequest, JobSchedulersControllerListMutationResponse, JobSchedulersControllerUpsertMutationRequest, JobSchedulersControllerUpsertMutationResponse, JobSchedulersControllerUpsertPathParams, JobSchedulersControllerUpdateMutationRequest, JobSchedulersControllerUpdateMutationResponse, JobSchedulersControllerUpdatePathParams, JobSchedulersControllerUpdate404, JobSchedulersControllerDeleteMutationResponse, JobSchedulersControllerDeletePathParams, JobSchedulersControllerDelete404, JobsControllerCreateJobMutationRequest, JobsControllerCreateJobMutationResponse, JobsControllerCreateJobsMutationRequest, JobsControllerCreateJobsMutationResponse, JobsControllerUpdateJobMutationRequest, JobsControllerUpdateJobMutationResponse, JobsControllerUpdateJobPathParams, JobsControllerCancelJobMutationResponse, JobsControllerCancelJobPathParams, JobsControllerCancelJobsMutationRequest, JobsControllerCancelJobsMutationResponse, JobsControllerRetryJobsMutationRequest, JobsControllerRetryJobsMutationResponse, JobsControllerClearJobsDataMutationResponse, JobsControllerClearWorkflowsDataMutationResponse, JobsControllerCancelPushProjectionJobsMutationResponse, QueueManagementControllerPauseMutationResponse, QueueManagementControllerResumeMutationResponse, QueueManagementControllerPauseSingleMutationResponse, QueueManagementControllerPauseSinglePathParams, QueueManagementControllerResumeSingleMutationResponse, QueueManagementControllerResumeSinglePathParams, LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest, LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, LegacyDocumentsControllerGenerateDocumentOnDemand400, LegacyDocumentsControllerGenerateDocumentOnDemand404, LegacyDocumentsControllerGetGenerationPayloadMutationRequest, LegacyDocumentsControllerGetGenerationPayloadMutationResponse, LegacyDocumentsControllerGetGenerationPayloadQueryParams, LegacyDocumentsControllerGetGenerationPayload400, LegacyDocumentsControllerGetGenerationPayload404, LegacyDocumentsControllerRegenerateDocumentMutationRequest, LegacyDocumentsControllerRegenerateDocumentMutationResponse, LegacyDocumentsControllerRegenerateDocument404, LegacyDocumentsControllerRegenerateDocument500, LockControllerDeleteLockMutationResponse, LockControllerDeleteLockPathParams, LockControllerCreateLockMutationRequest, LockControllerCreateLockMutationResponse, LockControllerCreateLockPathParams, LockControllerBatchCreateLocksMutationRequest, LockControllerBatchCreateLocksMutationResponse, LockControllerBatchGetLocksMutationRequest, LockControllerBatchGetLocksMutationResponse, LockControllerBatchDeleteLocksMutationRequest, LockControllerBatchDeleteLocksMutationResponse, NotificationControllerSendEmailMutationRequest, NotificationControllerSendEmailMutationResponse, NotificationControllerSendEmail400, NotificationControllerRenderEmailTemplateMutationRequest, NotificationControllerRenderEmailTemplateMutationResponse, NotificationControllerRenderEmailTemplatePathParams, NotificationControllerRenderEmailTemplate404, NotificationControllerSendTestEmailMutationRequest, NotificationControllerSendTestEmailMutationResponse, NotificationControllerSendTestEmailPathParams, NotificationControllerSendTestEmail404, NotificationControllerCreateNotificationMutationRequest, NotificationControllerCreateNotificationMutationResponse, NotificationControllerPatchNotificationMutationRequest, NotificationControllerPatchNotificationMutationResponse, NotificationControllerPatchNotificationPathParams, NotificationControllerDeleteNotificationMutationResponse, NotificationControllerDeleteNotificationPathParams, NotificationControllerSendNotificationMutationRequest, NotificationControllerSendNotificationMutationResponse, NotificationControllerSendNotification400, PaymentsControllerCreateCustomerMutationRequest, PaymentsControllerCreateCustomerMutationResponse, PaymentsControllerListCustomersMutationRequest, PaymentsControllerListCustomersMutationResponse, PaymentsControllerCreatePaymentMutationRequest, PaymentsControllerCreatePaymentMutationResponse, PaymentsControllerCreatePayment404, PaymentsControllerSetupIntentMutationRequest, PaymentsControllerSetupIntentMutationResponse, PaymentsControllerSetupIntent404, PaymentsControllerCancelPaymentMutationRequest, PaymentsControllerCancelPaymentMutationResponse, PaymentsControllerCancelPaymentPathParams, PaymentsControllerSoftDeletePaymentMethodMutationResponse, PaymentsControllerSoftDeletePaymentMethodPathParams, PolicyControllerEditPolicyMutationRequest, PolicyControllerEditPolicyMutationResponse, PolicyControllerEditPolicyPathParams, PolicyControllerEditPolicyQueryParams, PolicyControllerEditPolicy400, PolicyControllerEditPolicy403, PolicyControllerEditPolicy404, PolicyControllerEditPolicy409, PolicyControllerGenerateIncrementalIdMutationResponse, PolicyControllerGenerateIncrementalIdPathParams, PolicyControllerGenerateIncrementalId400, PolicyControllerGenerateDocumentUploadUrlMutationRequest, PolicyControllerGenerateDocumentUploadUrlMutationResponse, PolicyControllerGenerateDocumentUploadUrlPathParams, PolicyControllerGenerateDocumentUploadUrlQueryParams, PolicyControllerGenerateDocumentUploadUrl400, PolicyControllerGenerateDocumentUploadUrl403, PolicyControllerGenerateDocumentUploadUrl404, PolicyControllerDeletePolicyDocumentsMutationResponse, PolicyControllerDeletePolicyDocumentsPathParams, PolicyControllerDeletePolicyDocumentsQueryParams, PolicyControllerDeletePolicyDocuments403, PolicyControllerDeletePolicyDocuments404, PolicyControllerEditPolicyExternalIdMutationRequest, PolicyControllerEditPolicyExternalIdMutationResponse, PolicyControllerEditPolicyExternalIdPathParams, PolicyControllerEditPolicyExternalId409, PolicyControllerConfirmPolicyMutationResponse, PolicyControllerConfirmPolicyPathParams, PolicyControllerConfirmPolicyQueryParams, PolicyControllerConfirmPolicy400, PolicyControllerConfirmPolicy403, PolicyControllerConfirmPolicy404, PolicyControllerConfirmPolicy409, PolicyControllerGeneratePolicySignatureRequestMutationRequest, PolicyControllerGeneratePolicySignatureRequestMutationResponse, PolicyControllerGeneratePolicySignatureRequestPathParams, PolicyControllerGeneratePolicySignatureRequestQueryParams, PolicyControllerGeneratePolicySignatureRequest400, PolicyControllerGeneratePolicySignatureRequest403, PolicyControllerGeneratePolicySignatureRequest404, PolicyControllerGeneratePolicySignatureRequest409, PolicyControllerGeneratePolicySignatureRequest425, PolicyControllerPushPolicyEventMutationRequest, PolicyControllerPushPolicyEventMutationResponse, PolicyControllerPushPolicyEventPathParams, PolicyControllerPushPolicyEventQueryParams, PolicyControllerPushPolicyEvent400, PolicyControllerPushPolicyEvent404, PolicyControllerQuotePolicyMutationRequest, PolicyControllerQuotePolicyMutationResponse, PolicyControllerQuotePolicyPathParams, PolicyControllerQuotePolicyQueryParams, PolicyControllerQuotePolicy400, PolicyControllerQuotePolicy403, PolicyControllerQuotePolicy404, PolicyControllerQuotePolicy409, PolicyControllerStopPolicyMutationRequest, PolicyControllerStopPolicyMutationResponse, PolicyControllerStopPolicyPathParams, PolicyControllerStopPolicyQueryParams, PolicyControllerStopPolicy400, PolicyControllerStopPolicy403, PolicyControllerStopPolicy404, PolicyControllerStopPolicy409, PolicyControllerStopPolicy501, PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, PolicyControllerRegisterAdditionalQuoteComponentsPathParams, PolicyControllerRegisterAdditionalQuoteComponentsQueryParams, PolicyControllerUpdatePolicyQuoteMutationRequest, PolicyControllerUpdatePolicyQuoteMutationResponse, PolicyControllerUpdatePolicyQuotePathParams, PolicyControllerUpdatePolicyQuoteQueryParams, PolicyControllerUpdatePolicyQuote404, PolicyControllerUpdatePolicyQuote409, PolicyControllerSuspendPolicyMutationResponse, PolicyControllerSuspendPolicyPathParams, PolicyControllerSuspendPolicyQueryParams, PolicyControllerSuspendPolicy404, PolicyControllerSuspendPolicy409, PolicyControllerActivatePolicyMutationRequest, PolicyControllerActivatePolicyMutationResponse, PolicyControllerActivatePolicyPathParams, PolicyControllerActivatePolicyQueryParams, PolicyControllerActivatePolicy400, PolicyControllerActivatePolicy404, PolicyControllerActivatePolicy409, PolicyControllerSetPolicyFeesMutationRequest, PolicyControllerSetPolicyFeesMutationResponse, PolicyControllerSetPolicyFeesPathParams, PolicyControllerSetPolicyFeesQueryParams, PolicyControllerSetPolicyFees400, PolicyControllerSetPolicyFees404, PolicyControllerManualQuotePolicyMutationRequest, PolicyControllerManualQuotePolicyMutationResponse, PolicyControllerManualQuotePolicyPathParams, PolicyControllerManualQuotePolicyQueryParams, PolicyControllerManualQuotePolicy400, PolicyControllerManualQuotePolicy404, PolicyControllerManualQuotePolicy409, PricingControllerSavePricingSelectionMutationRequest, PricingControllerSavePricingSelectionMutationResponse, PricingControllerSavePricingSelectionPathParams, PricingControllerSavePricingSelectionQueryParams, PricingControllerSavePricingSelection404, QuoteControllerGetQuoteMutationRequest, QuoteControllerGetQuoteMutationResponse, QuoteControllerGetQuotePathParams, QuoteControllerGetQuote400, QuoteControllerGetQuote404, RenewalControllerFinalizeRenewalBranchMutationResponse, RenewalControllerFinalizeRenewalBranchPathParams, RenewalControllerFinalizeRenewalBranchQueryParams, RenewalControllerFinalizeRenewalBranch404, RenewalControllerFinalizeRenewalBranch409, ReportingControllerGenerateReportMutationRequest, ReportingControllerGenerateReportMutationResponse, ReportingControllerGenerateReport400, ReportingControllerGenerateCustomReportMutationRequest, ReportingControllerGenerateCustomReportMutationResponse, RepricingControllerExecuteRepricingForPolicyMutationResponse, RepricingControllerExecuteRepricingForPolicyPathParams, RepricingControllerExecuteRepricingForPolicyQueryParams, SignatureControllerFakeMutationResponse, SignatureControllerFakePathParams, SignatureControllerResendSignatureReminderMutationResponse, SignatureControllerResendSignatureReminderPathParams, DerogationControllerCreateDerogationMutationResponse, DerogationControllerCreateDerogationPathParams, DerogationControllerCreateDerogationQueryParams, DerogationControllerCreateDerogation404, DerogationControllerCreateDerogation409, DerogationControllerApproveDerogationMutationResponse, DerogationControllerApproveDerogationPathParams, DerogationControllerApproveDerogation404, DerogationControllerDenyDerogationMutationRequest, DerogationControllerDenyDerogationMutationResponse, DerogationControllerDenyDerogationPathParams, DerogationControllerDenyDerogation404, CommentsControllerCreateCommentMutationRequest, CommentsControllerCreateCommentMutationResponse, CommentsControllerCreateCommentPathParams, CommentsControllerCreateCommentQueryParams, CommentsControllerCreateComment409, CommentsControllerUpdateCommentMutationRequest, CommentsControllerUpdateCommentMutationResponse, CommentsControllerUpdateCommentPathParams, CommentsControllerUpdateComment404, CommentsControllerDeleteCommentMutationResponse, CommentsControllerDeleteCommentPathParams, CommentsControllerDeleteComment404, InternalNotesControllerCreateMutationRequest, InternalNotesControllerCreateMutationResponse, InternalNotesControllerCreatePathParams, InternalNotesControllerCreate400, InternalNotesControllerUpdateMutationRequest, InternalNotesControllerUpdateMutationResponse, InternalNotesControllerUpdatePathParams, InternalNotesControllerUpdate403, InternalNotesControllerUpdate404, InternalNotesControllerDeleteMutationResponse, InternalNotesControllerDeletePathParams, InternalNotesControllerDeleteQueryParams, InternalNotesControllerDelete403, InternalNotesControllerDelete404, ClaimInternalNotesControllerCreateMutationRequest, ClaimInternalNotesControllerCreateMutationResponse, ClaimInternalNotesControllerCreatePathParams, ClaimInternalNotesControllerCreate400, ClaimInternalNotesControllerUpdateMutationRequest, ClaimInternalNotesControllerUpdateMutationResponse, ClaimInternalNotesControllerUpdatePathParams, ClaimInternalNotesControllerUpdate403, ClaimInternalNotesControllerUpdate404, ClaimInternalNotesControllerDeleteMutationResponse, ClaimInternalNotesControllerDeletePathParams, ClaimInternalNotesControllerDeleteQueryParams, ClaimInternalNotesControllerDelete403, ClaimInternalNotesControllerDelete404, ConversationControllerCreateConversationMutationRequest, ConversationControllerCreateConversationMutationResponse, ConversationControllerDeleteConversationMutationResponse, ConversationControllerDeleteConversationPathParams, ConversationControllerDeleteConversation404, ConversationControllerSendConversationMessageMutationRequest, ConversationControllerSendConversationMessageMutationResponse, ConversationControllerSendConversationMessagePathParams, ConversationControllerSendConversationMessage404, ConversationControllerSendConversationMessageStreamMutationRequest, ConversationControllerSendConversationMessageStreamMutationResponse, ConversationControllerSendConversationMessageStreamPathParams, ConversationControllerSendConversationFeedbackMutationRequest, ConversationControllerSendConversationFeedbackMutationResponse, ConversationControllerSendConversationFeedbackPathParams, ConversationControllerSendConversationFeedback404, StripeWebhookControllerWebhookMutationResponse, StripeWebhookControllerWebhookHeaderParams, StripeWebhookControllerConnectWebhookMutationResponse, StripeWebhookControllerConnectWebhookHeaderParams, StripeWebhookControllerTestWebhookMutationResponse, StripeWebhookControllerTenantWebhookMutationResponse, StripeWebhookControllerTenantWebhookPathParams, StripeWebhookControllerTenantWebhookHeaderParams, StripeWebhookControllerTenantConnectWebhookMutationResponse, StripeWebhookControllerTenantConnectWebhookPathParams, StripeWebhookControllerTenantConnectWebhookHeaderParams, SydiaControllerListClaimsMutationRequest, SydiaControllerListClaimsMutationResponse, SydiaControllerGetClaimMutationRequest, SydiaControllerGetClaimMutationResponse, SydiaControllerUpsertPolicyClaimsMutationRequest, SydiaControllerUpsertPolicyClaimsMutationResponse, SydiaControllerGetCustomerMutationRequest, SydiaControllerGetCustomerMutationResponse, SydiaControllerListCustomersMutationRequest, SydiaControllerListCustomersMutationResponse, SydiaControllerListPoliciesMutationRequest, SydiaControllerListPoliciesMutationResponse, WorkflowsControllerStartWorkflowMutationRequest, WorkflowsControllerStartWorkflowMutationResponse, WorkflowsControllerCancelWorkflowRunsMutationRequest, WorkflowsControllerCancelWorkflowRunsMutationResponse, WorkflowsControllerRetryWorkflowRunMutationRequest, WorkflowsControllerRetryWorkflowRunMutationResponse, WorkflowsControllerRetryWorkflowRunPathParams, YeetControllerSurchargePolicyMutationRequest, YeetControllerSurchargePolicyMutationResponse, YeetControllerSurchargePolicyPathParams, YeetControllerSurchargePolicyQueryParams, YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, YeetControllerAttachDrivequantUserIdToCustomerPathParams, AxeceControllerSurchargePolicyMutationRequest, AxeceControllerSurchargePolicyMutationResponse, AxeceControllerSurchargePolicyPathParams, AxeceControllerSurchargePolicyQueryParams, AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, AxeceControllerAttachDrivequantUserIdToCustomerPathParams, YousignControllerWebhookMutationResponse, YousignControllerTenantWebhookMutationResponse, YousignControllerTenantWebhookPathParams, EmailEngineWebhookControllerWebhookMutationResponse, Ar24ControllerRegisteredLetterMutationResponse, AdminAr24ControllerCreateUserMutationRequest, AdminAr24ControllerCreateUserMutationResponse, AdminAr24ControllerRequestUserAccessMutationRequest, AdminAr24ControllerRequestUserAccessMutationResponse, AdminAr24ControllerUpdateUserMutationRequest, AdminAr24ControllerUpdateUserMutationResponse, AdminAr24ControllerUpdateUserPathParams, AdminAr24ControllerRequestUserEulaMutationResponse, AdminAr24ControllerRequestUserEulaPathParams, AdminAr24ControllerResendUserConfirmationMutationResponse, AdminAr24ControllerResendUserConfirmationPathParams, SesControllerSesEventMutationResponse, ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ViewSpecificControllerAcknowledgeComplianceAlertPathParams, ViewSpecificControllerCreateActiveTeamMutationRequest, ViewSpecificControllerCreateActiveTeamMutationResponse, ViewSpecificControllerCreateActiveTeamPathParams, ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ComplianceReadsControllerAcknowledgeComplianceAlertPathParams, BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest, BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, BrokerageFirmsReadsControllerCreateActiveTeamPathParams, McpServerControllerHandleRequestMutationResponse, ComplianceControllerCreateCheckMutationRequest, ComplianceControllerCreateCheckMutationResponse, ComplianceControllerUpdateCheckMutationRequest, ComplianceControllerUpdateCheckMutationResponse, ComplianceControllerUpdateCheckPathParams, ComplianceControllerUpdateCheck404, ComplianceControllerDeleteCheckMutationResponse, ComplianceControllerDeleteCheckPathParams, ComplianceControllerDeleteCheck404, ComplianceControllerCreateAlertMutationRequest, ComplianceControllerCreateAlertMutationResponse, ComplianceControllerCreateAlert404, ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ComplianceControllerAcknowledgeAlertsByEntityPathParams, ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest, ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ComplianceControllerUpdateAlertMutationRequest, ComplianceControllerUpdateAlertMutationResponse, ComplianceControllerUpdateAlertPathParams, ComplianceControllerUpdateAlert404, ComplianceControllerDeleteAlertMutationResponse, ComplianceControllerDeleteAlertPathParams, ComplianceControllerDeleteAlert404, RelationsControllerCreateRelationMutationRequest, RelationsControllerCreateRelationMutationResponse, RelationsControllerDeleteRelationMutationResponse, RelationsControllerDeleteRelationPathParams, BrokerageFirmControllerCreateBrokerageFirmMutationRequest, BrokerageFirmControllerCreateBrokerageFirmMutationResponse, BrokerageFirmControllerCreateBrokerageFirm400, BrokerageFirmControllerCreateBrokerageFirm404, BrokerageFirmControllerUpdateBrokerageFirmMutationRequest, BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, BrokerageFirmControllerUpdateBrokerageFirmPathParams, BrokerageFirmControllerUpdateBrokerageFirm400, BrokerageFirmControllerUpdateBrokerageFirm404, BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, BrokerageFirmControllerGenerateUploadDocumentUrlPathParams, BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams, BrokerageFirmControllerGenerateUploadDocumentUrl400, BrokerageFirmControllerGenerateUploadDocumentUrl403, BrokerageFirmControllerGenerateUploadDocumentUrl404, BrokerageFirmControllerDeleteDocumentsMutationResponse, BrokerageFirmControllerDeleteDocumentsPathParams, BrokerageFirmControllerDeleteDocumentsQueryParams, BrokerageFirmControllerDeleteDocuments400, BrokerageFirmControllerDeleteDocuments403, BrokerageFirmControllerDeleteDocuments404, BrokerageFirmControllerGenerateReportMutationRequest, BrokerageFirmControllerGenerateReportMutationResponse, BrokerageFirmControllerGenerateReportPathParams, BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest, BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, BrokerageFirmControllerGetCommissionStatementDocumentPathParams, BrokerageFirmControllerGetCommissionStatementDocument400, BrokerageFirmControllerGetCommissionStatementDocument403, BrokerageFirmControllerGetCommissionStatementDocument404, BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, BrokerageFirmControllerGenerateDocumentsForSignaturePathParams, BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams, BrokerageFirmControllerGenerateDocumentsForSignature404, BrokerageFirmControllerGenerateSignatureRequestMutationRequest, BrokerageFirmControllerGenerateSignatureRequestMutationResponse, BrokerageFirmControllerGenerateSignatureRequestPathParams, BrokerageFirmControllerGenerateSignatureRequest404, BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest, BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, BrokerageFirmControllerGenerateMandateSignatureRequestPathParams, BrokerageFirmControllerGenerateMandateSignatureRequest400, BrokerageFirmControllerGenerateMandateSignatureRequest404, BrokerageFirmControllerGenerateMandateSignatureRequest409, BrokerageFirmControllerGenerateMandateSignatureRequest425, BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams, BrokerageFirmControllerUpdatePreferredPaymentMethod400, BrokerageFirmControllerUpdatePreferredPaymentMethod404, BrokerageFirmControllerUpdatePreferredPaymentMethod409, BrokerageFirmControllerDeletePaymentMethodMutationResponse, BrokerageFirmControllerDeletePaymentMethodPathParams, BrokerageFirmControllerDeletePaymentMethod404, BrokerageFirmControllerDeletePaymentMethod409, BrokerageFirmControllerTransferPoliciesMutationRequest, BrokerageFirmControllerTransferPoliciesMutationResponse, BrokerageFirmControllerTransferPoliciesPathParams, BrokerageFirmControllerTransferPolicies404, DistributionRequestControllerCreateManyDistributionRequestsMutationRequest, DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, DistributionRequestControllerCreateManyDistributionRequests409, DistributionRequestControllerApproveDistributionRequestMutationResponse, DistributionRequestControllerApproveDistributionRequestPathParams, DistributionRequestControllerApproveDistributionRequest404, DistributionRequestControllerApproveDistributionRequest409, DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams, DistributionRequestControllerDenyDistributionRequestMutationResponse, DistributionRequestControllerDenyDistributionRequestPathParams, DistributionRequestControllerDenyDistributionRequest404, DistributionRequestControllerDenyDistributionRequest409, DistributionRequestControllerRevokeDistributionRequestMutationResponse, DistributionRequestControllerRevokeDistributionRequestPathParams, DistributionRequestControllerRevokeDistributionRequest404, DistributionRequestControllerRevokeDistributionRequest409, DistributionRequestControllerDeleteDistributionRequestMutationResponse, DistributionRequestControllerDeleteDistributionRequestPathParams, DistributionRequestControllerDeleteDistributionRequest404, BrokerageFeeControllerCreateBrokerageFeeMutationRequest, BrokerageFeeControllerCreateBrokerageFeeMutationResponse, BrokerageFeeControllerCreateBrokerageFeePathParams, BrokerageFeeControllerCreateBrokerageFee404, BrokerageFeeControllerUpdateBrokerageFeeMutationRequest, BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, BrokerageFeeControllerUpdateBrokerageFeePathParams, BrokerageFeeControllerUpdateBrokerageFee404, BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, BrokerageFeeControllerDeleteBrokerageFeePathParams, BrokerageFeeControllerDeleteBrokerageFee404, TelematicsControllerUpsertExternalServiceUserIdMutationRequest, TelematicsControllerUpsertExternalServiceUserIdMutationResponse, TenantOnboardingControllerCreateAccountMutationRequest, TenantOnboardingControllerCreateAccountMutationResponse, TenantOnboardingControllerCreateAccountLinkMutationResponse, TenantOnboardingControllerCreateAccountLinkPathParams, PortfolioMigrationControllerStartMigrationWorkflowMutationRequest, PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest, PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, EllisphereControllerOrderOnlineMutationRequest, EllisphereControllerOrderOnlineMutationResponse, SolvabilityControllerGetScoreMutationRequest, SolvabilityControllerGetScoreMutationResponse, FvaControllerUploadFileMutationResponse, FvaControllerUploadFileQueryParams, DocumentValidityControllerOverrideDocumentValidityMutationRequest, DocumentValidityControllerOverrideDocumentValidityMutationResponse, DocumentValidityControllerOverrideDocumentValidityPathParams, DocumentValidityControllerOverrideDocumentValidity500, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams, BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500, PolicyDocumentControllerAcceptMutationRequest, PolicyDocumentControllerAcceptMutationResponse, PolicyDocumentControllerAcceptPathParams, PolicyDocumentControllerAccept404, PolicyDocumentControllerRejectMutationRequest, PolicyDocumentControllerRejectMutationResponse, PolicyDocumentControllerRejectPathParams, PolicyDocumentControllerReject404, PolicyDocumentControllerAcceptAllMutationRequest, PolicyDocumentControllerAcceptAllMutationResponse, PolicyDocumentControllerAcceptAllPathParams, PolicyDocumentControllerAcceptAll409, PolicyDocumentControllerCancelMutationResponse, PolicyDocumentControllerCancelPathParams, PolicyDocumentControllerCancel404, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404, PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409, BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams, BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams, BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404, BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams, BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409, BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams, BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404, BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409, DocumentExtractionControllerRetryDocumentExtractionMutationResponse, DocumentExtractionControllerRetryDocumentExtractionPathParams, DocumentExtractionControllerRetryDocumentExtraction404, DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest, DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, DocumentExtractionControllerSubmitExtractionFeedbackPathParams, DocumentPrefillControllerRecordOutcomeMutationRequest, DocumentPrefillControllerRecordOutcomeMutationResponse, ImpersonationControllerCreateSessionMutationRequest, ImpersonationControllerCreateSessionMutationResponse, ImpersonationControllerRevokeCurrentSessionMutationResponse, ImpersonationControllerRevokeSessionMutationResponse, ImpersonationControllerRevokeSessionPathParams, FederatedSessionControllerRevokeCurrentSessionMutationResponse, SpeechToTextControllerGetCredentialsMutationRequest, SpeechToTextControllerGetCredentialsMutationResponse, FcbWidgetControllerInitWhatsappConversationMutationRequest, FcbWidgetControllerInitWhatsappConversationMutationResponse } from "./kubb-types.ts";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult, UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { addressAutocompleteControllerSuggest, aikanControllerGetAikanAssets, aikanControllerGetAikanDocumentById, appControllerIndex, assetControllerGetAsset, assetControllerGetAssetExternalQuote, billingControllerGetInvoices, billingControllerListInvoiceEvents, policyControllerListBranches, branchControllerGetBranchEffectiveDate, brokerControllerAtMe, brokerControllerListBrokers, brokerControllerListDescendantBrokers, brokerControllerGetBroker, emailAccountControllerListMine, emailControllerGetAttachmentDownloadUrl, emailControllerGetEmail, emailThreadControllerListThreads, emailThreadControllerGetThread, generalInboxControllerGetSummary, claimManagementControllerList, claimManagementControllerListMyClaims, claimManagementControllerGet, claimManagementControllerGetClaimsExportStatus, claimManagementControllerAvailableTransitions, claimManagementControllerGetClaimExtractions, claimManagementControllerStatusHistory, claimManagementControllerDocumentFraudScores, claimManagementControllerFraudNarrative, claimManagementControllerTimeline, claimsControllerList, claimsControllerGet, configControllerListTenants, configControllerGetTenantConfig, configControllerGetProductConfig, configControllerGetPublicTenantConfigByDomain, configControllerGetPublicProductConfig, configControllerGetPublicTenantConfig, configControllerGetProductsForTenant, configControllerGetBusinessRolePermissions, featureFlagControllerAtMe, featureFlagControllerFindAll, customerControllerGetCustomer, customerControllerGetCustomerPaymentMethods, customerControllerGetPaymentMethodSetupSecret, customerControllerListCustomers, customerControllerGetInvoicingSchedule, customerControllerGetBankTransferAccount, customerControllerGetCustomerBalance, customerControllerGetMigratedBillingTakeover, debugControllerGetProjections, debugControllerCountCoreEvents, documentsControllerValidateAndProcessDocument, documentsControllerGetDocuments, healthControllerIndex, healthControllerCheck, invitationControllerResolveAnonymousSessionEntities, jobSchedulersControllerGetJobSchedulers, jobSchedulersControllerGet, jobsControllerGetJob, jobsControllerListJobs, jobsControllerCountJobs, queueManagementControllerGetStatus, legacyDocumentsControllerGetOnDemandDocuments, legacyDocumentsControllerGetExpectedGeneratedDocuments, legacyDocumentsControllerGetExpectedUploadedDocuments, lockControllerListLocks, lockControllerGetLock, notificationControllerListEmailTemplates, notificationControllerListNotifications, notificationControllerGetNotification, paymentsControllerGetPayments, paymentsControllerGetCustomersPaymentMethods, paymentsControllerGetCustomerPayments, policyControllerGetPolicy, policyControllerListPolicyDocuments, policyControllerGetPremiumSchedule, policyControllerListPolicyDocumentsAdmin, policyControllerListPolicyEvents, policyControllerPlanTasks, policyControllerGetAggregate, policyControllerCalculatePolicyQuote, pricingControllerComputePricing, pricingControllerGetPrice, quoteControllerGetExternalQuote, monitoringControllerGetReports, monitoringControllerGetChecks, reportingControllerGetReportConfig, reportingControllerGetReports, searchControllerSearch, searchControllerGenericSearch, searchControllerCount, searchControllerReindex, searchControllerReindexAll, signatureControllerYousignSecurityCheck, signatureControllerGetSignatureRequestsByExternalId, signatureControllerGetSignerLink, sirenControllerSearchSiren, sivControllerSearchSiv, sivControllerSearchSivAtLegacyPath, derogationControllerCheckDerogationRequirement, aiAdminControllerListConversations, aiAdminControllerGetConversationMessages, commentsControllerGetComment, commentsControllerListComments, internalNotesControllerList, internalNotesControllerGet, claimInternalNotesControllerList, claimInternalNotesControllerGet, conversationControllerListConversations, conversationControllerGetConversation, conversationControllerGetConversationMessages, sraControllerGetFacet, sraControllerGetVehicleDetails, sraControllerGetVersionInformationFromBrandAndModel, hiscoxControllerGetActivitiesBySector, userControllerGetMyUserWithDrivequantData, workflowsControllerListWorkflowRuns, workflowsControllerGetWorkflowRun, workflowsControllerListWorkflowRunNodes, yeetControllerListDrivequantAverageScores, yeetControllerListPossibleDrivequantUsers, yeetControllerListDrivequantHistoricalUsers, axeceControllerListDrivequantAverageScores, axeceControllerListPossibleDrivequantUsers, axeceControllerListDrivequantHistoricalUsers, adminAr24ControllerListUsers, adminAr24ControllerGetUser, viewSpecificControllerAccountingSummary, viewSpecificControllerListComplianceChecksOnPolicy, viewSpecificControllerListPolicyComplianceAlerts, viewSpecificControllerListChildBrokerageFirms, viewSpecificControllerListWholesaleBrokerageFirmDistributionRequests, viewSpecificControllerListBrokerageFirmDistributionRequests, viewSpecificControllerListPolicyAssets, viewSpecificControllerGetAvailablePricing, viewSpecificControllerListPolicyCustomers, viewSpecificControllerListCustomerInvoices, viewSpecificControllerListCustomerPayments, viewSpecificControllerListCustomerPaymentMethods, viewSpecificControllerListBrokerageFirmPaymentMethods, viewSpecificControllerListBrokerageFirmPolicies, viewSpecificControllerGetAccountingSummaryForBrokerageFirm, viewSpecificControllerListCustomerRelations, viewSpecificControllerListBrokerageFirmDerogations, viewSpecificControllerListProductCommonDocuments, billingReadsControllerGetAccountingSummary, billingReadsControllerGetBrokerageFirmAccountingSummary, billingReadsControllerListCustomerInvoices, paymentsReadsControllerListCustomerPayments, paymentsReadsControllerListCustomerPaymentMethodsWithDocuments, paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments, customerReadsControllerListCustomerRelations, customerReadsControllerListPolicyCustomers, assetReadsControllerListPolicyAssets, pricingReadsControllerGetAvailablePricing, derogationsReadsControllerSearchBrokerageFirmDerogations, complianceReadsControllerListPolicyComplianceAlerts, complianceReadsControllerListPolicyComplianceChecks, brokerageFirmsReadsControllerListChildBrokerageFirms, policyReadsControllerSearchBrokerageFirmPolicies, distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests, distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests, documentsReadsControllerListProductCommonDocuments, mcpServerControllerHandleServerSentEvents, complianceControllerListChecks, complianceControllerGetCheck, complianceControllerListAlerts, complianceControllerGetAlert, relationsControllerGetPermissionRelationsForUser, relationsControllerListTenantUsers, relationsControllerListRelations, legacyPermissionsControllerAtMe, brokerageFirmControllerListBrokerageFirms, brokerageFirmControllerGetBrokerageFirm, brokerageFirmControllerListDocuments, brokerageFirmControllerListReports, brokerageFirmControllerGetReportConfig, brokerageFirmControllerListCommissionStatements, brokerageFirmControllerGetPaymentMethodSetupSecret, brokerageFirmControllerGetPaymentMethods, distributionRequestControllerGetDistributionRequest, distributionRequestControllerListDistributionRequests, brokerageFeeControllerGetBrokerFees, efficialeControllerCheckCompliance, efficialeControllerGetAlerts, metabaseControllerGetIframeUrl, fvaControllerRetrieveReportOutcome, documentValidityControllerGetPolicyValidity, documentValidityControllerGetDocumentValidity, brokerageFirmDocumentValidityControllerGetBrokerageFirmValidity, documentCoherenceControllerGetDocumentCoherence, policyDocumentControllerGetPolicyDocumentConformity, policyDocumentControllerGetPolicyDocumentVerdicts, policyDocumentControllerGetPolicyDocumentFraud, brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity, brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud, policyDocumentCollectionControllerGetCollectionState, policyDocumentExtractionControllerGetPolicyExtractions, documentExtractionControllerGetDocumentExtraction, documentExtractionControllerGetExtractionFeedback, brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions, jwksControllerGetJwks, impersonationControllerListSessions, fcbWidgetControllerMintToken, authControllerCheckEmail, assetControllerBatchCreateAssets, assetControllerBatchEditAssets, assetControllerBatchRemoveAssets, assetControllerCreateAsset, assetControllerReplaceAsset, assetControllerEditAsset, assetControllerRemoveAsset, assetControllerPushAssetEvent, billingControllerListInvoices, billingControllerCreateManualInvoice, billingControllerSetInvoiceCleanup, billingControllerIssueInvoices, billingControllerDeleteInvoices, branchControllerEditBranch, branchControllerCreateBranch, branchControllerForkBranch, branchControllerForkBranchWithoutPolicy, branchControllerInvalidateBranch, brokerControllerCreateBroker, brokerControllerUpdateBroker, brokerControllerDeleteBroker, emailAccountControllerConnect, emailAccountControllerReconnect, emailAccountControllerDisconnect, emailControllerAttachPolicies, emailControllerDetachPolicies, emailControllerDetachPolicy, emailControllerMovePolicy, emailThreadControllerSetThreadsArchived, emailThreadControllerAttachThreadsPolicies, claimManagementControllerLookupCustomer, claimManagementControllerCheckCoverage, claimManagementControllerGenerateFnolUploadUrl, claimManagementControllerBootstrap, claimManagementControllerUpdateDraft, claimManagementControllerUpdateCustomFields, claimManagementControllerAttachDocument, claimManagementControllerGenerateDocument, claimManagementControllerGetDocumentGenerationPayload, claimManagementControllerDetachDocument, claimManagementControllerTransition, claimManagementControllerRetryForward, claimManagementControllerAddNote, claimManagementControllerStartClaimsExport, claimManagementControllerCorrectDocumentFraudVerdict, externalClaimsControllerCreate, externalClaimsControllerResync, claimsControllerCreate, claimsControllerUpdate, claimsControllerDelete, featureFlagControllerUpdate, customerControllerEditCustomer, customerControllerInitializeCustomer, customerControllerPushCustomerEvent, customerControllerGenerateMandateSignatureRequest, customerControllerUpdatePreferredPaymentMethod, customerControllerDeletePaymentMethod, customerControllerUpdatePaymentMode, customerControllerCharge, customerControllerManuallyMarkInvoice, customerControllerSetMigratedBillingTakeover, customerControllerUnlockMigratedBillingTakeover, customerControllerCreateCustomerForPolicy, customerControllerDeleteCustomerFromPolicy, debugControllerClearTestData, debugControllerClearProjectionsData, debugControllerClearLegacyCache, debugControllerToggleIgnoreCoreEvents, debugControllerBillCustomer, debugControllerBatchBillCustomers, debugControllerBatchChargeInvoices, debugControllerStartDailyStagingCleanup, debugControllerCreateDistributionRequestsAndFees, debugControllerCreatePaymentFromStripe, debugControllerUpdatePaymentStatus, debugControllerRefreshInvoiceStatus, debugControllerBatchGenerateDocuments, debugControllerBatchCreateUserRelations, debugControllerCheckAllDocuments, debugControllerRetriggerClaimDocumentFraudCheck, debugControllerSuperDeletePolicies, documentsControllerGenerateDocumentUploadUrls, documentsControllerDeleteDocuments, documentsControllerArchiveDocuments, documentsControllerRestoreDocuments, documentsControllerSetDocumentCategory, documentsControllerListDocumentsWithPresignedUrl, documentsControllerCreatePdf, documentsControllerScheduleHandleMalwareProtectionScanResult, invitationControllerInvite, invitationControllerAdminInvite, invitationControllerBrokerInvite, invitationControllerCreateAnonymousSession, invitationControllerHandoffAnonymousSession, jobSchedulersControllerList, jobSchedulersControllerUpsert, jobSchedulersControllerUpdate, jobSchedulersControllerDelete, jobsControllerCreateJob, jobsControllerCreateJobs, jobsControllerUpdateJob, jobsControllerCancelJob, jobsControllerCancelJobs, jobsControllerRetryJobs, jobsControllerClearJobsData, jobsControllerClearWorkflowsData, jobsControllerCancelPushProjectionJobs, queueManagementControllerPause, queueManagementControllerResume, queueManagementControllerPauseSingle, queueManagementControllerResumeSingle, legacyDocumentsControllerGenerateDocumentOnDemand, legacyDocumentsControllerGetGenerationPayload, legacyDocumentsControllerRegenerateDocument, lockControllerDeleteLock, lockControllerCreateLock, lockControllerBatchCreateLocks, lockControllerBatchGetLocks, lockControllerBatchDeleteLocks, notificationControllerSendEmail, notificationControllerRenderEmailTemplate, notificationControllerSendTestEmail, notificationControllerCreateNotification, notificationControllerPatchNotification, notificationControllerDeleteNotification, notificationControllerSendNotification, paymentsControllerCreateCustomer, paymentsControllerListCustomers, paymentsControllerCreatePayment, paymentsControllerSetupIntent, paymentsControllerCancelPayment, paymentsControllerSoftDeletePaymentMethod, policyControllerEditPolicy, policyControllerGenerateIncrementalId, policyControllerGenerateDocumentUploadUrl, policyControllerDeletePolicyDocuments, policyControllerEditPolicyExternalId, policyControllerConfirmPolicy, policyControllerGeneratePolicySignatureRequest, policyControllerPushPolicyEvent, policyControllerQuotePolicy, policyControllerStopPolicy, policyControllerRegisterAdditionalQuoteComponents, policyControllerUpdatePolicyQuote, policyControllerSuspendPolicy, policyControllerActivatePolicy, policyControllerSetPolicyFees, policyControllerManualQuotePolicy, pricingControllerSavePricingSelection, quoteControllerGetQuote, renewalControllerFinalizeRenewalBranch, reportingControllerGenerateReport, reportingControllerGenerateCustomReport, repricingControllerExecuteRepricingForPolicy, signatureControllerFake, signatureControllerResendSignatureReminder, derogationControllerCreateDerogation, derogationControllerApproveDerogation, derogationControllerDenyDerogation, commentsControllerCreateComment, commentsControllerUpdateComment, commentsControllerDeleteComment, internalNotesControllerCreate, internalNotesControllerUpdate, internalNotesControllerDelete, claimInternalNotesControllerCreate, claimInternalNotesControllerUpdate, claimInternalNotesControllerDelete, conversationControllerCreateConversation, conversationControllerDeleteConversation, conversationControllerSendConversationMessage, conversationControllerSendConversationMessageStream, conversationControllerSendConversationFeedback, stripeWebhookControllerWebhook, stripeWebhookControllerConnectWebhook, stripeWebhookControllerTestWebhook, stripeWebhookControllerTenantWebhook, stripeWebhookControllerTenantConnectWebhook, sydiaControllerListClaims, sydiaControllerGetClaim, sydiaControllerUpsertPolicyClaims, sydiaControllerGetCustomer, sydiaControllerListCustomers, sydiaControllerListPolicies, workflowsControllerStartWorkflow, workflowsControllerCancelWorkflowRuns, workflowsControllerRetryWorkflowRun, yeetControllerSurchargePolicy, yeetControllerAttachDrivequantUserIdToCustomer, axeceControllerSurchargePolicy, axeceControllerAttachDrivequantUserIdToCustomer, yousignControllerWebhook, yousignControllerTenantWebhook, emailEngineWebhookControllerWebhook, ar24ControllerRegisteredLetter, adminAr24ControllerCreateUser, adminAr24ControllerRequestUserAccess, adminAr24ControllerUpdateUser, adminAr24ControllerRequestUserEula, adminAr24ControllerResendUserConfirmation, sesControllerSesEvent, viewSpecificControllerAcknowledgeComplianceAlert, viewSpecificControllerCreateActiveTeam, complianceReadsControllerAcknowledgeComplianceAlert, brokerageFirmsReadsControllerCreateActiveTeam, mcpServerControllerHandleRequest, complianceControllerCreateCheck, complianceControllerUpdateCheck, complianceControllerDeleteCheck, complianceControllerCreateAlert, complianceControllerAcknowledgeAlertsByEntity, complianceControllerAcknowledgeAlertsByCheckIds, complianceControllerUpdateAlert, complianceControllerDeleteAlert, relationsControllerCreateRelation, relationsControllerDeleteRelation, brokerageFirmControllerCreateBrokerageFirm, brokerageFirmControllerUpdateBrokerageFirm, brokerageFirmControllerGenerateUploadDocumentUrl, brokerageFirmControllerDeleteDocuments, brokerageFirmControllerGenerateReport, brokerageFirmControllerGetCommissionStatementDocument, brokerageFirmControllerGenerateDocumentsForSignature, brokerageFirmControllerGenerateSignatureRequest, brokerageFirmControllerGenerateMandateSignatureRequest, brokerageFirmControllerUpdatePreferredPaymentMethod, brokerageFirmControllerDeletePaymentMethod, brokerageFirmControllerTransferPolicies, distributionRequestControllerCreateManyDistributionRequests, distributionRequestControllerApproveDistributionRequest, distributionRequestControllerWaitingForSignatureDistributionRequest, distributionRequestControllerDenyDistributionRequest, distributionRequestControllerRevokeDistributionRequest, distributionRequestControllerDeleteDistributionRequest, brokerageFeeControllerCreateBrokerageFee, brokerageFeeControllerUpdateBrokerageFee, brokerageFeeControllerDeleteBrokerageFee, telematicsControllerUpsertExternalServiceUserId, tenantOnboardingControllerCreateAccount, tenantOnboardingControllerCreateAccountLink, portfolioMigrationControllerStartMigrationWorkflow, paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow, ellisphereControllerOrderOnline, solvabilityControllerGetScore, fvaControllerUploadFile, documentValidityControllerOverrideDocumentValidity, brokerageFirmDocumentValidityControllerOverrideDocumentValidity, policyDocumentControllerAccept, policyDocumentControllerReject, policyDocumentControllerAcceptAll, policyDocumentControllerCancel, policyDocumentControllerCorrectPolicyDocumentFraudVerdict, brokerageFirmDocumentControllerAcceptBrokerageFirmDocument, brokerageFirmDocumentControllerRejectBrokerageFirmDocument, brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments, brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity, brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict, documentExtractionControllerRetryDocumentExtraction, documentExtractionControllerSubmitExtractionFeedback, documentPrefillControllerRecordOutcome, impersonationControllerCreateSession, impersonationControllerRevokeCurrentSession, impersonationControllerRevokeSession, federatedSessionControllerRevokeCurrentSession, speechToTextControllerGetCredentials, fcbWidgetControllerInitWhatsappConversation } from "./kubb-client.ts";
import { mutationOptions, useMutation, queryOptions, useQuery } from "@tanstack/react-query";

export const appControllerIndexQueryKey = () => [{ url: '/' }] as const

export type AppControllerIndexQueryKey = ReturnType<typeof appControllerIndexQueryKey>

export function appControllerIndexQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = appControllerIndexQueryKey()
        return queryOptions<AppControllerIndexQueryResponse, ResponseErrorConfig<Error>, AppControllerIndexQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return appControllerIndex({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /}
 */
export function useAppControllerIndex<TData = AppControllerIndexQueryResponse, TQueryData = AppControllerIndexQueryResponse, TQueryKey extends QueryKey = AppControllerIndexQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<AppControllerIndexQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? appControllerIndexQueryKey()
         

         const query = useQuery({
          ...appControllerIndexQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const aikanControllerGetAikanDocumentByIdQueryKey = (params: AikanControllerGetAikanDocumentByIdQueryParams) => [{ url: '/aikan/documents' }, ...(params ? [params] : [])] as const

export type AikanControllerGetAikanDocumentByIdQueryKey = ReturnType<typeof aikanControllerGetAikanDocumentByIdQueryKey>

export function aikanControllerGetAikanDocumentByIdQueryOptions(params: AikanControllerGetAikanDocumentByIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = aikanControllerGetAikanDocumentByIdQueryKey(params)
        return queryOptions<AikanControllerGetAikanDocumentByIdQueryResponse, ResponseErrorConfig<Error>, AikanControllerGetAikanDocumentByIdQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return aikanControllerGetAikanDocumentById(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Endpoint for sydia to fetch documents
 * {@link /aikan/documents}
 */
export function useAikanControllerGetAikanDocumentById<TData = AikanControllerGetAikanDocumentByIdQueryResponse, TQueryData = AikanControllerGetAikanDocumentByIdQueryResponse, TQueryKey extends QueryKey = AikanControllerGetAikanDocumentByIdQueryKey>(params: AikanControllerGetAikanDocumentByIdQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AikanControllerGetAikanDocumentByIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? aikanControllerGetAikanDocumentByIdQueryKey(params)
         

         const query = useQuery({
          ...aikanControllerGetAikanDocumentByIdQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const aikanControllerGetAikanAssetsQueryKey = (params: AikanControllerGetAikanAssetsQueryParams) => [{ url: '/aikan/assets' }, ...(params ? [params] : [])] as const

export type AikanControllerGetAikanAssetsQueryKey = ReturnType<typeof aikanControllerGetAikanAssetsQueryKey>

export function aikanControllerGetAikanAssetsQueryOptions(params: AikanControllerGetAikanAssetsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = aikanControllerGetAikanAssetsQueryKey(params)
        return queryOptions<AikanControllerGetAikanAssetsQueryResponse, ResponseErrorConfig<Error>, AikanControllerGetAikanAssetsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return aikanControllerGetAikanAssets(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Endpoint for sydia to fetch assets
 * {@link /aikan/assets}
 */
export function useAikanControllerGetAikanAssets<TData = AikanControllerGetAikanAssetsQueryResponse, TQueryData = AikanControllerGetAikanAssetsQueryResponse, TQueryKey extends QueryKey = AikanControllerGetAikanAssetsQueryKey>(params: AikanControllerGetAikanAssetsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AikanControllerGetAikanAssetsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? aikanControllerGetAikanAssetsQueryKey(params)
         

         const query = useQuery({
          ...aikanControllerGetAikanAssetsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const assetControllerGetAssetQueryKey = (assetId: AssetControllerGetAssetPathParams["assetId"] | undefined, params?: AssetControllerGetAssetQueryParams) => [{ url: '/assets/:assetId', params: {assetId:assetId} }, ...(params ? [params] : [])] as const

export type AssetControllerGetAssetQueryKey = ReturnType<typeof assetControllerGetAssetQueryKey>

export function assetControllerGetAssetQueryOptions(assetId: AssetControllerGetAssetPathParams["assetId"] | undefined, params?: AssetControllerGetAssetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = assetControllerGetAssetQueryKey(assetId, params)
        return queryOptions<AssetControllerGetAssetQueryResponse, ResponseErrorConfig<AssetControllerGetAsset403 | AssetControllerGetAsset404>, AssetControllerGetAssetQueryResponse, typeof queryKey>({
         enabled: !!(assetId),
         queryKey,
         queryFn: async ({ signal }) => {
            return assetControllerGetAsset(assetId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get Asset
 * {@link /assets/:assetId}
 */
export function useAssetControllerGetAsset<TData = AssetControllerGetAssetQueryResponse, TQueryData = AssetControllerGetAssetQueryResponse, TQueryKey extends QueryKey = AssetControllerGetAssetQueryKey>(assetId: AssetControllerGetAssetPathParams["assetId"] | undefined, params?: AssetControllerGetAssetQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AssetControllerGetAssetQueryResponse, ResponseErrorConfig<AssetControllerGetAsset403 | AssetControllerGetAsset404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? assetControllerGetAssetQueryKey(assetId, params)
         

         const query = useQuery({
          ...assetControllerGetAssetQueryOptions(assetId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AssetControllerGetAsset403 | AssetControllerGetAsset404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const assetControllerGetAssetExternalQuoteQueryKey = (assetId: AssetControllerGetAssetExternalQuotePathParams["assetId"] | undefined, params?: AssetControllerGetAssetExternalQuoteQueryParams) => [{ url: '/assets/:assetId/external-quote', params: {assetId:assetId} }, ...(params ? [params] : [])] as const

export type AssetControllerGetAssetExternalQuoteQueryKey = ReturnType<typeof assetControllerGetAssetExternalQuoteQueryKey>

export function assetControllerGetAssetExternalQuoteQueryOptions(assetId: AssetControllerGetAssetExternalQuotePathParams["assetId"] | undefined, params?: AssetControllerGetAssetExternalQuoteQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = assetControllerGetAssetExternalQuoteQueryKey(assetId, params)
        return queryOptions<AssetControllerGetAssetExternalQuoteQueryResponse, ResponseErrorConfig<AssetControllerGetAssetExternalQuote404>, AssetControllerGetAssetExternalQuoteQueryResponse, typeof queryKey>({
         enabled: !!(assetId),
         queryKey,
         queryFn: async ({ signal }) => {
            return assetControllerGetAssetExternalQuote(assetId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get External Quote for this asset
 * {@link /assets/:assetId/external-quote}
 */
export function useAssetControllerGetAssetExternalQuote<TData = AssetControllerGetAssetExternalQuoteQueryResponse, TQueryData = AssetControllerGetAssetExternalQuoteQueryResponse, TQueryKey extends QueryKey = AssetControllerGetAssetExternalQuoteQueryKey>(assetId: AssetControllerGetAssetExternalQuotePathParams["assetId"] | undefined, params?: AssetControllerGetAssetExternalQuoteQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AssetControllerGetAssetExternalQuoteQueryResponse, ResponseErrorConfig<AssetControllerGetAssetExternalQuote404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? assetControllerGetAssetExternalQuoteQueryKey(assetId, params)
         

         const query = useQuery({
          ...assetControllerGetAssetExternalQuoteQueryOptions(assetId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AssetControllerGetAssetExternalQuote404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const billingControllerGetInvoicesQueryKey = (params: BillingControllerGetInvoicesQueryParams) => [{ url: '/billing' }, ...(params ? [params] : [])] as const

export type BillingControllerGetInvoicesQueryKey = ReturnType<typeof billingControllerGetInvoicesQueryKey>

export function billingControllerGetInvoicesQueryOptions(params: BillingControllerGetInvoicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = billingControllerGetInvoicesQueryKey(params)
        return queryOptions<BillingControllerGetInvoicesQueryResponse, ResponseErrorConfig<Error>, BillingControllerGetInvoicesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return billingControllerGetInvoices(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a paginated list of invoices specified by their IDs.
 * @summary Get invoices
 * {@link /billing}
 */
export function useBillingControllerGetInvoices<TData = BillingControllerGetInvoicesQueryResponse, TQueryData = BillingControllerGetInvoicesQueryResponse, TQueryKey extends QueryKey = BillingControllerGetInvoicesQueryKey>(params: BillingControllerGetInvoicesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BillingControllerGetInvoicesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? billingControllerGetInvoicesQueryKey(params)
         

         const query = useQuery({
          ...billingControllerGetInvoicesQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const billingControllerListInvoiceEventsQueryKey = (invoiceId: BillingControllerListInvoiceEventsPathParams["invoiceId"] | undefined) => [{ url: '/billing/debug/:invoiceId/events', params: {invoiceId:invoiceId} }] as const

export type BillingControllerListInvoiceEventsQueryKey = ReturnType<typeof billingControllerListInvoiceEventsQueryKey>

export function billingControllerListInvoiceEventsQueryOptions(invoiceId: BillingControllerListInvoiceEventsPathParams["invoiceId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = billingControllerListInvoiceEventsQueryKey(invoiceId)
        return queryOptions<BillingControllerListInvoiceEventsQueryResponse, ResponseErrorConfig<BillingControllerListInvoiceEvents404>, BillingControllerListInvoiceEventsQueryResponse, typeof queryKey>({
         enabled: !!(invoiceId),
         queryKey,
         queryFn: async ({ signal }) => {
            return billingControllerListInvoiceEvents(invoiceId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Lists domain events related to a given invoice.
 * @summary TEST List invoice events
 * {@link /billing/debug/:invoiceId/events}
 */
export function useBillingControllerListInvoiceEvents<TData = BillingControllerListInvoiceEventsQueryResponse, TQueryData = BillingControllerListInvoiceEventsQueryResponse, TQueryKey extends QueryKey = BillingControllerListInvoiceEventsQueryKey>(invoiceId: BillingControllerListInvoiceEventsPathParams["invoiceId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BillingControllerListInvoiceEventsQueryResponse, ResponseErrorConfig<BillingControllerListInvoiceEvents404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? billingControllerListInvoiceEventsQueryKey(invoiceId)
         

         const query = useQuery({
          ...billingControllerListInvoiceEventsQueryOptions(invoiceId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BillingControllerListInvoiceEvents404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerListBranchesQueryKey = (policyId: PolicyControllerListBranchesPathParams["policyId"] | undefined, params?: PolicyControllerListBranchesQueryParams) => [{ url: '/policies/:policyId/branches', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyControllerListBranchesQueryKey = ReturnType<typeof policyControllerListBranchesQueryKey>

export function policyControllerListBranchesQueryOptions(policyId: PolicyControllerListBranchesPathParams["policyId"] | undefined, params?: PolicyControllerListBranchesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerListBranchesQueryKey(policyId, params)
        return queryOptions<PolicyControllerListBranchesQueryResponse, ResponseErrorConfig<PolicyControllerListBranches403 | PolicyControllerListBranches404>, PolicyControllerListBranchesQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerListBranches(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns merged and closed branches as well as open ones, and never paginates — filter on `branchStatus`, where `BRANCH_OPEN` is the draft in play.
 * @summary List branches on the policy
 * {@link /policies/:policyId/branches}
 */
export function usePolicyControllerListBranches<TData = PolicyControllerListBranchesQueryResponse, TQueryData = PolicyControllerListBranchesQueryResponse, TQueryKey extends QueryKey = PolicyControllerListBranchesQueryKey>(policyId: PolicyControllerListBranchesPathParams["policyId"] | undefined, params?: PolicyControllerListBranchesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerListBranchesQueryResponse, ResponseErrorConfig<PolicyControllerListBranches403 | PolicyControllerListBranches404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerListBranchesQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyControllerListBranchesQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerListBranches403 | PolicyControllerListBranches404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const branchControllerGetBranchEffectiveDateQueryKey = (policyId: BranchControllerGetBranchEffectiveDatePathParams["policyId"] | undefined, branchId: BranchControllerGetBranchEffectiveDatePathParams["branchId"] | undefined, params?: BranchControllerGetBranchEffectiveDateQueryParams) => [{ url: '/policies/:policyId/branches/:branchId/effective-date', params: {policyId:policyId,branchId:branchId} }, ...(params ? [params] : [])] as const

export type BranchControllerGetBranchEffectiveDateQueryKey = ReturnType<typeof branchControllerGetBranchEffectiveDateQueryKey>

export function branchControllerGetBranchEffectiveDateQueryOptions(policyId: BranchControllerGetBranchEffectiveDatePathParams["policyId"] | undefined, branchId: BranchControllerGetBranchEffectiveDatePathParams["branchId"] | undefined, params?: BranchControllerGetBranchEffectiveDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = branchControllerGetBranchEffectiveDateQueryKey(policyId, branchId, params)
        return queryOptions<BranchControllerGetBranchEffectiveDateQueryResponse, ResponseErrorConfig<Error>, BranchControllerGetBranchEffectiveDateQueryResponse, typeof queryKey>({
         enabled: !!(policyId && branchId),
         queryKey,
         queryFn: async ({ signal }) => {
            return branchControllerGetBranchEffectiveDate(policyId!, branchId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Answers only for branches that move a date. A mid-term adjustment that merely changes declared or priced fields has none and returns an empty object — that change takes effect on signature.
 * @summary Get the date at which a branch takes effect
 * {@link /policies/:policyId/branches/:branchId/effective-date}
 */
export function useBranchControllerGetBranchEffectiveDate<TData = BranchControllerGetBranchEffectiveDateQueryResponse, TQueryData = BranchControllerGetBranchEffectiveDateQueryResponse, TQueryKey extends QueryKey = BranchControllerGetBranchEffectiveDateQueryKey>(policyId: BranchControllerGetBranchEffectiveDatePathParams["policyId"] | undefined, branchId: BranchControllerGetBranchEffectiveDatePathParams["branchId"] | undefined, params?: BranchControllerGetBranchEffectiveDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BranchControllerGetBranchEffectiveDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? branchControllerGetBranchEffectiveDateQueryKey(policyId, branchId, params)
         

         const query = useQuery({
          ...branchControllerGetBranchEffectiveDateQueryOptions(policyId, branchId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerControllerAtMeQueryKey = () => [{ url: '/brokerage-firms/@me' }] as const

export type BrokerControllerAtMeQueryKey = ReturnType<typeof brokerControllerAtMeQueryKey>

export function brokerControllerAtMeQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerControllerAtMeQueryKey()
        return queryOptions<BrokerControllerAtMeQueryResponse, ResponseErrorConfig<Error>, BrokerControllerAtMeQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerControllerAtMe({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the brokerage information of the authenticated user, including profile and brokerage firm context, if available. This endpoint is deprecated and may be removed in a future version. Requires a valid session (401 if unauthenticated).
 * @summary Get current user's brokerage firm info
 * {@link /brokerage-firms/@me}
 * @deprecated
 */
export function useBrokerControllerAtMe<TData = BrokerControllerAtMeQueryResponse, TQueryData = BrokerControllerAtMeQueryResponse, TQueryKey extends QueryKey = BrokerControllerAtMeQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<BrokerControllerAtMeQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerControllerAtMeQueryKey()
         

         const query = useQuery({
          ...brokerControllerAtMeQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerControllerListBrokersQueryKey = (brokerageFirmId: BrokerControllerListBrokersPathParams["brokerageFirmId"] | undefined, params?: BrokerControllerListBrokersQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/brokers', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BrokerControllerListBrokersQueryKey = ReturnType<typeof brokerControllerListBrokersQueryKey>

export function brokerControllerListBrokersQueryOptions(brokerageFirmId: BrokerControllerListBrokersPathParams["brokerageFirmId"] | undefined, params?: BrokerControllerListBrokersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerControllerListBrokersQueryKey(brokerageFirmId, params)
        return queryOptions<BrokerControllerListBrokersQueryResponse, ResponseErrorConfig<BrokerControllerListBrokers404>, BrokerControllerListBrokersQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerControllerListBrokers(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a paginated list of brokers for the specified brokerage firm. Supports pagination parameters (e.g., page cursors or limits) via query and may support optional role filters depending on configuration.
 * @summary List brokers in brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/brokers}
 */
export function useBrokerControllerListBrokers<TData = BrokerControllerListBrokersQueryResponse, TQueryData = BrokerControllerListBrokersQueryResponse, TQueryKey extends QueryKey = BrokerControllerListBrokersQueryKey>(brokerageFirmId: BrokerControllerListBrokersPathParams["brokerageFirmId"] | undefined, params?: BrokerControllerListBrokersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerControllerListBrokersQueryResponse, ResponseErrorConfig<BrokerControllerListBrokers404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerControllerListBrokersQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...brokerControllerListBrokersQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerControllerListBrokers404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerControllerListDescendantBrokersQueryKey = (brokerageFirmId: BrokerControllerListDescendantBrokersPathParams["brokerageFirmId"] | undefined, params?: BrokerControllerListDescendantBrokersQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/brokers/descendants', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BrokerControllerListDescendantBrokersQueryKey = ReturnType<typeof brokerControllerListDescendantBrokersQueryKey>

export function brokerControllerListDescendantBrokersQueryOptions(brokerageFirmId: BrokerControllerListDescendantBrokersPathParams["brokerageFirmId"] | undefined, params?: BrokerControllerListDescendantBrokersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerControllerListDescendantBrokersQueryKey(brokerageFirmId, params)
        return queryOptions<BrokerControllerListDescendantBrokersQueryResponse, ResponseErrorConfig<BrokerControllerListDescendantBrokers404>, BrokerControllerListDescendantBrokersQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerControllerListDescendantBrokers(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a paginated list of brokers that belong to the given brokerage firm or any descendant in its hierarchy. Each entry is enriched with the brokerage firm id and display name so callers can group results by firm. Supports a queryString that matches broker firstName or lastName.
 * @summary List brokers of a firm and its descendants
 * {@link /brokerage-firms/:brokerageFirmId/brokers/descendants}
 */
export function useBrokerControllerListDescendantBrokers<TData = BrokerControllerListDescendantBrokersQueryResponse, TQueryData = BrokerControllerListDescendantBrokersQueryResponse, TQueryKey extends QueryKey = BrokerControllerListDescendantBrokersQueryKey>(brokerageFirmId: BrokerControllerListDescendantBrokersPathParams["brokerageFirmId"] | undefined, params?: BrokerControllerListDescendantBrokersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerControllerListDescendantBrokersQueryResponse, ResponseErrorConfig<BrokerControllerListDescendantBrokers404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerControllerListDescendantBrokersQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...brokerControllerListDescendantBrokersQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerControllerListDescendantBrokers404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerControllerGetBrokerQueryKey = (brokerUserId: BrokerControllerGetBrokerPathParams["brokerUserId"] | undefined) => [{ url: '/brokerage-firms/brokers/:brokerUserId', params: {brokerUserId:brokerUserId} }] as const

export type BrokerControllerGetBrokerQueryKey = ReturnType<typeof brokerControllerGetBrokerQueryKey>

export function brokerControllerGetBrokerQueryOptions(brokerUserId: BrokerControllerGetBrokerPathParams["brokerUserId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerControllerGetBrokerQueryKey(brokerUserId)
        return queryOptions<BrokerControllerGetBrokerQueryResponse, ResponseErrorConfig<BrokerControllerGetBroker404>, BrokerControllerGetBrokerQueryResponse, typeof queryKey>({
         enabled: !!(brokerUserId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerControllerGetBroker(brokerUserId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Fetches a broker by the broker user id. This endpoint returns profile and brokerage context for the specified broker.
 * @summary Get a broker
 * {@link /brokerage-firms/brokers/:brokerUserId}
 */
export function useBrokerControllerGetBroker<TData = BrokerControllerGetBrokerQueryResponse, TQueryData = BrokerControllerGetBrokerQueryResponse, TQueryKey extends QueryKey = BrokerControllerGetBrokerQueryKey>(brokerUserId: BrokerControllerGetBrokerPathParams["brokerUserId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerControllerGetBrokerQueryResponse, ResponseErrorConfig<BrokerControllerGetBroker404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerControllerGetBrokerQueryKey(brokerUserId)
         

         const query = useQuery({
          ...brokerControllerGetBrokerQueryOptions(brokerUserId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerControllerGetBroker404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const emailAccountControllerListMineQueryKey = () => [{ url: '/email-accounts/@me' }] as const

export type EmailAccountControllerListMineQueryKey = ReturnType<typeof emailAccountControllerListMineQueryKey>

export function emailAccountControllerListMineQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = emailAccountControllerListMineQueryKey()
        return queryOptions<EmailAccountControllerListMineQueryResponse, ResponseErrorConfig<Error>, EmailAccountControllerListMineQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return emailAccountControllerListMine({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the connected email accounts owned by the authenticated broker plus every account shared within the broker's brokerage firm.
 * @summary List the logged-in broker's connected email accounts
 * {@link /email-accounts/@me}
 */
export function useEmailAccountControllerListMine<TData = EmailAccountControllerListMineQueryResponse, TQueryData = EmailAccountControllerListMineQueryResponse, TQueryKey extends QueryKey = EmailAccountControllerListMineQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<EmailAccountControllerListMineQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? emailAccountControllerListMineQueryKey()
         

         const query = useQuery({
          ...emailAccountControllerListMineQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const emailControllerGetAttachmentDownloadUrlQueryKey = (emailId: EmailControllerGetAttachmentDownloadUrlPathParams["emailId"] | undefined, emailAttachmentId: EmailControllerGetAttachmentDownloadUrlPathParams["emailAttachmentId"] | undefined) => [{ url: '/emails/:emailId/attachments/:emailAttachmentId/download-url', params: {emailId:emailId,emailAttachmentId:emailAttachmentId} }] as const

export type EmailControllerGetAttachmentDownloadUrlQueryKey = ReturnType<typeof emailControllerGetAttachmentDownloadUrlQueryKey>

export function emailControllerGetAttachmentDownloadUrlQueryOptions(emailId: EmailControllerGetAttachmentDownloadUrlPathParams["emailId"] | undefined, emailAttachmentId: EmailControllerGetAttachmentDownloadUrlPathParams["emailAttachmentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = emailControllerGetAttachmentDownloadUrlQueryKey(emailId, emailAttachmentId)
        return queryOptions<EmailControllerGetAttachmentDownloadUrlQueryResponse, ResponseErrorConfig<EmailControllerGetAttachmentDownloadUrl401 | EmailControllerGetAttachmentDownloadUrl409>, EmailControllerGetAttachmentDownloadUrlQueryResponse, typeof queryKey>({
         enabled: !!(emailId && emailAttachmentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return emailControllerGetAttachmentDownloadUrl(emailId!, emailAttachmentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a presigned URL serving the attachment under its original filename. The email must belong to one of the broker's accounts or to an account shared within their brokerage firm. Responds 409 while the attachment is not stored yet, or was skipped or failed.
 * @summary Get a short-lived download URL for an email attachment
 * {@link /emails/:emailId/attachments/:emailAttachmentId/download-url}
 */
export function useEmailControllerGetAttachmentDownloadUrl<TData = EmailControllerGetAttachmentDownloadUrlQueryResponse, TQueryData = EmailControllerGetAttachmentDownloadUrlQueryResponse, TQueryKey extends QueryKey = EmailControllerGetAttachmentDownloadUrlQueryKey>(emailId: EmailControllerGetAttachmentDownloadUrlPathParams["emailId"] | undefined, emailAttachmentId: EmailControllerGetAttachmentDownloadUrlPathParams["emailAttachmentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<EmailControllerGetAttachmentDownloadUrlQueryResponse, ResponseErrorConfig<EmailControllerGetAttachmentDownloadUrl401 | EmailControllerGetAttachmentDownloadUrl409>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? emailControllerGetAttachmentDownloadUrlQueryKey(emailId, emailAttachmentId)
         

         const query = useQuery({
          ...emailControllerGetAttachmentDownloadUrlQueryOptions(emailId, emailAttachmentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<EmailControllerGetAttachmentDownloadUrl401 | EmailControllerGetAttachmentDownloadUrl409>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const emailControllerGetEmailQueryKey = (emailId: EmailControllerGetEmailPathParams["emailId"] | undefined) => [{ url: '/emails/:emailId', params: {emailId:emailId} }] as const

export type EmailControllerGetEmailQueryKey = ReturnType<typeof emailControllerGetEmailQueryKey>

export function emailControllerGetEmailQueryOptions(emailId: EmailControllerGetEmailPathParams["emailId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = emailControllerGetEmailQueryKey(emailId)
        return queryOptions<EmailControllerGetEmailQueryResponse, ResponseErrorConfig<EmailControllerGetEmail400 | EmailControllerGetEmail401>, EmailControllerGetEmailQueryResponse, typeof queryKey>({
         enabled: !!(emailId),
         queryKey,
         queryFn: async ({ signal }) => {
            return emailControllerGetEmail(emailId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the email with its stored web-safe HTML body, its attachments and their storage status. Opening an unread email marks it as read and schedules the Seen flag write to the mailbox. The email must belong to one of the broker's accounts or to an account shared within their brokerage firm; disconnected accounts keep their history readable.
 * @summary Read an email: metadata, stored body and attachments
 * {@link /emails/:emailId}
 */
export function useEmailControllerGetEmail<TData = EmailControllerGetEmailQueryResponse, TQueryData = EmailControllerGetEmailQueryResponse, TQueryKey extends QueryKey = EmailControllerGetEmailQueryKey>(emailId: EmailControllerGetEmailPathParams["emailId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<EmailControllerGetEmailQueryResponse, ResponseErrorConfig<EmailControllerGetEmail400 | EmailControllerGetEmail401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? emailControllerGetEmailQueryKey(emailId)
         

         const query = useQuery({
          ...emailControllerGetEmailQueryOptions(emailId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<EmailControllerGetEmail400 | EmailControllerGetEmail401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const emailThreadControllerListThreadsQueryKey = (params?: EmailThreadControllerListThreadsQueryParams) => [{ url: '/email-threads' }, ...(params ? [params] : [])] as const

export type EmailThreadControllerListThreadsQueryKey = ReturnType<typeof emailThreadControllerListThreadsQueryKey>

export function emailThreadControllerListThreadsQueryOptions(params?: EmailThreadControllerListThreadsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = emailThreadControllerListThreadsQueryKey(params)
        return queryOptions<EmailThreadControllerListThreadsQueryResponse, ResponseErrorConfig<EmailThreadControllerListThreads400 | EmailThreadControllerListThreads401>, EmailThreadControllerListThreadsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return emailThreadControllerListThreads(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Threads to process or processed, newest latest email first, cursor-paginated. With policyId, returns whole threads containing an active link to that policy, with their emails oldest first, including archived emails. Requires policy access and covers personal and firm-shared accounts for every broker. Without policyId, shared accounts require shared-account admin permission. Disconnected accounts retain their history. Listing never marks an email as read.
 * @summary List the email threads
 * {@link /email-threads}
 */
export function useEmailThreadControllerListThreads<TData = EmailThreadControllerListThreadsQueryResponse, TQueryData = EmailThreadControllerListThreadsQueryResponse, TQueryKey extends QueryKey = EmailThreadControllerListThreadsQueryKey>(params?: EmailThreadControllerListThreadsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<EmailThreadControllerListThreadsQueryResponse, ResponseErrorConfig<EmailThreadControllerListThreads400 | EmailThreadControllerListThreads401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? emailThreadControllerListThreadsQueryKey(params)
         

         const query = useQuery({
          ...emailThreadControllerListThreadsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<EmailThreadControllerListThreads400 | EmailThreadControllerListThreads401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const emailThreadControllerGetThreadQueryKey = (threadId: EmailThreadControllerGetThreadPathParams["threadId"] | undefined) => [{ url: '/email-threads/:threadId', params: {threadId:threadId} }] as const

export type EmailThreadControllerGetThreadQueryKey = ReturnType<typeof emailThreadControllerGetThreadQueryKey>

export function emailThreadControllerGetThreadQueryOptions(threadId: EmailThreadControllerGetThreadPathParams["threadId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = emailThreadControllerGetThreadQueryKey(threadId)
        return queryOptions<EmailThreadControllerGetThreadQueryResponse, ResponseErrorConfig<EmailThreadControllerGetThread400 | EmailThreadControllerGetThread401>, EmailThreadControllerGetThreadQueryResponse, typeof queryKey>({
         enabled: !!(threadId),
         queryKey,
         queryFn: async ({ signal }) => {
            return emailThreadControllerGetThread(threadId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Every email of the thread, oldest first, with its linked policies; bodies are read through GET /emails/{emailId}. Opening the thread marks each unread email as read and schedules the Seen flag write to the mailbox. The thread must belong to one of the broker's accounts or to an account shared within their brokerage firm.
 * @summary Open an email thread
 * {@link /email-threads/:threadId}
 */
export function useEmailThreadControllerGetThread<TData = EmailThreadControllerGetThreadQueryResponse, TQueryData = EmailThreadControllerGetThreadQueryResponse, TQueryKey extends QueryKey = EmailThreadControllerGetThreadQueryKey>(threadId: EmailThreadControllerGetThreadPathParams["threadId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<EmailThreadControllerGetThreadQueryResponse, ResponseErrorConfig<EmailThreadControllerGetThread400 | EmailThreadControllerGetThread401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? emailThreadControllerGetThreadQueryKey(threadId)
         

         const query = useQuery({
          ...emailThreadControllerGetThreadQueryOptions(threadId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<EmailThreadControllerGetThread400 | EmailThreadControllerGetThread401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const generalInboxControllerGetSummaryQueryKey = () => [{ url: '/general-inbox/summary' }] as const

export type GeneralInboxControllerGetSummaryQueryKey = ReturnType<typeof generalInboxControllerGetSummaryQueryKey>

export function generalInboxControllerGetSummaryQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = generalInboxControllerGetSummaryQueryKey()
        return queryOptions<GeneralInboxControllerGetSummaryQueryResponse, ResponseErrorConfig<Error>, GeneralInboxControllerGetSummaryQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return generalInboxControllerGetSummary({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Counters for the sidebar and the mailbox filter: unread threads to process, in total and per mailbox. Covers the broker's personal accounts, plus the firm's shared accounts for shared-account admins.
 * @summary Summary counters of the general inbox
 * {@link /general-inbox/summary}
 */
export function useGeneralInboxControllerGetSummary<TData = GeneralInboxControllerGetSummaryQueryResponse, TQueryData = GeneralInboxControllerGetSummaryQueryResponse, TQueryKey extends QueryKey = GeneralInboxControllerGetSummaryQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GeneralInboxControllerGetSummaryQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? generalInboxControllerGetSummaryQueryKey()
         

         const query = useQuery({
          ...generalInboxControllerGetSummaryQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerListQueryKey = (params?: ClaimManagementControllerListQueryParams) => [{ url: '/claim-management/claims' }, ...(params ? [params] : [])] as const

export type ClaimManagementControllerListQueryKey = ReturnType<typeof claimManagementControllerListQueryKey>

export function claimManagementControllerListQueryOptions(params?: ClaimManagementControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerListQueryKey(params)
        return queryOptions<ClaimManagementControllerListQueryResponse, ResponseErrorConfig<ClaimManagementControllerList400>, ClaimManagementControllerListQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerList(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List claims (internal — claim managers only)
 * {@link /claim-management/claims}
 */
export function useClaimManagementControllerList<TData = ClaimManagementControllerListQueryResponse, TQueryData = ClaimManagementControllerListQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerListQueryKey>(params?: ClaimManagementControllerListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerListQueryResponse, ResponseErrorConfig<ClaimManagementControllerList400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerListQueryKey(params)
         

         const query = useQuery({
          ...claimManagementControllerListQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerList400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerListMyClaimsQueryKey = (params?: ClaimManagementControllerListMyClaimsQueryParams) => [{ url: '/claim-management/my-claims' }, ...(params ? [params] : [])] as const

export type ClaimManagementControllerListMyClaimsQueryKey = ReturnType<typeof claimManagementControllerListMyClaimsQueryKey>

export function claimManagementControllerListMyClaimsQueryOptions(params?: ClaimManagementControllerListMyClaimsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerListMyClaimsQueryKey(params)
        return queryOptions<ClaimManagementControllerListMyClaimsQueryResponse, ResponseErrorConfig<ClaimManagementControllerListMyClaims400>, ClaimManagementControllerListMyClaimsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerListMyClaims(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the caller's own claims (self-service)
 * {@link /claim-management/my-claims}
 */
export function useClaimManagementControllerListMyClaims<TData = ClaimManagementControllerListMyClaimsQueryResponse, TQueryData = ClaimManagementControllerListMyClaimsQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerListMyClaimsQueryKey>(params?: ClaimManagementControllerListMyClaimsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerListMyClaimsQueryResponse, ResponseErrorConfig<ClaimManagementControllerListMyClaims400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerListMyClaimsQueryKey(params)
         

         const query = useQuery({
          ...claimManagementControllerListMyClaimsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerListMyClaims400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerGetQueryKey = (id: ClaimManagementControllerGetPathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id', params: {id:id} }] as const

export type ClaimManagementControllerGetQueryKey = ReturnType<typeof claimManagementControllerGetQueryKey>

export function claimManagementControllerGetQueryOptions(id: ClaimManagementControllerGetPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerGetQueryKey(id)
        return queryOptions<ClaimManagementControllerGetQueryResponse, ResponseErrorConfig<ClaimManagementControllerGet400 | ClaimManagementControllerGet404>, ClaimManagementControllerGetQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerGet(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a claim by ID (the claimant for their own claim, or a claims manager for any)
 * {@link /claim-management/claims/:id}
 */
export function useClaimManagementControllerGet<TData = ClaimManagementControllerGetQueryResponse, TQueryData = ClaimManagementControllerGetQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerGetQueryKey>(id: ClaimManagementControllerGetPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerGetQueryResponse, ResponseErrorConfig<ClaimManagementControllerGet400 | ClaimManagementControllerGet404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerGetQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerGetQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerGet400 | ClaimManagementControllerGet404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerGetClaimsExportStatusQueryKey = (jobId: ClaimManagementControllerGetClaimsExportStatusPathParams["jobId"] | undefined) => [{ url: '/claim-management/claims/export/:jobId', params: {jobId:jobId} }] as const

export type ClaimManagementControllerGetClaimsExportStatusQueryKey = ReturnType<typeof claimManagementControllerGetClaimsExportStatusQueryKey>

export function claimManagementControllerGetClaimsExportStatusQueryOptions(jobId: ClaimManagementControllerGetClaimsExportStatusPathParams["jobId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerGetClaimsExportStatusQueryKey(jobId)
        return queryOptions<ClaimManagementControllerGetClaimsExportStatusQueryResponse, ResponseErrorConfig<ClaimManagementControllerGetClaimsExportStatus400>, ClaimManagementControllerGetClaimsExportStatusQueryResponse, typeof queryKey>({
         enabled: !!(jobId),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerGetClaimsExportStatus(jobId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description `downloadUrl` is present only once `status` is SUCCEEDED. Terminal states are SUCCEEDED, ERROR and CANCELLED.
 * @summary Poll a claims CSV export job (internal — claim managers only)
 * {@link /claim-management/claims/export/:jobId}
 */
export function useClaimManagementControllerGetClaimsExportStatus<TData = ClaimManagementControllerGetClaimsExportStatusQueryResponse, TQueryData = ClaimManagementControllerGetClaimsExportStatusQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerGetClaimsExportStatusQueryKey>(jobId: ClaimManagementControllerGetClaimsExportStatusPathParams["jobId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerGetClaimsExportStatusQueryResponse, ResponseErrorConfig<ClaimManagementControllerGetClaimsExportStatus400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerGetClaimsExportStatusQueryKey(jobId)
         

         const query = useQuery({
          ...claimManagementControllerGetClaimsExportStatusQueryOptions(jobId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerGetClaimsExportStatus400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerAvailableTransitionsQueryKey = (id: ClaimManagementControllerAvailableTransitionsPathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id/available-transitions', params: {id:id} }] as const

export type ClaimManagementControllerAvailableTransitionsQueryKey = ReturnType<typeof claimManagementControllerAvailableTransitionsQueryKey>

export function claimManagementControllerAvailableTransitionsQueryOptions(id: ClaimManagementControllerAvailableTransitionsPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerAvailableTransitionsQueryKey(id)
        return queryOptions<ClaimManagementControllerAvailableTransitionsQueryResponse, ResponseErrorConfig<ClaimManagementControllerAvailableTransitions400 | ClaimManagementControllerAvailableTransitions404>, ClaimManagementControllerAvailableTransitionsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerAvailableTransitions(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get valid next state-machine events from the current state
 * {@link /claim-management/claims/:id/available-transitions}
 */
export function useClaimManagementControllerAvailableTransitions<TData = ClaimManagementControllerAvailableTransitionsQueryResponse, TQueryData = ClaimManagementControllerAvailableTransitionsQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerAvailableTransitionsQueryKey>(id: ClaimManagementControllerAvailableTransitionsPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerAvailableTransitionsQueryResponse, ResponseErrorConfig<ClaimManagementControllerAvailableTransitions400 | ClaimManagementControllerAvailableTransitions404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerAvailableTransitionsQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerAvailableTransitionsQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerAvailableTransitions400 | ClaimManagementControllerAvailableTransitions404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerGetClaimExtractionsQueryKey = (id: ClaimManagementControllerGetClaimExtractionsPathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id/document-extractions', params: {id:id} }] as const

export type ClaimManagementControllerGetClaimExtractionsQueryKey = ReturnType<typeof claimManagementControllerGetClaimExtractionsQueryKey>

export function claimManagementControllerGetClaimExtractionsQueryOptions(id: ClaimManagementControllerGetClaimExtractionsPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerGetClaimExtractionsQueryKey(id)
        return queryOptions<ClaimManagementControllerGetClaimExtractionsQueryResponse, ResponseErrorConfig<ClaimManagementControllerGetClaimExtractions400 | ClaimManagementControllerGetClaimExtractions404>, ClaimManagementControllerGetClaimExtractionsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerGetClaimExtractions(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List AI document extractions for a claim (FNOL prefill candidates)
 * {@link /claim-management/claims/:id/document-extractions}
 */
export function useClaimManagementControllerGetClaimExtractions<TData = ClaimManagementControllerGetClaimExtractionsQueryResponse, TQueryData = ClaimManagementControllerGetClaimExtractionsQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerGetClaimExtractionsQueryKey>(id: ClaimManagementControllerGetClaimExtractionsPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerGetClaimExtractionsQueryResponse, ResponseErrorConfig<ClaimManagementControllerGetClaimExtractions400 | ClaimManagementControllerGetClaimExtractions404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerGetClaimExtractionsQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerGetClaimExtractionsQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerGetClaimExtractions400 | ClaimManagementControllerGetClaimExtractions404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerStatusHistoryQueryKey = (id: ClaimManagementControllerStatusHistoryPathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id/status-history', params: {id:id} }] as const

export type ClaimManagementControllerStatusHistoryQueryKey = ReturnType<typeof claimManagementControllerStatusHistoryQueryKey>

export function claimManagementControllerStatusHistoryQueryOptions(id: ClaimManagementControllerStatusHistoryPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerStatusHistoryQueryKey(id)
        return queryOptions<ClaimManagementControllerStatusHistoryQueryResponse, ResponseErrorConfig<ClaimManagementControllerStatusHistory400 | ClaimManagementControllerStatusHistory404>, ClaimManagementControllerStatusHistoryQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerStatusHistory(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a claim's status-change history (owner)
 * {@link /claim-management/claims/:id/status-history}
 */
export function useClaimManagementControllerStatusHistory<TData = ClaimManagementControllerStatusHistoryQueryResponse, TQueryData = ClaimManagementControllerStatusHistoryQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerStatusHistoryQueryKey>(id: ClaimManagementControllerStatusHistoryPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerStatusHistoryQueryResponse, ResponseErrorConfig<ClaimManagementControllerStatusHistory400 | ClaimManagementControllerStatusHistory404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerStatusHistoryQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerStatusHistoryQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerStatusHistory400 | ClaimManagementControllerStatusHistory404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerDocumentFraudScoresQueryKey = (id: ClaimManagementControllerDocumentFraudScoresPathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id/fraud-scores', params: {id:id} }] as const

export type ClaimManagementControllerDocumentFraudScoresQueryKey = ReturnType<typeof claimManagementControllerDocumentFraudScoresQueryKey>

export function claimManagementControllerDocumentFraudScoresQueryOptions(id: ClaimManagementControllerDocumentFraudScoresPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerDocumentFraudScoresQueryKey(id)
        return queryOptions<ClaimManagementControllerDocumentFraudScoresQueryResponse, ResponseErrorConfig<ClaimManagementControllerDocumentFraudScores400>, ClaimManagementControllerDocumentFraudScoresQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerDocumentFraudScores(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get per-document fraud scores for a claim (internal — claim managers only)
 * {@link /claim-management/claims/:id/fraud-scores}
 */
export function useClaimManagementControllerDocumentFraudScores<TData = ClaimManagementControllerDocumentFraudScoresQueryResponse, TQueryData = ClaimManagementControllerDocumentFraudScoresQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerDocumentFraudScoresQueryKey>(id: ClaimManagementControllerDocumentFraudScoresPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerDocumentFraudScoresQueryResponse, ResponseErrorConfig<ClaimManagementControllerDocumentFraudScores400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerDocumentFraudScoresQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerDocumentFraudScoresQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerDocumentFraudScores400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerFraudNarrativeQueryKey = (id: ClaimManagementControllerFraudNarrativePathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id/fraud-narrative', params: {id:id} }] as const

export type ClaimManagementControllerFraudNarrativeQueryKey = ReturnType<typeof claimManagementControllerFraudNarrativeQueryKey>

export function claimManagementControllerFraudNarrativeQueryOptions(id: ClaimManagementControllerFraudNarrativePathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerFraudNarrativeQueryKey(id)
        return queryOptions<ClaimManagementControllerFraudNarrativeQueryResponse, ResponseErrorConfig<ClaimManagementControllerFraudNarrative400>, ClaimManagementControllerFraudNarrativeQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerFraudNarrative(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Short AI-generated summary of the per-document fraud findings. Lazily generated and cached server-side; the first call after a verdict change may take a few seconds. `narrative` is null when the claim has no verdicts yet or generation is unavailable.
 * @summary Get the AI-generated claim fraud narrative (internal — claim managers only)
 * {@link /claim-management/claims/:id/fraud-narrative}
 */
export function useClaimManagementControllerFraudNarrative<TData = ClaimManagementControllerFraudNarrativeQueryResponse, TQueryData = ClaimManagementControllerFraudNarrativeQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerFraudNarrativeQueryKey>(id: ClaimManagementControllerFraudNarrativePathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerFraudNarrativeQueryResponse, ResponseErrorConfig<ClaimManagementControllerFraudNarrative400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerFraudNarrativeQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerFraudNarrativeQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerFraudNarrative400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimManagementControllerTimelineQueryKey = (id: ClaimManagementControllerTimelinePathParams["id"] | undefined) => [{ url: '/claim-management/claims/:id/timeline', params: {id:id} }] as const

export type ClaimManagementControllerTimelineQueryKey = ReturnType<typeof claimManagementControllerTimelineQueryKey>

export function claimManagementControllerTimelineQueryOptions(id: ClaimManagementControllerTimelinePathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimManagementControllerTimelineQueryKey(id)
        return queryOptions<ClaimManagementControllerTimelineQueryResponse, ResponseErrorConfig<ClaimManagementControllerTimeline400 | ClaimManagementControllerTimeline404>, ClaimManagementControllerTimelineQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimManagementControllerTimeline(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get claim event timeline (internal — claim managers only)
 * {@link /claim-management/claims/:id/timeline}
 */
export function useClaimManagementControllerTimeline<TData = ClaimManagementControllerTimelineQueryResponse, TQueryData = ClaimManagementControllerTimelineQueryResponse, TQueryKey extends QueryKey = ClaimManagementControllerTimelineQueryKey>(id: ClaimManagementControllerTimelinePathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimManagementControllerTimelineQueryResponse, ResponseErrorConfig<ClaimManagementControllerTimeline400 | ClaimManagementControllerTimeline404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimManagementControllerTimelineQueryKey(id)
         

         const query = useQuery({
          ...claimManagementControllerTimelineQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimManagementControllerTimeline400 | ClaimManagementControllerTimeline404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimsControllerListQueryKey = (params: ClaimsControllerListQueryParams) => [{ url: '/claims' }, ...(params ? [params] : [])] as const

export type ClaimsControllerListQueryKey = ReturnType<typeof claimsControllerListQueryKey>

export function claimsControllerListQueryOptions(params: ClaimsControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimsControllerListQueryKey(params)
        return queryOptions<ClaimsControllerListQueryResponse, ResponseErrorConfig<ClaimsControllerList400>, ClaimsControllerListQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return claimsControllerList(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List claims
 * {@link /claims}
 */
export function useClaimsControllerList<TData = ClaimsControllerListQueryResponse, TQueryData = ClaimsControllerListQueryResponse, TQueryKey extends QueryKey = ClaimsControllerListQueryKey>(params: ClaimsControllerListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ClaimsControllerListQueryResponse, ResponseErrorConfig<ClaimsControllerList400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimsControllerListQueryKey(params)
         

         const query = useQuery({
          ...claimsControllerListQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimsControllerList400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimsControllerGetQueryKey = (id: ClaimsControllerGetPathParams["id"] | undefined) => [{ url: '/claims/:id', params: {id:id} }] as const

export type ClaimsControllerGetQueryKey = ReturnType<typeof claimsControllerGetQueryKey>

export function claimsControllerGetQueryOptions(id: ClaimsControllerGetPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimsControllerGetQueryKey(id)
        return queryOptions<ClaimsControllerGetQueryResponse, ResponseErrorConfig<ClaimsControllerGet400 | ClaimsControllerGet404>, ClaimsControllerGetQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimsControllerGet(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get claim
 * {@link /claims/:id}
 */
export function useClaimsControllerGet<TData = ClaimsControllerGetQueryResponse, TQueryData = ClaimsControllerGetQueryResponse, TQueryKey extends QueryKey = ClaimsControllerGetQueryKey>(id: ClaimsControllerGetPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimsControllerGetQueryResponse, ResponseErrorConfig<ClaimsControllerGet400 | ClaimsControllerGet404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimsControllerGetQueryKey(id)
         

         const query = useQuery({
          ...claimsControllerGetQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimsControllerGet400 | ClaimsControllerGet404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerListTenantsQueryKey = () => [{ url: '/admin/tenants' }] as const

export type ConfigControllerListTenantsQueryKey = ReturnType<typeof configControllerListTenantsQueryKey>

export function configControllerListTenantsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerListTenantsQueryKey()
        return queryOptions<ConfigControllerListTenantsQueryResponse, ResponseErrorConfig<Error>, ConfigControllerListTenantsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerListTenants({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Admin only: list every configured tenant id
 * {@link /admin/tenants}
 */
export function useConfigControllerListTenants<TData = ConfigControllerListTenantsQueryResponse, TQueryData = ConfigControllerListTenantsQueryResponse, TQueryKey extends QueryKey = ConfigControllerListTenantsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerListTenantsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerListTenantsQueryKey()
         

         const query = useQuery({
          ...configControllerListTenantsQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetTenantConfigQueryKey = () => [{ url: '/admin/config' }] as const

export type ConfigControllerGetTenantConfigQueryKey = ReturnType<typeof configControllerGetTenantConfigQueryKey>

export function configControllerGetTenantConfigQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetTenantConfigQueryKey()
        return queryOptions<ConfigControllerGetTenantConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetTenantConfig400>, ConfigControllerGetTenantConfigQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetTenantConfig({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Admin only: Get tenant config
 * {@link /admin/config}
 */
export function useConfigControllerGetTenantConfig<TData = ConfigControllerGetTenantConfigQueryResponse, TQueryData = ConfigControllerGetTenantConfigQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetTenantConfigQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetTenantConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetTenantConfig400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetTenantConfigQueryKey()
         

         const query = useQuery({
          ...configControllerGetTenantConfigQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetTenantConfig400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetProductConfigQueryKey = (productId: ConfigControllerGetProductConfigPathParams["productId"] | undefined) => [{ url: '/admin/config/:productId', params: {productId:productId} }] as const

export type ConfigControllerGetProductConfigQueryKey = ReturnType<typeof configControllerGetProductConfigQueryKey>

export function configControllerGetProductConfigQueryOptions(productId: ConfigControllerGetProductConfigPathParams["productId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetProductConfigQueryKey(productId)
        return queryOptions<ConfigControllerGetProductConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetProductConfig400>, ConfigControllerGetProductConfigQueryResponse, typeof queryKey>({
         enabled: !!(productId),
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetProductConfig(productId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Admin only: Get product config
 * {@link /admin/config/:productId}
 */
export function useConfigControllerGetProductConfig<TData = ConfigControllerGetProductConfigQueryResponse, TQueryData = ConfigControllerGetProductConfigQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetProductConfigQueryKey>(productId: ConfigControllerGetProductConfigPathParams["productId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetProductConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetProductConfig400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetProductConfigQueryKey(productId)
         

         const query = useQuery({
          ...configControllerGetProductConfigQueryOptions(productId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetProductConfig400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetPublicTenantConfigByDomainQueryKey = (params: ConfigControllerGetPublicTenantConfigByDomainQueryParams) => [{ url: '/config/by-domain' }, ...(params ? [params] : [])] as const

export type ConfigControllerGetPublicTenantConfigByDomainQueryKey = ReturnType<typeof configControllerGetPublicTenantConfigByDomainQueryKey>

export function configControllerGetPublicTenantConfigByDomainQueryOptions(params: ConfigControllerGetPublicTenantConfigByDomainQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetPublicTenantConfigByDomainQueryKey(params)
        return queryOptions<ConfigControllerGetPublicTenantConfigByDomainQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicTenantConfigByDomain400>, ConfigControllerGetPublicTenantConfigByDomainQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetPublicTenantConfigByDomain(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Matches a bare domain (no scheme, path or port) case-insensitively. Only domains explicitly registered against a tenant resolve, which is a small set used by white-label frontends — any other domain returns INVALID_TENANT, including one that looks like a Korint hostname.
 * @summary Get a tenant's public config by domain
 * {@link /config/by-domain}
 */
export function useConfigControllerGetPublicTenantConfigByDomain<TData = ConfigControllerGetPublicTenantConfigByDomainQueryResponse, TQueryData = ConfigControllerGetPublicTenantConfigByDomainQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetPublicTenantConfigByDomainQueryKey>(params: ConfigControllerGetPublicTenantConfigByDomainQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetPublicTenantConfigByDomainQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicTenantConfigByDomain400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetPublicTenantConfigByDomainQueryKey(params)
         

         const query = useQuery({
          ...configControllerGetPublicTenantConfigByDomainQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetPublicTenantConfigByDomain400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetPublicProductConfigQueryKey = (productId: ConfigControllerGetPublicProductConfigPathParams["productId"] | undefined) => [{ url: '/config/:productId', params: {productId:productId} }] as const

export type ConfigControllerGetPublicProductConfigQueryKey = ReturnType<typeof configControllerGetPublicProductConfigQueryKey>

export function configControllerGetPublicProductConfigQueryOptions(productId: ConfigControllerGetPublicProductConfigPathParams["productId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetPublicProductConfigQueryKey(productId)
        return queryOptions<ConfigControllerGetPublicProductConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicProductConfig400>, ConfigControllerGetPublicProductConfigQueryResponse, typeof queryKey>({
         enabled: !!(productId),
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetPublicProductConfig(productId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Read this at runtime before every journey — products gain fields, and a transcribed list silently stops matching. Fields from the `*AggregateFields` lists are top-level properties of their entity; the rest go in its `customFields` array.
 * @summary Get public product config
 * {@link /config/:productId}
 */
export function useConfigControllerGetPublicProductConfig<TData = ConfigControllerGetPublicProductConfigQueryResponse, TQueryData = ConfigControllerGetPublicProductConfigQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetPublicProductConfigQueryKey>(productId: ConfigControllerGetPublicProductConfigPathParams["productId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetPublicProductConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicProductConfig400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetPublicProductConfigQueryKey(productId)
         

         const query = useQuery({
          ...configControllerGetPublicProductConfigQueryOptions(productId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetPublicProductConfig400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetPublicTenantConfigQueryKey = () => [{ url: '/config' }] as const

export type ConfigControllerGetPublicTenantConfigQueryKey = ReturnType<typeof configControllerGetPublicTenantConfigQueryKey>

export function configControllerGetPublicTenantConfigQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetPublicTenantConfigQueryKey()
        return queryOptions<ConfigControllerGetPublicTenantConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicTenantConfig400>, ConfigControllerGetPublicTenantConfigQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetPublicTenantConfig({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Carries `availableProductIds`; fetch each product's own configuration separately. Needs no credentials.
 * @summary Get public tenant config
 * {@link /config}
 */
export function useConfigControllerGetPublicTenantConfig<TData = ConfigControllerGetPublicTenantConfigQueryResponse, TQueryData = ConfigControllerGetPublicTenantConfigQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetPublicTenantConfigQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetPublicTenantConfigQueryResponse, ResponseErrorConfig<ConfigControllerGetPublicTenantConfig400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetPublicTenantConfigQueryKey()
         

         const query = useQuery({
          ...configControllerGetPublicTenantConfigQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetPublicTenantConfig400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetProductsForTenantQueryKey = () => [{ url: '/products' }] as const

export type ConfigControllerGetProductsForTenantQueryKey = ReturnType<typeof configControllerGetProductsForTenantQueryKey>

export function configControllerGetProductsForTenantQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetProductsForTenantQueryKey()
        return queryOptions<ConfigControllerGetProductsForTenantQueryResponse, ResponseErrorConfig<ConfigControllerGetProductsForTenant400>, ConfigControllerGetProductsForTenantQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetProductsForTenant({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Admin only: Get products for a given tenant
 * {@link /products}
 */
export function useConfigControllerGetProductsForTenant<TData = ConfigControllerGetProductsForTenantQueryResponse, TQueryData = ConfigControllerGetProductsForTenantQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetProductsForTenantQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetProductsForTenantQueryResponse, ResponseErrorConfig<ConfigControllerGetProductsForTenant400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetProductsForTenantQueryKey()
         

         const query = useQuery({
          ...configControllerGetProductsForTenantQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetProductsForTenant400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const configControllerGetBusinessRolePermissionsQueryKey = (params: ConfigControllerGetBusinessRolePermissionsQueryParams) => [{ url: '/business-role-permissions' }, ...(params ? [params] : [])] as const

export type ConfigControllerGetBusinessRolePermissionsQueryKey = ReturnType<typeof configControllerGetBusinessRolePermissionsQueryKey>

export function configControllerGetBusinessRolePermissionsQueryOptions(params: ConfigControllerGetBusinessRolePermissionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = configControllerGetBusinessRolePermissionsQueryKey(params)
        return queryOptions<ConfigControllerGetBusinessRolePermissionsQueryResponse, ResponseErrorConfig<ConfigControllerGetBusinessRolePermissions400>, ConfigControllerGetBusinessRolePermissionsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return configControllerGetBusinessRolePermissions(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the permissions granted by a business role
 * {@link /business-role-permissions}
 */
export function useConfigControllerGetBusinessRolePermissions<TData = ConfigControllerGetBusinessRolePermissionsQueryResponse, TQueryData = ConfigControllerGetBusinessRolePermissionsQueryResponse, TQueryKey extends QueryKey = ConfigControllerGetBusinessRolePermissionsQueryKey>(params: ConfigControllerGetBusinessRolePermissionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ConfigControllerGetBusinessRolePermissionsQueryResponse, ResponseErrorConfig<ConfigControllerGetBusinessRolePermissions400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? configControllerGetBusinessRolePermissionsQueryKey(params)
         

         const query = useQuery({
          ...configControllerGetBusinessRolePermissionsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConfigControllerGetBusinessRolePermissions400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const featureFlagControllerAtMeQueryKey = (params: FeatureFlagControllerAtMeQueryParams) => [{ url: '/feature-flags/@me' }, ...(params ? [params] : [])] as const

export type FeatureFlagControllerAtMeQueryKey = ReturnType<typeof featureFlagControllerAtMeQueryKey>

export function featureFlagControllerAtMeQueryOptions(params: FeatureFlagControllerAtMeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = featureFlagControllerAtMeQueryKey(params)
        return queryOptions<FeatureFlagControllerAtMeQueryResponse, ResponseErrorConfig<Error>, FeatureFlagControllerAtMeQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return featureFlagControllerAtMe(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get evaluated feature flags for the current user and tenant
 * {@link /feature-flags/@me}
 */
export function useFeatureFlagControllerAtMe<TData = FeatureFlagControllerAtMeQueryResponse, TQueryData = FeatureFlagControllerAtMeQueryResponse, TQueryKey extends QueryKey = FeatureFlagControllerAtMeQueryKey>(params: FeatureFlagControllerAtMeQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<FeatureFlagControllerAtMeQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? featureFlagControllerAtMeQueryKey(params)
         

         const query = useQuery({
          ...featureFlagControllerAtMeQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const featureFlagControllerFindAllQueryKey = () => [{ url: '/feature-flags' }] as const

export type FeatureFlagControllerFindAllQueryKey = ReturnType<typeof featureFlagControllerFindAllQueryKey>

export function featureFlagControllerFindAllQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = featureFlagControllerFindAllQueryKey()
        return queryOptions<FeatureFlagControllerFindAllQueryResponse, ResponseErrorConfig<Error>, FeatureFlagControllerFindAllQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return featureFlagControllerFindAll({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List all feature flags with their state
 * {@link /feature-flags}
 */
export function useFeatureFlagControllerFindAll<TData = FeatureFlagControllerFindAllQueryResponse, TQueryData = FeatureFlagControllerFindAllQueryResponse, TQueryKey extends QueryKey = FeatureFlagControllerFindAllQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<FeatureFlagControllerFindAllQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? featureFlagControllerFindAllQueryKey()
         

         const query = useQuery({
          ...featureFlagControllerFindAllQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetCustomerQueryKey = (customerId: CustomerControllerGetCustomerPathParams["customerId"] | undefined, params?: CustomerControllerGetCustomerQueryParams) => [{ url: '/customers/:customerId', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type CustomerControllerGetCustomerQueryKey = ReturnType<typeof customerControllerGetCustomerQueryKey>

export function customerControllerGetCustomerQueryOptions(customerId: CustomerControllerGetCustomerPathParams["customerId"] | undefined, params?: CustomerControllerGetCustomerQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetCustomerQueryKey(customerId, params)
        return queryOptions<CustomerControllerGetCustomerQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomer404>, CustomerControllerGetCustomerQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetCustomer(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Read the customer back after any step that enriches it — a registry lookup or a document extraction — rather than trusting your local copy.
 * @summary Get Customer
 * {@link /customers/:customerId}
 */
export function useCustomerControllerGetCustomer<TData = CustomerControllerGetCustomerQueryResponse, TQueryData = CustomerControllerGetCustomerQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetCustomerQueryKey>(customerId: CustomerControllerGetCustomerPathParams["customerId"] | undefined, params?: CustomerControllerGetCustomerQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetCustomerQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomer404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetCustomerQueryKey(customerId, params)
         

         const query = useQuery({
          ...customerControllerGetCustomerQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerControllerGetCustomer404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetCustomerPaymentMethodsQueryKey = (customerId: CustomerControllerGetCustomerPaymentMethodsPathParams["customerId"] | undefined, params?: CustomerControllerGetCustomerPaymentMethodsQueryParams) => [{ url: '/customers/:customerId/payment-methods', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type CustomerControllerGetCustomerPaymentMethodsQueryKey = ReturnType<typeof customerControllerGetCustomerPaymentMethodsQueryKey>

export function customerControllerGetCustomerPaymentMethodsQueryOptions(customerId: CustomerControllerGetCustomerPaymentMethodsPathParams["customerId"] | undefined, params?: CustomerControllerGetCustomerPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetCustomerPaymentMethodsQueryKey(customerId, params)
        return queryOptions<CustomerControllerGetCustomerPaymentMethodsQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomerPaymentMethods404>, CustomerControllerGetCustomerPaymentMethodsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetCustomerPaymentMethods(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description `WAITING_MANDATE_SIGNATURE` is accepted for new business, which is what lets a customer sign the contract and the SEPA mandate in one session.
 * @summary Get Customer Payment Methods
 * {@link /customers/:customerId/payment-methods}
 */
export function useCustomerControllerGetCustomerPaymentMethods<TData = CustomerControllerGetCustomerPaymentMethodsQueryResponse, TQueryData = CustomerControllerGetCustomerPaymentMethodsQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetCustomerPaymentMethodsQueryKey>(customerId: CustomerControllerGetCustomerPaymentMethodsPathParams["customerId"] | undefined, params?: CustomerControllerGetCustomerPaymentMethodsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetCustomerPaymentMethodsQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomerPaymentMethods404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetCustomerPaymentMethodsQueryKey(customerId, params)
         

         const query = useQuery({
          ...customerControllerGetCustomerPaymentMethodsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerControllerGetCustomerPaymentMethods404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetPaymentMethodSetupSecretQueryKey = (customerId: CustomerControllerGetPaymentMethodSetupSecretPathParams["customerId"] | undefined, params?: CustomerControllerGetPaymentMethodSetupSecretQueryParams) => [{ url: '/customers/:customerId/payment-methods/secret', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type CustomerControllerGetPaymentMethodSetupSecretQueryKey = ReturnType<typeof customerControllerGetPaymentMethodSetupSecretQueryKey>

export function customerControllerGetPaymentMethodSetupSecretQueryOptions(customerId: CustomerControllerGetPaymentMethodSetupSecretPathParams["customerId"] | undefined, params?: CustomerControllerGetPaymentMethodSetupSecretQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetPaymentMethodSetupSecretQueryKey(customerId, params)
        return queryOptions<CustomerControllerGetPaymentMethodSetupSecretQueryResponse, ResponseErrorConfig<CustomerControllerGetPaymentMethodSetupSecret400 | CustomerControllerGetPaymentMethodSetupSecret404 | CustomerControllerGetPaymentMethodSetupSecret409>, CustomerControllerGetPaymentMethodSetupSecretQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetPaymentMethodSetupSecret(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Quote the policy first: the payment-side customer is created by quoting, so asking earlier returns `PAYMENT_CUSTOMER_NOT_FOUND`. Needs `DIRECT_DEBIT` in the product's `allowedPaymentModes`, or it refuses with `CONFLICTING_CONFIG`. Initialise Stripe.js with the publishable key of Korint's Stripe account for your tenant and environment — ask your Korint contact; a key from another account fails in the browser as `No such setupintent`, which reads as a bad secret but is not.
 * @summary Get Payment Method Setup Secret
 * {@link /customers/:customerId/payment-methods/secret}
 */
export function useCustomerControllerGetPaymentMethodSetupSecret<TData = CustomerControllerGetPaymentMethodSetupSecretQueryResponse, TQueryData = CustomerControllerGetPaymentMethodSetupSecretQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetPaymentMethodSetupSecretQueryKey>(customerId: CustomerControllerGetPaymentMethodSetupSecretPathParams["customerId"] | undefined, params?: CustomerControllerGetPaymentMethodSetupSecretQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetPaymentMethodSetupSecretQueryResponse, ResponseErrorConfig<CustomerControllerGetPaymentMethodSetupSecret400 | CustomerControllerGetPaymentMethodSetupSecret404 | CustomerControllerGetPaymentMethodSetupSecret409>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetPaymentMethodSetupSecretQueryKey(customerId, params)
         

         const query = useQuery({
          ...customerControllerGetPaymentMethodSetupSecretQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerControllerGetPaymentMethodSetupSecret400 | CustomerControllerGetPaymentMethodSetupSecret404 | CustomerControllerGetPaymentMethodSetupSecret409>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerListCustomersQueryKey = (params?: CustomerControllerListCustomersQueryParams) => [{ url: '/customers' }, ...(params ? [params] : [])] as const

export type CustomerControllerListCustomersQueryKey = ReturnType<typeof customerControllerListCustomersQueryKey>

export function customerControllerListCustomersQueryOptions(params?: CustomerControllerListCustomersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerListCustomersQueryKey(params)
        return queryOptions<CustomerControllerListCustomersQueryResponse, ResponseErrorConfig<Error>, CustomerControllerListCustomersQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerListCustomers(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Use it to find an existing policyholder before initialising a new one, so a returning customer is not duplicated.
 * @summary List Customers
 * {@link /customers}
 */
export function useCustomerControllerListCustomers<TData = CustomerControllerListCustomersQueryResponse, TQueryData = CustomerControllerListCustomersQueryResponse, TQueryKey extends QueryKey = CustomerControllerListCustomersQueryKey>(params?: CustomerControllerListCustomersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerListCustomersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerListCustomersQueryKey(params)
         

         const query = useQuery({
          ...customerControllerListCustomersQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetInvoicingScheduleQueryKey = (customerId: CustomerControllerGetInvoicingSchedulePathParams["customerId"] | undefined, params?: CustomerControllerGetInvoicingScheduleQueryParams) => [{ url: '/customers/:customerId/invoicing-schedule', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type CustomerControllerGetInvoicingScheduleQueryKey = ReturnType<typeof customerControllerGetInvoicingScheduleQueryKey>

export function customerControllerGetInvoicingScheduleQueryOptions(customerId: CustomerControllerGetInvoicingSchedulePathParams["customerId"] | undefined, params?: CustomerControllerGetInvoicingScheduleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetInvoicingScheduleQueryKey(customerId, params)
        return queryOptions<CustomerControllerGetInvoicingScheduleQueryResponse, ResponseErrorConfig<CustomerControllerGetInvoicingSchedule400 | CustomerControllerGetInvoicingSchedule404>, CustomerControllerGetInvoicingScheduleQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetInvoicingSchedule(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get invoicing schedule
 * {@link /customers/:customerId/invoicing-schedule}
 */
export function useCustomerControllerGetInvoicingSchedule<TData = CustomerControllerGetInvoicingScheduleQueryResponse, TQueryData = CustomerControllerGetInvoicingScheduleQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetInvoicingScheduleQueryKey>(customerId: CustomerControllerGetInvoicingSchedulePathParams["customerId"] | undefined, params?: CustomerControllerGetInvoicingScheduleQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetInvoicingScheduleQueryResponse, ResponseErrorConfig<CustomerControllerGetInvoicingSchedule400 | CustomerControllerGetInvoicingSchedule404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetInvoicingScheduleQueryKey(customerId, params)
         

         const query = useQuery({
          ...customerControllerGetInvoicingScheduleQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerControllerGetInvoicingSchedule400 | CustomerControllerGetInvoicingSchedule404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetBankTransferAccountQueryKey = (customerId: CustomerControllerGetBankTransferAccountPathParams["customerId"] | undefined) => [{ url: '/customers/:customerId/bank-transfer-account', params: {customerId:customerId} }] as const

export type CustomerControllerGetBankTransferAccountQueryKey = ReturnType<typeof customerControllerGetBankTransferAccountQueryKey>

export function customerControllerGetBankTransferAccountQueryOptions(customerId: CustomerControllerGetBankTransferAccountPathParams["customerId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetBankTransferAccountQueryKey(customerId)
        return queryOptions<CustomerControllerGetBankTransferAccountQueryResponse, ResponseErrorConfig<CustomerControllerGetBankTransferAccount400 | CustomerControllerGetBankTransferAccount404 | CustomerControllerGetBankTransferAccount409>, CustomerControllerGetBankTransferAccountQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetBankTransferAccount(customerId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get bank transfer account
 * {@link /customers/:customerId/bank-transfer-account}
 */
export function useCustomerControllerGetBankTransferAccount<TData = CustomerControllerGetBankTransferAccountQueryResponse, TQueryData = CustomerControllerGetBankTransferAccountQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetBankTransferAccountQueryKey>(customerId: CustomerControllerGetBankTransferAccountPathParams["customerId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetBankTransferAccountQueryResponse, ResponseErrorConfig<CustomerControllerGetBankTransferAccount400 | CustomerControllerGetBankTransferAccount404 | CustomerControllerGetBankTransferAccount409>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetBankTransferAccountQueryKey(customerId)
         

         const query = useQuery({
          ...customerControllerGetBankTransferAccountQueryOptions(customerId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerControllerGetBankTransferAccount400 | CustomerControllerGetBankTransferAccount404 | CustomerControllerGetBankTransferAccount409>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetCustomerBalanceQueryKey = (customerId: CustomerControllerGetCustomerBalancePathParams["customerId"] | undefined) => [{ url: '/customers/:customerId/balance', params: {customerId:customerId} }] as const

export type CustomerControllerGetCustomerBalanceQueryKey = ReturnType<typeof customerControllerGetCustomerBalanceQueryKey>

export function customerControllerGetCustomerBalanceQueryOptions(customerId: CustomerControllerGetCustomerBalancePathParams["customerId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetCustomerBalanceQueryKey(customerId)
        return queryOptions<CustomerControllerGetCustomerBalanceQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomerBalance404>, CustomerControllerGetCustomerBalanceQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetCustomerBalance(customerId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get Customer Balance
 * {@link /customers/:customerId/balance}
 */
export function useCustomerControllerGetCustomerBalance<TData = CustomerControllerGetCustomerBalanceQueryResponse, TQueryData = CustomerControllerGetCustomerBalanceQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetCustomerBalanceQueryKey>(customerId: CustomerControllerGetCustomerBalancePathParams["customerId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetCustomerBalanceQueryResponse, ResponseErrorConfig<CustomerControllerGetCustomerBalance404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetCustomerBalanceQueryKey(customerId)
         

         const query = useQuery({
          ...customerControllerGetCustomerBalanceQueryOptions(customerId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerControllerGetCustomerBalance404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerControllerGetMigratedBillingTakeoverQueryKey = (customerId: CustomerControllerGetMigratedBillingTakeoverPathParams["customerId"] | undefined) => [{ url: '/customers/:customerId/migrated-billing-takeover', params: {customerId:customerId} }] as const

export type CustomerControllerGetMigratedBillingTakeoverQueryKey = ReturnType<typeof customerControllerGetMigratedBillingTakeoverQueryKey>

export function customerControllerGetMigratedBillingTakeoverQueryOptions(customerId: CustomerControllerGetMigratedBillingTakeoverPathParams["customerId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerControllerGetMigratedBillingTakeoverQueryKey(customerId)
        return queryOptions<CustomerControllerGetMigratedBillingTakeoverQueryResponse, ResponseErrorConfig<Error>, CustomerControllerGetMigratedBillingTakeoverQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerControllerGetMigratedBillingTakeover(customerId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description One entry per policy the customer pays for. `migrated` tells a customer that was never imported apart from one whose rows are missing.
 * @summary Get the migrated billing takeover dates of a customer
 * {@link /customers/:customerId/migrated-billing-takeover}
 */
export function useCustomerControllerGetMigratedBillingTakeover<TData = CustomerControllerGetMigratedBillingTakeoverQueryResponse, TQueryData = CustomerControllerGetMigratedBillingTakeoverQueryResponse, TQueryKey extends QueryKey = CustomerControllerGetMigratedBillingTakeoverQueryKey>(customerId: CustomerControllerGetMigratedBillingTakeoverPathParams["customerId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<CustomerControllerGetMigratedBillingTakeoverQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerControllerGetMigratedBillingTakeoverQueryKey(customerId)
         

         const query = useQuery({
          ...customerControllerGetMigratedBillingTakeoverQueryOptions(customerId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const debugControllerGetProjectionsQueryKey = (projectionTable: DebugControllerGetProjectionsPathParams["projectionTable"] | undefined, params: DebugControllerGetProjectionsQueryParams) => [{ url: '/debug/projections/:projectionTable', params: {projectionTable:projectionTable} }, ...(params ? [params] : [])] as const

export type DebugControllerGetProjectionsQueryKey = ReturnType<typeof debugControllerGetProjectionsQueryKey>

export function debugControllerGetProjectionsQueryOptions(projectionTable: DebugControllerGetProjectionsPathParams["projectionTable"] | undefined, params: DebugControllerGetProjectionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = debugControllerGetProjectionsQueryKey(projectionTable, params)
        return queryOptions<DebugControllerGetProjectionsQueryResponse, ResponseErrorConfig<Error>, DebugControllerGetProjectionsQueryResponse, typeof queryKey>({
         enabled: !!(projectionTable),
         queryKey,
         queryFn: async ({ signal }) => {
            return debugControllerGetProjections(projectionTable!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /debug/projections/:projectionTable}
 */
export function useDebugControllerGetProjections<TData = DebugControllerGetProjectionsQueryResponse, TQueryData = DebugControllerGetProjectionsQueryResponse, TQueryKey extends QueryKey = DebugControllerGetProjectionsQueryKey>(projectionTable: DebugControllerGetProjectionsPathParams["projectionTable"] | undefined, params: DebugControllerGetProjectionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DebugControllerGetProjectionsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? debugControllerGetProjectionsQueryKey(projectionTable, params)
         

         const query = useQuery({
          ...debugControllerGetProjectionsQueryOptions(projectionTable, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const debugControllerCountCoreEventsQueryKey = (aggregateId: DebugControllerCountCoreEventsPathParams["aggregateId"] | undefined, params?: DebugControllerCountCoreEventsQueryParams) => [{ url: '/debug/core/:aggregateId/events/count', params: {aggregateId:aggregateId} }, ...(params ? [params] : [])] as const

export type DebugControllerCountCoreEventsQueryKey = ReturnType<typeof debugControllerCountCoreEventsQueryKey>

export function debugControllerCountCoreEventsQueryOptions(aggregateId: DebugControllerCountCoreEventsPathParams["aggregateId"] | undefined, params?: DebugControllerCountCoreEventsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = debugControllerCountCoreEventsQueryKey(aggregateId, params)
        return queryOptions<DebugControllerCountCoreEventsQueryResponse, ResponseErrorConfig<Error>, DebugControllerCountCoreEventsQueryResponse, typeof queryKey>({
         enabled: !!(aggregateId),
         queryKey,
         queryFn: async ({ signal }) => {
            return debugControllerCountCoreEvents(aggregateId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /debug/core/:aggregateId/events/count}
 */
export function useDebugControllerCountCoreEvents<TData = DebugControllerCountCoreEventsQueryResponse, TQueryData = DebugControllerCountCoreEventsQueryResponse, TQueryKey extends QueryKey = DebugControllerCountCoreEventsQueryKey>(aggregateId: DebugControllerCountCoreEventsPathParams["aggregateId"] | undefined, params?: DebugControllerCountCoreEventsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DebugControllerCountCoreEventsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? debugControllerCountCoreEventsQueryKey(aggregateId, params)
         

         const query = useQuery({
          ...debugControllerCountCoreEventsQueryOptions(aggregateId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentsControllerValidateAndProcessDocumentQueryKey = (params: DocumentsControllerValidateAndProcessDocumentQueryParams) => [{ url: '/documents/validate' }, ...(params ? [params] : [])] as const

export type DocumentsControllerValidateAndProcessDocumentQueryKey = ReturnType<typeof documentsControllerValidateAndProcessDocumentQueryKey>

export function documentsControllerValidateAndProcessDocumentQueryOptions(params: DocumentsControllerValidateAndProcessDocumentQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentsControllerValidateAndProcessDocumentQueryKey(params)
        return queryOptions<DocumentsControllerValidateAndProcessDocumentQueryResponse, ResponseErrorConfig<Error>, DocumentsControllerValidateAndProcessDocumentQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return documentsControllerValidateAndProcessDocument(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Validates a document upload, waits for malware scan, classifies with AI, and extracts data. Streams progress updates via Server-Sent Events.
 * @summary Validate, scan, classify, and extract document (SSE)
 * {@link /documents/validate}
 */
export function useDocumentsControllerValidateAndProcessDocument<TData = DocumentsControllerValidateAndProcessDocumentQueryResponse, TQueryData = DocumentsControllerValidateAndProcessDocumentQueryResponse, TQueryKey extends QueryKey = DocumentsControllerValidateAndProcessDocumentQueryKey>(params: DocumentsControllerValidateAndProcessDocumentQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DocumentsControllerValidateAndProcessDocumentQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentsControllerValidateAndProcessDocumentQueryKey(params)
         

         const query = useQuery({
          ...documentsControllerValidateAndProcessDocumentQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentsControllerGetDocumentsQueryKey = (params: DocumentsControllerGetDocumentsQueryParams) => [{ url: '/documents' }, ...(params ? [params] : [])] as const

export type DocumentsControllerGetDocumentsQueryKey = ReturnType<typeof documentsControllerGetDocumentsQueryKey>

export function documentsControllerGetDocumentsQueryOptions(params: DocumentsControllerGetDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentsControllerGetDocumentsQueryKey(params)
        return queryOptions<DocumentsControllerGetDocumentsQueryResponse, ResponseErrorConfig<Error>, DocumentsControllerGetDocumentsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return documentsControllerGetDocuments(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get documents by ID with a signed URL
 * {@link /documents}
 */
export function useDocumentsControllerGetDocuments<TData = DocumentsControllerGetDocumentsQueryResponse, TQueryData = DocumentsControllerGetDocumentsQueryResponse, TQueryKey extends QueryKey = DocumentsControllerGetDocumentsQueryKey>(params: DocumentsControllerGetDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DocumentsControllerGetDocumentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentsControllerGetDocumentsQueryKey(params)
         

         const query = useQuery({
          ...documentsControllerGetDocumentsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const healthControllerIndexQueryKey = () => [{ url: '/health' }] as const

export type HealthControllerIndexQueryKey = ReturnType<typeof healthControllerIndexQueryKey>

export function healthControllerIndexQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = healthControllerIndexQueryKey()
        return queryOptions<HealthControllerIndexQueryResponse, ResponseErrorConfig<Error>, HealthControllerIndexQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return healthControllerIndex({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /health}
 */
export function useHealthControllerIndex<TData = HealthControllerIndexQueryResponse, TQueryData = HealthControllerIndexQueryResponse, TQueryKey extends QueryKey = HealthControllerIndexQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<HealthControllerIndexQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? healthControllerIndexQueryKey()
         

         const query = useQuery({
          ...healthControllerIndexQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const healthControllerCheckQueryKey = (service: HealthControllerCheckPathParams["service"] | undefined) => [{ url: '/health/:service', params: {service:service} }] as const

export type HealthControllerCheckQueryKey = ReturnType<typeof healthControllerCheckQueryKey>

export function healthControllerCheckQueryOptions(service: HealthControllerCheckPathParams["service"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = healthControllerCheckQueryKey(service)
        return queryOptions<HealthControllerCheckQueryResponse, ResponseErrorConfig<Error>, HealthControllerCheckQueryResponse, typeof queryKey>({
         enabled: !!(service),
         queryKey,
         queryFn: async ({ signal }) => {
            return healthControllerCheck(service!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /health/:service}
 */
export function useHealthControllerCheck<TData = HealthControllerCheckQueryResponse, TQueryData = HealthControllerCheckQueryResponse, TQueryKey extends QueryKey = HealthControllerCheckQueryKey>(service: HealthControllerCheckPathParams["service"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<HealthControllerCheckQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? healthControllerCheckQueryKey(service)
         

         const query = useQuery({
          ...healthControllerCheckQueryOptions(service, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const invitationControllerResolveAnonymousSessionEntitiesQueryKey = () => [{ url: '/anonymous-session/entities' }] as const

export type InvitationControllerResolveAnonymousSessionEntitiesQueryKey = ReturnType<typeof invitationControllerResolveAnonymousSessionEntitiesQueryKey>

export function invitationControllerResolveAnonymousSessionEntitiesQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = invitationControllerResolveAnonymousSessionEntitiesQueryKey()
        return queryOptions<InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, ResponseErrorConfig<Error>, InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return invitationControllerResolveAnonymousSessionEntities({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the entities created during an anonymous session
 * {@link /anonymous-session/entities}
 */
export function useInvitationControllerResolveAnonymousSessionEntities<TData = InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, TQueryData = InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, TQueryKey extends QueryKey = InvitationControllerResolveAnonymousSessionEntitiesQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<InvitationControllerResolveAnonymousSessionEntitiesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? invitationControllerResolveAnonymousSessionEntitiesQueryKey()
         

         const query = useQuery({
          ...invitationControllerResolveAnonymousSessionEntitiesQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const jobSchedulersControllerGetJobSchedulersQueryKey = () => [{ url: '/job-schedulers/bull-mq' }] as const

export type JobSchedulersControllerGetJobSchedulersQueryKey = ReturnType<typeof jobSchedulersControllerGetJobSchedulersQueryKey>

export function jobSchedulersControllerGetJobSchedulersQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = jobSchedulersControllerGetJobSchedulersQueryKey()
        return queryOptions<JobSchedulersControllerGetJobSchedulersQueryResponse, ResponseErrorConfig<Error>, JobSchedulersControllerGetJobSchedulersQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return jobSchedulersControllerGetJobSchedulers({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get current job schedulers using bullmq api
 * {@link /job-schedulers/bull-mq}
 */
export function useJobSchedulersControllerGetJobSchedulers<TData = JobSchedulersControllerGetJobSchedulersQueryResponse, TQueryData = JobSchedulersControllerGetJobSchedulersQueryResponse, TQueryKey extends QueryKey = JobSchedulersControllerGetJobSchedulersQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<JobSchedulersControllerGetJobSchedulersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? jobSchedulersControllerGetJobSchedulersQueryKey()
         

         const query = useQuery({
          ...jobSchedulersControllerGetJobSchedulersQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const jobSchedulersControllerGetQueryKey = (id: JobSchedulersControllerGetPathParams["id"] | undefined) => [{ url: '/job-schedulers/:id', params: {id:id} }] as const

export type JobSchedulersControllerGetQueryKey = ReturnType<typeof jobSchedulersControllerGetQueryKey>

export function jobSchedulersControllerGetQueryOptions(id: JobSchedulersControllerGetPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = jobSchedulersControllerGetQueryKey(id)
        return queryOptions<JobSchedulersControllerGetQueryResponse, ResponseErrorConfig<JobSchedulersControllerGet404>, JobSchedulersControllerGetQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return jobSchedulersControllerGet(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a job scheduler
 * {@link /job-schedulers/:id}
 */
export function useJobSchedulersControllerGet<TData = JobSchedulersControllerGetQueryResponse, TQueryData = JobSchedulersControllerGetQueryResponse, TQueryKey extends QueryKey = JobSchedulersControllerGetQueryKey>(id: JobSchedulersControllerGetPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<JobSchedulersControllerGetQueryResponse, ResponseErrorConfig<JobSchedulersControllerGet404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? jobSchedulersControllerGetQueryKey(id)
         

         const query = useQuery({
          ...jobSchedulersControllerGetQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<JobSchedulersControllerGet404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const jobsControllerGetJobQueryKey = (id: JobsControllerGetJobPathParams["id"] | undefined) => [{ url: '/jobs/:id', params: {id:id} }] as const

export type JobsControllerGetJobQueryKey = ReturnType<typeof jobsControllerGetJobQueryKey>

export function jobsControllerGetJobQueryOptions(id: JobsControllerGetJobPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = jobsControllerGetJobQueryKey(id)
        return queryOptions<JobsControllerGetJobQueryResponse, ResponseErrorConfig<Error>, JobsControllerGetJobQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return jobsControllerGetJob(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get job
 * {@link /jobs/:id}
 */
export function useJobsControllerGetJob<TData = JobsControllerGetJobQueryResponse, TQueryData = JobsControllerGetJobQueryResponse, TQueryKey extends QueryKey = JobsControllerGetJobQueryKey>(id: JobsControllerGetJobPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<JobsControllerGetJobQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? jobsControllerGetJobQueryKey(id)
         

         const query = useQuery({
          ...jobsControllerGetJobQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const jobsControllerListJobsQueryKey = (data: JobsControllerListJobsMutationRequest) => [{ url: '/jobs/list-by-metadata' }, ...(data ? [data] : [])] as const

export type JobsControllerListJobsQueryKey = ReturnType<typeof jobsControllerListJobsQueryKey>

export function jobsControllerListJobsQueryOptions(data: JobsControllerListJobsMutationRequest, config: Partial<RequestConfig<JobsControllerListJobsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = jobsControllerListJobsQueryKey(data)
        return queryOptions<JobsControllerListJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerListJobsMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return jobsControllerListJobs(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List jobs by metadata
 * {@link /jobs/list-by-metadata}
 */
export function useJobsControllerListJobs<TData = JobsControllerListJobsMutationResponse, TQueryData = JobsControllerListJobsMutationResponse, TQueryKey extends QueryKey = JobsControllerListJobsQueryKey>(data: JobsControllerListJobsMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<JobsControllerListJobsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerListJobsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? jobsControllerListJobsQueryKey(data)
         

         const query = useQuery({
          ...jobsControllerListJobsQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const jobsControllerCountJobsQueryKey = (data: JobsControllerCountJobsMutationRequest) => [{ url: '/jobs/count-by-metadata' }, ...(data ? [data] : [])] as const

export type JobsControllerCountJobsQueryKey = ReturnType<typeof jobsControllerCountJobsQueryKey>

export function jobsControllerCountJobsQueryOptions(data: JobsControllerCountJobsMutationRequest, config: Partial<RequestConfig<JobsControllerCountJobsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = jobsControllerCountJobsQueryKey(data)
        return queryOptions<JobsControllerCountJobsMutationResponse, ResponseErrorConfig<Error>, JobsControllerCountJobsMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return jobsControllerCountJobs(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Count jobs matching filters, grouped by status
 * {@link /jobs/count-by-metadata}
 */
export function useJobsControllerCountJobs<TData = JobsControllerCountJobsMutationResponse, TQueryData = JobsControllerCountJobsMutationResponse, TQueryKey extends QueryKey = JobsControllerCountJobsQueryKey>(data: JobsControllerCountJobsMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<JobsControllerCountJobsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerCountJobsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? jobsControllerCountJobsQueryKey(data)
         

         const query = useQuery({
          ...jobsControllerCountJobsQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const queueManagementControllerGetStatusQueryKey = () => [{ url: '/queues/status' }] as const

export type QueueManagementControllerGetStatusQueryKey = ReturnType<typeof queueManagementControllerGetStatusQueryKey>

export function queueManagementControllerGetStatusQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = queueManagementControllerGetStatusQueryKey()
        return queryOptions<QueueManagementControllerGetStatusQueryResponse, ResponseErrorConfig<Error>, QueueManagementControllerGetStatusQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return queueManagementControllerGetStatus({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get pause/running status of all BullMQ queues
 * {@link /queues/status}
 */
export function useQueueManagementControllerGetStatus<TData = QueueManagementControllerGetStatusQueryResponse, TQueryData = QueueManagementControllerGetStatusQueryResponse, TQueryKey extends QueryKey = QueueManagementControllerGetStatusQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<QueueManagementControllerGetStatusQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? queueManagementControllerGetStatusQueryKey()
         

         const query = useQuery({
          ...queueManagementControllerGetStatusQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const legacyDocumentsControllerGetOnDemandDocumentsQueryKey = (params: LegacyDocumentsControllerGetOnDemandDocumentsQueryParams) => [{ url: '/on-demand-documents' }, ...(params ? [params] : [])] as const

export type LegacyDocumentsControllerGetOnDemandDocumentsQueryKey = ReturnType<typeof legacyDocumentsControllerGetOnDemandDocumentsQueryKey>

export function legacyDocumentsControllerGetOnDemandDocumentsQueryOptions(params: LegacyDocumentsControllerGetOnDemandDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = legacyDocumentsControllerGetOnDemandDocumentsQueryKey(params)
        return queryOptions<LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetOnDemandDocuments400 | LegacyDocumentsControllerGetOnDemandDocuments404>, LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return legacyDocumentsControllerGetOnDemandDocuments(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Narrowed to the configs flagged `generateOnDemandByPolicyholder` when the caller is a policyholder.
 * @summary List on-demand documents eligible for a target
 * {@link /on-demand-documents}
 */
export function useLegacyDocumentsControllerGetOnDemandDocuments<TData = LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, TQueryData = LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, TQueryKey extends QueryKey = LegacyDocumentsControllerGetOnDemandDocumentsQueryKey>(params: LegacyDocumentsControllerGetOnDemandDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<LegacyDocumentsControllerGetOnDemandDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetOnDemandDocuments400 | LegacyDocumentsControllerGetOnDemandDocuments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? legacyDocumentsControllerGetOnDemandDocumentsQueryKey(params)
         

         const query = useQuery({
          ...legacyDocumentsControllerGetOnDemandDocumentsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<LegacyDocumentsControllerGetOnDemandDocuments400 | LegacyDocumentsControllerGetOnDemandDocuments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const legacyDocumentsControllerGetExpectedGeneratedDocumentsQueryKey = (params: LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams) => [{ url: '/expected-generated-documents' }, ...(params ? [params] : [])] as const

export type LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryKey = ReturnType<typeof legacyDocumentsControllerGetExpectedGeneratedDocumentsQueryKey>

export function legacyDocumentsControllerGetExpectedGeneratedDocumentsQueryOptions(params: LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = legacyDocumentsControllerGetExpectedGeneratedDocumentsQueryKey(params)
        return queryOptions<LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedGeneratedDocuments400 | LegacyDocumentsControllerGetExpectedGeneratedDocuments404>, LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return legacyDocumentsControllerGetExpectedGeneratedDocuments(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description The minimum: the product's common documents, plus generated documents whose trigger fired and whose filters pass. On-demand documents are excluded, so a policy legitimately holds more than this list. `whenAt` defaults to now; a past one dates the events and the policy but not the assets (ENG-4476).
 * @summary List the generated document types a policy is expected to have on a branch
 * {@link /expected-generated-documents}
 */
export function useLegacyDocumentsControllerGetExpectedGeneratedDocuments<TData = LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, TQueryData = LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, TQueryKey extends QueryKey = LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryKey>(params: LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<LegacyDocumentsControllerGetExpectedGeneratedDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedGeneratedDocuments400 | LegacyDocumentsControllerGetExpectedGeneratedDocuments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? legacyDocumentsControllerGetExpectedGeneratedDocumentsQueryKey(params)
         

         const query = useQuery({
          ...legacyDocumentsControllerGetExpectedGeneratedDocumentsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedGeneratedDocuments400 | LegacyDocumentsControllerGetExpectedGeneratedDocuments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const legacyDocumentsControllerGetExpectedUploadedDocumentsQueryKey = (params: LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams) => [{ url: '/expected-uploaded-documents' }, ...(params ? [params] : [])] as const

export type LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryKey = ReturnType<typeof legacyDocumentsControllerGetExpectedUploadedDocumentsQueryKey>

export function legacyDocumentsControllerGetExpectedUploadedDocumentsQueryOptions(params: LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = legacyDocumentsControllerGetExpectedUploadedDocumentsQueryKey(params)
        return queryOptions<LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedUploadedDocuments400 | LegacyDocumentsControllerGetExpectedUploadedDocuments404 | LegacyDocumentsControllerGetExpectedUploadedDocuments501>, LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return legacyDocumentsControllerGetExpectedUploadedDocuments(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description The entity is read from the `targetId` prefix: a policy id returns the product's policyholderDocuments, a brokerage firm id the tenant's brokerageFirmDocumentsList — minus the entries whose filters do not pass on that entity's payload. Entries without filters are always expected. `required` says whether a missing document blocks conformity.
 * @summary List the document categories an entity is expected to upload
 * {@link /expected-uploaded-documents}
 */
export function useLegacyDocumentsControllerGetExpectedUploadedDocuments<TData = LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, TQueryData = LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, TQueryKey extends QueryKey = LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryKey>(params: LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<LegacyDocumentsControllerGetExpectedUploadedDocumentsQueryResponse, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedUploadedDocuments400 | LegacyDocumentsControllerGetExpectedUploadedDocuments404 | LegacyDocumentsControllerGetExpectedUploadedDocuments501>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? legacyDocumentsControllerGetExpectedUploadedDocumentsQueryKey(params)
         

         const query = useQuery({
          ...legacyDocumentsControllerGetExpectedUploadedDocumentsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<LegacyDocumentsControllerGetExpectedUploadedDocuments400 | LegacyDocumentsControllerGetExpectedUploadedDocuments404 | LegacyDocumentsControllerGetExpectedUploadedDocuments501>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const lockControllerListLocksQueryKey = (params?: LockControllerListLocksQueryParams) => [{ url: '/locks' }, ...(params ? [params] : [])] as const

export type LockControllerListLocksQueryKey = ReturnType<typeof lockControllerListLocksQueryKey>

export function lockControllerListLocksQueryOptions(params?: LockControllerListLocksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = lockControllerListLocksQueryKey(params)
        return queryOptions<LockControllerListLocksQueryResponse, ResponseErrorConfig<Error>, LockControllerListLocksQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return lockControllerListLocks(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Super-admin-only, cross-tenant listing of currently held locks.
 * @summary List locks currently held
 * {@link /locks}
 */
export function useLockControllerListLocks<TData = LockControllerListLocksQueryResponse, TQueryData = LockControllerListLocksQueryResponse, TQueryKey extends QueryKey = LockControllerListLocksQueryKey>(params?: LockControllerListLocksQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<LockControllerListLocksQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? lockControllerListLocksQueryKey(params)
         

         const query = useQuery({
          ...lockControllerListLocksQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const lockControllerGetLockQueryKey = (id: LockControllerGetLockPathParams["id"] | undefined) => [{ url: '/locks/:id', params: {id:id} }] as const

export type LockControllerGetLockQueryKey = ReturnType<typeof lockControllerGetLockQueryKey>

export function lockControllerGetLockQueryOptions(id: LockControllerGetLockPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = lockControllerGetLockQueryKey(id)
        return queryOptions<LockControllerGetLockQueryResponse, ResponseErrorConfig<Error>, LockControllerGetLockQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return lockControllerGetLock(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /locks/:id}
 */
export function useLockControllerGetLock<TData = LockControllerGetLockQueryResponse, TQueryData = LockControllerGetLockQueryResponse, TQueryKey extends QueryKey = LockControllerGetLockQueryKey>(id: LockControllerGetLockPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<LockControllerGetLockQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? lockControllerGetLockQueryKey(id)
         

         const query = useQuery({
          ...lockControllerGetLockQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const notificationControllerListEmailTemplatesQueryKey = (params?: NotificationControllerListEmailTemplatesQueryParams) => [{ url: '/notifications/email-templates' }, ...(params ? [params] : [])] as const

export type NotificationControllerListEmailTemplatesQueryKey = ReturnType<typeof notificationControllerListEmailTemplatesQueryKey>

export function notificationControllerListEmailTemplatesQueryOptions(params?: NotificationControllerListEmailTemplatesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = notificationControllerListEmailTemplatesQueryKey(params)
        return queryOptions<NotificationControllerListEmailTemplatesQueryResponse, ResponseErrorConfig<Error>, NotificationControllerListEmailTemplatesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return notificationControllerListEmailTemplates(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List in-repo email templates
 * {@link /notifications/email-templates}
 */
export function useNotificationControllerListEmailTemplates<TData = NotificationControllerListEmailTemplatesQueryResponse, TQueryData = NotificationControllerListEmailTemplatesQueryResponse, TQueryKey extends QueryKey = NotificationControllerListEmailTemplatesQueryKey>(params?: NotificationControllerListEmailTemplatesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<NotificationControllerListEmailTemplatesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? notificationControllerListEmailTemplatesQueryKey(params)
         

         const query = useQuery({
          ...notificationControllerListEmailTemplatesQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const notificationControllerListNotificationsQueryKey = (params?: NotificationControllerListNotificationsQueryParams) => [{ url: '/notifications' }, ...(params ? [params] : [])] as const

export type NotificationControllerListNotificationsQueryKey = ReturnType<typeof notificationControllerListNotificationsQueryKey>

export function notificationControllerListNotificationsQueryOptions(params?: NotificationControllerListNotificationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = notificationControllerListNotificationsQueryKey(params)
        return queryOptions<NotificationControllerListNotificationsQueryResponse, ResponseErrorConfig<Error>, NotificationControllerListNotificationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return notificationControllerListNotifications(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List notifications
 * {@link /notifications}
 */
export function useNotificationControllerListNotifications<TData = NotificationControllerListNotificationsQueryResponse, TQueryData = NotificationControllerListNotificationsQueryResponse, TQueryKey extends QueryKey = NotificationControllerListNotificationsQueryKey>(params?: NotificationControllerListNotificationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<NotificationControllerListNotificationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? notificationControllerListNotificationsQueryKey(params)
         

         const query = useQuery({
          ...notificationControllerListNotificationsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const notificationControllerGetNotificationQueryKey = (id: NotificationControllerGetNotificationPathParams["id"] | undefined) => [{ url: '/notifications/:id', params: {id:id} }] as const

export type NotificationControllerGetNotificationQueryKey = ReturnType<typeof notificationControllerGetNotificationQueryKey>

export function notificationControllerGetNotificationQueryOptions(id: NotificationControllerGetNotificationPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = notificationControllerGetNotificationQueryKey(id)
        return queryOptions<NotificationControllerGetNotificationQueryResponse, ResponseErrorConfig<NotificationControllerGetNotification404>, NotificationControllerGetNotificationQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return notificationControllerGetNotification(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a notification
 * {@link /notifications/:id}
 */
export function useNotificationControllerGetNotification<TData = NotificationControllerGetNotificationQueryResponse, TQueryData = NotificationControllerGetNotificationQueryResponse, TQueryKey extends QueryKey = NotificationControllerGetNotificationQueryKey>(id: NotificationControllerGetNotificationPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<NotificationControllerGetNotificationQueryResponse, ResponseErrorConfig<NotificationControllerGetNotification404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? notificationControllerGetNotificationQueryKey(id)
         

         const query = useQuery({
          ...notificationControllerGetNotificationQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NotificationControllerGetNotification404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const paymentsControllerGetPaymentsQueryKey = (params: PaymentsControllerGetPaymentsQueryParams) => [{ url: '/payments' }, ...(params ? [params] : [])] as const

export type PaymentsControllerGetPaymentsQueryKey = ReturnType<typeof paymentsControllerGetPaymentsQueryKey>

export function paymentsControllerGetPaymentsQueryOptions(params: PaymentsControllerGetPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = paymentsControllerGetPaymentsQueryKey(params)
        return queryOptions<PaymentsControllerGetPaymentsQueryResponse, ResponseErrorConfig<Error>, PaymentsControllerGetPaymentsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return paymentsControllerGetPayments(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get payments by ids
 * {@link /payments}
 */
export function usePaymentsControllerGetPayments<TData = PaymentsControllerGetPaymentsQueryResponse, TQueryData = PaymentsControllerGetPaymentsQueryResponse, TQueryKey extends QueryKey = PaymentsControllerGetPaymentsQueryKey>(params: PaymentsControllerGetPaymentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PaymentsControllerGetPaymentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? paymentsControllerGetPaymentsQueryKey(params)
         

         const query = useQuery({
          ...paymentsControllerGetPaymentsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const paymentsControllerGetCustomersPaymentMethodsQueryKey = (params: PaymentsControllerGetCustomersPaymentMethodsQueryParams) => [{ url: '/payments/payment-methods' }, ...(params ? [params] : [])] as const

export type PaymentsControllerGetCustomersPaymentMethodsQueryKey = ReturnType<typeof paymentsControllerGetCustomersPaymentMethodsQueryKey>

export function paymentsControllerGetCustomersPaymentMethodsQueryOptions(params: PaymentsControllerGetCustomersPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = paymentsControllerGetCustomersPaymentMethodsQueryKey(params)
        return queryOptions<PaymentsControllerGetCustomersPaymentMethodsQueryResponse, ResponseErrorConfig<Error>, PaymentsControllerGetCustomersPaymentMethodsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return paymentsControllerGetCustomersPaymentMethods(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get payment methods associated to a customer
 * {@link /payments/payment-methods}
 */
export function usePaymentsControllerGetCustomersPaymentMethods<TData = PaymentsControllerGetCustomersPaymentMethodsQueryResponse, TQueryData = PaymentsControllerGetCustomersPaymentMethodsQueryResponse, TQueryKey extends QueryKey = PaymentsControllerGetCustomersPaymentMethodsQueryKey>(params: PaymentsControllerGetCustomersPaymentMethodsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PaymentsControllerGetCustomersPaymentMethodsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? paymentsControllerGetCustomersPaymentMethodsQueryKey(params)
         

         const query = useQuery({
          ...paymentsControllerGetCustomersPaymentMethodsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const paymentsControllerGetCustomerPaymentsQueryKey = (customerId: PaymentsControllerGetCustomerPaymentsPathParams["customerId"] | undefined, params?: PaymentsControllerGetCustomerPaymentsQueryParams) => [{ url: '/payments/:customerId/payments', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type PaymentsControllerGetCustomerPaymentsQueryKey = ReturnType<typeof paymentsControllerGetCustomerPaymentsQueryKey>

export function paymentsControllerGetCustomerPaymentsQueryOptions(customerId: PaymentsControllerGetCustomerPaymentsPathParams["customerId"] | undefined, params?: PaymentsControllerGetCustomerPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = paymentsControllerGetCustomerPaymentsQueryKey(customerId, params)
        return queryOptions<PaymentsControllerGetCustomerPaymentsQueryResponse, ResponseErrorConfig<Error>, PaymentsControllerGetCustomerPaymentsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return paymentsControllerGetCustomerPayments(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get payments by customerId
 * {@link /payments/:customerId/payments}
 */
export function usePaymentsControllerGetCustomerPayments<TData = PaymentsControllerGetCustomerPaymentsQueryResponse, TQueryData = PaymentsControllerGetCustomerPaymentsQueryResponse, TQueryKey extends QueryKey = PaymentsControllerGetCustomerPaymentsQueryKey>(customerId: PaymentsControllerGetCustomerPaymentsPathParams["customerId"] | undefined, params?: PaymentsControllerGetCustomerPaymentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PaymentsControllerGetCustomerPaymentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? paymentsControllerGetCustomerPaymentsQueryKey(customerId, params)
         

         const query = useQuery({
          ...paymentsControllerGetCustomerPaymentsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerGetPolicyQueryKey = (policyId: PolicyControllerGetPolicyPathParams["policyId"] | undefined, params?: PolicyControllerGetPolicyQueryParams) => [{ url: '/policies/:policyId', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyControllerGetPolicyQueryKey = ReturnType<typeof policyControllerGetPolicyQueryKey>

export function policyControllerGetPolicyQueryOptions(policyId: PolicyControllerGetPolicyPathParams["policyId"] | undefined, params?: PolicyControllerGetPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerGetPolicyQueryKey(policyId, params)
        return queryOptions<PolicyControllerGetPolicyQueryResponse, ResponseErrorConfig<PolicyControllerGetPolicy403 | PolicyControllerGetPolicy404>, PolicyControllerGetPolicyQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerGetPolicy(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Poll this for anything that completes outside your request: a signature finishing, a first premium arriving, cover starting. Reads are branch-scoped, so pass the branch the work was done on.
 * @summary Get Policy
 * {@link /policies/:policyId}
 */
export function usePolicyControllerGetPolicy<TData = PolicyControllerGetPolicyQueryResponse, TQueryData = PolicyControllerGetPolicyQueryResponse, TQueryKey extends QueryKey = PolicyControllerGetPolicyQueryKey>(policyId: PolicyControllerGetPolicyPathParams["policyId"] | undefined, params?: PolicyControllerGetPolicyQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerGetPolicyQueryResponse, ResponseErrorConfig<PolicyControllerGetPolicy403 | PolicyControllerGetPolicy404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerGetPolicyQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyControllerGetPolicyQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerGetPolicy403 | PolicyControllerGetPolicy404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerListPolicyDocumentsQueryKey = (policyId: PolicyControllerListPolicyDocumentsPathParams["policyId"] | undefined, params?: PolicyControllerListPolicyDocumentsQueryParams) => [{ url: '/policies/:policyId/documents', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyControllerListPolicyDocumentsQueryKey = ReturnType<typeof policyControllerListPolicyDocumentsQueryKey>

export function policyControllerListPolicyDocumentsQueryOptions(policyId: PolicyControllerListPolicyDocumentsPathParams["policyId"] | undefined, params?: PolicyControllerListPolicyDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerListPolicyDocumentsQueryKey(policyId, params)
        return queryOptions<PolicyControllerListPolicyDocumentsQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyDocuments403 | PolicyControllerListPolicyDocuments404>, PolicyControllerListPolicyDocumentsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerListPolicyDocuments(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a policy's documents
 * {@link /policies/:policyId/documents}
 */
export function usePolicyControllerListPolicyDocuments<TData = PolicyControllerListPolicyDocumentsQueryResponse, TQueryData = PolicyControllerListPolicyDocumentsQueryResponse, TQueryKey extends QueryKey = PolicyControllerListPolicyDocumentsQueryKey>(policyId: PolicyControllerListPolicyDocumentsPathParams["policyId"] | undefined, params?: PolicyControllerListPolicyDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerListPolicyDocumentsQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyDocuments403 | PolicyControllerListPolicyDocuments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerListPolicyDocumentsQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyControllerListPolicyDocumentsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerListPolicyDocuments403 | PolicyControllerListPolicyDocuments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerGetPremiumScheduleQueryKey = (policyId: PolicyControllerGetPremiumSchedulePathParams["policyId"] | undefined, params: PolicyControllerGetPremiumScheduleQueryParams) => [{ url: '/policies/:policyId/premium-schedule', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyControllerGetPremiumScheduleQueryKey = ReturnType<typeof policyControllerGetPremiumScheduleQueryKey>

export function policyControllerGetPremiumScheduleQueryOptions(policyId: PolicyControllerGetPremiumSchedulePathParams["policyId"] | undefined, params: PolicyControllerGetPremiumScheduleQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerGetPremiumScheduleQueryKey(policyId, params)
        return queryOptions<PolicyControllerGetPremiumScheduleQueryResponse, ResponseErrorConfig<PolicyControllerGetPremiumSchedule403 | PolicyControllerGetPremiumSchedule404>, PolicyControllerGetPremiumScheduleQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerGetPremiumSchedule(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description The quote's premium is the contract total, not the first charge. Use this to show what will be paid and when instead of deriving a schedule from `invoicingConfig`.
 * @summary Get the premium schedule
 * {@link /policies/:policyId/premium-schedule}
 */
export function usePolicyControllerGetPremiumSchedule<TData = PolicyControllerGetPremiumScheduleQueryResponse, TQueryData = PolicyControllerGetPremiumScheduleQueryResponse, TQueryKey extends QueryKey = PolicyControllerGetPremiumScheduleQueryKey>(policyId: PolicyControllerGetPremiumSchedulePathParams["policyId"] | undefined, params: PolicyControllerGetPremiumScheduleQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerGetPremiumScheduleQueryResponse, ResponseErrorConfig<PolicyControllerGetPremiumSchedule403 | PolicyControllerGetPremiumSchedule404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerGetPremiumScheduleQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyControllerGetPremiumScheduleQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerGetPremiumSchedule403 | PolicyControllerGetPremiumSchedule404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerListPolicyDocumentsAdminQueryKey = (policyId: PolicyControllerListPolicyDocumentsAdminPathParams["policyId"] | undefined, params?: PolicyControllerListPolicyDocumentsAdminQueryParams) => [{ url: '/policies/:policyId/admin/documents', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyControllerListPolicyDocumentsAdminQueryKey = ReturnType<typeof policyControllerListPolicyDocumentsAdminQueryKey>

export function policyControllerListPolicyDocumentsAdminQueryOptions(policyId: PolicyControllerListPolicyDocumentsAdminPathParams["policyId"] | undefined, params?: PolicyControllerListPolicyDocumentsAdminQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerListPolicyDocumentsAdminQueryKey(policyId, params)
        return queryOptions<PolicyControllerListPolicyDocumentsAdminQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyDocumentsAdmin403 | PolicyControllerListPolicyDocumentsAdmin404>, PolicyControllerListPolicyDocumentsAdminQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerListPolicyDocumentsAdmin(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List policy documents (Admin only - includes deleted)
 * {@link /policies/:policyId/admin/documents}
 */
export function usePolicyControllerListPolicyDocumentsAdmin<TData = PolicyControllerListPolicyDocumentsAdminQueryResponse, TQueryData = PolicyControllerListPolicyDocumentsAdminQueryResponse, TQueryKey extends QueryKey = PolicyControllerListPolicyDocumentsAdminQueryKey>(policyId: PolicyControllerListPolicyDocumentsAdminPathParams["policyId"] | undefined, params?: PolicyControllerListPolicyDocumentsAdminQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerListPolicyDocumentsAdminQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyDocumentsAdmin403 | PolicyControllerListPolicyDocumentsAdmin404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerListPolicyDocumentsAdminQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyControllerListPolicyDocumentsAdminQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerListPolicyDocumentsAdmin403 | PolicyControllerListPolicyDocumentsAdmin404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerListPolicyEventsQueryKey = (policyId: PolicyControllerListPolicyEventsPathParams["policyId"] | undefined) => [{ url: '/policies/:policyId/events', params: {policyId:policyId} }] as const

export type PolicyControllerListPolicyEventsQueryKey = ReturnType<typeof policyControllerListPolicyEventsQueryKey>

export function policyControllerListPolicyEventsQueryOptions(policyId: PolicyControllerListPolicyEventsPathParams["policyId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerListPolicyEventsQueryKey(policyId)
        return queryOptions<PolicyControllerListPolicyEventsQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyEvents404>, PolicyControllerListPolicyEventsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerListPolicyEvents(policyId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List policy, asset or customer events.
 * {@link /policies/:policyId/events}
 */
export function usePolicyControllerListPolicyEvents<TData = PolicyControllerListPolicyEventsQueryResponse, TQueryData = PolicyControllerListPolicyEventsQueryResponse, TQueryKey extends QueryKey = PolicyControllerListPolicyEventsQueryKey>(policyId: PolicyControllerListPolicyEventsPathParams["policyId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerListPolicyEventsQueryResponse, ResponseErrorConfig<PolicyControllerListPolicyEvents404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerListPolicyEventsQueryKey(policyId)
         

         const query = useQuery({
          ...policyControllerListPolicyEventsQueryOptions(policyId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerListPolicyEvents404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerPlanTasksQueryKey = (policyId: PolicyControllerPlanTasksPathParams["policyId"] | undefined, params?: PolicyControllerPlanTasksQueryParams) => [{ url: '/policies/:policyId/recurring-tasks', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyControllerPlanTasksQueryKey = ReturnType<typeof policyControllerPlanTasksQueryKey>

export function policyControllerPlanTasksQueryOptions(policyId: PolicyControllerPlanTasksPathParams["policyId"] | undefined, params?: PolicyControllerPlanTasksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerPlanTasksQueryKey(policyId, params)
        return queryOptions<PolicyControllerPlanTasksQueryResponse, ResponseErrorConfig<PolicyControllerPlanTasks403 | PolicyControllerPlanTasks404>, PolicyControllerPlanTasksQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerPlanTasks(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns recurring tasks for the requested date range. Execution history is not checked. Requires permission to plan tasks for the policy.
 * @summary List planned policy tasks
 * {@link /policies/:policyId/recurring-tasks}
 */
export function usePolicyControllerPlanTasks<TData = PolicyControllerPlanTasksQueryResponse, TQueryData = PolicyControllerPlanTasksQueryResponse, TQueryKey extends QueryKey = PolicyControllerPlanTasksQueryKey>(policyId: PolicyControllerPlanTasksPathParams["policyId"] | undefined, params?: PolicyControllerPlanTasksQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerPlanTasksQueryResponse, ResponseErrorConfig<PolicyControllerPlanTasks403 | PolicyControllerPlanTasks404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerPlanTasksQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyControllerPlanTasksQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerPlanTasks403 | PolicyControllerPlanTasks404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerGetAggregateQueryKey = (params: PolicyControllerGetAggregateQueryParams) => [{ url: '/policies/debug/aggregate' }, ...(params ? [params] : [])] as const

export type PolicyControllerGetAggregateQueryKey = ReturnType<typeof policyControllerGetAggregateQueryKey>

export function policyControllerGetAggregateQueryOptions(params: PolicyControllerGetAggregateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyControllerGetAggregateQueryKey(params)
        return queryOptions<PolicyControllerGetAggregateQueryResponse, ResponseErrorConfig<PolicyControllerGetAggregate404>, PolicyControllerGetAggregateQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerGetAggregate(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get Aggregate
 * {@link /policies/debug/aggregate}
 */
export function usePolicyControllerGetAggregate<TData = PolicyControllerGetAggregateQueryResponse, TQueryData = PolicyControllerGetAggregateQueryResponse, TQueryKey extends QueryKey = PolicyControllerGetAggregateQueryKey>(params: PolicyControllerGetAggregateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerGetAggregateQueryResponse, ResponseErrorConfig<PolicyControllerGetAggregate404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerGetAggregateQueryKey(params)
         

         const query = useQuery({
          ...policyControllerGetAggregateQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerGetAggregate404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyControllerCalculatePolicyQuoteQueryKey = (policyId: PolicyControllerCalculatePolicyQuotePathParams["policyId"] | undefined, data: PolicyControllerCalculatePolicyQuoteMutationRequest, params?: PolicyControllerCalculatePolicyQuoteQueryParams) => [{ url: '/policies/:policyId/calculate-quote', params: {policyId:policyId} }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type PolicyControllerCalculatePolicyQuoteQueryKey = ReturnType<typeof policyControllerCalculatePolicyQuoteQueryKey>

export function policyControllerCalculatePolicyQuoteQueryOptions(policyId: PolicyControllerCalculatePolicyQuotePathParams["policyId"] | undefined, data: PolicyControllerCalculatePolicyQuoteMutationRequest, params?: PolicyControllerCalculatePolicyQuoteQueryParams, config: Partial<RequestConfig<PolicyControllerCalculatePolicyQuoteMutationRequest>> & { client?: Client } = {}) {

        const queryKey = policyControllerCalculatePolicyQuoteQueryKey(policyId, data, params)
        return queryOptions<PolicyControllerCalculatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerCalculatePolicyQuote400 | PolicyControllerCalculatePolicyQuote404 | PolicyControllerCalculatePolicyQuote409>, PolicyControllerCalculatePolicyQuoteMutationResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyControllerCalculatePolicyQuote(policyId!, data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Calculate quote information for a policy without actually quoting it. The quote contains the full pricing details, i.e. base prices for assets or policy, the multipliers applied, peril breakdown, etc.
 * @summary Calculate policy quote
 * {@link /policies/:policyId/calculate-quote}
 */
export function usePolicyControllerCalculatePolicyQuote<TData = PolicyControllerCalculatePolicyQuoteMutationResponse, TQueryData = PolicyControllerCalculatePolicyQuoteMutationResponse, TQueryKey extends QueryKey = PolicyControllerCalculatePolicyQuoteQueryKey>(policyId: PolicyControllerCalculatePolicyQuotePathParams["policyId"] | undefined, data: PolicyControllerCalculatePolicyQuoteMutationRequest, params?: PolicyControllerCalculatePolicyQuoteQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyControllerCalculatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerCalculatePolicyQuote400 | PolicyControllerCalculatePolicyQuote404 | PolicyControllerCalculatePolicyQuote409>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerCalculatePolicyQuoteMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyControllerCalculatePolicyQuoteQueryKey(policyId, data, params)
         

         const query = useQuery({
          ...policyControllerCalculatePolicyQuoteQueryOptions(policyId, data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyControllerCalculatePolicyQuote400 | PolicyControllerCalculatePolicyQuote404 | PolicyControllerCalculatePolicyQuote409>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const pricingControllerComputePricingQueryKey = (policyId: PricingControllerComputePricingPathParams["policyId"] | undefined, params: PricingControllerComputePricingQueryParams) => [{ url: '/pricing/:policyId', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PricingControllerComputePricingQueryKey = ReturnType<typeof pricingControllerComputePricingQueryKey>

export function pricingControllerComputePricingQueryOptions(policyId: PricingControllerComputePricingPathParams["policyId"] | undefined, params: PricingControllerComputePricingQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pricingControllerComputePricingQueryKey(policyId, params)
        return queryOptions<PricingControllerComputePricingQueryResponse, ResponseErrorConfig<PricingControllerComputePricing400 | PricingControllerComputePricing404>, PricingControllerComputePricingQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return pricingControllerComputePricing(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Compute pricing for selected tier and perils
 * {@link /pricing/:policyId}
 */
export function usePricingControllerComputePricing<TData = PricingControllerComputePricingQueryResponse, TQueryData = PricingControllerComputePricingQueryResponse, TQueryKey extends QueryKey = PricingControllerComputePricingQueryKey>(policyId: PricingControllerComputePricingPathParams["policyId"] | undefined, params: PricingControllerComputePricingQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PricingControllerComputePricingQueryResponse, ResponseErrorConfig<PricingControllerComputePricing400 | PricingControllerComputePricing404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? pricingControllerComputePricingQueryKey(policyId, params)
         

         const query = useQuery({
          ...pricingControllerComputePricingQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PricingControllerComputePricing400 | PricingControllerComputePricing404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const pricingControllerGetPriceQueryKey = (policyId: PricingControllerGetPricePathParams["policyId"] | undefined, params?: PricingControllerGetPriceQueryParams) => [{ url: '/pricing/:policyId/price', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PricingControllerGetPriceQueryKey = ReturnType<typeof pricingControllerGetPriceQueryKey>

export function pricingControllerGetPriceQueryOptions(policyId: PricingControllerGetPricePathParams["policyId"] | undefined, params?: PricingControllerGetPriceQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pricingControllerGetPriceQueryKey(policyId, params)
        return queryOptions<PricingControllerGetPriceQueryResponse, ResponseErrorConfig<PricingControllerGetPrice404>, PricingControllerGetPriceQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return pricingControllerGetPrice(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get price lines for display
 * {@link /pricing/:policyId/price}
 */
export function usePricingControllerGetPrice<TData = PricingControllerGetPriceQueryResponse, TQueryData = PricingControllerGetPriceQueryResponse, TQueryKey extends QueryKey = PricingControllerGetPriceQueryKey>(policyId: PricingControllerGetPricePathParams["policyId"] | undefined, params?: PricingControllerGetPriceQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PricingControllerGetPriceQueryResponse, ResponseErrorConfig<PricingControllerGetPrice404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? pricingControllerGetPriceQueryKey(policyId, params)
         

         const query = useQuery({
          ...pricingControllerGetPriceQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PricingControllerGetPrice404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const quoteControllerGetExternalQuoteQueryKey = (params: QuoteControllerGetExternalQuoteQueryParams) => [{ url: '/quote/external-quote' }, ...(params ? [params] : [])] as const

export type QuoteControllerGetExternalQuoteQueryKey = ReturnType<typeof quoteControllerGetExternalQuoteQueryKey>

export function quoteControllerGetExternalQuoteQueryOptions(params: QuoteControllerGetExternalQuoteQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = quoteControllerGetExternalQuoteQueryKey(params)
        return queryOptions<QuoteControllerGetExternalQuoteQueryResponse, ResponseErrorConfig<QuoteControllerGetExternalQuote404>, QuoteControllerGetExternalQuoteQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return quoteControllerGetExternalQuote(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves an external quote representation associated with a Korint internal quote `quoteId`. Returns external identifiers and raw external data if found.
 * @summary Get external quote by internal quote id
 * {@link /quote/external-quote}
 */
export function useQuoteControllerGetExternalQuote<TData = QuoteControllerGetExternalQuoteQueryResponse, TQueryData = QuoteControllerGetExternalQuoteQueryResponse, TQueryKey extends QueryKey = QuoteControllerGetExternalQuoteQueryKey>(params: QuoteControllerGetExternalQuoteQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<QuoteControllerGetExternalQuoteQueryResponse, ResponseErrorConfig<QuoteControllerGetExternalQuote404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? quoteControllerGetExternalQuoteQueryKey(params)
         

         const query = useQuery({
          ...quoteControllerGetExternalQuoteQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<QuoteControllerGetExternalQuote404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const monitoringControllerGetReportsQueryKey = () => [{ url: '/monitoring/reports' }] as const

export type MonitoringControllerGetReportsQueryKey = ReturnType<typeof monitoringControllerGetReportsQueryKey>

export function monitoringControllerGetReportsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = monitoringControllerGetReportsQueryKey()
        return queryOptions<MonitoringControllerGetReportsQueryResponse, ResponseErrorConfig<Error>, MonitoringControllerGetReportsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return monitoringControllerGetReports({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get daily monitoring reports
 * {@link /monitoring/reports}
 */
export function useMonitoringControllerGetReports<TData = MonitoringControllerGetReportsQueryResponse, TQueryData = MonitoringControllerGetReportsQueryResponse, TQueryKey extends QueryKey = MonitoringControllerGetReportsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<MonitoringControllerGetReportsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? monitoringControllerGetReportsQueryKey()
         

         const query = useQuery({
          ...monitoringControllerGetReportsQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const monitoringControllerGetChecksQueryKey = () => [{ url: '/monitoring/checks' }] as const

export type MonitoringControllerGetChecksQueryKey = ReturnType<typeof monitoringControllerGetChecksQueryKey>

export function monitoringControllerGetChecksQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = monitoringControllerGetChecksQueryKey()
        return queryOptions<MonitoringControllerGetChecksQueryResponse, ResponseErrorConfig<Error>, MonitoringControllerGetChecksQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return monitoringControllerGetChecks({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the available monitoring checks
 * {@link /monitoring/checks}
 */
export function useMonitoringControllerGetChecks<TData = MonitoringControllerGetChecksQueryResponse, TQueryData = MonitoringControllerGetChecksQueryResponse, TQueryKey extends QueryKey = MonitoringControllerGetChecksQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<MonitoringControllerGetChecksQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? monitoringControllerGetChecksQueryKey()
         

         const query = useQuery({
          ...monitoringControllerGetChecksQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const reportingControllerGetReportConfigQueryKey = (type: ReportingControllerGetReportConfigPathParams["type"] | undefined) => [{ url: '/reporting/:type/config', params: {type:type} }] as const

export type ReportingControllerGetReportConfigQueryKey = ReturnType<typeof reportingControllerGetReportConfigQueryKey>

export function reportingControllerGetReportConfigQueryOptions(type: ReportingControllerGetReportConfigPathParams["type"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = reportingControllerGetReportConfigQueryKey(type)
        return queryOptions<ReportingControllerGetReportConfigQueryResponse, ResponseErrorConfig<Error>, ReportingControllerGetReportConfigQueryResponse, typeof queryKey>({
         enabled: !!(type),
         queryKey,
         queryFn: async ({ signal }) => {
            return reportingControllerGetReportConfig(type!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get report config
 * {@link /reporting/:type/config}
 */
export function useReportingControllerGetReportConfig<TData = ReportingControllerGetReportConfigQueryResponse, TQueryData = ReportingControllerGetReportConfigQueryResponse, TQueryKey extends QueryKey = ReportingControllerGetReportConfigQueryKey>(type: ReportingControllerGetReportConfigPathParams["type"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ReportingControllerGetReportConfigQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? reportingControllerGetReportConfigQueryKey(type)
         

         const query = useQuery({
          ...reportingControllerGetReportConfigQueryOptions(type, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const reportingControllerGetReportsQueryKey = (data: ReportingControllerGetReportsMutationRequest) => [{ url: '/reporting/retrieve' }, ...(data ? [data] : [])] as const

export type ReportingControllerGetReportsQueryKey = ReturnType<typeof reportingControllerGetReportsQueryKey>

export function reportingControllerGetReportsQueryOptions(data: ReportingControllerGetReportsMutationRequest, config: Partial<RequestConfig<ReportingControllerGetReportsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = reportingControllerGetReportsQueryKey(data)
        return queryOptions<ReportingControllerGetReportsMutationResponse, ResponseErrorConfig<Error>, ReportingControllerGetReportsMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return reportingControllerGetReports(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get reports
 * {@link /reporting/retrieve}
 */
export function useReportingControllerGetReports<TData = ReportingControllerGetReportsMutationResponse, TQueryData = ReportingControllerGetReportsMutationResponse, TQueryKey extends QueryKey = ReportingControllerGetReportsQueryKey>(data: ReportingControllerGetReportsMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<ReportingControllerGetReportsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<ReportingControllerGetReportsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? reportingControllerGetReportsQueryKey(data)
         

         const query = useQuery({
          ...reportingControllerGetReportsQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const searchControllerSearchQueryKey = (data: SearchControllerSearchMutationRequest, params?: SearchControllerSearchQueryParams) => [{ url: '/search' }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type SearchControllerSearchQueryKey = ReturnType<typeof searchControllerSearchQueryKey>

export function searchControllerSearchQueryOptions(data: SearchControllerSearchMutationRequest, params?: SearchControllerSearchQueryParams, config: Partial<RequestConfig<SearchControllerSearchMutationRequest>> & { client?: Client } = {}) {

        const queryKey = searchControllerSearchQueryKey(data, params)
        return queryOptions<SearchControllerSearchMutationResponse, ResponseErrorConfig<Error>, SearchControllerSearchMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return searchControllerSearch(data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Search
 * {@link /search}
 */
export function useSearchControllerSearch<TData = SearchControllerSearchMutationResponse, TQueryData = SearchControllerSearchMutationResponse, TQueryKey extends QueryKey = SearchControllerSearchQueryKey>(data: SearchControllerSearchMutationRequest, params?: SearchControllerSearchQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SearchControllerSearchMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<SearchControllerSearchMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? searchControllerSearchQueryKey(data, params)
         

         const query = useQuery({
          ...searchControllerSearchQueryOptions(data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const searchControllerGenericSearchQueryKey = (name: SearchControllerGenericSearchPathParams["name"] | undefined, data: SearchControllerGenericSearchMutationRequest, params: SearchControllerGenericSearchQueryParams) => [{ url: '/search/:name/find', params: {name:name} }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type SearchControllerGenericSearchQueryKey = ReturnType<typeof searchControllerGenericSearchQueryKey>

export function searchControllerGenericSearchQueryOptions(name: SearchControllerGenericSearchPathParams["name"] | undefined, data: SearchControllerGenericSearchMutationRequest, params: SearchControllerGenericSearchQueryParams, config: Partial<RequestConfig<SearchControllerGenericSearchMutationRequest>> & { client?: Client } = {}) {

        const queryKey = searchControllerGenericSearchQueryKey(name, data, params)
        return queryOptions<SearchControllerGenericSearchMutationResponse, ResponseErrorConfig<Error>, SearchControllerGenericSearchMutationResponse, typeof queryKey>({
         enabled: !!(name),
         queryKey,
         queryFn: async ({ signal }) => {
            return searchControllerGenericSearch(name!, data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Generic Search
 * {@link /search/:name/find}
 */
export function useSearchControllerGenericSearch<TData = SearchControllerGenericSearchMutationResponse, TQueryData = SearchControllerGenericSearchMutationResponse, TQueryKey extends QueryKey = SearchControllerGenericSearchQueryKey>(name: SearchControllerGenericSearchPathParams["name"] | undefined, data: SearchControllerGenericSearchMutationRequest, params: SearchControllerGenericSearchQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SearchControllerGenericSearchMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<SearchControllerGenericSearchMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? searchControllerGenericSearchQueryKey(name, data, params)
         

         const query = useQuery({
          ...searchControllerGenericSearchQueryOptions(name, data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const searchControllerCountQueryKey = (data: SearchControllerCountMutationRequest) => [{ url: '/search/count' }, ...(data ? [data] : [])] as const

export type SearchControllerCountQueryKey = ReturnType<typeof searchControllerCountQueryKey>

export function searchControllerCountQueryOptions(data: SearchControllerCountMutationRequest, config: Partial<RequestConfig<SearchControllerCountMutationRequest>> & { client?: Client } = {}) {

        const queryKey = searchControllerCountQueryKey(data)
        return queryOptions<SearchControllerCountMutationResponse, ResponseErrorConfig<Error>, SearchControllerCountMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return searchControllerCount(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Count
 * {@link /search/count}
 */
export function useSearchControllerCount<TData = SearchControllerCountMutationResponse, TQueryData = SearchControllerCountMutationResponse, TQueryKey extends QueryKey = SearchControllerCountQueryKey>(data: SearchControllerCountMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<SearchControllerCountMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<SearchControllerCountMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? searchControllerCountQueryKey(data)
         

         const query = useQuery({
          ...searchControllerCountQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const searchControllerReindexQueryKey = (data: SearchControllerReindexMutationRequest) => [{ url: '/search/reindex' }, ...(data ? [data] : [])] as const

export type SearchControllerReindexQueryKey = ReturnType<typeof searchControllerReindexQueryKey>

export function searchControllerReindexQueryOptions(data: SearchControllerReindexMutationRequest, config: Partial<RequestConfig<SearchControllerReindexMutationRequest>> & { client?: Client } = {}) {

        const queryKey = searchControllerReindexQueryKey(data)
        return queryOptions<SearchControllerReindexMutationResponse, ResponseErrorConfig<Error>, SearchControllerReindexMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return searchControllerReindex(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Reindex collections
 * {@link /search/reindex}
 */
export function useSearchControllerReindex<TData = SearchControllerReindexMutationResponse, TQueryData = SearchControllerReindexMutationResponse, TQueryKey extends QueryKey = SearchControllerReindexQueryKey>(data: SearchControllerReindexMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<SearchControllerReindexMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<SearchControllerReindexMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? searchControllerReindexQueryKey(data)
         

         const query = useQuery({
          ...searchControllerReindexQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const searchControllerReindexAllQueryKey = (data: SearchControllerReindexAllMutationRequest) => [{ url: '/search/reindex-all' }, ...(data ? [data] : [])] as const

export type SearchControllerReindexAllQueryKey = ReturnType<typeof searchControllerReindexAllQueryKey>

export function searchControllerReindexAllQueryOptions(data: SearchControllerReindexAllMutationRequest, config: Partial<RequestConfig<SearchControllerReindexAllMutationRequest>> & { client?: Client } = {}) {

        const queryKey = searchControllerReindexAllQueryKey(data)
        return queryOptions<SearchControllerReindexAllMutationResponse, ResponseErrorConfig<Error>, SearchControllerReindexAllMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return searchControllerReindexAll(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Reindex all collections (tenant agnostic)
 * {@link /search/reindex-all}
 */
export function useSearchControllerReindexAll<TData = SearchControllerReindexAllMutationResponse, TQueryData = SearchControllerReindexAllMutationResponse, TQueryKey extends QueryKey = SearchControllerReindexAllQueryKey>(data: SearchControllerReindexAllMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<SearchControllerReindexAllMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<SearchControllerReindexAllMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? searchControllerReindexAllQueryKey(data)
         

         const query = useQuery({
          ...searchControllerReindexAllQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const signatureControllerYousignSecurityCheckQueryKey = () => [{ url: '/signature/yousign/security-check' }] as const

export type SignatureControllerYousignSecurityCheckQueryKey = ReturnType<typeof signatureControllerYousignSecurityCheckQueryKey>

export function signatureControllerYousignSecurityCheckQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = signatureControllerYousignSecurityCheckQueryKey()
        return queryOptions<SignatureControllerYousignSecurityCheckQueryResponse, ResponseErrorConfig<Error>, SignatureControllerYousignSecurityCheckQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return signatureControllerYousignSecurityCheck({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * {@link /signature/yousign/security-check}
 */
export function useSignatureControllerYousignSecurityCheck<TData = SignatureControllerYousignSecurityCheckQueryResponse, TQueryData = SignatureControllerYousignSecurityCheckQueryResponse, TQueryKey extends QueryKey = SignatureControllerYousignSecurityCheckQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<SignatureControllerYousignSecurityCheckQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? signatureControllerYousignSecurityCheckQueryKey()
         

         const query = useQuery({
          ...signatureControllerYousignSecurityCheckQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const signatureControllerGetSignatureRequestsByExternalIdQueryKey = (externalId: SignatureControllerGetSignatureRequestsByExternalIdPathParams["externalId"] | undefined) => [{ url: '/signature/by-external-id/:externalId', params: {externalId:externalId} }] as const

export type SignatureControllerGetSignatureRequestsByExternalIdQueryKey = ReturnType<typeof signatureControllerGetSignatureRequestsByExternalIdQueryKey>

export function signatureControllerGetSignatureRequestsByExternalIdQueryOptions(externalId: SignatureControllerGetSignatureRequestsByExternalIdPathParams["externalId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = signatureControllerGetSignatureRequestsByExternalIdQueryKey(externalId)
        return queryOptions<SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, ResponseErrorConfig<Error>, SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, typeof queryKey>({
         enabled: !!(externalId),
         queryKey,
         queryFn: async ({ signal }) => {
            return signatureControllerGetSignatureRequestsByExternalId(externalId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Pass the policy id as `externalId`. A policy with no requests returns `200` and an empty `signatureRequests` array rather than a 404, so an empty result does not distinguish "not requested yet" from a wrong id.
 * @summary List signature requests for a policy
 * {@link /signature/by-external-id/:externalId}
 */
export function useSignatureControllerGetSignatureRequestsByExternalId<TData = SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, TQueryData = SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, TQueryKey extends QueryKey = SignatureControllerGetSignatureRequestsByExternalIdQueryKey>(externalId: SignatureControllerGetSignatureRequestsByExternalIdPathParams["externalId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<SignatureControllerGetSignatureRequestsByExternalIdQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? signatureControllerGetSignatureRequestsByExternalIdQueryKey(externalId)
         

         const query = useQuery({
          ...signatureControllerGetSignatureRequestsByExternalIdQueryOptions(externalId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const signatureControllerGetSignerLinkQueryKey = (policyId: SignatureControllerGetSignerLinkPathParams["policyId"] | undefined, signatureId: SignatureControllerGetSignerLinkPathParams["signatureId"] | undefined, signerCustomerId: SignatureControllerGetSignerLinkPathParams["signerCustomerId"] | undefined) => [{ url: '/signature/:signatureId/policy/:policyId/signers/:signerCustomerId/link', params: {signatureId:signatureId,policyId:policyId,signerCustomerId:signerCustomerId} }] as const

export type SignatureControllerGetSignerLinkQueryKey = ReturnType<typeof signatureControllerGetSignerLinkQueryKey>

export function signatureControllerGetSignerLinkQueryOptions(policyId: SignatureControllerGetSignerLinkPathParams["policyId"] | undefined, signatureId: SignatureControllerGetSignerLinkPathParams["signatureId"] | undefined, signerCustomerId: SignatureControllerGetSignerLinkPathParams["signerCustomerId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = signatureControllerGetSignerLinkQueryKey(policyId, signatureId, signerCustomerId)
        return queryOptions<SignatureControllerGetSignerLinkQueryResponse, ResponseErrorConfig<Error>, SignatureControllerGetSignerLinkQueryResponse, typeof queryKey>({
         enabled: !!(policyId && signatureId && signerCustomerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return signatureControllerGetSignerLink(policyId!, signatureId!, signerCustomerId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get signature link for a specific signer
 * {@link /signature/:signatureId/policy/:policyId/signers/:signerCustomerId/link}
 */
export function useSignatureControllerGetSignerLink<TData = SignatureControllerGetSignerLinkQueryResponse, TQueryData = SignatureControllerGetSignerLinkQueryResponse, TQueryKey extends QueryKey = SignatureControllerGetSignerLinkQueryKey>(policyId: SignatureControllerGetSignerLinkPathParams["policyId"] | undefined, signatureId: SignatureControllerGetSignerLinkPathParams["signatureId"] | undefined, signerCustomerId: SignatureControllerGetSignerLinkPathParams["signerCustomerId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<SignatureControllerGetSignerLinkQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? signatureControllerGetSignerLinkQueryKey(policyId, signatureId, signerCustomerId)
         

         const query = useQuery({
          ...signatureControllerGetSignerLinkQueryOptions(policyId, signatureId, signerCustomerId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const sirenControllerSearchSirenQueryKey = (params?: SirenControllerSearchSirenQueryParams) => [{ url: '/siren' }, ...(params ? [params] : [])] as const

export type SirenControllerSearchSirenQueryKey = ReturnType<typeof sirenControllerSearchSirenQueryKey>

export function sirenControllerSearchSirenQueryOptions(params?: SirenControllerSearchSirenQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = sirenControllerSearchSirenQueryKey(params)
        return queryOptions<SirenControllerSearchSirenQueryResponse, ResponseErrorConfig<SirenControllerSearchSiren400>, SirenControllerSearchSirenQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return sirenControllerSearchSiren(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Fetch company data from a SIREN API, from a SIRET, SIREN or a name
 * @summary Search SIREN
 * {@link /siren}
 */
export function useSirenControllerSearchSiren<TData = SirenControllerSearchSirenQueryResponse, TQueryData = SirenControllerSearchSirenQueryResponse, TQueryKey extends QueryKey = SirenControllerSearchSirenQueryKey>(params?: SirenControllerSearchSirenQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SirenControllerSearchSirenQueryResponse, ResponseErrorConfig<SirenControllerSearchSiren400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? sirenControllerSearchSirenQueryKey(params)
         

         const query = useQuery({
          ...sirenControllerSearchSirenQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SirenControllerSearchSiren400>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const addressAutocompleteControllerSuggestQueryKey = (params: AddressAutocompleteControllerSuggestQueryParams) => [{ url: '/address-autocomplete/suggest' }, ...(params ? [params] : [])] as const

export type AddressAutocompleteControllerSuggestQueryKey = ReturnType<typeof addressAutocompleteControllerSuggestQueryKey>

export function addressAutocompleteControllerSuggestQueryOptions(params: AddressAutocompleteControllerSuggestQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = addressAutocompleteControllerSuggestQueryKey(params)
        return queryOptions<AddressAutocompleteControllerSuggestQueryResponse, ResponseErrorConfig<Error>, AddressAutocompleteControllerSuggestQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return addressAutocompleteControllerSuggest(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Autocomplete addresses from a partial query
 * @summary Suggest addresses
 * {@link /address-autocomplete/suggest}
 */
export function useAddressAutocompleteControllerSuggest<TData = AddressAutocompleteControllerSuggestQueryResponse, TQueryData = AddressAutocompleteControllerSuggestQueryResponse, TQueryKey extends QueryKey = AddressAutocompleteControllerSuggestQueryKey>(params: AddressAutocompleteControllerSuggestQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AddressAutocompleteControllerSuggestQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? addressAutocompleteControllerSuggestQueryKey(params)
         

         const query = useQuery({
          ...addressAutocompleteControllerSuggestQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const sivControllerSearchSivQueryKey = (params: SivControllerSearchSivQueryParams) => [{ url: '/vehicle-information/registration' }, ...(params ? [params] : [])] as const

export type SivControllerSearchSivQueryKey = ReturnType<typeof sivControllerSearchSivQueryKey>

export function sivControllerSearchSivQueryOptions(params: SivControllerSearchSivQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = sivControllerSearchSivQueryKey(params)
        return queryOptions<SivControllerSearchSivQueryResponse, ResponseErrorConfig<SivControllerSearchSiv404>, SivControllerSearchSivQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return sivControllerSearchSiv(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the vehicle registered under the given French registration number (plaque).
 * @summary Look up a vehicle by registration number
 * {@link /vehicle-information/registration}
 */
export function useSivControllerSearchSiv<TData = SivControllerSearchSivQueryResponse, TQueryData = SivControllerSearchSivQueryResponse, TQueryKey extends QueryKey = SivControllerSearchSivQueryKey>(params: SivControllerSearchSivQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SivControllerSearchSivQueryResponse, ResponseErrorConfig<SivControllerSearchSiv404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? sivControllerSearchSivQueryKey(params)
         

         const query = useQuery({
          ...sivControllerSearchSivQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SivControllerSearchSiv404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const sivControllerSearchSivAtLegacyPathQueryKey = (params: SivControllerSearchSivAtLegacyPathQueryParams) => [{ url: '/siv' }, ...(params ? [params] : [])] as const

export type SivControllerSearchSivAtLegacyPathQueryKey = ReturnType<typeof sivControllerSearchSivAtLegacyPathQueryKey>

export function sivControllerSearchSivAtLegacyPathQueryOptions(params: SivControllerSearchSivAtLegacyPathQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = sivControllerSearchSivAtLegacyPathQueryKey(params)
        return queryOptions<SivControllerSearchSivAtLegacyPathQueryResponse, ResponseErrorConfig<SivControllerSearchSivAtLegacyPath404>, SivControllerSearchSivAtLegacyPathQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return sivControllerSearchSivAtLegacyPath(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Look up a vehicle by registration number
 * {@link /siv}
 * @deprecated
 */
export function useSivControllerSearchSivAtLegacyPath<TData = SivControllerSearchSivAtLegacyPathQueryResponse, TQueryData = SivControllerSearchSivAtLegacyPathQueryResponse, TQueryKey extends QueryKey = SivControllerSearchSivAtLegacyPathQueryKey>(params: SivControllerSearchSivAtLegacyPathQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SivControllerSearchSivAtLegacyPathQueryResponse, ResponseErrorConfig<SivControllerSearchSivAtLegacyPath404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? sivControllerSearchSivAtLegacyPathQueryKey(params)
         

         const query = useQuery({
          ...sivControllerSearchSivAtLegacyPathQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SivControllerSearchSivAtLegacyPath404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const derogationControllerCheckDerogationRequirementQueryKey = (branchId: DerogationControllerCheckDerogationRequirementPathParams["branchId"] | undefined, data: DerogationControllerCheckDerogationRequirementMutationRequest, params: DerogationControllerCheckDerogationRequirementQueryParams) => [{ url: '/derogations/branches/:branchId/check', params: {branchId:branchId} }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type DerogationControllerCheckDerogationRequirementQueryKey = ReturnType<typeof derogationControllerCheckDerogationRequirementQueryKey>

export function derogationControllerCheckDerogationRequirementQueryOptions(branchId: DerogationControllerCheckDerogationRequirementPathParams["branchId"] | undefined, data: DerogationControllerCheckDerogationRequirementMutationRequest, params: DerogationControllerCheckDerogationRequirementQueryParams, config: Partial<RequestConfig<DerogationControllerCheckDerogationRequirementMutationRequest>> & { client?: Client } = {}) {

        const queryKey = derogationControllerCheckDerogationRequirementQueryKey(branchId, data, params)
        return queryOptions<DerogationControllerCheckDerogationRequirementMutationResponse, ResponseErrorConfig<Error>, DerogationControllerCheckDerogationRequirementMutationResponse, typeof queryKey>({
         enabled: !!(branchId),
         queryKey,
         queryFn: async ({ signal }) => {
            return derogationControllerCheckDerogationRequirement(branchId!, data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Check if a derogation is required for a branch/action
 * {@link /derogations/branches/:branchId/check}
 */
export function useDerogationControllerCheckDerogationRequirement<TData = DerogationControllerCheckDerogationRequirementMutationResponse, TQueryData = DerogationControllerCheckDerogationRequirementMutationResponse, TQueryKey extends QueryKey = DerogationControllerCheckDerogationRequirementQueryKey>(branchId: DerogationControllerCheckDerogationRequirementPathParams["branchId"] | undefined, data: DerogationControllerCheckDerogationRequirementMutationRequest, params: DerogationControllerCheckDerogationRequirementQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DerogationControllerCheckDerogationRequirementMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<DerogationControllerCheckDerogationRequirementMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? derogationControllerCheckDerogationRequirementQueryKey(branchId, data, params)
         

         const query = useQuery({
          ...derogationControllerCheckDerogationRequirementQueryOptions(branchId, data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const aiAdminControllerListConversationsQueryKey = (params?: AiAdminControllerListConversationsQueryParams) => [{ url: '/ai-admin/conversations' }, ...(params ? [params] : [])] as const

export type AiAdminControllerListConversationsQueryKey = ReturnType<typeof aiAdminControllerListConversationsQueryKey>

export function aiAdminControllerListConversationsQueryOptions(params?: AiAdminControllerListConversationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = aiAdminControllerListConversationsQueryKey(params)
        return queryOptions<AiAdminControllerListConversationsQueryResponse, ResponseErrorConfig<Error>, AiAdminControllerListConversationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return aiAdminControllerListConversations(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List all conversations (admin)
 * {@link /ai-admin/conversations}
 */
export function useAiAdminControllerListConversations<TData = AiAdminControllerListConversationsQueryResponse, TQueryData = AiAdminControllerListConversationsQueryResponse, TQueryKey extends QueryKey = AiAdminControllerListConversationsQueryKey>(params?: AiAdminControllerListConversationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AiAdminControllerListConversationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? aiAdminControllerListConversationsQueryKey(params)
         

         const query = useQuery({
          ...aiAdminControllerListConversationsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const aiAdminControllerGetConversationMessagesQueryKey = (conversationId: AiAdminControllerGetConversationMessagesPathParams["conversationId"] | undefined) => [{ url: '/ai-admin/conversations/:conversationId/messages', params: {conversationId:conversationId} }] as const

export type AiAdminControllerGetConversationMessagesQueryKey = ReturnType<typeof aiAdminControllerGetConversationMessagesQueryKey>

export function aiAdminControllerGetConversationMessagesQueryOptions(conversationId: AiAdminControllerGetConversationMessagesPathParams["conversationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = aiAdminControllerGetConversationMessagesQueryKey(conversationId)
        return queryOptions<AiAdminControllerGetConversationMessagesQueryResponse, ResponseErrorConfig<Error>, AiAdminControllerGetConversationMessagesQueryResponse, typeof queryKey>({
         enabled: !!(conversationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return aiAdminControllerGetConversationMessages(conversationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get conversation messages (admin)
 * {@link /ai-admin/conversations/:conversationId/messages}
 */
export function useAiAdminControllerGetConversationMessages<TData = AiAdminControllerGetConversationMessagesQueryResponse, TQueryData = AiAdminControllerGetConversationMessagesQueryResponse, TQueryKey extends QueryKey = AiAdminControllerGetConversationMessagesQueryKey>(conversationId: AiAdminControllerGetConversationMessagesPathParams["conversationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<AiAdminControllerGetConversationMessagesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? aiAdminControllerGetConversationMessagesQueryKey(conversationId)
         

         const query = useQuery({
          ...aiAdminControllerGetConversationMessagesQueryOptions(conversationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const commentsControllerGetCommentQueryKey = (commentId: CommentsControllerGetCommentPathParams["commentId"] | undefined) => [{ url: '/comments/:commentId', params: {commentId:commentId} }] as const

export type CommentsControllerGetCommentQueryKey = ReturnType<typeof commentsControllerGetCommentQueryKey>

export function commentsControllerGetCommentQueryOptions(commentId: CommentsControllerGetCommentPathParams["commentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = commentsControllerGetCommentQueryKey(commentId)
        return queryOptions<CommentsControllerGetCommentQueryResponse, ResponseErrorConfig<CommentsControllerGetComment404>, CommentsControllerGetCommentQueryResponse, typeof queryKey>({
         enabled: !!(commentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return commentsControllerGetComment(commentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a comment for an entity and branch
 * {@link /comments/:commentId}
 */
export function useCommentsControllerGetComment<TData = CommentsControllerGetCommentQueryResponse, TQueryData = CommentsControllerGetCommentQueryResponse, TQueryKey extends QueryKey = CommentsControllerGetCommentQueryKey>(commentId: CommentsControllerGetCommentPathParams["commentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<CommentsControllerGetCommentQueryResponse, ResponseErrorConfig<CommentsControllerGetComment404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? commentsControllerGetCommentQueryKey(commentId)
         

         const query = useQuery({
          ...commentsControllerGetCommentQueryOptions(commentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CommentsControllerGetComment404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const commentsControllerListCommentsQueryKey = (entityId: CommentsControllerListCommentsPathParams["entityId"] | undefined, params?: CommentsControllerListCommentsQueryParams) => [{ url: '/comments/:entityId/list', params: {entityId:entityId} }, ...(params ? [params] : [])] as const

export type CommentsControllerListCommentsQueryKey = ReturnType<typeof commentsControllerListCommentsQueryKey>

export function commentsControllerListCommentsQueryOptions(entityId: CommentsControllerListCommentsPathParams["entityId"] | undefined, params?: CommentsControllerListCommentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = commentsControllerListCommentsQueryKey(entityId, params)
        return queryOptions<CommentsControllerListCommentsQueryResponse, ResponseErrorConfig<Error>, CommentsControllerListCommentsQueryResponse, typeof queryKey>({
         enabled: !!(entityId),
         queryKey,
         queryFn: async ({ signal }) => {
            return commentsControllerListComments(entityId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List comments for an entity and branch
 * {@link /comments/:entityId/list}
 */
export function useCommentsControllerListComments<TData = CommentsControllerListCommentsQueryResponse, TQueryData = CommentsControllerListCommentsQueryResponse, TQueryKey extends QueryKey = CommentsControllerListCommentsQueryKey>(entityId: CommentsControllerListCommentsPathParams["entityId"] | undefined, params?: CommentsControllerListCommentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CommentsControllerListCommentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? commentsControllerListCommentsQueryKey(entityId, params)
         

         const query = useQuery({
          ...commentsControllerListCommentsQueryOptions(entityId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const internalNotesControllerListQueryKey = (policyId: InternalNotesControllerListPathParams["policyId"] | undefined, params?: InternalNotesControllerListQueryParams) => [{ url: '/policies/:policyId/internal-notes', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type InternalNotesControllerListQueryKey = ReturnType<typeof internalNotesControllerListQueryKey>

export function internalNotesControllerListQueryOptions(policyId: InternalNotesControllerListPathParams["policyId"] | undefined, params?: InternalNotesControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = internalNotesControllerListQueryKey(policyId, params)
        return queryOptions<InternalNotesControllerListQueryResponse, ResponseErrorConfig<Error>, InternalNotesControllerListQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return internalNotesControllerList(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List internal notes on a policy
 * {@link /policies/:policyId/internal-notes}
 */
export function useInternalNotesControllerList<TData = InternalNotesControllerListQueryResponse, TQueryData = InternalNotesControllerListQueryResponse, TQueryKey extends QueryKey = InternalNotesControllerListQueryKey>(policyId: InternalNotesControllerListPathParams["policyId"] | undefined, params?: InternalNotesControllerListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<InternalNotesControllerListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? internalNotesControllerListQueryKey(policyId, params)
         

         const query = useQuery({
          ...internalNotesControllerListQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const internalNotesControllerGetQueryKey = (policyId: InternalNotesControllerGetPathParams["policyId"] | undefined, noteId: InternalNotesControllerGetPathParams["noteId"] | undefined) => [{ url: '/policies/:policyId/internal-notes/:noteId', params: {policyId:policyId,noteId:noteId} }] as const

export type InternalNotesControllerGetQueryKey = ReturnType<typeof internalNotesControllerGetQueryKey>

export function internalNotesControllerGetQueryOptions(policyId: InternalNotesControllerGetPathParams["policyId"] | undefined, noteId: InternalNotesControllerGetPathParams["noteId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = internalNotesControllerGetQueryKey(policyId, noteId)
        return queryOptions<InternalNotesControllerGetQueryResponse, ResponseErrorConfig<InternalNotesControllerGet404>, InternalNotesControllerGetQueryResponse, typeof queryKey>({
         enabled: !!(policyId && noteId),
         queryKey,
         queryFn: async ({ signal }) => {
            return internalNotesControllerGet(policyId!, noteId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get an internal note by id
 * {@link /policies/:policyId/internal-notes/:noteId}
 */
export function useInternalNotesControllerGet<TData = InternalNotesControllerGetQueryResponse, TQueryData = InternalNotesControllerGetQueryResponse, TQueryKey extends QueryKey = InternalNotesControllerGetQueryKey>(policyId: InternalNotesControllerGetPathParams["policyId"] | undefined, noteId: InternalNotesControllerGetPathParams["noteId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<InternalNotesControllerGetQueryResponse, ResponseErrorConfig<InternalNotesControllerGet404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? internalNotesControllerGetQueryKey(policyId, noteId)
         

         const query = useQuery({
          ...internalNotesControllerGetQueryOptions(policyId, noteId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<InternalNotesControllerGet404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimInternalNotesControllerListQueryKey = (claimId: ClaimInternalNotesControllerListPathParams["claimId"] | undefined, params?: ClaimInternalNotesControllerListQueryParams) => [{ url: '/claim-management/claims/:claimId/internal-notes', params: {claimId:claimId} }, ...(params ? [params] : [])] as const

export type ClaimInternalNotesControllerListQueryKey = ReturnType<typeof claimInternalNotesControllerListQueryKey>

export function claimInternalNotesControllerListQueryOptions(claimId: ClaimInternalNotesControllerListPathParams["claimId"] | undefined, params?: ClaimInternalNotesControllerListQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimInternalNotesControllerListQueryKey(claimId, params)
        return queryOptions<ClaimInternalNotesControllerListQueryResponse, ResponseErrorConfig<Error>, ClaimInternalNotesControllerListQueryResponse, typeof queryKey>({
         enabled: !!(claimId),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimInternalNotesControllerList(claimId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List internal notes on a claim
 * {@link /claim-management/claims/:claimId/internal-notes}
 */
export function useClaimInternalNotesControllerList<TData = ClaimInternalNotesControllerListQueryResponse, TQueryData = ClaimInternalNotesControllerListQueryResponse, TQueryKey extends QueryKey = ClaimInternalNotesControllerListQueryKey>(claimId: ClaimInternalNotesControllerListPathParams["claimId"] | undefined, params?: ClaimInternalNotesControllerListQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ClaimInternalNotesControllerListQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimInternalNotesControllerListQueryKey(claimId, params)
         

         const query = useQuery({
          ...claimInternalNotesControllerListQueryOptions(claimId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const claimInternalNotesControllerGetQueryKey = (claimId: ClaimInternalNotesControllerGetPathParams["claimId"] | undefined, noteId: ClaimInternalNotesControllerGetPathParams["noteId"] | undefined) => [{ url: '/claim-management/claims/:claimId/internal-notes/:noteId', params: {claimId:claimId,noteId:noteId} }] as const

export type ClaimInternalNotesControllerGetQueryKey = ReturnType<typeof claimInternalNotesControllerGetQueryKey>

export function claimInternalNotesControllerGetQueryOptions(claimId: ClaimInternalNotesControllerGetPathParams["claimId"] | undefined, noteId: ClaimInternalNotesControllerGetPathParams["noteId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = claimInternalNotesControllerGetQueryKey(claimId, noteId)
        return queryOptions<ClaimInternalNotesControllerGetQueryResponse, ResponseErrorConfig<ClaimInternalNotesControllerGet404>, ClaimInternalNotesControllerGetQueryResponse, typeof queryKey>({
         enabled: !!(claimId && noteId),
         queryKey,
         queryFn: async ({ signal }) => {
            return claimInternalNotesControllerGet(claimId!, noteId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get an internal note on a claim
 * {@link /claim-management/claims/:claimId/internal-notes/:noteId}
 */
export function useClaimInternalNotesControllerGet<TData = ClaimInternalNotesControllerGetQueryResponse, TQueryData = ClaimInternalNotesControllerGetQueryResponse, TQueryKey extends QueryKey = ClaimInternalNotesControllerGetQueryKey>(claimId: ClaimInternalNotesControllerGetPathParams["claimId"] | undefined, noteId: ClaimInternalNotesControllerGetPathParams["noteId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ClaimInternalNotesControllerGetQueryResponse, ResponseErrorConfig<ClaimInternalNotesControllerGet404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? claimInternalNotesControllerGetQueryKey(claimId, noteId)
         

         const query = useQuery({
          ...claimInternalNotesControllerGetQueryOptions(claimId, noteId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ClaimInternalNotesControllerGet404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const conversationControllerListConversationsQueryKey = () => [{ url: '/conversations' }] as const

export type ConversationControllerListConversationsQueryKey = ReturnType<typeof conversationControllerListConversationsQueryKey>

export function conversationControllerListConversationsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = conversationControllerListConversationsQueryKey()
        return queryOptions<ConversationControllerListConversationsQueryResponse, ResponseErrorConfig<Error>, ConversationControllerListConversationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return conversationControllerListConversations({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List conversations for the current user
 * {@link /conversations}
 */
export function useConversationControllerListConversations<TData = ConversationControllerListConversationsQueryResponse, TQueryData = ConversationControllerListConversationsQueryResponse, TQueryKey extends QueryKey = ConversationControllerListConversationsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<ConversationControllerListConversationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? conversationControllerListConversationsQueryKey()
         

         const query = useQuery({
          ...conversationControllerListConversationsQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const conversationControllerGetConversationQueryKey = (conversationId: ConversationControllerGetConversationPathParams["conversationId"] | undefined) => [{ url: '/conversations/:conversationId', params: {conversationId:conversationId} }] as const

export type ConversationControllerGetConversationQueryKey = ReturnType<typeof conversationControllerGetConversationQueryKey>

export function conversationControllerGetConversationQueryOptions(conversationId: ConversationControllerGetConversationPathParams["conversationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = conversationControllerGetConversationQueryKey(conversationId)
        return queryOptions<ConversationControllerGetConversationQueryResponse, ResponseErrorConfig<ConversationControllerGetConversation404>, ConversationControllerGetConversationQueryResponse, typeof queryKey>({
         enabled: !!(conversationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return conversationControllerGetConversation(conversationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a conversation
 * {@link /conversations/:conversationId}
 */
export function useConversationControllerGetConversation<TData = ConversationControllerGetConversationQueryResponse, TQueryData = ConversationControllerGetConversationQueryResponse, TQueryKey extends QueryKey = ConversationControllerGetConversationQueryKey>(conversationId: ConversationControllerGetConversationPathParams["conversationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ConversationControllerGetConversationQueryResponse, ResponseErrorConfig<ConversationControllerGetConversation404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? conversationControllerGetConversationQueryKey(conversationId)
         

         const query = useQuery({
          ...conversationControllerGetConversationQueryOptions(conversationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConversationControllerGetConversation404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const conversationControllerGetConversationMessagesQueryKey = (conversationId: ConversationControllerGetConversationMessagesPathParams["conversationId"] | undefined) => [{ url: '/conversations/:conversationId/messages', params: {conversationId:conversationId} }] as const

export type ConversationControllerGetConversationMessagesQueryKey = ReturnType<typeof conversationControllerGetConversationMessagesQueryKey>

export function conversationControllerGetConversationMessagesQueryOptions(conversationId: ConversationControllerGetConversationMessagesPathParams["conversationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = conversationControllerGetConversationMessagesQueryKey(conversationId)
        return queryOptions<ConversationControllerGetConversationMessagesQueryResponse, ResponseErrorConfig<ConversationControllerGetConversationMessages404>, ConversationControllerGetConversationMessagesQueryResponse, typeof queryKey>({
         enabled: !!(conversationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return conversationControllerGetConversationMessages(conversationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get messages for a conversation
 * {@link /conversations/:conversationId/messages}
 */
export function useConversationControllerGetConversationMessages<TData = ConversationControllerGetConversationMessagesQueryResponse, TQueryData = ConversationControllerGetConversationMessagesQueryResponse, TQueryKey extends QueryKey = ConversationControllerGetConversationMessagesQueryKey>(conversationId: ConversationControllerGetConversationMessagesPathParams["conversationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ConversationControllerGetConversationMessagesQueryResponse, ResponseErrorConfig<ConversationControllerGetConversationMessages404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? conversationControllerGetConversationMessagesQueryKey(conversationId)
         

         const query = useQuery({
          ...conversationControllerGetConversationMessagesQueryOptions(conversationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ConversationControllerGetConversationMessages404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const sraControllerGetFacetQueryKey = (params: SraControllerGetFacetQueryParams) => [{ url: '/vehicle-information/facet' }, ...(params ? [params] : [])] as const

export type SraControllerGetFacetQueryKey = ReturnType<typeof sraControllerGetFacetQueryKey>

export function sraControllerGetFacetQueryOptions(params: SraControllerGetFacetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = sraControllerGetFacetQueryKey(params)
        return queryOptions<SraControllerGetFacetQueryResponse, ResponseErrorConfig<Error>, SraControllerGetFacetQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return sraControllerGetFacet(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the available values for one facet, such as brand or model.
 * @summary List the values of a vehicle facet
 * {@link /vehicle-information/facet}
 */
export function useSraControllerGetFacet<TData = SraControllerGetFacetQueryResponse, TQueryData = SraControllerGetFacetQueryResponse, TQueryKey extends QueryKey = SraControllerGetFacetQueryKey>(params: SraControllerGetFacetQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SraControllerGetFacetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? sraControllerGetFacetQueryKey(params)
         

         const query = useQuery({
          ...sraControllerGetFacetQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const sraControllerGetVehicleDetailsQueryKey = (params: SraControllerGetVehicleDetailsQueryParams) => [{ url: '/vehicle-information/details' }, ...(params ? [params] : [])] as const

export type SraControllerGetVehicleDetailsQueryKey = ReturnType<typeof sraControllerGetVehicleDetailsQueryKey>

export function sraControllerGetVehicleDetailsQueryOptions(params: SraControllerGetVehicleDetailsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = sraControllerGetVehicleDetailsQueryKey(params)
        return queryOptions<SraControllerGetVehicleDetailsQueryResponse, ResponseErrorConfig<Error>, SraControllerGetVehicleDetailsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return sraControllerGetVehicleDetails(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get vehicle details
 * {@link /vehicle-information/details}
 */
export function useSraControllerGetVehicleDetails<TData = SraControllerGetVehicleDetailsQueryResponse, TQueryData = SraControllerGetVehicleDetailsQueryResponse, TQueryKey extends QueryKey = SraControllerGetVehicleDetailsQueryKey>(params: SraControllerGetVehicleDetailsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SraControllerGetVehicleDetailsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? sraControllerGetVehicleDetailsQueryKey(params)
         

         const query = useQuery({
          ...sraControllerGetVehicleDetailsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const sraControllerGetVersionInformationFromBrandAndModelQueryKey = (params: SraControllerGetVersionInformationFromBrandAndModelQueryParams) => [{ url: '/vehicle-information/versions' }, ...(params ? [params] : [])] as const

export type SraControllerGetVersionInformationFromBrandAndModelQueryKey = ReturnType<typeof sraControllerGetVersionInformationFromBrandAndModelQueryKey>

export function sraControllerGetVersionInformationFromBrandAndModelQueryOptions(params: SraControllerGetVersionInformationFromBrandAndModelQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = sraControllerGetVersionInformationFromBrandAndModelQueryKey(params)
        return queryOptions<SraControllerGetVersionInformationFromBrandAndModelQueryResponse, ResponseErrorConfig<Error>, SraControllerGetVersionInformationFromBrandAndModelQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return sraControllerGetVersionInformationFromBrandAndModel(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Each version comes with its fiscal power and number of seats.
 * @summary List the versions of a brand and model
 * {@link /vehicle-information/versions}
 */
export function useSraControllerGetVersionInformationFromBrandAndModel<TData = SraControllerGetVersionInformationFromBrandAndModelQueryResponse, TQueryData = SraControllerGetVersionInformationFromBrandAndModelQueryResponse, TQueryKey extends QueryKey = SraControllerGetVersionInformationFromBrandAndModelQueryKey>(params: SraControllerGetVersionInformationFromBrandAndModelQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<SraControllerGetVersionInformationFromBrandAndModelQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? sraControllerGetVersionInformationFromBrandAndModelQueryKey(params)
         

         const query = useQuery({
          ...sraControllerGetVersionInformationFromBrandAndModelQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const hiscoxControllerGetActivitiesBySectorQueryKey = (params: HiscoxControllerGetActivitiesBySectorQueryParams) => [{ url: '/hiscox/activities-by-sector' }, ...(params ? [params] : [])] as const

export type HiscoxControllerGetActivitiesBySectorQueryKey = ReturnType<typeof hiscoxControllerGetActivitiesBySectorQueryKey>

export function hiscoxControllerGetActivitiesBySectorQueryOptions(params: HiscoxControllerGetActivitiesBySectorQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = hiscoxControllerGetActivitiesBySectorQueryKey(params)
        return queryOptions<HiscoxControllerGetActivitiesBySectorQueryResponse, ResponseErrorConfig<Error>, HiscoxControllerGetActivitiesBySectorQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return hiscoxControllerGetActivitiesBySector(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get activities from the same sector as the given activity
 * {@link /hiscox/activities-by-sector}
 */
export function useHiscoxControllerGetActivitiesBySector<TData = HiscoxControllerGetActivitiesBySectorQueryResponse, TQueryData = HiscoxControllerGetActivitiesBySectorQueryResponse, TQueryKey extends QueryKey = HiscoxControllerGetActivitiesBySectorQueryKey>(params: HiscoxControllerGetActivitiesBySectorQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<HiscoxControllerGetActivitiesBySectorQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? hiscoxControllerGetActivitiesBySectorQueryKey(params)
         

         const query = useQuery({
          ...hiscoxControllerGetActivitiesBySectorQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const userControllerGetMyUserWithDrivequantDataQueryKey = (params?: UserControllerGetMyUserWithDrivequantDataQueryParams) => [{ url: '/user/@me/drivequant' }, ...(params ? [params] : [])] as const

export type UserControllerGetMyUserWithDrivequantDataQueryKey = ReturnType<typeof userControllerGetMyUserWithDrivequantDataQueryKey>

export function userControllerGetMyUserWithDrivequantDataQueryOptions(params?: UserControllerGetMyUserWithDrivequantDataQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = userControllerGetMyUserWithDrivequantDataQueryKey(params)
        return queryOptions<UserControllerGetMyUserWithDrivequantDataQueryResponse, ResponseErrorConfig<UserControllerGetMyUserWithDrivequantData404>, UserControllerGetMyUserWithDrivequantDataQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return userControllerGetMyUserWithDrivequantData(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve user data with Drivequant unique ID
 * {@link /user/@me/drivequant}
 */
export function useUserControllerGetMyUserWithDrivequantData<TData = UserControllerGetMyUserWithDrivequantDataQueryResponse, TQueryData = UserControllerGetMyUserWithDrivequantDataQueryResponse, TQueryKey extends QueryKey = UserControllerGetMyUserWithDrivequantDataQueryKey>(params?: UserControllerGetMyUserWithDrivequantDataQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<UserControllerGetMyUserWithDrivequantDataQueryResponse, ResponseErrorConfig<UserControllerGetMyUserWithDrivequantData404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? userControllerGetMyUserWithDrivequantDataQueryKey(params)
         

         const query = useQuery({
          ...userControllerGetMyUserWithDrivequantDataQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UserControllerGetMyUserWithDrivequantData404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const workflowsControllerListWorkflowRunsQueryKey = (data: WorkflowsControllerListWorkflowRunsMutationRequest) => [{ url: '/workflows/list-by-metadata' }, ...(data ? [data] : [])] as const

export type WorkflowsControllerListWorkflowRunsQueryKey = ReturnType<typeof workflowsControllerListWorkflowRunsQueryKey>

export function workflowsControllerListWorkflowRunsQueryOptions(data: WorkflowsControllerListWorkflowRunsMutationRequest, config: Partial<RequestConfig<WorkflowsControllerListWorkflowRunsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = workflowsControllerListWorkflowRunsQueryKey(data)
        return queryOptions<WorkflowsControllerListWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, WorkflowsControllerListWorkflowRunsMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return workflowsControllerListWorkflowRuns(data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List workflow runs
 * {@link /workflows/list-by-metadata}
 */
export function useWorkflowsControllerListWorkflowRuns<TData = WorkflowsControllerListWorkflowRunsMutationResponse, TQueryData = WorkflowsControllerListWorkflowRunsMutationResponse, TQueryKey extends QueryKey = WorkflowsControllerListWorkflowRunsQueryKey>(data: WorkflowsControllerListWorkflowRunsMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<WorkflowsControllerListWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<WorkflowsControllerListWorkflowRunsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? workflowsControllerListWorkflowRunsQueryKey(data)
         

         const query = useQuery({
          ...workflowsControllerListWorkflowRunsQueryOptions(data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const workflowsControllerGetWorkflowRunQueryKey = (id: WorkflowsControllerGetWorkflowRunPathParams["id"] | undefined) => [{ url: '/workflows/:id', params: {id:id} }] as const

export type WorkflowsControllerGetWorkflowRunQueryKey = ReturnType<typeof workflowsControllerGetWorkflowRunQueryKey>

export function workflowsControllerGetWorkflowRunQueryOptions(id: WorkflowsControllerGetWorkflowRunPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = workflowsControllerGetWorkflowRunQueryKey(id)
        return queryOptions<WorkflowsControllerGetWorkflowRunQueryResponse, ResponseErrorConfig<Error>, WorkflowsControllerGetWorkflowRunQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return workflowsControllerGetWorkflowRun(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get workflow run
 * {@link /workflows/:id}
 */
export function useWorkflowsControllerGetWorkflowRun<TData = WorkflowsControllerGetWorkflowRunQueryResponse, TQueryData = WorkflowsControllerGetWorkflowRunQueryResponse, TQueryKey extends QueryKey = WorkflowsControllerGetWorkflowRunQueryKey>(id: WorkflowsControllerGetWorkflowRunPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<WorkflowsControllerGetWorkflowRunQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? workflowsControllerGetWorkflowRunQueryKey(id)
         

         const query = useQuery({
          ...workflowsControllerGetWorkflowRunQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const workflowsControllerListWorkflowRunNodesQueryKey = (id: WorkflowsControllerListWorkflowRunNodesPathParams["id"] | undefined, params?: WorkflowsControllerListWorkflowRunNodesQueryParams) => [{ url: '/workflows/:id/nodes', params: {id:id} }, ...(params ? [params] : [])] as const

export type WorkflowsControllerListWorkflowRunNodesQueryKey = ReturnType<typeof workflowsControllerListWorkflowRunNodesQueryKey>

export function workflowsControllerListWorkflowRunNodesQueryOptions(id: WorkflowsControllerListWorkflowRunNodesPathParams["id"] | undefined, params?: WorkflowsControllerListWorkflowRunNodesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = workflowsControllerListWorkflowRunNodesQueryKey(id, params)
        return queryOptions<WorkflowsControllerListWorkflowRunNodesQueryResponse, ResponseErrorConfig<Error>, WorkflowsControllerListWorkflowRunNodesQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return workflowsControllerListWorkflowRunNodes(id!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List workflow run nodes
 * {@link /workflows/:id/nodes}
 */
export function useWorkflowsControllerListWorkflowRunNodes<TData = WorkflowsControllerListWorkflowRunNodesQueryResponse, TQueryData = WorkflowsControllerListWorkflowRunNodesQueryResponse, TQueryKey extends QueryKey = WorkflowsControllerListWorkflowRunNodesQueryKey>(id: WorkflowsControllerListWorkflowRunNodesPathParams["id"] | undefined, params?: WorkflowsControllerListWorkflowRunNodesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<WorkflowsControllerListWorkflowRunNodesQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? workflowsControllerListWorkflowRunNodesQueryKey(id, params)
         

         const query = useQuery({
          ...workflowsControllerListWorkflowRunNodesQueryOptions(id, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const yeetControllerListDrivequantAverageScoresQueryKey = (policyId: YeetControllerListDrivequantAverageScoresPathParams["policyId"] | undefined, params?: YeetControllerListDrivequantAverageScoresQueryParams) => [{ url: '/yeet/drivequant-scores/:policyId/average', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type YeetControllerListDrivequantAverageScoresQueryKey = ReturnType<typeof yeetControllerListDrivequantAverageScoresQueryKey>

export function yeetControllerListDrivequantAverageScoresQueryOptions(policyId: YeetControllerListDrivequantAverageScoresPathParams["policyId"] | undefined, params?: YeetControllerListDrivequantAverageScoresQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = yeetControllerListDrivequantAverageScoresQueryKey(policyId, params)
        return queryOptions<YeetControllerListDrivequantAverageScoresQueryResponse, ResponseErrorConfig<Error>, YeetControllerListDrivequantAverageScoresQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return yeetControllerListDrivequantAverageScores(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List averages scores on the policy
 * {@link /yeet/drivequant-scores/:policyId/average}
 */
export function useYeetControllerListDrivequantAverageScores<TData = YeetControllerListDrivequantAverageScoresQueryResponse, TQueryData = YeetControllerListDrivequantAverageScoresQueryResponse, TQueryKey extends QueryKey = YeetControllerListDrivequantAverageScoresQueryKey>(policyId: YeetControllerListDrivequantAverageScoresPathParams["policyId"] | undefined, params?: YeetControllerListDrivequantAverageScoresQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<YeetControllerListDrivequantAverageScoresQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? yeetControllerListDrivequantAverageScoresQueryKey(policyId, params)
         

         const query = useQuery({
          ...yeetControllerListDrivequantAverageScoresQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const yeetControllerListPossibleDrivequantUsersQueryKey = (customerId: YeetControllerListPossibleDrivequantUsersPathParams["customerId"] | undefined, params?: YeetControllerListPossibleDrivequantUsersQueryParams) => [{ url: '/yeet/:customerId/possible-drivequant-ids', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type YeetControllerListPossibleDrivequantUsersQueryKey = ReturnType<typeof yeetControllerListPossibleDrivequantUsersQueryKey>

export function yeetControllerListPossibleDrivequantUsersQueryOptions(customerId: YeetControllerListPossibleDrivequantUsersPathParams["customerId"] | undefined, params?: YeetControllerListPossibleDrivequantUsersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = yeetControllerListPossibleDrivequantUsersQueryKey(customerId, params)
        return queryOptions<YeetControllerListPossibleDrivequantUsersQueryResponse, ResponseErrorConfig<Error>, YeetControllerListPossibleDrivequantUsersQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return yeetControllerListPossibleDrivequantUsers(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get customer possible external service ids
 * {@link /yeet/:customerId/possible-drivequant-ids}
 */
export function useYeetControllerListPossibleDrivequantUsers<TData = YeetControllerListPossibleDrivequantUsersQueryResponse, TQueryData = YeetControllerListPossibleDrivequantUsersQueryResponse, TQueryKey extends QueryKey = YeetControllerListPossibleDrivequantUsersQueryKey>(customerId: YeetControllerListPossibleDrivequantUsersPathParams["customerId"] | undefined, params?: YeetControllerListPossibleDrivequantUsersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<YeetControllerListPossibleDrivequantUsersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? yeetControllerListPossibleDrivequantUsersQueryKey(customerId, params)
         

         const query = useQuery({
          ...yeetControllerListPossibleDrivequantUsersQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const yeetControllerListDrivequantHistoricalUsersQueryKey = (customerId: YeetControllerListDrivequantHistoricalUsersPathParams["customerId"] | undefined) => [{ url: '/yeet/:customerId/drivequant-users', params: {customerId:customerId} }] as const

export type YeetControllerListDrivequantHistoricalUsersQueryKey = ReturnType<typeof yeetControllerListDrivequantHistoricalUsersQueryKey>

export function yeetControllerListDrivequantHistoricalUsersQueryOptions(customerId: YeetControllerListDrivequantHistoricalUsersPathParams["customerId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = yeetControllerListDrivequantHistoricalUsersQueryKey(customerId)
        return queryOptions<YeetControllerListDrivequantHistoricalUsersQueryResponse, ResponseErrorConfig<Error>, YeetControllerListDrivequantHistoricalUsersQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return yeetControllerListDrivequantHistoricalUsers(customerId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List historical Drivequant users attached to the customer
 * {@link /yeet/:customerId/drivequant-users}
 */
export function useYeetControllerListDrivequantHistoricalUsers<TData = YeetControllerListDrivequantHistoricalUsersQueryResponse, TQueryData = YeetControllerListDrivequantHistoricalUsersQueryResponse, TQueryKey extends QueryKey = YeetControllerListDrivequantHistoricalUsersQueryKey>(customerId: YeetControllerListDrivequantHistoricalUsersPathParams["customerId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<YeetControllerListDrivequantHistoricalUsersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? yeetControllerListDrivequantHistoricalUsersQueryKey(customerId)
         

         const query = useQuery({
          ...yeetControllerListDrivequantHistoricalUsersQueryOptions(customerId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const axeceControllerListDrivequantAverageScoresQueryKey = (policyId: AxeceControllerListDrivequantAverageScoresPathParams["policyId"] | undefined, params?: AxeceControllerListDrivequantAverageScoresQueryParams) => [{ url: '/axece/drivequant-scores/:policyId/average', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type AxeceControllerListDrivequantAverageScoresQueryKey = ReturnType<typeof axeceControllerListDrivequantAverageScoresQueryKey>

export function axeceControllerListDrivequantAverageScoresQueryOptions(policyId: AxeceControllerListDrivequantAverageScoresPathParams["policyId"] | undefined, params?: AxeceControllerListDrivequantAverageScoresQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = axeceControllerListDrivequantAverageScoresQueryKey(policyId, params)
        return queryOptions<AxeceControllerListDrivequantAverageScoresQueryResponse, ResponseErrorConfig<Error>, AxeceControllerListDrivequantAverageScoresQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return axeceControllerListDrivequantAverageScores(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List averages scores on the policy
 * {@link /axece/drivequant-scores/:policyId/average}
 */
export function useAxeceControllerListDrivequantAverageScores<TData = AxeceControllerListDrivequantAverageScoresQueryResponse, TQueryData = AxeceControllerListDrivequantAverageScoresQueryResponse, TQueryKey extends QueryKey = AxeceControllerListDrivequantAverageScoresQueryKey>(policyId: AxeceControllerListDrivequantAverageScoresPathParams["policyId"] | undefined, params?: AxeceControllerListDrivequantAverageScoresQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AxeceControllerListDrivequantAverageScoresQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? axeceControllerListDrivequantAverageScoresQueryKey(policyId, params)
         

         const query = useQuery({
          ...axeceControllerListDrivequantAverageScoresQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const axeceControllerListPossibleDrivequantUsersQueryKey = (customerId: AxeceControllerListPossibleDrivequantUsersPathParams["customerId"] | undefined, params?: AxeceControllerListPossibleDrivequantUsersQueryParams) => [{ url: '/axece/:customerId/possible-drivequant-ids', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type AxeceControllerListPossibleDrivequantUsersQueryKey = ReturnType<typeof axeceControllerListPossibleDrivequantUsersQueryKey>

export function axeceControllerListPossibleDrivequantUsersQueryOptions(customerId: AxeceControllerListPossibleDrivequantUsersPathParams["customerId"] | undefined, params?: AxeceControllerListPossibleDrivequantUsersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = axeceControllerListPossibleDrivequantUsersQueryKey(customerId, params)
        return queryOptions<AxeceControllerListPossibleDrivequantUsersQueryResponse, ResponseErrorConfig<Error>, AxeceControllerListPossibleDrivequantUsersQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return axeceControllerListPossibleDrivequantUsers(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get customer possible external service ids
 * {@link /axece/:customerId/possible-drivequant-ids}
 */
export function useAxeceControllerListPossibleDrivequantUsers<TData = AxeceControllerListPossibleDrivequantUsersQueryResponse, TQueryData = AxeceControllerListPossibleDrivequantUsersQueryResponse, TQueryKey extends QueryKey = AxeceControllerListPossibleDrivequantUsersQueryKey>(customerId: AxeceControllerListPossibleDrivequantUsersPathParams["customerId"] | undefined, params?: AxeceControllerListPossibleDrivequantUsersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AxeceControllerListPossibleDrivequantUsersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? axeceControllerListPossibleDrivequantUsersQueryKey(customerId, params)
         

         const query = useQuery({
          ...axeceControllerListPossibleDrivequantUsersQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const axeceControllerListDrivequantHistoricalUsersQueryKey = (customerId: AxeceControllerListDrivequantHistoricalUsersPathParams["customerId"] | undefined) => [{ url: '/axece/:customerId/drivequant-users', params: {customerId:customerId} }] as const

export type AxeceControllerListDrivequantHistoricalUsersQueryKey = ReturnType<typeof axeceControllerListDrivequantHistoricalUsersQueryKey>

export function axeceControllerListDrivequantHistoricalUsersQueryOptions(customerId: AxeceControllerListDrivequantHistoricalUsersPathParams["customerId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = axeceControllerListDrivequantHistoricalUsersQueryKey(customerId)
        return queryOptions<AxeceControllerListDrivequantHistoricalUsersQueryResponse, ResponseErrorConfig<Error>, AxeceControllerListDrivequantHistoricalUsersQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return axeceControllerListDrivequantHistoricalUsers(customerId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List historical Drivequant users attached to the customer
 * {@link /axece/:customerId/drivequant-users}
 */
export function useAxeceControllerListDrivequantHistoricalUsers<TData = AxeceControllerListDrivequantHistoricalUsersQueryResponse, TQueryData = AxeceControllerListDrivequantHistoricalUsersQueryResponse, TQueryKey extends QueryKey = AxeceControllerListDrivequantHistoricalUsersQueryKey>(customerId: AxeceControllerListDrivequantHistoricalUsersPathParams["customerId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<AxeceControllerListDrivequantHistoricalUsersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? axeceControllerListDrivequantHistoricalUsersQueryKey(customerId)
         

         const query = useQuery({
          ...axeceControllerListDrivequantHistoricalUsersQueryOptions(customerId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const adminAr24ControllerListUsersQueryKey = () => [{ url: '/ar24/users' }] as const

export type AdminAr24ControllerListUsersQueryKey = ReturnType<typeof adminAr24ControllerListUsersQueryKey>

export function adminAr24ControllerListUsersQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = adminAr24ControllerListUsersQueryKey()
        return queryOptions<AdminAr24ControllerListUsersQueryResponse, ResponseErrorConfig<Error>, AdminAr24ControllerListUsersQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return adminAr24ControllerListUsers({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the AR24 accounts registered letters are sent from
 * {@link /ar24/users}
 */
export function useAdminAr24ControllerListUsers<TData = AdminAr24ControllerListUsersQueryResponse, TQueryData = AdminAr24ControllerListUsersQueryResponse, TQueryKey extends QueryKey = AdminAr24ControllerListUsersQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<AdminAr24ControllerListUsersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? adminAr24ControllerListUsersQueryKey()
         

         const query = useQuery({
          ...adminAr24ControllerListUsersQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const adminAr24ControllerGetUserQueryKey = (userId: AdminAr24ControllerGetUserPathParams["userId"] | undefined) => [{ url: '/ar24/users/:userId', params: {userId:userId} }] as const

export type AdminAr24ControllerGetUserQueryKey = ReturnType<typeof adminAr24ControllerGetUserQueryKey>

export function adminAr24ControllerGetUserQueryOptions(userId: AdminAr24ControllerGetUserPathParams["userId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = adminAr24ControllerGetUserQueryKey(userId)
        return queryOptions<AdminAr24ControllerGetUserQueryResponse, ResponseErrorConfig<Error>, AdminAr24ControllerGetUserQueryResponse, typeof queryKey>({
         enabled: !!(userId),
         queryKey,
         queryFn: async ({ signal }) => {
            return adminAr24ControllerGetUser(userId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get one AR24 account
 * {@link /ar24/users/:userId}
 */
export function useAdminAr24ControllerGetUser<TData = AdminAr24ControllerGetUserQueryResponse, TQueryData = AdminAr24ControllerGetUserQueryResponse, TQueryKey extends QueryKey = AdminAr24ControllerGetUserQueryKey>(userId: AdminAr24ControllerGetUserPathParams["userId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<AdminAr24ControllerGetUserQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? adminAr24ControllerGetUserQueryKey(userId)
         

         const query = useQuery({
          ...adminAr24ControllerGetUserQueryOptions(userId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerAccountingSummaryQueryKey = (params?: ViewSpecificControllerAccountingSummaryQueryParams) => [{ url: '/view-specific/accounting-summary' }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerAccountingSummaryQueryKey = ReturnType<typeof viewSpecificControllerAccountingSummaryQueryKey>

export function viewSpecificControllerAccountingSummaryQueryOptions(params?: ViewSpecificControllerAccountingSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerAccountingSummaryQueryKey(params)
        return queryOptions<ViewSpecificControllerAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerAccountingSummaryQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerAccountingSummary(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Accounting summary
 * {@link /view-specific/accounting-summary}
 */
export function useViewSpecificControllerAccountingSummary<TData = ViewSpecificControllerAccountingSummaryQueryResponse, TQueryData = ViewSpecificControllerAccountingSummaryQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerAccountingSummaryQueryKey>(params?: ViewSpecificControllerAccountingSummaryQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerAccountingSummaryQueryKey(params)
         

         const query = useQuery({
          ...viewSpecificControllerAccountingSummaryQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListComplianceChecksOnPolicyQueryKey = (policyId: ViewSpecificControllerListComplianceChecksOnPolicyPathParams["policyId"] | undefined, params?: ViewSpecificControllerListComplianceChecksOnPolicyQueryParams) => [{ url: '/view-specific/compliance/:policyId/checks', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListComplianceChecksOnPolicyQueryKey = ReturnType<typeof viewSpecificControllerListComplianceChecksOnPolicyQueryKey>

export function viewSpecificControllerListComplianceChecksOnPolicyQueryOptions(policyId: ViewSpecificControllerListComplianceChecksOnPolicyPathParams["policyId"] | undefined, params?: ViewSpecificControllerListComplianceChecksOnPolicyQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListComplianceChecksOnPolicyQueryKey(policyId, params)
        return queryOptions<ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListComplianceChecksOnPolicy(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List compliance checks on policy
 * {@link /view-specific/compliance/:policyId/checks}
 */
export function useViewSpecificControllerListComplianceChecksOnPolicy<TData = ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, TQueryData = ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListComplianceChecksOnPolicyQueryKey>(policyId: ViewSpecificControllerListComplianceChecksOnPolicyPathParams["policyId"] | undefined, params?: ViewSpecificControllerListComplianceChecksOnPolicyQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListComplianceChecksOnPolicyQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListComplianceChecksOnPolicyQueryKey(policyId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListComplianceChecksOnPolicyQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListPolicyComplianceAlertsQueryKey = (policyId: ViewSpecificControllerListPolicyComplianceAlertsPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyComplianceAlertsQueryParams) => [{ url: '/view-specific/compliance/:policyId/alerts', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListPolicyComplianceAlertsQueryKey = ReturnType<typeof viewSpecificControllerListPolicyComplianceAlertsQueryKey>

export function viewSpecificControllerListPolicyComplianceAlertsQueryOptions(policyId: ViewSpecificControllerListPolicyComplianceAlertsPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyComplianceAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListPolicyComplianceAlertsQueryKey(policyId, params)
        return queryOptions<ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListPolicyComplianceAlerts(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List compliance alerts on policy
 * {@link /view-specific/compliance/:policyId/alerts}
 */
export function useViewSpecificControllerListPolicyComplianceAlerts<TData = ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, TQueryData = ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListPolicyComplianceAlertsQueryKey>(policyId: ViewSpecificControllerListPolicyComplianceAlertsPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyComplianceAlertsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListPolicyComplianceAlertsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListPolicyComplianceAlertsQueryKey(policyId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListPolicyComplianceAlertsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListChildBrokerageFirmsQueryKey = (brokerageFirmId: ViewSpecificControllerListChildBrokerageFirmsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListChildBrokerageFirmsQueryParams) => [{ url: '/view-specific/:brokerageFirmId/child-brokerage-firms', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListChildBrokerageFirmsQueryKey = ReturnType<typeof viewSpecificControllerListChildBrokerageFirmsQueryKey>

export function viewSpecificControllerListChildBrokerageFirmsQueryOptions(brokerageFirmId: ViewSpecificControllerListChildBrokerageFirmsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListChildBrokerageFirmsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListChildBrokerageFirmsQueryKey(brokerageFirmId, params)
        return queryOptions<ViewSpecificControllerListChildBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListChildBrokerageFirmsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListChildBrokerageFirms(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List child brokerage firms
 * {@link /view-specific/:brokerageFirmId/child-brokerage-firms}
 */
export function useViewSpecificControllerListChildBrokerageFirms<TData = ViewSpecificControllerListChildBrokerageFirmsQueryResponse, TQueryData = ViewSpecificControllerListChildBrokerageFirmsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListChildBrokerageFirmsQueryKey>(brokerageFirmId: ViewSpecificControllerListChildBrokerageFirmsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListChildBrokerageFirmsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListChildBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListChildBrokerageFirmsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListChildBrokerageFirmsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey = (brokerageFirmId: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams) => [{ url: '/view-specific/:brokerageFirmId/wholesale-distribution-requests', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey = ReturnType<typeof viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey>

export function viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
        return queryOptions<ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListWholesaleBrokerageFirmDistributionRequests(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List distribution requested to the brokerage firm given in the path
 * {@link /view-specific/:brokerageFirmId/wholesale-distribution-requests}
 */
export function useViewSpecificControllerListWholesaleBrokerageFirmDistributionRequests<TData = ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, TQueryData = ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey>(brokerageFirmId: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListWholesaleBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListBrokerageFirmDistributionRequestsQueryKey = (brokerageFirmId: ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams) => [{ url: '/view-specific/:brokerageFirmId/distribution-requests', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryKey = ReturnType<typeof viewSpecificControllerListBrokerageFirmDistributionRequestsQueryKey>

export function viewSpecificControllerListBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
        return queryOptions<ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListBrokerageFirmDistributionRequests(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List distribution requested by the brokerage firm given in the path
 * {@link /view-specific/:brokerageFirmId/distribution-requests}
 */
export function useViewSpecificControllerListBrokerageFirmDistributionRequests<TData = ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, TQueryData = ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, TQueryKey extends QueryKey = ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryKey>(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListBrokerageFirmDistributionRequestsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListBrokerageFirmDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListPolicyAssetsQueryKey = (policyId: ViewSpecificControllerListPolicyAssetsPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyAssetsQueryParams) => [{ url: '/view-specific/:policyId/assets', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListPolicyAssetsQueryKey = ReturnType<typeof viewSpecificControllerListPolicyAssetsQueryKey>

export function viewSpecificControllerListPolicyAssetsQueryOptions(policyId: ViewSpecificControllerListPolicyAssetsPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyAssetsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListPolicyAssetsQueryKey(policyId, params)
        return queryOptions<ViewSpecificControllerListPolicyAssetsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListPolicyAssets403 | ViewSpecificControllerListPolicyAssets404>, ViewSpecificControllerListPolicyAssetsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListPolicyAssets(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List Assets On Policy
 * {@link /view-specific/:policyId/assets}
 */
export function useViewSpecificControllerListPolicyAssets<TData = ViewSpecificControllerListPolicyAssetsQueryResponse, TQueryData = ViewSpecificControllerListPolicyAssetsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListPolicyAssetsQueryKey>(policyId: ViewSpecificControllerListPolicyAssetsPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyAssetsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListPolicyAssetsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListPolicyAssets403 | ViewSpecificControllerListPolicyAssets404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListPolicyAssetsQueryKey(policyId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListPolicyAssetsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ViewSpecificControllerListPolicyAssets403 | ViewSpecificControllerListPolicyAssets404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerGetAvailablePricingQueryKey = (policyId: ViewSpecificControllerGetAvailablePricingPathParams["policyId"] | undefined, params?: ViewSpecificControllerGetAvailablePricingQueryParams) => [{ url: '/view-specific/:policyId/available-pricing', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerGetAvailablePricingQueryKey = ReturnType<typeof viewSpecificControllerGetAvailablePricingQueryKey>

export function viewSpecificControllerGetAvailablePricingQueryOptions(policyId: ViewSpecificControllerGetAvailablePricingPathParams["policyId"] | undefined, params?: ViewSpecificControllerGetAvailablePricingQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerGetAvailablePricingQueryKey(policyId, params)
        return queryOptions<ViewSpecificControllerGetAvailablePricingQueryResponse, ResponseErrorConfig<ViewSpecificControllerGetAvailablePricing400 | ViewSpecificControllerGetAvailablePricing404>, ViewSpecificControllerGetAvailablePricingQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerGetAvailablePricing(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get available pricing tiers for policy
 * {@link /view-specific/:policyId/available-pricing}
 */
export function useViewSpecificControllerGetAvailablePricing<TData = ViewSpecificControllerGetAvailablePricingQueryResponse, TQueryData = ViewSpecificControllerGetAvailablePricingQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerGetAvailablePricingQueryKey>(policyId: ViewSpecificControllerGetAvailablePricingPathParams["policyId"] | undefined, params?: ViewSpecificControllerGetAvailablePricingQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerGetAvailablePricingQueryResponse, ResponseErrorConfig<ViewSpecificControllerGetAvailablePricing400 | ViewSpecificControllerGetAvailablePricing404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerGetAvailablePricingQueryKey(policyId, params)
         

         const query = useQuery({
          ...viewSpecificControllerGetAvailablePricingQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ViewSpecificControllerGetAvailablePricing400 | ViewSpecificControllerGetAvailablePricing404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListPolicyCustomersQueryKey = (policyId: ViewSpecificControllerListPolicyCustomersPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyCustomersQueryParams) => [{ url: '/view-specific/:policyId/customers', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListPolicyCustomersQueryKey = ReturnType<typeof viewSpecificControllerListPolicyCustomersQueryKey>

export function viewSpecificControllerListPolicyCustomersQueryOptions(policyId: ViewSpecificControllerListPolicyCustomersPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyCustomersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListPolicyCustomersQueryKey(policyId, params)
        return queryOptions<ViewSpecificControllerListPolicyCustomersQueryResponse, ResponseErrorConfig<ViewSpecificControllerListPolicyCustomers403 | ViewSpecificControllerListPolicyCustomers404>, ViewSpecificControllerListPolicyCustomersQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListPolicyCustomers(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List Customers On Policy
 * {@link /view-specific/:policyId/customers}
 */
export function useViewSpecificControllerListPolicyCustomers<TData = ViewSpecificControllerListPolicyCustomersQueryResponse, TQueryData = ViewSpecificControllerListPolicyCustomersQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListPolicyCustomersQueryKey>(policyId: ViewSpecificControllerListPolicyCustomersPathParams["policyId"] | undefined, params?: ViewSpecificControllerListPolicyCustomersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListPolicyCustomersQueryResponse, ResponseErrorConfig<ViewSpecificControllerListPolicyCustomers403 | ViewSpecificControllerListPolicyCustomers404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListPolicyCustomersQueryKey(policyId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListPolicyCustomersQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ViewSpecificControllerListPolicyCustomers403 | ViewSpecificControllerListPolicyCustomers404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListCustomerInvoicesQueryKey = (customerId: ViewSpecificControllerListCustomerInvoicesPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerInvoicesQueryParams) => [{ url: '/view-specific/:customerId/invoices', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListCustomerInvoicesQueryKey = ReturnType<typeof viewSpecificControllerListCustomerInvoicesQueryKey>

export function viewSpecificControllerListCustomerInvoicesQueryOptions(customerId: ViewSpecificControllerListCustomerInvoicesPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerInvoicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListCustomerInvoicesQueryKey(customerId, params)
        return queryOptions<ViewSpecificControllerListCustomerInvoicesQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerInvoices404>, ViewSpecificControllerListCustomerInvoicesQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListCustomerInvoices(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List invoices on customer
 * {@link /view-specific/:customerId/invoices}
 */
export function useViewSpecificControllerListCustomerInvoices<TData = ViewSpecificControllerListCustomerInvoicesQueryResponse, TQueryData = ViewSpecificControllerListCustomerInvoicesQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListCustomerInvoicesQueryKey>(customerId: ViewSpecificControllerListCustomerInvoicesPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerInvoicesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListCustomerInvoicesQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerInvoices404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListCustomerInvoicesQueryKey(customerId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListCustomerInvoicesQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ViewSpecificControllerListCustomerInvoices404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListCustomerPaymentsQueryKey = (customerId: ViewSpecificControllerListCustomerPaymentsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerPaymentsQueryParams) => [{ url: '/view-specific/:customerId/payments', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListCustomerPaymentsQueryKey = ReturnType<typeof viewSpecificControllerListCustomerPaymentsQueryKey>

export function viewSpecificControllerListCustomerPaymentsQueryOptions(customerId: ViewSpecificControllerListCustomerPaymentsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListCustomerPaymentsQueryKey(customerId, params)
        return queryOptions<ViewSpecificControllerListCustomerPaymentsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerPayments404>, ViewSpecificControllerListCustomerPaymentsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListCustomerPayments(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List Customer Payments
 * {@link /view-specific/:customerId/payments}
 */
export function useViewSpecificControllerListCustomerPayments<TData = ViewSpecificControllerListCustomerPaymentsQueryResponse, TQueryData = ViewSpecificControllerListCustomerPaymentsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListCustomerPaymentsQueryKey>(customerId: ViewSpecificControllerListCustomerPaymentsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerPaymentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListCustomerPaymentsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerPayments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListCustomerPaymentsQueryKey(customerId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListCustomerPaymentsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ViewSpecificControllerListCustomerPayments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListCustomerPaymentMethodsQueryKey = (customerId: ViewSpecificControllerListCustomerPaymentMethodsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerPaymentMethodsQueryParams) => [{ url: '/view-specific/:customerId/payment-methods', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListCustomerPaymentMethodsQueryKey = ReturnType<typeof viewSpecificControllerListCustomerPaymentMethodsQueryKey>

export function viewSpecificControllerListCustomerPaymentMethodsQueryOptions(customerId: ViewSpecificControllerListCustomerPaymentMethodsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListCustomerPaymentMethodsQueryKey(customerId, params)
        return queryOptions<ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerPaymentMethods404>, ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListCustomerPaymentMethods(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List customer payment methods with documents
 * {@link /view-specific/:customerId/payment-methods}
 */
export function useViewSpecificControllerListCustomerPaymentMethods<TData = ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, TQueryData = ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListCustomerPaymentMethodsQueryKey>(customerId: ViewSpecificControllerListCustomerPaymentMethodsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerPaymentMethodsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListCustomerPaymentMethodsQueryResponse, ResponseErrorConfig<ViewSpecificControllerListCustomerPaymentMethods404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListCustomerPaymentMethodsQueryKey(customerId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListCustomerPaymentMethodsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ViewSpecificControllerListCustomerPaymentMethods404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListBrokerageFirmPaymentMethodsQueryKey = (brokerageFirmId: ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams) => [{ url: '/view-specific/brokerage-firms/:brokerageFirmId/payment-methods', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryKey = ReturnType<typeof viewSpecificControllerListBrokerageFirmPaymentMethodsQueryKey>

export function viewSpecificControllerListBrokerageFirmPaymentMethodsQueryOptions(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListBrokerageFirmPaymentMethodsQueryKey(brokerageFirmId, params)
        return queryOptions<ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListBrokerageFirmPaymentMethods(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List brokerage firm payment methods with documents
 * {@link /view-specific/brokerage-firms/:brokerageFirmId/payment-methods}
 */
export function useViewSpecificControllerListBrokerageFirmPaymentMethods<TData = ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, TQueryData = ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryKey>(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPaymentMethodsPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListBrokerageFirmPaymentMethodsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListBrokerageFirmPaymentMethodsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListBrokerageFirmPaymentMethodsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListBrokerageFirmPoliciesQueryKey = (brokerageFirmId: ViewSpecificControllerListBrokerageFirmPoliciesPathParams["brokerageFirmId"] | undefined, data: ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest) => [{ url: '/view-specific/:brokerageFirmId/policies', params: {brokerageFirmId:brokerageFirmId} }, ...(data ? [data] : [])] as const

export type ViewSpecificControllerListBrokerageFirmPoliciesQueryKey = ReturnType<typeof viewSpecificControllerListBrokerageFirmPoliciesQueryKey>

export function viewSpecificControllerListBrokerageFirmPoliciesQueryOptions(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPoliciesPathParams["brokerageFirmId"] | undefined, data: ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest, config: Partial<RequestConfig<ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest>> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListBrokerageFirmPoliciesQueryKey(brokerageFirmId, data)
        return queryOptions<ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListBrokerageFirmPolicies(brokerageFirmId!, data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description `LIST_LIVE_POLICIES_FROM_BROKERAGE_FIRM` lists `viewType: live` only; `newBusiness`, `archivedNewBusiness` and `derogation` need `LIST_ALL_POLICIES_FROM_BROKERAGE_FIRM` (403 otherwise).
 * @summary List brokerage firm policies
 * {@link /view-specific/:brokerageFirmId/policies}
 */
export function useViewSpecificControllerListBrokerageFirmPolicies<TData = ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, TQueryData = ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, TQueryKey extends QueryKey = ViewSpecificControllerListBrokerageFirmPoliciesQueryKey>(brokerageFirmId: ViewSpecificControllerListBrokerageFirmPoliciesPathParams["brokerageFirmId"] | undefined, data: ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListBrokerageFirmPoliciesMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<ViewSpecificControllerListBrokerageFirmPoliciesMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListBrokerageFirmPoliciesQueryKey(brokerageFirmId, data)
         

         const query = useQuery({
          ...viewSpecificControllerListBrokerageFirmPoliciesQueryOptions(brokerageFirmId, data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryKey = (brokerageFirmId: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams) => [{ url: '/view-specific/:brokerageFirmId/accounting-summary', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryKey = ReturnType<typeof viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryKey>

export function viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryOptions(brokerageFirmId: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryKey(brokerageFirmId, params)
        return queryOptions<ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerGetAccountingSummaryForBrokerageFirm(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Accounting summary for a brokerage firm
 * {@link /view-specific/:brokerageFirmId/accounting-summary}
 */
export function useViewSpecificControllerGetAccountingSummaryForBrokerageFirm<TData = ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, TQueryData = ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryKey>(brokerageFirmId: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmPathParams["brokerageFirmId"] | undefined, params?: ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...viewSpecificControllerGetAccountingSummaryForBrokerageFirmQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListCustomerRelationsQueryKey = (customerId: ViewSpecificControllerListCustomerRelationsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerRelationsQueryParams) => [{ url: '/view-specific/:customerId/relations', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListCustomerRelationsQueryKey = ReturnType<typeof viewSpecificControllerListCustomerRelationsQueryKey>

export function viewSpecificControllerListCustomerRelationsQueryOptions(customerId: ViewSpecificControllerListCustomerRelationsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerRelationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListCustomerRelationsQueryKey(customerId, params)
        return queryOptions<ViewSpecificControllerListCustomerRelationsQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListCustomerRelationsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListCustomerRelations(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List customer relations
 * {@link /view-specific/:customerId/relations}
 */
export function useViewSpecificControllerListCustomerRelations<TData = ViewSpecificControllerListCustomerRelationsQueryResponse, TQueryData = ViewSpecificControllerListCustomerRelationsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListCustomerRelationsQueryKey>(customerId: ViewSpecificControllerListCustomerRelationsPathParams["customerId"] | undefined, params?: ViewSpecificControllerListCustomerRelationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListCustomerRelationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListCustomerRelationsQueryKey(customerId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListCustomerRelationsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListBrokerageFirmDerogationsQueryKey = (brokerageFirmId: ViewSpecificControllerListBrokerageFirmDerogationsPathParams["brokerageFirmId"] | undefined, data: ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest, params?: ViewSpecificControllerListBrokerageFirmDerogationsQueryParams) => [{ url: '/view-specific/:brokerageFirmId/derogations', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type ViewSpecificControllerListBrokerageFirmDerogationsQueryKey = ReturnType<typeof viewSpecificControllerListBrokerageFirmDerogationsQueryKey>

export function viewSpecificControllerListBrokerageFirmDerogationsQueryOptions(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDerogationsPathParams["brokerageFirmId"] | undefined, data: ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest, params?: ViewSpecificControllerListBrokerageFirmDerogationsQueryParams, config: Partial<RequestConfig<ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListBrokerageFirmDerogationsQueryKey(brokerageFirmId, data, params)
        return queryOptions<ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListBrokerageFirmDerogations(brokerageFirmId!, data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List brokerage firm derogations
 * {@link /view-specific/:brokerageFirmId/derogations}
 */
export function useViewSpecificControllerListBrokerageFirmDerogations<TData = ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, TQueryData = ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, TQueryKey extends QueryKey = ViewSpecificControllerListBrokerageFirmDerogationsQueryKey>(brokerageFirmId: ViewSpecificControllerListBrokerageFirmDerogationsPathParams["brokerageFirmId"] | undefined, data: ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest, params?: ViewSpecificControllerListBrokerageFirmDerogationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListBrokerageFirmDerogationsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<ViewSpecificControllerListBrokerageFirmDerogationsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListBrokerageFirmDerogationsQueryKey(brokerageFirmId, data, params)
         

         const query = useQuery({
          ...viewSpecificControllerListBrokerageFirmDerogationsQueryOptions(brokerageFirmId, data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const viewSpecificControllerListProductCommonDocumentsQueryKey = (productId: ViewSpecificControllerListProductCommonDocumentsPathParams["productId"] | undefined, params?: ViewSpecificControllerListProductCommonDocumentsQueryParams) => [{ url: '/view-specific/:productId/common-documents', params: {productId:productId} }, ...(params ? [params] : [])] as const

export type ViewSpecificControllerListProductCommonDocumentsQueryKey = ReturnType<typeof viewSpecificControllerListProductCommonDocumentsQueryKey>

export function viewSpecificControllerListProductCommonDocumentsQueryOptions(productId: ViewSpecificControllerListProductCommonDocumentsPathParams["productId"] | undefined, params?: ViewSpecificControllerListProductCommonDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = viewSpecificControllerListProductCommonDocumentsQueryKey(productId, params)
        return queryOptions<ViewSpecificControllerListProductCommonDocumentsQueryResponse, ResponseErrorConfig<Error>, ViewSpecificControllerListProductCommonDocumentsQueryResponse, typeof queryKey>({
         enabled: !!(productId),
         queryKey,
         queryFn: async ({ signal }) => {
            return viewSpecificControllerListProductCommonDocuments(productId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List product general documents
 * {@link /view-specific/:productId/common-documents}
 */
export function useViewSpecificControllerListProductCommonDocuments<TData = ViewSpecificControllerListProductCommonDocumentsQueryResponse, TQueryData = ViewSpecificControllerListProductCommonDocumentsQueryResponse, TQueryKey extends QueryKey = ViewSpecificControllerListProductCommonDocumentsQueryKey>(productId: ViewSpecificControllerListProductCommonDocumentsPathParams["productId"] | undefined, params?: ViewSpecificControllerListProductCommonDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ViewSpecificControllerListProductCommonDocumentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? viewSpecificControllerListProductCommonDocumentsQueryKey(productId, params)
         

         const query = useQuery({
          ...viewSpecificControllerListProductCommonDocumentsQueryOptions(productId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const billingReadsControllerGetAccountingSummaryQueryKey = (params?: BillingReadsControllerGetAccountingSummaryQueryParams) => [{ url: '/accounting-summary' }, ...(params ? [params] : [])] as const

export type BillingReadsControllerGetAccountingSummaryQueryKey = ReturnType<typeof billingReadsControllerGetAccountingSummaryQueryKey>

export function billingReadsControllerGetAccountingSummaryQueryOptions(params?: BillingReadsControllerGetAccountingSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = billingReadsControllerGetAccountingSummaryQueryKey(params)
        return queryOptions<BillingReadsControllerGetAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, BillingReadsControllerGetAccountingSummaryQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return billingReadsControllerGetAccountingSummary(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get the accounting summary
 * {@link /accounting-summary}
 */
export function useBillingReadsControllerGetAccountingSummary<TData = BillingReadsControllerGetAccountingSummaryQueryResponse, TQueryData = BillingReadsControllerGetAccountingSummaryQueryResponse, TQueryKey extends QueryKey = BillingReadsControllerGetAccountingSummaryQueryKey>(params?: BillingReadsControllerGetAccountingSummaryQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BillingReadsControllerGetAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? billingReadsControllerGetAccountingSummaryQueryKey(params)
         

         const query = useQuery({
          ...billingReadsControllerGetAccountingSummaryQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const billingReadsControllerGetBrokerageFirmAccountingSummaryQueryKey = (brokerageFirmId: BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams["brokerageFirmId"] | undefined, params?: BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/accounting-summary', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryKey = ReturnType<typeof billingReadsControllerGetBrokerageFirmAccountingSummaryQueryKey>

export function billingReadsControllerGetBrokerageFirmAccountingSummaryQueryOptions(brokerageFirmId: BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams["brokerageFirmId"] | undefined, params?: BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = billingReadsControllerGetBrokerageFirmAccountingSummaryQueryKey(brokerageFirmId, params)
        return queryOptions<BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return billingReadsControllerGetBrokerageFirmAccountingSummary(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a brokerage firm's accounting summary
 * {@link /brokerage-firms/:brokerageFirmId/accounting-summary}
 */
export function useBillingReadsControllerGetBrokerageFirmAccountingSummary<TData = BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, TQueryData = BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, TQueryKey extends QueryKey = BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryKey>(brokerageFirmId: BillingReadsControllerGetBrokerageFirmAccountingSummaryPathParams["brokerageFirmId"] | undefined, params?: BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BillingReadsControllerGetBrokerageFirmAccountingSummaryQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? billingReadsControllerGetBrokerageFirmAccountingSummaryQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...billingReadsControllerGetBrokerageFirmAccountingSummaryQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const billingReadsControllerListCustomerInvoicesQueryKey = (customerId: BillingReadsControllerListCustomerInvoicesPathParams["customerId"] | undefined, params?: BillingReadsControllerListCustomerInvoicesQueryParams) => [{ url: '/customers/:customerId/invoices', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type BillingReadsControllerListCustomerInvoicesQueryKey = ReturnType<typeof billingReadsControllerListCustomerInvoicesQueryKey>

export function billingReadsControllerListCustomerInvoicesQueryOptions(customerId: BillingReadsControllerListCustomerInvoicesPathParams["customerId"] | undefined, params?: BillingReadsControllerListCustomerInvoicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = billingReadsControllerListCustomerInvoicesQueryKey(customerId, params)
        return queryOptions<BillingReadsControllerListCustomerInvoicesQueryResponse, ResponseErrorConfig<BillingReadsControllerListCustomerInvoices404>, BillingReadsControllerListCustomerInvoicesQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return billingReadsControllerListCustomerInvoices(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a customer's invoices
 * {@link /customers/:customerId/invoices}
 */
export function useBillingReadsControllerListCustomerInvoices<TData = BillingReadsControllerListCustomerInvoicesQueryResponse, TQueryData = BillingReadsControllerListCustomerInvoicesQueryResponse, TQueryKey extends QueryKey = BillingReadsControllerListCustomerInvoicesQueryKey>(customerId: BillingReadsControllerListCustomerInvoicesPathParams["customerId"] | undefined, params?: BillingReadsControllerListCustomerInvoicesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BillingReadsControllerListCustomerInvoicesQueryResponse, ResponseErrorConfig<BillingReadsControllerListCustomerInvoices404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? billingReadsControllerListCustomerInvoicesQueryKey(customerId, params)
         

         const query = useQuery({
          ...billingReadsControllerListCustomerInvoicesQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BillingReadsControllerListCustomerInvoices404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const paymentsReadsControllerListCustomerPaymentsQueryKey = (customerId: PaymentsReadsControllerListCustomerPaymentsPathParams["customerId"] | undefined, params?: PaymentsReadsControllerListCustomerPaymentsQueryParams) => [{ url: '/customers/:customerId/payments', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type PaymentsReadsControllerListCustomerPaymentsQueryKey = ReturnType<typeof paymentsReadsControllerListCustomerPaymentsQueryKey>

export function paymentsReadsControllerListCustomerPaymentsQueryOptions(customerId: PaymentsReadsControllerListCustomerPaymentsPathParams["customerId"] | undefined, params?: PaymentsReadsControllerListCustomerPaymentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = paymentsReadsControllerListCustomerPaymentsQueryKey(customerId, params)
        return queryOptions<PaymentsReadsControllerListCustomerPaymentsQueryResponse, ResponseErrorConfig<PaymentsReadsControllerListCustomerPayments404>, PaymentsReadsControllerListCustomerPaymentsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return paymentsReadsControllerListCustomerPayments(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a customer's payments
 * {@link /customers/:customerId/payments}
 */
export function usePaymentsReadsControllerListCustomerPayments<TData = PaymentsReadsControllerListCustomerPaymentsQueryResponse, TQueryData = PaymentsReadsControllerListCustomerPaymentsQueryResponse, TQueryKey extends QueryKey = PaymentsReadsControllerListCustomerPaymentsQueryKey>(customerId: PaymentsReadsControllerListCustomerPaymentsPathParams["customerId"] | undefined, params?: PaymentsReadsControllerListCustomerPaymentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PaymentsReadsControllerListCustomerPaymentsQueryResponse, ResponseErrorConfig<PaymentsReadsControllerListCustomerPayments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? paymentsReadsControllerListCustomerPaymentsQueryKey(customerId, params)
         

         const query = useQuery({
          ...paymentsReadsControllerListCustomerPaymentsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PaymentsReadsControllerListCustomerPayments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const paymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryKey = (customerId: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams["customerId"] | undefined, params?: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams) => [{ url: '/customers/:customerId/payment-methods/with-documents', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryKey = ReturnType<typeof paymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryKey>

export function paymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryOptions(customerId: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams["customerId"] | undefined, params?: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = paymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryKey(customerId, params)
        return queryOptions<PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, ResponseErrorConfig<PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404>, PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return paymentsReadsControllerListCustomerPaymentMethodsWithDocuments(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Same payment methods as `GET /customers/{customerId}/payment-methods`, each with the documents attached to it.
 * @summary List a customer's payment methods with their documents
 * {@link /customers/:customerId/payment-methods/with-documents}
 */
export function usePaymentsReadsControllerListCustomerPaymentMethodsWithDocuments<TData = PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, TQueryData = PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, TQueryKey extends QueryKey = PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryKey>(customerId: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsPathParams["customerId"] | undefined, params?: PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PaymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryResponse, ResponseErrorConfig<PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? paymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryKey(customerId, params)
         

         const query = useQuery({
          ...paymentsReadsControllerListCustomerPaymentMethodsWithDocumentsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PaymentsReadsControllerListCustomerPaymentMethodsWithDocuments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryKey = (brokerageFirmId: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams["brokerageFirmId"] | undefined, params?: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/payment-methods/with-documents', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryKey = ReturnType<typeof paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryKey>

export function paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryOptions(brokerageFirmId: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams["brokerageFirmId"] | undefined, params?: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryKey(brokerageFirmId, params)
        return queryOptions<PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, ResponseErrorConfig<Error>, PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Same payment methods as `GET /brokerage-firms/{brokerageFirmId}/payment-methods`, each with the documents attached to it.
 * @summary List a brokerage firm's payment methods with their documents
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/with-documents}
 */
export function usePaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocuments<TData = PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, TQueryData = PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, TQueryKey extends QueryKey = PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryKey>(brokerageFirmId: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsPathParams["brokerageFirmId"] | undefined, params?: PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PaymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...paymentsReadsControllerListBrokerageFirmPaymentMethodsWithDocumentsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerReadsControllerListCustomerRelationsQueryKey = (customerId: CustomerReadsControllerListCustomerRelationsPathParams["customerId"] | undefined, params?: CustomerReadsControllerListCustomerRelationsQueryParams) => [{ url: '/customers/:customerId/relations', params: {customerId:customerId} }, ...(params ? [params] : [])] as const

export type CustomerReadsControllerListCustomerRelationsQueryKey = ReturnType<typeof customerReadsControllerListCustomerRelationsQueryKey>

export function customerReadsControllerListCustomerRelationsQueryOptions(customerId: CustomerReadsControllerListCustomerRelationsPathParams["customerId"] | undefined, params?: CustomerReadsControllerListCustomerRelationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerReadsControllerListCustomerRelationsQueryKey(customerId, params)
        return queryOptions<CustomerReadsControllerListCustomerRelationsQueryResponse, ResponseErrorConfig<Error>, CustomerReadsControllerListCustomerRelationsQueryResponse, typeof queryKey>({
         enabled: !!(customerId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerReadsControllerListCustomerRelations(customerId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a customer's relations
 * {@link /customers/:customerId/relations}
 */
export function useCustomerReadsControllerListCustomerRelations<TData = CustomerReadsControllerListCustomerRelationsQueryResponse, TQueryData = CustomerReadsControllerListCustomerRelationsQueryResponse, TQueryKey extends QueryKey = CustomerReadsControllerListCustomerRelationsQueryKey>(customerId: CustomerReadsControllerListCustomerRelationsPathParams["customerId"] | undefined, params?: CustomerReadsControllerListCustomerRelationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerReadsControllerListCustomerRelationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerReadsControllerListCustomerRelationsQueryKey(customerId, params)
         

         const query = useQuery({
          ...customerReadsControllerListCustomerRelationsQueryOptions(customerId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const customerReadsControllerListPolicyCustomersQueryKey = (policyId: CustomerReadsControllerListPolicyCustomersPathParams["policyId"] | undefined, params?: CustomerReadsControllerListPolicyCustomersQueryParams) => [{ url: '/policies/:policyId/customers', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type CustomerReadsControllerListPolicyCustomersQueryKey = ReturnType<typeof customerReadsControllerListPolicyCustomersQueryKey>

export function customerReadsControllerListPolicyCustomersQueryOptions(policyId: CustomerReadsControllerListPolicyCustomersPathParams["policyId"] | undefined, params?: CustomerReadsControllerListPolicyCustomersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = customerReadsControllerListPolicyCustomersQueryKey(policyId, params)
        return queryOptions<CustomerReadsControllerListPolicyCustomersQueryResponse, ResponseErrorConfig<CustomerReadsControllerListPolicyCustomers403 | CustomerReadsControllerListPolicyCustomers404>, CustomerReadsControllerListPolicyCustomersQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return customerReadsControllerListPolicyCustomers(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Lists everyone on the contract with their role — use it to find the payer whose payment method gates a signature request.
 * @summary List a policy's customers
 * {@link /policies/:policyId/customers}
 */
export function useCustomerReadsControllerListPolicyCustomers<TData = CustomerReadsControllerListPolicyCustomersQueryResponse, TQueryData = CustomerReadsControllerListPolicyCustomersQueryResponse, TQueryKey extends QueryKey = CustomerReadsControllerListPolicyCustomersQueryKey>(policyId: CustomerReadsControllerListPolicyCustomersPathParams["policyId"] | undefined, params?: CustomerReadsControllerListPolicyCustomersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<CustomerReadsControllerListPolicyCustomersQueryResponse, ResponseErrorConfig<CustomerReadsControllerListPolicyCustomers403 | CustomerReadsControllerListPolicyCustomers404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? customerReadsControllerListPolicyCustomersQueryKey(policyId, params)
         

         const query = useQuery({
          ...customerReadsControllerListPolicyCustomersQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<CustomerReadsControllerListPolicyCustomers403 | CustomerReadsControllerListPolicyCustomers404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const assetReadsControllerListPolicyAssetsQueryKey = (policyId: AssetReadsControllerListPolicyAssetsPathParams["policyId"] | undefined, params?: AssetReadsControllerListPolicyAssetsQueryParams) => [{ url: '/policies/:policyId/assets', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type AssetReadsControllerListPolicyAssetsQueryKey = ReturnType<typeof assetReadsControllerListPolicyAssetsQueryKey>

export function assetReadsControllerListPolicyAssetsQueryOptions(policyId: AssetReadsControllerListPolicyAssetsPathParams["policyId"] | undefined, params?: AssetReadsControllerListPolicyAssetsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = assetReadsControllerListPolicyAssetsQueryKey(policyId, params)
        return queryOptions<AssetReadsControllerListPolicyAssetsQueryResponse, ResponseErrorConfig<AssetReadsControllerListPolicyAssets403 | AssetReadsControllerListPolicyAssets404>, AssetReadsControllerListPolicyAssetsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return assetReadsControllerListPolicyAssets(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Branch-scoped: pass the branch the assets were created on, or the result comes back empty as though they never existed.
 * @summary List a policy's assets
 * {@link /policies/:policyId/assets}
 */
export function useAssetReadsControllerListPolicyAssets<TData = AssetReadsControllerListPolicyAssetsQueryResponse, TQueryData = AssetReadsControllerListPolicyAssetsQueryResponse, TQueryKey extends QueryKey = AssetReadsControllerListPolicyAssetsQueryKey>(policyId: AssetReadsControllerListPolicyAssetsPathParams["policyId"] | undefined, params?: AssetReadsControllerListPolicyAssetsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AssetReadsControllerListPolicyAssetsQueryResponse, ResponseErrorConfig<AssetReadsControllerListPolicyAssets403 | AssetReadsControllerListPolicyAssets404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? assetReadsControllerListPolicyAssetsQueryKey(policyId, params)
         

         const query = useQuery({
          ...assetReadsControllerListPolicyAssetsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AssetReadsControllerListPolicyAssets403 | AssetReadsControllerListPolicyAssets404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const pricingReadsControllerGetAvailablePricingQueryKey = (policyId: PricingReadsControllerGetAvailablePricingPathParams["policyId"] | undefined, params?: PricingReadsControllerGetAvailablePricingQueryParams) => [{ url: '/policies/:policyId/available-pricing', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PricingReadsControllerGetAvailablePricingQueryKey = ReturnType<typeof pricingReadsControllerGetAvailablePricingQueryKey>

export function pricingReadsControllerGetAvailablePricingQueryOptions(policyId: PricingReadsControllerGetAvailablePricingPathParams["policyId"] | undefined, params?: PricingReadsControllerGetAvailablePricingQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pricingReadsControllerGetAvailablePricingQueryKey(policyId, params)
        return queryOptions<PricingReadsControllerGetAvailablePricingQueryResponse, ResponseErrorConfig<PricingReadsControllerGetAvailablePricing400 | PricingReadsControllerGetAvailablePricing404>, PricingReadsControllerGetAvailablePricingQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return pricingReadsControllerGetAvailablePricing(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get the pricing tiers available for a policy
 * {@link /policies/:policyId/available-pricing}
 */
export function usePricingReadsControllerGetAvailablePricing<TData = PricingReadsControllerGetAvailablePricingQueryResponse, TQueryData = PricingReadsControllerGetAvailablePricingQueryResponse, TQueryKey extends QueryKey = PricingReadsControllerGetAvailablePricingQueryKey>(policyId: PricingReadsControllerGetAvailablePricingPathParams["policyId"] | undefined, params?: PricingReadsControllerGetAvailablePricingQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PricingReadsControllerGetAvailablePricingQueryResponse, ResponseErrorConfig<PricingReadsControllerGetAvailablePricing400 | PricingReadsControllerGetAvailablePricing404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? pricingReadsControllerGetAvailablePricingQueryKey(policyId, params)
         

         const query = useQuery({
          ...pricingReadsControllerGetAvailablePricingQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PricingReadsControllerGetAvailablePricing400 | PricingReadsControllerGetAvailablePricing404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const derogationsReadsControllerSearchBrokerageFirmDerogationsQueryKey = (brokerageFirmId: DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams["brokerageFirmId"] | undefined, data: DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest, params?: DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/derogations/search', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryKey = ReturnType<typeof derogationsReadsControllerSearchBrokerageFirmDerogationsQueryKey>

export function derogationsReadsControllerSearchBrokerageFirmDerogationsQueryOptions(brokerageFirmId: DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams["brokerageFirmId"] | undefined, data: DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest, params?: DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams, config: Partial<RequestConfig<DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = derogationsReadsControllerSearchBrokerageFirmDerogationsQueryKey(brokerageFirmId, data, params)
        return queryOptions<DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, ResponseErrorConfig<Error>, DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return derogationsReadsControllerSearchBrokerageFirmDerogations(brokerageFirmId!, data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Filters are sent in the request body, which is why this is a POST.
 * @summary Search a brokerage firm's derogations
 * {@link /brokerage-firms/:brokerageFirmId/derogations/search}
 */
export function useDerogationsReadsControllerSearchBrokerageFirmDerogations<TData = DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, TQueryData = DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, TQueryKey extends QueryKey = DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryKey>(brokerageFirmId: DerogationsReadsControllerSearchBrokerageFirmDerogationsPathParams["brokerageFirmId"] | undefined, data: DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest, params?: DerogationsReadsControllerSearchBrokerageFirmDerogationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<DerogationsReadsControllerSearchBrokerageFirmDerogationsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? derogationsReadsControllerSearchBrokerageFirmDerogationsQueryKey(brokerageFirmId, data, params)
         

         const query = useQuery({
          ...derogationsReadsControllerSearchBrokerageFirmDerogationsQueryOptions(brokerageFirmId, data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const complianceReadsControllerListPolicyComplianceAlertsQueryKey = (policyId: ComplianceReadsControllerListPolicyComplianceAlertsPathParams["policyId"] | undefined, params?: ComplianceReadsControllerListPolicyComplianceAlertsQueryParams) => [{ url: '/policies/:policyId/compliance/alerts', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ComplianceReadsControllerListPolicyComplianceAlertsQueryKey = ReturnType<typeof complianceReadsControllerListPolicyComplianceAlertsQueryKey>

export function complianceReadsControllerListPolicyComplianceAlertsQueryOptions(policyId: ComplianceReadsControllerListPolicyComplianceAlertsPathParams["policyId"] | undefined, params?: ComplianceReadsControllerListPolicyComplianceAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = complianceReadsControllerListPolicyComplianceAlertsQueryKey(policyId, params)
        return queryOptions<ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, ResponseErrorConfig<Error>, ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return complianceReadsControllerListPolicyComplianceAlerts(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a policy's compliance alerts
 * {@link /policies/:policyId/compliance/alerts}
 */
export function useComplianceReadsControllerListPolicyComplianceAlerts<TData = ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, TQueryData = ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, TQueryKey extends QueryKey = ComplianceReadsControllerListPolicyComplianceAlertsQueryKey>(policyId: ComplianceReadsControllerListPolicyComplianceAlertsPathParams["policyId"] | undefined, params?: ComplianceReadsControllerListPolicyComplianceAlertsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ComplianceReadsControllerListPolicyComplianceAlertsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? complianceReadsControllerListPolicyComplianceAlertsQueryKey(policyId, params)
         

         const query = useQuery({
          ...complianceReadsControllerListPolicyComplianceAlertsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const complianceReadsControllerListPolicyComplianceChecksQueryKey = (policyId: ComplianceReadsControllerListPolicyComplianceChecksPathParams["policyId"] | undefined, params?: ComplianceReadsControllerListPolicyComplianceChecksQueryParams) => [{ url: '/policies/:policyId/compliance/checks', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type ComplianceReadsControllerListPolicyComplianceChecksQueryKey = ReturnType<typeof complianceReadsControllerListPolicyComplianceChecksQueryKey>

export function complianceReadsControllerListPolicyComplianceChecksQueryOptions(policyId: ComplianceReadsControllerListPolicyComplianceChecksPathParams["policyId"] | undefined, params?: ComplianceReadsControllerListPolicyComplianceChecksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = complianceReadsControllerListPolicyComplianceChecksQueryKey(policyId, params)
        return queryOptions<ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, ResponseErrorConfig<Error>, ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return complianceReadsControllerListPolicyComplianceChecks(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a policy's compliance checks
 * {@link /policies/:policyId/compliance/checks}
 */
export function useComplianceReadsControllerListPolicyComplianceChecks<TData = ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, TQueryData = ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, TQueryKey extends QueryKey = ComplianceReadsControllerListPolicyComplianceChecksQueryKey>(policyId: ComplianceReadsControllerListPolicyComplianceChecksPathParams["policyId"] | undefined, params?: ComplianceReadsControllerListPolicyComplianceChecksQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ComplianceReadsControllerListPolicyComplianceChecksQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? complianceReadsControllerListPolicyComplianceChecksQueryKey(policyId, params)
         

         const query = useQuery({
          ...complianceReadsControllerListPolicyComplianceChecksQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmsReadsControllerListChildBrokerageFirmsQueryKey = (brokerageFirmId: BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/children', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryKey = ReturnType<typeof brokerageFirmsReadsControllerListChildBrokerageFirmsQueryKey>

export function brokerageFirmsReadsControllerListChildBrokerageFirmsQueryOptions(brokerageFirmId: BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmsReadsControllerListChildBrokerageFirmsQueryKey(brokerageFirmId, params)
        return queryOptions<BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmsReadsControllerListChildBrokerageFirms(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a brokerage firm's children
 * {@link /brokerage-firms/:brokerageFirmId/children}
 */
export function useBrokerageFirmsReadsControllerListChildBrokerageFirms<TData = BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, TQueryData = BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryKey>(brokerageFirmId: BrokerageFirmsReadsControllerListChildBrokerageFirmsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmsReadsControllerListChildBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmsReadsControllerListChildBrokerageFirmsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...brokerageFirmsReadsControllerListChildBrokerageFirmsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyReadsControllerSearchBrokerageFirmPoliciesQueryKey = (brokerageFirmId: PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams["brokerageFirmId"] | undefined, data: PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest) => [{ url: '/brokerage-firms/:brokerageFirmId/policies/search', params: {brokerageFirmId:brokerageFirmId} }, ...(data ? [data] : [])] as const

export type PolicyReadsControllerSearchBrokerageFirmPoliciesQueryKey = ReturnType<typeof policyReadsControllerSearchBrokerageFirmPoliciesQueryKey>

export function policyReadsControllerSearchBrokerageFirmPoliciesQueryOptions(brokerageFirmId: PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams["brokerageFirmId"] | undefined, data: PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest, config: Partial<RequestConfig<PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest>> & { client?: Client } = {}) {

        const queryKey = policyReadsControllerSearchBrokerageFirmPoliciesQueryKey(brokerageFirmId, data)
        return queryOptions<PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, ResponseErrorConfig<Error>, PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyReadsControllerSearchBrokerageFirmPolicies(brokerageFirmId!, data, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Filters go in the body, which is why this is a POST. `viewType: live` means issued rather than currently in force — it includes stopped contracts, so read each row's status before offering an action that needs a running one. `pageInfo` takes `{ count, page }`. `LIST_LIVE_POLICIES_FROM_BROKERAGE_FIRM` lists `viewType: live` only; `newBusiness`, `archivedNewBusiness` and `derogation` need `LIST_ALL_POLICIES_FROM_BROKERAGE_FIRM` (403 otherwise).
 * @summary Search a brokerage firm's policies
 * {@link /brokerage-firms/:brokerageFirmId/policies/search}
 */
export function usePolicyReadsControllerSearchBrokerageFirmPolicies<TData = PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, TQueryData = PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, TQueryKey extends QueryKey = PolicyReadsControllerSearchBrokerageFirmPoliciesQueryKey>(brokerageFirmId: PolicyReadsControllerSearchBrokerageFirmPoliciesPathParams["brokerageFirmId"] | undefined, data: PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest, options: 
{
  query?: Partial<QueryObserverOptions<PolicyReadsControllerSearchBrokerageFirmPoliciesMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyReadsControllerSearchBrokerageFirmPoliciesMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyReadsControllerSearchBrokerageFirmPoliciesQueryKey(brokerageFirmId, data)
         

         const query = useQuery({
          ...policyReadsControllerSearchBrokerageFirmPoliciesQueryOptions(brokerageFirmId, data, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryKey = (brokerageFirmId: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/distribution-requests/search', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryKey = ReturnType<typeof distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryKey>

export function distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
        return queryOptions<DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Filters are sent as query parameters. Kept a POST for symmetry with the other searches.
 * @summary Search the distribution requests a brokerage firm has made
 * {@link /brokerage-firms/:brokerageFirmId/distribution-requests/search}
 */
export function useDistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequests<TData = DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, TQueryData = DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, TQueryKey extends QueryKey = DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryKey>(brokerageFirmId: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DistributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...distributionRequestsReadsControllerSearchBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey = (brokerageFirmId: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/wholesale-distribution-requests', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey = ReturnType<typeof distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey>

export function distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
        return queryOptions<DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ResponseErrorConfig<Error>, DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the distribution requests made to a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/wholesale-distribution-requests}
 */
export function useDistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequests<TData = DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, TQueryData = DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, TQueryKey extends QueryKey = DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey>(brokerageFirmId: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsPathParams["brokerageFirmId"] | undefined, params?: DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DistributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...distributionRequestsReadsControllerListWholesaleBrokerageFirmDistributionRequestsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentsReadsControllerListProductCommonDocumentsQueryKey = (productId: DocumentsReadsControllerListProductCommonDocumentsPathParams["productId"] | undefined, params?: DocumentsReadsControllerListProductCommonDocumentsQueryParams) => [{ url: '/products/:productId/documents', params: {productId:productId} }, ...(params ? [params] : [])] as const

export type DocumentsReadsControllerListProductCommonDocumentsQueryKey = ReturnType<typeof documentsReadsControllerListProductCommonDocumentsQueryKey>

export function documentsReadsControllerListProductCommonDocumentsQueryOptions(productId: DocumentsReadsControllerListProductCommonDocumentsPathParams["productId"] | undefined, params?: DocumentsReadsControllerListProductCommonDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentsReadsControllerListProductCommonDocumentsQueryKey(productId, params)
        return queryOptions<DocumentsReadsControllerListProductCommonDocumentsQueryResponse, ResponseErrorConfig<Error>, DocumentsReadsControllerListProductCommonDocumentsQueryResponse, typeof queryKey>({
         enabled: !!(productId),
         queryKey,
         queryFn: async ({ signal }) => {
            return documentsReadsControllerListProductCommonDocuments(productId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List a product's general documents
 * {@link /products/:productId/documents}
 */
export function useDocumentsReadsControllerListProductCommonDocuments<TData = DocumentsReadsControllerListProductCommonDocumentsQueryResponse, TQueryData = DocumentsReadsControllerListProductCommonDocumentsQueryResponse, TQueryKey extends QueryKey = DocumentsReadsControllerListProductCommonDocumentsQueryKey>(productId: DocumentsReadsControllerListProductCommonDocumentsPathParams["productId"] | undefined, params?: DocumentsReadsControllerListProductCommonDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DocumentsReadsControllerListProductCommonDocumentsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentsReadsControllerListProductCommonDocumentsQueryKey(productId, params)
         

         const query = useQuery({
          ...documentsReadsControllerListProductCommonDocumentsQueryOptions(productId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const mcpServerControllerHandleServerSentEventsQueryKey = () => [{ url: '/mcp' }] as const

export type McpServerControllerHandleServerSentEventsQueryKey = ReturnType<typeof mcpServerControllerHandleServerSentEventsQueryKey>

export function mcpServerControllerHandleServerSentEventsQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = mcpServerControllerHandleServerSentEventsQueryKey()
        return queryOptions<McpServerControllerHandleServerSentEventsQueryResponse, ResponseErrorConfig<Error>, McpServerControllerHandleServerSentEventsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return mcpServerControllerHandleServerSentEvents({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary MCP: SSE stream for server-to-client notifications
 * {@link /mcp}
 */
export function useMcpServerControllerHandleServerSentEvents<TData = McpServerControllerHandleServerSentEventsQueryResponse, TQueryData = McpServerControllerHandleServerSentEventsQueryResponse, TQueryKey extends QueryKey = McpServerControllerHandleServerSentEventsQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<McpServerControllerHandleServerSentEventsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? mcpServerControllerHandleServerSentEventsQueryKey()
         

         const query = useQuery({
          ...mcpServerControllerHandleServerSentEventsQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const complianceControllerListChecksQueryKey = (params?: ComplianceControllerListChecksQueryParams) => [{ url: '/compliance/checks' }, ...(params ? [params] : [])] as const

export type ComplianceControllerListChecksQueryKey = ReturnType<typeof complianceControllerListChecksQueryKey>

export function complianceControllerListChecksQueryOptions(params?: ComplianceControllerListChecksQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = complianceControllerListChecksQueryKey(params)
        return queryOptions<ComplianceControllerListChecksQueryResponse, ResponseErrorConfig<Error>, ComplianceControllerListChecksQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return complianceControllerListChecks(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List compliance checks
 * {@link /compliance/checks}
 */
export function useComplianceControllerListChecks<TData = ComplianceControllerListChecksQueryResponse, TQueryData = ComplianceControllerListChecksQueryResponse, TQueryKey extends QueryKey = ComplianceControllerListChecksQueryKey>(params?: ComplianceControllerListChecksQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ComplianceControllerListChecksQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? complianceControllerListChecksQueryKey(params)
         

         const query = useQuery({
          ...complianceControllerListChecksQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const complianceControllerGetCheckQueryKey = (checkId: ComplianceControllerGetCheckPathParams["checkId"] | undefined) => [{ url: '/compliance/checks/:checkId', params: {checkId:checkId} }] as const

export type ComplianceControllerGetCheckQueryKey = ReturnType<typeof complianceControllerGetCheckQueryKey>

export function complianceControllerGetCheckQueryOptions(checkId: ComplianceControllerGetCheckPathParams["checkId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = complianceControllerGetCheckQueryKey(checkId)
        return queryOptions<ComplianceControllerGetCheckQueryResponse, ResponseErrorConfig<ComplianceControllerGetCheck404>, ComplianceControllerGetCheckQueryResponse, typeof queryKey>({
         enabled: !!(checkId),
         queryKey,
         queryFn: async ({ signal }) => {
            return complianceControllerGetCheck(checkId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get compliance check
 * {@link /compliance/checks/:checkId}
 */
export function useComplianceControllerGetCheck<TData = ComplianceControllerGetCheckQueryResponse, TQueryData = ComplianceControllerGetCheckQueryResponse, TQueryKey extends QueryKey = ComplianceControllerGetCheckQueryKey>(checkId: ComplianceControllerGetCheckPathParams["checkId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ComplianceControllerGetCheckQueryResponse, ResponseErrorConfig<ComplianceControllerGetCheck404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? complianceControllerGetCheckQueryKey(checkId)
         

         const query = useQuery({
          ...complianceControllerGetCheckQueryOptions(checkId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComplianceControllerGetCheck404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const complianceControllerListAlertsQueryKey = (params?: ComplianceControllerListAlertsQueryParams) => [{ url: '/compliance/alerts' }, ...(params ? [params] : [])] as const

export type ComplianceControllerListAlertsQueryKey = ReturnType<typeof complianceControllerListAlertsQueryKey>

export function complianceControllerListAlertsQueryOptions(params?: ComplianceControllerListAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = complianceControllerListAlertsQueryKey(params)
        return queryOptions<ComplianceControllerListAlertsQueryResponse, ResponseErrorConfig<Error>, ComplianceControllerListAlertsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return complianceControllerListAlerts(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List compliance alerts
 * {@link /compliance/alerts}
 */
export function useComplianceControllerListAlerts<TData = ComplianceControllerListAlertsQueryResponse, TQueryData = ComplianceControllerListAlertsQueryResponse, TQueryKey extends QueryKey = ComplianceControllerListAlertsQueryKey>(params?: ComplianceControllerListAlertsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ComplianceControllerListAlertsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? complianceControllerListAlertsQueryKey(params)
         

         const query = useQuery({
          ...complianceControllerListAlertsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const complianceControllerGetAlertQueryKey = (alertId: ComplianceControllerGetAlertPathParams["alertId"] | undefined) => [{ url: '/compliance/alerts/:alertId', params: {alertId:alertId} }] as const

export type ComplianceControllerGetAlertQueryKey = ReturnType<typeof complianceControllerGetAlertQueryKey>

export function complianceControllerGetAlertQueryOptions(alertId: ComplianceControllerGetAlertPathParams["alertId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = complianceControllerGetAlertQueryKey(alertId)
        return queryOptions<ComplianceControllerGetAlertQueryResponse, ResponseErrorConfig<ComplianceControllerGetAlert404>, ComplianceControllerGetAlertQueryResponse, typeof queryKey>({
         enabled: !!(alertId),
         queryKey,
         queryFn: async ({ signal }) => {
            return complianceControllerGetAlert(alertId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get compliance alert
 * {@link /compliance/alerts/:alertId}
 */
export function useComplianceControllerGetAlert<TData = ComplianceControllerGetAlertQueryResponse, TQueryData = ComplianceControllerGetAlertQueryResponse, TQueryKey extends QueryKey = ComplianceControllerGetAlertQueryKey>(alertId: ComplianceControllerGetAlertPathParams["alertId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<ComplianceControllerGetAlertQueryResponse, ResponseErrorConfig<ComplianceControllerGetAlert404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? complianceControllerGetAlertQueryKey(alertId)
         

         const query = useQuery({
          ...complianceControllerGetAlertQueryOptions(alertId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ComplianceControllerGetAlert404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const relationsControllerGetPermissionRelationsForUserQueryKey = (params: RelationsControllerGetPermissionRelationsForUserQueryParams) => [{ url: '/relations/permission-relations' }, ...(params ? [params] : [])] as const

export type RelationsControllerGetPermissionRelationsForUserQueryKey = ReturnType<typeof relationsControllerGetPermissionRelationsForUserQueryKey>

export function relationsControllerGetPermissionRelationsForUserQueryOptions(params: RelationsControllerGetPermissionRelationsForUserQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = relationsControllerGetPermissionRelationsForUserQueryKey(params)
        return queryOptions<RelationsControllerGetPermissionRelationsForUserQueryResponse, ResponseErrorConfig<Error>, RelationsControllerGetPermissionRelationsForUserQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return relationsControllerGetPermissionRelationsForUser(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get all permission relations for a user
 * {@link /relations/permission-relations}
 */
export function useRelationsControllerGetPermissionRelationsForUser<TData = RelationsControllerGetPermissionRelationsForUserQueryResponse, TQueryData = RelationsControllerGetPermissionRelationsForUserQueryResponse, TQueryKey extends QueryKey = RelationsControllerGetPermissionRelationsForUserQueryKey>(params: RelationsControllerGetPermissionRelationsForUserQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<RelationsControllerGetPermissionRelationsForUserQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? relationsControllerGetPermissionRelationsForUserQueryKey(params)
         

         const query = useQuery({
          ...relationsControllerGetPermissionRelationsForUserQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const relationsControllerListTenantUsersQueryKey = (params?: RelationsControllerListTenantUsersQueryParams) => [{ url: '/relations/users' }, ...(params ? [params] : [])] as const

export type RelationsControllerListTenantUsersQueryKey = ReturnType<typeof relationsControllerListTenantUsersQueryKey>

export function relationsControllerListTenantUsersQueryOptions(params?: RelationsControllerListTenantUsersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = relationsControllerListTenantUsersQueryKey(params)
        return queryOptions<RelationsControllerListTenantUsersQueryResponse, ResponseErrorConfig<Error>, RelationsControllerListTenantUsersQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return relationsControllerListTenantUsers(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List the users holding relations, one row per user
 * {@link /relations/users}
 */
export function useRelationsControllerListTenantUsers<TData = RelationsControllerListTenantUsersQueryResponse, TQueryData = RelationsControllerListTenantUsersQueryResponse, TQueryKey extends QueryKey = RelationsControllerListTenantUsersQueryKey>(params?: RelationsControllerListTenantUsersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<RelationsControllerListTenantUsersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? relationsControllerListTenantUsersQueryKey(params)
         

         const query = useQuery({
          ...relationsControllerListTenantUsersQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const relationsControllerListRelationsQueryKey = (params?: RelationsControllerListRelationsQueryParams) => [{ url: '/relations/list' }, ...(params ? [params] : [])] as const

export type RelationsControllerListRelationsQueryKey = ReturnType<typeof relationsControllerListRelationsQueryKey>

export function relationsControllerListRelationsQueryOptions(params?: RelationsControllerListRelationsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = relationsControllerListRelationsQueryKey(params)
        return queryOptions<RelationsControllerListRelationsQueryResponse, ResponseErrorConfig<Error>, RelationsControllerListRelationsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return relationsControllerListRelations(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List all relations for a resource and/or a user or none
 * {@link /relations/list}
 */
export function useRelationsControllerListRelations<TData = RelationsControllerListRelationsQueryResponse, TQueryData = RelationsControllerListRelationsQueryResponse, TQueryKey extends QueryKey = RelationsControllerListRelationsQueryKey>(params?: RelationsControllerListRelationsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<RelationsControllerListRelationsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? relationsControllerListRelationsQueryKey(params)
         

         const query = useQuery({
          ...relationsControllerListRelationsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const legacyPermissionsControllerAtMeQueryKey = () => [{ url: '/users/permissions/@me' }] as const

export type LegacyPermissionsControllerAtMeQueryKey = ReturnType<typeof legacyPermissionsControllerAtMeQueryKey>

export function legacyPermissionsControllerAtMeQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = legacyPermissionsControllerAtMeQueryKey()
        return queryOptions<LegacyPermissionsControllerAtMeQueryResponse, ResponseErrorConfig<LegacyPermissionsControllerAtMe404>, LegacyPermissionsControllerAtMeQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return legacyPermissionsControllerAtMe({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Do not use the status code as a signed-in test: an anonymous session gets `200` with an empty identity rather than an error, so branch on a field in the body. On this route a request with no token is `401`, as is a malformed, expired or wrong-tenant token.
 * @summary Get the current user's roles and relations
 * {@link /users/permissions/@me}
 */
export function useLegacyPermissionsControllerAtMe<TData = LegacyPermissionsControllerAtMeQueryResponse, TQueryData = LegacyPermissionsControllerAtMeQueryResponse, TQueryKey extends QueryKey = LegacyPermissionsControllerAtMeQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<LegacyPermissionsControllerAtMeQueryResponse, ResponseErrorConfig<LegacyPermissionsControllerAtMe404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? legacyPermissionsControllerAtMeQueryKey()
         

         const query = useQuery({
          ...legacyPermissionsControllerAtMeQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<LegacyPermissionsControllerAtMe404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerListBrokerageFirmsQueryKey = (params?: BrokerageFirmControllerListBrokerageFirmsQueryParams) => [{ url: '/brokerage-firms' }, ...(params ? [params] : [])] as const

export type BrokerageFirmControllerListBrokerageFirmsQueryKey = ReturnType<typeof brokerageFirmControllerListBrokerageFirmsQueryKey>

export function brokerageFirmControllerListBrokerageFirmsQueryOptions(params?: BrokerageFirmControllerListBrokerageFirmsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerListBrokerageFirmsQueryKey(params)
        return queryOptions<BrokerageFirmControllerListBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmControllerListBrokerageFirmsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerListBrokerageFirms(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a paginated list of brokerage firms in the current tenant. Results may vary by user permissions.
 * @summary List brokerage firms on tenant
 * {@link /brokerage-firms}
 */
export function useBrokerageFirmControllerListBrokerageFirms<TData = BrokerageFirmControllerListBrokerageFirmsQueryResponse, TQueryData = BrokerageFirmControllerListBrokerageFirmsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerListBrokerageFirmsQueryKey>(params?: BrokerageFirmControllerListBrokerageFirmsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerListBrokerageFirmsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerListBrokerageFirmsQueryKey(params)
         

         const query = useQuery({
          ...brokerageFirmControllerListBrokerageFirmsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerGetBrokerageFirmQueryKey = (brokerageFirmId: BrokerageFirmControllerGetBrokerageFirmPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmControllerGetBrokerageFirmQueryKey = ReturnType<typeof brokerageFirmControllerGetBrokerageFirmQueryKey>

export function brokerageFirmControllerGetBrokerageFirmQueryOptions(brokerageFirmId: BrokerageFirmControllerGetBrokerageFirmPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerGetBrokerageFirmQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmControllerGetBrokerageFirmQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetBrokerageFirm404>, BrokerageFirmControllerGetBrokerageFirmQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerGetBrokerageFirm(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves a brokerage firm by id including configuration and metadata.
 * @summary Get brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId}
 */
export function useBrokerageFirmControllerGetBrokerageFirm<TData = BrokerageFirmControllerGetBrokerageFirmQueryResponse, TQueryData = BrokerageFirmControllerGetBrokerageFirmQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerGetBrokerageFirmQueryKey>(brokerageFirmId: BrokerageFirmControllerGetBrokerageFirmPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerGetBrokerageFirmQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetBrokerageFirm404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerGetBrokerageFirmQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmControllerGetBrokerageFirmQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerageFirmControllerGetBrokerageFirm404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerListDocumentsQueryKey = (brokerageFirmId: BrokerageFirmControllerListDocumentsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListDocumentsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/documents', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BrokerageFirmControllerListDocumentsQueryKey = ReturnType<typeof brokerageFirmControllerListDocumentsQueryKey>

export function brokerageFirmControllerListDocumentsQueryOptions(brokerageFirmId: BrokerageFirmControllerListDocumentsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListDocumentsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerListDocumentsQueryKey(brokerageFirmId, params)
        return queryOptions<BrokerageFirmControllerListDocumentsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerListDocuments400 | BrokerageFirmControllerListDocuments403 | BrokerageFirmControllerListDocuments404>, BrokerageFirmControllerListDocumentsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerListDocuments(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Lists documents that belong to the brokerage firm. Supports pagination and filters via query params.
 * @summary List documents on brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents}
 */
export function useBrokerageFirmControllerListDocuments<TData = BrokerageFirmControllerListDocumentsQueryResponse, TQueryData = BrokerageFirmControllerListDocumentsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerListDocumentsQueryKey>(brokerageFirmId: BrokerageFirmControllerListDocumentsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListDocumentsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerListDocumentsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerListDocuments400 | BrokerageFirmControllerListDocuments403 | BrokerageFirmControllerListDocuments404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerListDocumentsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...brokerageFirmControllerListDocumentsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerageFirmControllerListDocuments400 | BrokerageFirmControllerListDocuments403 | BrokerageFirmControllerListDocuments404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerListReportsQueryKey = (brokerageFirmId: BrokerageFirmControllerListReportsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListReportsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/reports', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BrokerageFirmControllerListReportsQueryKey = ReturnType<typeof brokerageFirmControllerListReportsQueryKey>

export function brokerageFirmControllerListReportsQueryOptions(brokerageFirmId: BrokerageFirmControllerListReportsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListReportsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerListReportsQueryKey(brokerageFirmId, params)
        return queryOptions<BrokerageFirmControllerListReportsQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmControllerListReportsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerListReports(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a paginated list of generated reports for the brokerage firm.
 * @summary List reports for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/reports}
 */
export function useBrokerageFirmControllerListReports<TData = BrokerageFirmControllerListReportsQueryResponse, TQueryData = BrokerageFirmControllerListReportsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerListReportsQueryKey>(brokerageFirmId: BrokerageFirmControllerListReportsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListReportsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerListReportsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerListReportsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...brokerageFirmControllerListReportsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerGetReportConfigQueryKey = (brokerageFirmId: BrokerageFirmControllerGetReportConfigPathParams["brokerageFirmId"] | undefined, type: BrokerageFirmControllerGetReportConfigPathParams["type"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/reports/:type/config', params: {brokerageFirmId:brokerageFirmId,type:type} }] as const

export type BrokerageFirmControllerGetReportConfigQueryKey = ReturnType<typeof brokerageFirmControllerGetReportConfigQueryKey>

export function brokerageFirmControllerGetReportConfigQueryOptions(brokerageFirmId: BrokerageFirmControllerGetReportConfigPathParams["brokerageFirmId"] | undefined, type: BrokerageFirmControllerGetReportConfigPathParams["type"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerGetReportConfigQueryKey(brokerageFirmId, type)
        return queryOptions<BrokerageFirmControllerGetReportConfigQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmControllerGetReportConfigQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId && type),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerGetReportConfig(brokerageFirmId!, type!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves the report configuration for the specified brokerage firm.
 * @summary Get report config for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/reports/:type/config}
 */
export function useBrokerageFirmControllerGetReportConfig<TData = BrokerageFirmControllerGetReportConfigQueryResponse, TQueryData = BrokerageFirmControllerGetReportConfigQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerGetReportConfigQueryKey>(brokerageFirmId: BrokerageFirmControllerGetReportConfigPathParams["brokerageFirmId"] | undefined, type: BrokerageFirmControllerGetReportConfigPathParams["type"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerGetReportConfigQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerGetReportConfigQueryKey(brokerageFirmId, type)
         

         const query = useQuery({
          ...brokerageFirmControllerGetReportConfigQueryOptions(brokerageFirmId, type, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerListCommissionStatementsQueryKey = (brokerageFirmId: BrokerageFirmControllerListCommissionStatementsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListCommissionStatementsQueryParams) => [{ url: '/brokerage-firms/:brokerageFirmId/commission-statements', params: {brokerageFirmId:brokerageFirmId} }, ...(params ? [params] : [])] as const

export type BrokerageFirmControllerListCommissionStatementsQueryKey = ReturnType<typeof brokerageFirmControllerListCommissionStatementsQueryKey>

export function brokerageFirmControllerListCommissionStatementsQueryOptions(brokerageFirmId: BrokerageFirmControllerListCommissionStatementsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListCommissionStatementsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerListCommissionStatementsQueryKey(brokerageFirmId, params)
        return queryOptions<BrokerageFirmControllerListCommissionStatementsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerListCommissionStatements403 | BrokerageFirmControllerListCommissionStatements404>, BrokerageFirmControllerListCommissionStatementsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerListCommissionStatements(brokerageFirmId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns the monthly commission statements of one exercise with their downloadable reports: what a wholesale firm paid its retail firms, or what a retail firm received.
 * @summary List commission statements for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/commission-statements}
 */
export function useBrokerageFirmControllerListCommissionStatements<TData = BrokerageFirmControllerListCommissionStatementsQueryResponse, TQueryData = BrokerageFirmControllerListCommissionStatementsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerListCommissionStatementsQueryKey>(brokerageFirmId: BrokerageFirmControllerListCommissionStatementsPathParams["brokerageFirmId"] | undefined, params?: BrokerageFirmControllerListCommissionStatementsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerListCommissionStatementsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerListCommissionStatements403 | BrokerageFirmControllerListCommissionStatements404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerListCommissionStatementsQueryKey(brokerageFirmId, params)
         

         const query = useQuery({
          ...brokerageFirmControllerListCommissionStatementsQueryOptions(brokerageFirmId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerageFirmControllerListCommissionStatements403 | BrokerageFirmControllerListCommissionStatements404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerGetPaymentMethodSetupSecretQueryKey = (brokerageFirmId: BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/payment-methods/secret', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmControllerGetPaymentMethodSetupSecretQueryKey = ReturnType<typeof brokerageFirmControllerGetPaymentMethodSetupSecretQueryKey>

export function brokerageFirmControllerGetPaymentMethodSetupSecretQueryOptions(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerGetPaymentMethodSetupSecretQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethodSetupSecret404>, BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerGetPaymentMethodSetupSecret(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Fetches a setup secret to initialize payment method configuration for the brokerage firm.
 * @summary Get Payment Method Setup Secret
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/secret}
 */
export function useBrokerageFirmControllerGetPaymentMethodSetupSecret<TData = BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, TQueryData = BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerGetPaymentMethodSetupSecretQueryKey>(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodSetupSecretPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerGetPaymentMethodSetupSecretQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethodSetupSecret404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerGetPaymentMethodSetupSecretQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmControllerGetPaymentMethodSetupSecretQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethodSetupSecret404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmControllerGetPaymentMethodsQueryKey = (brokerageFirmId: BrokerageFirmControllerGetPaymentMethodsPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/payment-methods', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmControllerGetPaymentMethodsQueryKey = ReturnType<typeof brokerageFirmControllerGetPaymentMethodsQueryKey>

export function brokerageFirmControllerGetPaymentMethodsQueryOptions(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodsPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmControllerGetPaymentMethodsQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmControllerGetPaymentMethodsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethods404>, BrokerageFirmControllerGetPaymentMethodsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmControllerGetPaymentMethods(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves the payment methods currently configured for the brokerage firm.
 * @summary Get Payment Methods
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods}
 */
export function useBrokerageFirmControllerGetPaymentMethods<TData = BrokerageFirmControllerGetPaymentMethodsQueryResponse, TQueryData = BrokerageFirmControllerGetPaymentMethodsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmControllerGetPaymentMethodsQueryKey>(brokerageFirmId: BrokerageFirmControllerGetPaymentMethodsPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmControllerGetPaymentMethodsQueryResponse, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethods404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmControllerGetPaymentMethodsQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmControllerGetPaymentMethodsQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerageFirmControllerGetPaymentMethods404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const distributionRequestControllerGetDistributionRequestQueryKey = (id: DistributionRequestControllerGetDistributionRequestPathParams["id"] | undefined) => [{ url: '/distribution-requests/:id', params: {id:id} }] as const

export type DistributionRequestControllerGetDistributionRequestQueryKey = ReturnType<typeof distributionRequestControllerGetDistributionRequestQueryKey>

export function distributionRequestControllerGetDistributionRequestQueryOptions(id: DistributionRequestControllerGetDistributionRequestPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = distributionRequestControllerGetDistributionRequestQueryKey(id)
        return queryOptions<DistributionRequestControllerGetDistributionRequestQueryResponse, ResponseErrorConfig<DistributionRequestControllerGetDistributionRequest404>, DistributionRequestControllerGetDistributionRequestQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return distributionRequestControllerGetDistributionRequest(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get distribution request
 * {@link /distribution-requests/:id}
 */
export function useDistributionRequestControllerGetDistributionRequest<TData = DistributionRequestControllerGetDistributionRequestQueryResponse, TQueryData = DistributionRequestControllerGetDistributionRequestQueryResponse, TQueryKey extends QueryKey = DistributionRequestControllerGetDistributionRequestQueryKey>(id: DistributionRequestControllerGetDistributionRequestPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<DistributionRequestControllerGetDistributionRequestQueryResponse, ResponseErrorConfig<DistributionRequestControllerGetDistributionRequest404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? distributionRequestControllerGetDistributionRequestQueryKey(id)
         

         const query = useQuery({
          ...distributionRequestControllerGetDistributionRequestQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DistributionRequestControllerGetDistributionRequest404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const distributionRequestControllerListDistributionRequestsQueryKey = (data: DistributionRequestControllerListDistributionRequestsMutationRequest, params?: DistributionRequestControllerListDistributionRequestsQueryParams) => [{ url: '/distribution-requests/list' }, ...(params ? [params] : []), ...(data ? [data] : [])] as const

export type DistributionRequestControllerListDistributionRequestsQueryKey = ReturnType<typeof distributionRequestControllerListDistributionRequestsQueryKey>

export function distributionRequestControllerListDistributionRequestsQueryOptions(data: DistributionRequestControllerListDistributionRequestsMutationRequest, params?: DistributionRequestControllerListDistributionRequestsQueryParams, config: Partial<RequestConfig<DistributionRequestControllerListDistributionRequestsMutationRequest>> & { client?: Client } = {}) {

        const queryKey = distributionRequestControllerListDistributionRequestsQueryKey(data, params)
        return queryOptions<DistributionRequestControllerListDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, DistributionRequestControllerListDistributionRequestsMutationResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return distributionRequestControllerListDistributionRequests(data, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List distribution requests
 * {@link /distribution-requests/list}
 */
export function useDistributionRequestControllerListDistributionRequests<TData = DistributionRequestControllerListDistributionRequestsMutationResponse, TQueryData = DistributionRequestControllerListDistributionRequestsMutationResponse, TQueryKey extends QueryKey = DistributionRequestControllerListDistributionRequestsQueryKey>(data: DistributionRequestControllerListDistributionRequestsMutationRequest, params?: DistributionRequestControllerListDistributionRequestsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DistributionRequestControllerListDistributionRequestsMutationResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig<DistributionRequestControllerListDistributionRequestsMutationRequest>> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? distributionRequestControllerListDistributionRequestsQueryKey(data, params)
         

         const query = useQuery({
          ...distributionRequestControllerListDistributionRequestsQueryOptions(data, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFeeControllerGetBrokerFeesQueryKey = (params: BrokerageFeeControllerGetBrokerFeesQueryParams) => [{ url: '/brokerage-fees' }, ...(params ? [params] : [])] as const

export type BrokerageFeeControllerGetBrokerFeesQueryKey = ReturnType<typeof brokerageFeeControllerGetBrokerFeesQueryKey>

export function brokerageFeeControllerGetBrokerFeesQueryOptions(params: BrokerageFeeControllerGetBrokerFeesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFeeControllerGetBrokerFeesQueryKey(params)
        return queryOptions<BrokerageFeeControllerGetBrokerFeesQueryResponse, ResponseErrorConfig<BrokerageFeeControllerGetBrokerFees404>, BrokerageFeeControllerGetBrokerFeesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFeeControllerGetBrokerFees(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get all brokerage fees defined for a firm
 * {@link /brokerage-fees}
 */
export function useBrokerageFeeControllerGetBrokerFees<TData = BrokerageFeeControllerGetBrokerFeesQueryResponse, TQueryData = BrokerageFeeControllerGetBrokerFeesQueryResponse, TQueryKey extends QueryKey = BrokerageFeeControllerGetBrokerFeesQueryKey>(params: BrokerageFeeControllerGetBrokerFeesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFeeControllerGetBrokerFeesQueryResponse, ResponseErrorConfig<BrokerageFeeControllerGetBrokerFees404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFeeControllerGetBrokerFeesQueryKey(params)
         

         const query = useQuery({
          ...brokerageFeeControllerGetBrokerFeesQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<BrokerageFeeControllerGetBrokerFees404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const efficialeControllerCheckComplianceQueryKey = (params: EfficialeControllerCheckComplianceQueryParams) => [{ url: '/efficiale' }, ...(params ? [params] : [])] as const

export type EfficialeControllerCheckComplianceQueryKey = ReturnType<typeof efficialeControllerCheckComplianceQueryKey>

export function efficialeControllerCheckComplianceQueryOptions(params: EfficialeControllerCheckComplianceQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = efficialeControllerCheckComplianceQueryKey(params)
        return queryOptions<EfficialeControllerCheckComplianceQueryResponse, ResponseErrorConfig<Error>, EfficialeControllerCheckComplianceQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return efficialeControllerCheckCompliance(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Compliance check for one individual
 * {@link /efficiale}
 */
export function useEfficialeControllerCheckCompliance<TData = EfficialeControllerCheckComplianceQueryResponse, TQueryData = EfficialeControllerCheckComplianceQueryResponse, TQueryKey extends QueryKey = EfficialeControllerCheckComplianceQueryKey>(params: EfficialeControllerCheckComplianceQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<EfficialeControllerCheckComplianceQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? efficialeControllerCheckComplianceQueryKey(params)
         

         const query = useQuery({
          ...efficialeControllerCheckComplianceQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const efficialeControllerGetAlertsQueryKey = (params?: EfficialeControllerGetAlertsQueryParams) => [{ url: '/efficiale/alerts' }, ...(params ? [params] : [])] as const

export type EfficialeControllerGetAlertsQueryKey = ReturnType<typeof efficialeControllerGetAlertsQueryKey>

export function efficialeControllerGetAlertsQueryOptions(params?: EfficialeControllerGetAlertsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = efficialeControllerGetAlertsQueryKey(params)
        return queryOptions<EfficialeControllerGetAlertsQueryResponse, ResponseErrorConfig<Error>, EfficialeControllerGetAlertsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return efficialeControllerGetAlerts(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get alerts from Efficiale
 * {@link /efficiale/alerts}
 */
export function useEfficialeControllerGetAlerts<TData = EfficialeControllerGetAlertsQueryResponse, TQueryData = EfficialeControllerGetAlertsQueryResponse, TQueryKey extends QueryKey = EfficialeControllerGetAlertsQueryKey>(params?: EfficialeControllerGetAlertsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<EfficialeControllerGetAlertsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? efficialeControllerGetAlertsQueryKey(params)
         

         const query = useQuery({
          ...efficialeControllerGetAlertsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const metabaseControllerGetIframeUrlQueryKey = (params?: MetabaseControllerGetIframeUrlQueryParams) => [{ url: '/metabase/iframe-url' }, ...(params ? [params] : [])] as const

export type MetabaseControllerGetIframeUrlQueryKey = ReturnType<typeof metabaseControllerGetIframeUrlQueryKey>

export function metabaseControllerGetIframeUrlQueryOptions(params?: MetabaseControllerGetIframeUrlQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = metabaseControllerGetIframeUrlQueryKey(params)
        return queryOptions<MetabaseControllerGetIframeUrlQueryResponse, ResponseErrorConfig<Error>, MetabaseControllerGetIframeUrlQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return metabaseControllerGetIframeUrl(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a short-lived URL that embeds the analytics dashboard in an iframe.
 * @summary Get a signed analytics dashboard URL
 * {@link /metabase/iframe-url}
 */
export function useMetabaseControllerGetIframeUrl<TData = MetabaseControllerGetIframeUrlQueryResponse, TQueryData = MetabaseControllerGetIframeUrlQueryResponse, TQueryKey extends QueryKey = MetabaseControllerGetIframeUrlQueryKey>(params?: MetabaseControllerGetIframeUrlQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<MetabaseControllerGetIframeUrlQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? metabaseControllerGetIframeUrlQueryKey(params)
         

         const query = useQuery({
          ...metabaseControllerGetIframeUrlQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const fvaControllerRetrieveReportOutcomeQueryKey = (params: FvaControllerRetrieveReportOutcomeQueryParams) => [{ url: '/fva/report-outcome' }, ...(params ? [params] : [])] as const

export type FvaControllerRetrieveReportOutcomeQueryKey = ReturnType<typeof fvaControllerRetrieveReportOutcomeQueryKey>

export function fvaControllerRetrieveReportOutcomeQueryOptions(params: FvaControllerRetrieveReportOutcomeQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = fvaControllerRetrieveReportOutcomeQueryKey(params)
        return queryOptions<FvaControllerRetrieveReportOutcomeQueryResponse, ResponseErrorConfig<Error>, FvaControllerRetrieveReportOutcomeQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return fvaControllerRetrieveReportOutcome(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve FVA report outcome
 * {@link /fva/report-outcome}
 */
export function useFvaControllerRetrieveReportOutcome<TData = FvaControllerRetrieveReportOutcomeQueryResponse, TQueryData = FvaControllerRetrieveReportOutcomeQueryResponse, TQueryKey extends QueryKey = FvaControllerRetrieveReportOutcomeQueryKey>(params: FvaControllerRetrieveReportOutcomeQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<FvaControllerRetrieveReportOutcomeQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? fvaControllerRetrieveReportOutcomeQueryKey(params)
         

         const query = useQuery({
          ...fvaControllerRetrieveReportOutcomeQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentValidityControllerGetPolicyValidityQueryKey = (policyId: DocumentValidityControllerGetPolicyValidityPathParams["policyId"] | undefined, params?: DocumentValidityControllerGetPolicyValidityQueryParams) => [{ url: '/policies/:policyId/documents/validity', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type DocumentValidityControllerGetPolicyValidityQueryKey = ReturnType<typeof documentValidityControllerGetPolicyValidityQueryKey>

export function documentValidityControllerGetPolicyValidityQueryOptions(policyId: DocumentValidityControllerGetPolicyValidityPathParams["policyId"] | undefined, params?: DocumentValidityControllerGetPolicyValidityQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentValidityControllerGetPolicyValidityQueryKey(policyId, params)
        return queryOptions<DocumentValidityControllerGetPolicyValidityQueryResponse, ResponseErrorConfig<DocumentValidityControllerGetPolicyValidity404>, DocumentValidityControllerGetPolicyValidityQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return documentValidityControllerGetPolicyValidity(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List document validity results for a policy
 * {@link /policies/:policyId/documents/validity}
 */
export function useDocumentValidityControllerGetPolicyValidity<TData = DocumentValidityControllerGetPolicyValidityQueryResponse, TQueryData = DocumentValidityControllerGetPolicyValidityQueryResponse, TQueryKey extends QueryKey = DocumentValidityControllerGetPolicyValidityQueryKey>(policyId: DocumentValidityControllerGetPolicyValidityPathParams["policyId"] | undefined, params?: DocumentValidityControllerGetPolicyValidityQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DocumentValidityControllerGetPolicyValidityQueryResponse, ResponseErrorConfig<DocumentValidityControllerGetPolicyValidity404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentValidityControllerGetPolicyValidityQueryKey(policyId, params)
         

         const query = useQuery({
          ...documentValidityControllerGetPolicyValidityQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentValidityControllerGetPolicyValidity404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentValidityControllerGetDocumentValidityQueryKey = (policyId: DocumentValidityControllerGetDocumentValidityPathParams["policyId"] | undefined, documentId: DocumentValidityControllerGetDocumentValidityPathParams["documentId"] | undefined) => [{ url: '/policies/:policyId/documents/validity/:documentId', params: {policyId:policyId,documentId:documentId} }] as const

export type DocumentValidityControllerGetDocumentValidityQueryKey = ReturnType<typeof documentValidityControllerGetDocumentValidityQueryKey>

export function documentValidityControllerGetDocumentValidityQueryOptions(policyId: DocumentValidityControllerGetDocumentValidityPathParams["policyId"] | undefined, documentId: DocumentValidityControllerGetDocumentValidityPathParams["documentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentValidityControllerGetDocumentValidityQueryKey(policyId, documentId)
        return queryOptions<DocumentValidityControllerGetDocumentValidityQueryResponse, ResponseErrorConfig<DocumentValidityControllerGetDocumentValidity500>, DocumentValidityControllerGetDocumentValidityQueryResponse, typeof queryKey>({
         enabled: !!(policyId && documentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return documentValidityControllerGetDocumentValidity(policyId!, documentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get validity results for a specific document
 * {@link /policies/:policyId/documents/validity/:documentId}
 */
export function useDocumentValidityControllerGetDocumentValidity<TData = DocumentValidityControllerGetDocumentValidityQueryResponse, TQueryData = DocumentValidityControllerGetDocumentValidityQueryResponse, TQueryKey extends QueryKey = DocumentValidityControllerGetDocumentValidityQueryKey>(policyId: DocumentValidityControllerGetDocumentValidityPathParams["policyId"] | undefined, documentId: DocumentValidityControllerGetDocumentValidityPathParams["documentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<DocumentValidityControllerGetDocumentValidityQueryResponse, ResponseErrorConfig<DocumentValidityControllerGetDocumentValidity500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentValidityControllerGetDocumentValidityQueryKey(policyId, documentId)
         

         const query = useQuery({
          ...documentValidityControllerGetDocumentValidityQueryOptions(policyId, documentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentValidityControllerGetDocumentValidity500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryKey = (brokerageFirmId: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/documents/validity', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryKey = ReturnType<typeof brokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryKey>

export function brokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryOptions(brokerageFirmId: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmDocumentValidityControllerGetBrokerageFirmValidity(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List document validity results for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/validity}
 */
export function useBrokerageFirmDocumentValidityControllerGetBrokerageFirmValidity<TData = BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, TQueryData = BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, TQueryKey extends QueryKey = BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryKey>(brokerageFirmId: BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmDocumentValidityControllerGetBrokerageFirmValidityQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentCoherenceControllerGetDocumentCoherenceQueryKey = (entityId: DocumentCoherenceControllerGetDocumentCoherencePathParams["entityId"] | undefined, params?: DocumentCoherenceControllerGetDocumentCoherenceQueryParams) => [{ url: '/documents/coherence/:entityId', params: {entityId:entityId} }, ...(params ? [params] : [])] as const

export type DocumentCoherenceControllerGetDocumentCoherenceQueryKey = ReturnType<typeof documentCoherenceControllerGetDocumentCoherenceQueryKey>

export function documentCoherenceControllerGetDocumentCoherenceQueryOptions(entityId: DocumentCoherenceControllerGetDocumentCoherencePathParams["entityId"] | undefined, params?: DocumentCoherenceControllerGetDocumentCoherenceQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentCoherenceControllerGetDocumentCoherenceQueryKey(entityId, params)
        return queryOptions<DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, ResponseErrorConfig<DocumentCoherenceControllerGetDocumentCoherence400 | DocumentCoherenceControllerGetDocumentCoherence404>, DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, typeof queryKey>({
         enabled: !!(entityId),
         queryKey,
         queryFn: async ({ signal }) => {
            return documentCoherenceControllerGetDocumentCoherence(entityId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Compare document extracted values with typed values
 * {@link /documents/coherence/:entityId}
 */
export function useDocumentCoherenceControllerGetDocumentCoherence<TData = DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, TQueryData = DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, TQueryKey extends QueryKey = DocumentCoherenceControllerGetDocumentCoherenceQueryKey>(entityId: DocumentCoherenceControllerGetDocumentCoherencePathParams["entityId"] | undefined, params?: DocumentCoherenceControllerGetDocumentCoherenceQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<DocumentCoherenceControllerGetDocumentCoherenceQueryResponse, ResponseErrorConfig<DocumentCoherenceControllerGetDocumentCoherence400 | DocumentCoherenceControllerGetDocumentCoherence404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentCoherenceControllerGetDocumentCoherenceQueryKey(entityId, params)
         

         const query = useQuery({
          ...documentCoherenceControllerGetDocumentCoherenceQueryOptions(entityId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentCoherenceControllerGetDocumentCoherence400 | DocumentCoherenceControllerGetDocumentCoherence404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyDocumentControllerGetPolicyDocumentConformityQueryKey = (policyId: PolicyDocumentControllerGetPolicyDocumentConformityPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentConformityQueryParams) => [{ url: '/policies/:policyId/documents/conformity', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyDocumentControllerGetPolicyDocumentConformityQueryKey = ReturnType<typeof policyDocumentControllerGetPolicyDocumentConformityQueryKey>

export function policyDocumentControllerGetPolicyDocumentConformityQueryOptions(policyId: PolicyDocumentControllerGetPolicyDocumentConformityPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentConformityQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyDocumentControllerGetPolicyDocumentConformityQueryKey(policyId, params)
        return queryOptions<PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, ResponseErrorConfig<Error>, PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyDocumentControllerGetPolicyDocumentConformity(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get effective document conformity for a policy branch
 * {@link /policies/:policyId/documents/conformity}
 */
export function usePolicyDocumentControllerGetPolicyDocumentConformity<TData = PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, TQueryData = PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, TQueryKey extends QueryKey = PolicyDocumentControllerGetPolicyDocumentConformityQueryKey>(policyId: PolicyDocumentControllerGetPolicyDocumentConformityPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentConformityQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyDocumentControllerGetPolicyDocumentConformityQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyDocumentControllerGetPolicyDocumentConformityQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyDocumentControllerGetPolicyDocumentConformityQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyDocumentControllerGetPolicyDocumentVerdictsQueryKey = (policyId: PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams) => [{ url: '/policies/:policyId/documents/verdicts', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyDocumentControllerGetPolicyDocumentVerdictsQueryKey = ReturnType<typeof policyDocumentControllerGetPolicyDocumentVerdictsQueryKey>

export function policyDocumentControllerGetPolicyDocumentVerdictsQueryOptions(policyId: PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyDocumentControllerGetPolicyDocumentVerdictsQueryKey(policyId, params)
        return queryOptions<PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, ResponseErrorConfig<Error>, PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyDocumentControllerGetPolicyDocumentVerdicts(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get the AI verdict for the documents of a policy branch
 * {@link /policies/:policyId/documents/verdicts}
 */
export function usePolicyDocumentControllerGetPolicyDocumentVerdicts<TData = PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, TQueryData = PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, TQueryKey extends QueryKey = PolicyDocumentControllerGetPolicyDocumentVerdictsQueryKey>(policyId: PolicyDocumentControllerGetPolicyDocumentVerdictsPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentVerdictsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyDocumentControllerGetPolicyDocumentVerdictsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyDocumentControllerGetPolicyDocumentVerdictsQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyDocumentControllerGetPolicyDocumentVerdictsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyDocumentControllerGetPolicyDocumentFraudQueryKey = (policyId: PolicyDocumentControllerGetPolicyDocumentFraudPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentFraudQueryParams) => [{ url: '/policies/:policyId/documents/fraud', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyDocumentControllerGetPolicyDocumentFraudQueryKey = ReturnType<typeof policyDocumentControllerGetPolicyDocumentFraudQueryKey>

export function policyDocumentControllerGetPolicyDocumentFraudQueryOptions(policyId: PolicyDocumentControllerGetPolicyDocumentFraudPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentFraudQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyDocumentControllerGetPolicyDocumentFraudQueryKey(policyId, params)
        return queryOptions<PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, ResponseErrorConfig<Error>, PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyDocumentControllerGetPolicyDocumentFraud(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get current fraud results for the documents of a policy branch
 * {@link /policies/:policyId/documents/fraud}
 */
export function usePolicyDocumentControllerGetPolicyDocumentFraud<TData = PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, TQueryData = PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, TQueryKey extends QueryKey = PolicyDocumentControllerGetPolicyDocumentFraudQueryKey>(policyId: PolicyDocumentControllerGetPolicyDocumentFraudPathParams["policyId"] | undefined, params: PolicyDocumentControllerGetPolicyDocumentFraudQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyDocumentControllerGetPolicyDocumentFraudQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyDocumentControllerGetPolicyDocumentFraudQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyDocumentControllerGetPolicyDocumentFraudQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryKey = (brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/documents/conformity', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryKey = ReturnType<typeof brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryKey>

export function brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryOptions(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get effective document conformity for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/conformity}
 */
export function useBrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformity<TData = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, TQueryData = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, TQueryKey extends QueryKey = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryKey>(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmDocumentControllerGetBrokerageFirmDocumentConformityQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryKey = (brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/documents/fraud', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryKey = ReturnType<typeof brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryKey>

export function brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryOptions(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get current fraud results for the onboarding documents of a firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/fraud}
 */
export function useBrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraud<TData = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, TQueryData = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, TQueryKey extends QueryKey = BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryKey>(brokerageFirmId: BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmDocumentControllerGetBrokerageFirmDocumentFraudQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyDocumentCollectionControllerGetCollectionStateQueryKey = (policyId: PolicyDocumentCollectionControllerGetCollectionStatePathParams["policyId"] | undefined, params: PolicyDocumentCollectionControllerGetCollectionStateQueryParams) => [{ url: '/policies/:policyId/document-collection', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyDocumentCollectionControllerGetCollectionStateQueryKey = ReturnType<typeof policyDocumentCollectionControllerGetCollectionStateQueryKey>

export function policyDocumentCollectionControllerGetCollectionStateQueryOptions(policyId: PolicyDocumentCollectionControllerGetCollectionStatePathParams["policyId"] | undefined, params: PolicyDocumentCollectionControllerGetCollectionStateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyDocumentCollectionControllerGetCollectionStateQueryKey(policyId, params)
        return queryOptions<PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, ResponseErrorConfig<Error>, PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyDocumentCollectionControllerGetCollectionState(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get document collection status for a policy branch
 * {@link /policies/:policyId/document-collection}
 */
export function usePolicyDocumentCollectionControllerGetCollectionState<TData = PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, TQueryData = PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, TQueryKey extends QueryKey = PolicyDocumentCollectionControllerGetCollectionStateQueryKey>(policyId: PolicyDocumentCollectionControllerGetCollectionStatePathParams["policyId"] | undefined, params: PolicyDocumentCollectionControllerGetCollectionStateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyDocumentCollectionControllerGetCollectionStateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyDocumentCollectionControllerGetCollectionStateQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyDocumentCollectionControllerGetCollectionStateQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const policyDocumentExtractionControllerGetPolicyExtractionsQueryKey = (policyId: PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams["policyId"] | undefined, params?: PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams) => [{ url: '/policies/:policyId/document-extractions', params: {policyId:policyId} }, ...(params ? [params] : [])] as const

export type PolicyDocumentExtractionControllerGetPolicyExtractionsQueryKey = ReturnType<typeof policyDocumentExtractionControllerGetPolicyExtractionsQueryKey>

export function policyDocumentExtractionControllerGetPolicyExtractionsQueryOptions(policyId: PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams["policyId"] | undefined, params?: PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = policyDocumentExtractionControllerGetPolicyExtractionsQueryKey(policyId, params)
        return queryOptions<PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, ResponseErrorConfig<PolicyDocumentExtractionControllerGetPolicyExtractions404>, PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, typeof queryKey>({
         enabled: !!(policyId),
         queryKey,
         queryFn: async ({ signal }) => {
            return policyDocumentExtractionControllerGetPolicyExtractions(policyId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List document extractions for a policy
 * {@link /policies/:policyId/document-extractions}
 */
export function usePolicyDocumentExtractionControllerGetPolicyExtractions<TData = PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, TQueryData = PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, TQueryKey extends QueryKey = PolicyDocumentExtractionControllerGetPolicyExtractionsQueryKey>(policyId: PolicyDocumentExtractionControllerGetPolicyExtractionsPathParams["policyId"] | undefined, params?: PolicyDocumentExtractionControllerGetPolicyExtractionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PolicyDocumentExtractionControllerGetPolicyExtractionsQueryResponse, ResponseErrorConfig<PolicyDocumentExtractionControllerGetPolicyExtractions404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? policyDocumentExtractionControllerGetPolicyExtractionsQueryKey(policyId, params)
         

         const query = useQuery({
          ...policyDocumentExtractionControllerGetPolicyExtractionsQueryOptions(policyId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<PolicyDocumentExtractionControllerGetPolicyExtractions404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentExtractionControllerGetDocumentExtractionQueryKey = (documentId: DocumentExtractionControllerGetDocumentExtractionPathParams["documentId"] | undefined) => [{ url: '/document-extractions/:documentId', params: {documentId:documentId} }] as const

export type DocumentExtractionControllerGetDocumentExtractionQueryKey = ReturnType<typeof documentExtractionControllerGetDocumentExtractionQueryKey>

export function documentExtractionControllerGetDocumentExtractionQueryOptions(documentId: DocumentExtractionControllerGetDocumentExtractionPathParams["documentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentExtractionControllerGetDocumentExtractionQueryKey(documentId)
        return queryOptions<DocumentExtractionControllerGetDocumentExtractionQueryResponse, ResponseErrorConfig<DocumentExtractionControllerGetDocumentExtraction404>, DocumentExtractionControllerGetDocumentExtractionQueryResponse, typeof queryKey>({
         enabled: !!(documentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return documentExtractionControllerGetDocumentExtraction(documentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get a specific document extraction
 * {@link /document-extractions/:documentId}
 */
export function useDocumentExtractionControllerGetDocumentExtraction<TData = DocumentExtractionControllerGetDocumentExtractionQueryResponse, TQueryData = DocumentExtractionControllerGetDocumentExtractionQueryResponse, TQueryKey extends QueryKey = DocumentExtractionControllerGetDocumentExtractionQueryKey>(documentId: DocumentExtractionControllerGetDocumentExtractionPathParams["documentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<DocumentExtractionControllerGetDocumentExtractionQueryResponse, ResponseErrorConfig<DocumentExtractionControllerGetDocumentExtraction404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentExtractionControllerGetDocumentExtractionQueryKey(documentId)
         

         const query = useQuery({
          ...documentExtractionControllerGetDocumentExtractionQueryOptions(documentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentExtractionControllerGetDocumentExtraction404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const documentExtractionControllerGetExtractionFeedbackQueryKey = (documentId: DocumentExtractionControllerGetExtractionFeedbackPathParams["documentId"] | undefined) => [{ url: '/document-extractions/:documentId/feedback', params: {documentId:documentId} }] as const

export type DocumentExtractionControllerGetExtractionFeedbackQueryKey = ReturnType<typeof documentExtractionControllerGetExtractionFeedbackQueryKey>

export function documentExtractionControllerGetExtractionFeedbackQueryOptions(documentId: DocumentExtractionControllerGetExtractionFeedbackPathParams["documentId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = documentExtractionControllerGetExtractionFeedbackQueryKey(documentId)
        return queryOptions<DocumentExtractionControllerGetExtractionFeedbackQueryResponse, ResponseErrorConfig<Error>, DocumentExtractionControllerGetExtractionFeedbackQueryResponse, typeof queryKey>({
         enabled: !!(documentId),
         queryKey,
         queryFn: async ({ signal }) => {
            return documentExtractionControllerGetExtractionFeedback(documentId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get feedback for a document extraction
 * {@link /document-extractions/:documentId/feedback}
 */
export function useDocumentExtractionControllerGetExtractionFeedback<TData = DocumentExtractionControllerGetExtractionFeedbackQueryResponse, TQueryData = DocumentExtractionControllerGetExtractionFeedbackQueryResponse, TQueryKey extends QueryKey = DocumentExtractionControllerGetExtractionFeedbackQueryKey>(documentId: DocumentExtractionControllerGetExtractionFeedbackPathParams["documentId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<DocumentExtractionControllerGetExtractionFeedbackQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? documentExtractionControllerGetExtractionFeedbackQueryKey(documentId)
         

         const query = useQuery({
          ...documentExtractionControllerGetExtractionFeedbackQueryOptions(documentId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryKey = (brokerageFirmId: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams["brokerageFirmId"] | undefined) => [{ url: '/brokerage-firms/:brokerageFirmId/document-extractions', params: {brokerageFirmId:brokerageFirmId} }] as const

export type BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryKey = ReturnType<typeof brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryKey>

export function brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryOptions(brokerageFirmId: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams["brokerageFirmId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryKey(brokerageFirmId)
        return queryOptions<BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, ResponseErrorConfig<Error>, BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, typeof queryKey>({
         enabled: !!(brokerageFirmId),
         queryKey,
         queryFn: async ({ signal }) => {
            return brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions(brokerageFirmId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List document extractions for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/document-extractions}
 */
export function useBrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractions<TData = BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, TQueryData = BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, TQueryKey extends QueryKey = BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryKey>(brokerageFirmId: BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsPathParams["brokerageFirmId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<BrokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryKey(brokerageFirmId)
         

         const query = useQuery({
          ...brokerageFirmDocumentExtractionControllerGetBrokerageFirmExtractionsQueryOptions(brokerageFirmId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const jwksControllerGetJwksQueryKey = () => [{ url: '/.well-known/jwks.json' }] as const

export type JwksControllerGetJwksQueryKey = ReturnType<typeof jwksControllerGetJwksQueryKey>

export function jwksControllerGetJwksQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = jwksControllerGetJwksQueryKey()
        return queryOptions<JwksControllerGetJwksQueryResponse, ResponseErrorConfig<Error>, JwksControllerGetJwksQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return jwksControllerGetJwks({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Advertises the public keys used to verify Korint-signed JWTs.
 * @summary Get the JSON Web Key Set
 * {@link /.well-known/jwks.json}
 */
export function useJwksControllerGetJwks<TData = JwksControllerGetJwksQueryResponse, TQueryData = JwksControllerGetJwksQueryResponse, TQueryKey extends QueryKey = JwksControllerGetJwksQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<JwksControllerGetJwksQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? jwksControllerGetJwksQueryKey()
         

         const query = useQuery({
          ...jwksControllerGetJwksQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const impersonationControllerListSessionsQueryKey = (params?: ImpersonationControllerListSessionsQueryParams) => [{ url: '/impersonation/sessions' }, ...(params ? [params] : [])] as const

export type ImpersonationControllerListSessionsQueryKey = ReturnType<typeof impersonationControllerListSessionsQueryKey>

export function impersonationControllerListSessionsQueryOptions(params?: ImpersonationControllerListSessionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = impersonationControllerListSessionsQueryKey(params)
        return queryOptions<ImpersonationControllerListSessionsQueryResponse, ResponseErrorConfig<Error>, ImpersonationControllerListSessionsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return impersonationControllerListSessions(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary List impersonation sessions, live or past
 * {@link /impersonation/sessions}
 */
export function useImpersonationControllerListSessions<TData = ImpersonationControllerListSessionsQueryResponse, TQueryData = ImpersonationControllerListSessionsQueryResponse, TQueryKey extends QueryKey = ImpersonationControllerListSessionsQueryKey>(params?: ImpersonationControllerListSessionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ImpersonationControllerListSessionsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? impersonationControllerListSessionsQueryKey(params)
         

         const query = useQuery({
          ...impersonationControllerListSessionsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const fcbWidgetControllerMintTokenQueryKey = () => [{ url: '/fcb-widget/token' }] as const

export type FcbWidgetControllerMintTokenQueryKey = ReturnType<typeof fcbWidgetControllerMintTokenQueryKey>

export function fcbWidgetControllerMintTokenQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = fcbWidgetControllerMintTokenQueryKey()
        return queryOptions<FcbWidgetControllerMintTokenQueryResponse, ResponseErrorConfig<Error>, FcbWidgetControllerMintTokenQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return fcbWidgetControllerMintToken({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Mint a short-lived RS256 JWT for the FCB WhatsApp widget
 * {@link /fcb-widget/token}
 */
export function useFcbWidgetControllerMintToken<TData = FcbWidgetControllerMintTokenQueryResponse, TQueryData = FcbWidgetControllerMintTokenQueryResponse, TQueryKey extends QueryKey = FcbWidgetControllerMintTokenQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<FcbWidgetControllerMintTokenQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? fcbWidgetControllerMintTokenQueryKey()
         

         const query = useQuery({
          ...fcbWidgetControllerMintTokenQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}

export const authControllerCheckEmailMutationKey = () => [{ url: '/auth/check-email' }] as const

export type AuthControllerCheckEmailMutationKey = ReturnType<typeof authControllerCheckEmailMutationKey>

export function authControllerCheckEmailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AuthControllerCheckEmailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = authControllerCheckEmailMutationKey()
        return mutationOptions<AuthControllerCheckEmailMutationResponse, ResponseErrorConfig<Error>, {data: AuthControllerCheckEmailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return authControllerCheckEmail(data, config)
          },
        })

}

/**
 * @summary Check email status for authentication
 * {@link /auth/check-email}
 */
export function useAuthControllerCheckEmail<TContext>(options: 
{
  mutation?: UseMutationOptions<AuthControllerCheckEmailMutationResponse, ResponseErrorConfig<Error>, {data: AuthControllerCheckEmailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AuthControllerCheckEmailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? authControllerCheckEmailMutationKey()

          const baseOptions = authControllerCheckEmailMutationOptions(config) as UseMutationOptions<AuthControllerCheckEmailMutationResponse, ResponseErrorConfig<Error>, {data: AuthControllerCheckEmailMutationRequest}, TContext>
          

          return useMutation<AuthControllerCheckEmailMutationResponse, ResponseErrorConfig<Error>, {data: AuthControllerCheckEmailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuthControllerCheckEmailMutationResponse, ResponseErrorConfig<Error>, {data: AuthControllerCheckEmailMutationRequest}, TContext>
      
}

export const assetControllerBatchCreateAssetsMutationKey = () => [{ url: '/assets/batch/create' }] as const

export type AssetControllerBatchCreateAssetsMutationKey = ReturnType<typeof assetControllerBatchCreateAssetsMutationKey>

export function assetControllerBatchCreateAssetsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerBatchCreateAssetsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerBatchCreateAssetsMutationKey()
        return mutationOptions<AssetControllerBatchCreateAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchCreateAssetsMutationRequest, params: AssetControllerBatchCreateAssetsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return assetControllerBatchCreateAssets(data, params, config)
          },
        })

}

/**
 * @summary Create several assets on the same policy
 * {@link /assets/batch/create}
 */
export function useAssetControllerBatchCreateAssets<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerBatchCreateAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchCreateAssetsMutationRequest, params: AssetControllerBatchCreateAssetsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerBatchCreateAssetsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerBatchCreateAssetsMutationKey()

          const baseOptions = assetControllerBatchCreateAssetsMutationOptions(config) as UseMutationOptions<AssetControllerBatchCreateAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchCreateAssetsMutationRequest, params: AssetControllerBatchCreateAssetsQueryParams}, TContext>
          

          return useMutation<AssetControllerBatchCreateAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchCreateAssetsMutationRequest, params: AssetControllerBatchCreateAssetsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerBatchCreateAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchCreateAssetsMutationRequest, params: AssetControllerBatchCreateAssetsQueryParams}, TContext>
      
}

export const assetControllerBatchEditAssetsMutationKey = () => [{ url: '/assets/batch/edit' }] as const

export type AssetControllerBatchEditAssetsMutationKey = ReturnType<typeof assetControllerBatchEditAssetsMutationKey>

export function assetControllerBatchEditAssetsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerBatchEditAssetsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerBatchEditAssetsMutationKey()
        return mutationOptions<AssetControllerBatchEditAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchEditAssetsMutationRequest, params?: AssetControllerBatchEditAssetsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return assetControllerBatchEditAssets(data, params, config)
          },
        })

}

/**
 * @summary Edit several assets of the same policy
 * {@link /assets/batch/edit}
 */
export function useAssetControllerBatchEditAssets<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerBatchEditAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchEditAssetsMutationRequest, params?: AssetControllerBatchEditAssetsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerBatchEditAssetsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerBatchEditAssetsMutationKey()

          const baseOptions = assetControllerBatchEditAssetsMutationOptions(config) as UseMutationOptions<AssetControllerBatchEditAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchEditAssetsMutationRequest, params?: AssetControllerBatchEditAssetsQueryParams}, TContext>
          

          return useMutation<AssetControllerBatchEditAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchEditAssetsMutationRequest, params?: AssetControllerBatchEditAssetsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerBatchEditAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchEditAssetsMutationRequest, params?: AssetControllerBatchEditAssetsQueryParams}, TContext>
      
}

export const assetControllerBatchRemoveAssetsMutationKey = () => [{ url: '/assets/batch/remove' }] as const

export type AssetControllerBatchRemoveAssetsMutationKey = ReturnType<typeof assetControllerBatchRemoveAssetsMutationKey>

export function assetControllerBatchRemoveAssetsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerBatchRemoveAssetsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerBatchRemoveAssetsMutationKey()
        return mutationOptions<AssetControllerBatchRemoveAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchRemoveAssetsMutationRequest, params: AssetControllerBatchRemoveAssetsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return assetControllerBatchRemoveAssets(data, params, config)
          },
        })

}

/**
 * @summary Remove several assets from their policy
 * {@link /assets/batch/remove}
 */
export function useAssetControllerBatchRemoveAssets<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerBatchRemoveAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchRemoveAssetsMutationRequest, params: AssetControllerBatchRemoveAssetsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerBatchRemoveAssetsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerBatchRemoveAssetsMutationKey()

          const baseOptions = assetControllerBatchRemoveAssetsMutationOptions(config) as UseMutationOptions<AssetControllerBatchRemoveAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchRemoveAssetsMutationRequest, params: AssetControllerBatchRemoveAssetsQueryParams}, TContext>
          

          return useMutation<AssetControllerBatchRemoveAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchRemoveAssetsMutationRequest, params: AssetControllerBatchRemoveAssetsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerBatchRemoveAssetsMutationResponse, ResponseErrorConfig<Error>, {data: AssetControllerBatchRemoveAssetsMutationRequest, params: AssetControllerBatchRemoveAssetsQueryParams}, TContext>
      
}

export const assetControllerCreateAssetMutationKey = () => [{ url: '/assets' }] as const

export type AssetControllerCreateAssetMutationKey = ReturnType<typeof assetControllerCreateAssetMutationKey>

export function assetControllerCreateAssetMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerCreateAssetMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerCreateAssetMutationKey()
        return mutationOptions<AssetControllerCreateAssetMutationResponse, ResponseErrorConfig<AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409>, {data: AssetControllerCreateAssetMutationRequest, params: AssetControllerCreateAssetQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return assetControllerCreateAsset(data, params, config)
          },
        })

}

/**
 * @description `startedAt` must be the start of the day in `Europe/Paris`, expressed in UTC — `endedAt` is derived from it by snapping to that zone, so UTC midnight yields a contract two hours short with no error anywhere. Most products require it before the contract can be quoted.
 * @summary Create Asset
 * {@link /assets}
 */
export function useAssetControllerCreateAsset<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerCreateAssetMutationResponse, ResponseErrorConfig<AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409>, {data: AssetControllerCreateAssetMutationRequest, params: AssetControllerCreateAssetQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerCreateAssetMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerCreateAssetMutationKey()

          const baseOptions = assetControllerCreateAssetMutationOptions(config) as UseMutationOptions<AssetControllerCreateAssetMutationResponse, ResponseErrorConfig<AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409>, {data: AssetControllerCreateAssetMutationRequest, params: AssetControllerCreateAssetQueryParams}, TContext>
          

          return useMutation<AssetControllerCreateAssetMutationResponse, ResponseErrorConfig<AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409>, {data: AssetControllerCreateAssetMutationRequest, params: AssetControllerCreateAssetQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerCreateAssetMutationResponse, ResponseErrorConfig<AssetControllerCreateAsset400 | AssetControllerCreateAsset403 | AssetControllerCreateAsset404 | AssetControllerCreateAsset409>, {data: AssetControllerCreateAssetMutationRequest, params: AssetControllerCreateAssetQueryParams}, TContext>
      
}

export const assetControllerReplaceAssetMutationKey = () => [{ url: '/assets/:originAssetId/replace' }] as const

export type AssetControllerReplaceAssetMutationKey = ReturnType<typeof assetControllerReplaceAssetMutationKey>

export function assetControllerReplaceAssetMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerReplaceAssetMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerReplaceAssetMutationKey()
        return mutationOptions<AssetControllerReplaceAssetMutationResponse, ResponseErrorConfig<AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409>, {originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"], data: AssetControllerReplaceAssetMutationRequest, params: AssetControllerReplaceAssetQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ originAssetId, data, params }) => {
            return assetControllerReplaceAsset(originAssetId, data, params, config)
          },
        })

}

/**
 * @summary Replace Asset
 * {@link /assets/:originAssetId/replace}
 */
export function useAssetControllerReplaceAsset<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerReplaceAssetMutationResponse, ResponseErrorConfig<AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409>, {originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"], data: AssetControllerReplaceAssetMutationRequest, params: AssetControllerReplaceAssetQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerReplaceAssetMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerReplaceAssetMutationKey()

          const baseOptions = assetControllerReplaceAssetMutationOptions(config) as UseMutationOptions<AssetControllerReplaceAssetMutationResponse, ResponseErrorConfig<AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409>, {originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"], data: AssetControllerReplaceAssetMutationRequest, params: AssetControllerReplaceAssetQueryParams}, TContext>
          

          return useMutation<AssetControllerReplaceAssetMutationResponse, ResponseErrorConfig<AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409>, {originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"], data: AssetControllerReplaceAssetMutationRequest, params: AssetControllerReplaceAssetQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerReplaceAssetMutationResponse, ResponseErrorConfig<AssetControllerReplaceAsset400 | AssetControllerReplaceAsset404 | AssetControllerReplaceAsset409>, {originAssetId: AssetControllerReplaceAssetPathParams["originAssetId"], data: AssetControllerReplaceAssetMutationRequest, params: AssetControllerReplaceAssetQueryParams}, TContext>
      
}

export const assetControllerEditAssetMutationKey = () => [{ url: '/assets/:assetId' }] as const

export type AssetControllerEditAssetMutationKey = ReturnType<typeof assetControllerEditAssetMutationKey>

export function assetControllerEditAssetMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerEditAssetMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerEditAssetMutationKey()
        return mutationOptions<AssetControllerEditAssetMutationResponse, ResponseErrorConfig<AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409>, {assetId: AssetControllerEditAssetPathParams["assetId"], data: AssetControllerEditAssetMutationRequest, params?: AssetControllerEditAssetQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ assetId, data, params }) => {
            return assetControllerEditAsset(assetId, data, params, config)
          },
        })

}

/**
 * @summary Edit an asset
 * {@link /assets/:assetId}
 */
export function useAssetControllerEditAsset<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerEditAssetMutationResponse, ResponseErrorConfig<AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409>, {assetId: AssetControllerEditAssetPathParams["assetId"], data: AssetControllerEditAssetMutationRequest, params?: AssetControllerEditAssetQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerEditAssetMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerEditAssetMutationKey()

          const baseOptions = assetControllerEditAssetMutationOptions(config) as UseMutationOptions<AssetControllerEditAssetMutationResponse, ResponseErrorConfig<AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409>, {assetId: AssetControllerEditAssetPathParams["assetId"], data: AssetControllerEditAssetMutationRequest, params?: AssetControllerEditAssetQueryParams}, TContext>
          

          return useMutation<AssetControllerEditAssetMutationResponse, ResponseErrorConfig<AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409>, {assetId: AssetControllerEditAssetPathParams["assetId"], data: AssetControllerEditAssetMutationRequest, params?: AssetControllerEditAssetQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerEditAssetMutationResponse, ResponseErrorConfig<AssetControllerEditAsset400 | AssetControllerEditAsset403 | AssetControllerEditAsset404 | AssetControllerEditAsset409>, {assetId: AssetControllerEditAssetPathParams["assetId"], data: AssetControllerEditAssetMutationRequest, params?: AssetControllerEditAssetQueryParams}, TContext>
      
}

export const assetControllerRemoveAssetMutationKey = () => [{ url: '/assets/:assetId' }] as const

export type AssetControllerRemoveAssetMutationKey = ReturnType<typeof assetControllerRemoveAssetMutationKey>

export function assetControllerRemoveAssetMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = assetControllerRemoveAssetMutationKey()
        return mutationOptions<AssetControllerRemoveAssetMutationResponse, ResponseErrorConfig<AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409>, {assetId: AssetControllerRemoveAssetPathParams["assetId"], params: AssetControllerRemoveAssetQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ assetId, params }) => {
            return assetControllerRemoveAsset(assetId, params, config)
          },
        })

}

/**
 * @description Only possible when the asset was created on the same branch it is being removed on.
 * @summary Remove an asset from its policy
 * {@link /assets/:assetId}
 */
export function useAssetControllerRemoveAsset<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerRemoveAssetMutationResponse, ResponseErrorConfig<AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409>, {assetId: AssetControllerRemoveAssetPathParams["assetId"], params: AssetControllerRemoveAssetQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerRemoveAssetMutationKey()

          const baseOptions = assetControllerRemoveAssetMutationOptions(config) as UseMutationOptions<AssetControllerRemoveAssetMutationResponse, ResponseErrorConfig<AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409>, {assetId: AssetControllerRemoveAssetPathParams["assetId"], params: AssetControllerRemoveAssetQueryParams}, TContext>
          

          return useMutation<AssetControllerRemoveAssetMutationResponse, ResponseErrorConfig<AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409>, {assetId: AssetControllerRemoveAssetPathParams["assetId"], params: AssetControllerRemoveAssetQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerRemoveAssetMutationResponse, ResponseErrorConfig<AssetControllerRemoveAsset400 | AssetControllerRemoveAsset403 | AssetControllerRemoveAsset404 | AssetControllerRemoveAsset409>, {assetId: AssetControllerRemoveAssetPathParams["assetId"], params: AssetControllerRemoveAssetQueryParams}, TContext>
      
}

export const assetControllerPushAssetEventMutationKey = () => [{ url: '/assets/:assetId/events' }] as const

export type AssetControllerPushAssetEventMutationKey = ReturnType<typeof assetControllerPushAssetEventMutationKey>

export function assetControllerPushAssetEventMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AssetControllerPushAssetEventMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = assetControllerPushAssetEventMutationKey()
        return mutationOptions<AssetControllerPushAssetEventMutationResponse, ResponseErrorConfig<AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404>, {assetId: AssetControllerPushAssetEventPathParams["assetId"], data: AssetControllerPushAssetEventMutationRequest, params: AssetControllerPushAssetEventQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ assetId, data, params }) => {
            return assetControllerPushAssetEvent(assetId, data, params, config)
          },
        })

}

/**
 * @summary Push a custom event onto an asset
 * {@link /assets/:assetId/events}
 */
export function useAssetControllerPushAssetEvent<TContext>(options: 
{
  mutation?: UseMutationOptions<AssetControllerPushAssetEventMutationResponse, ResponseErrorConfig<AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404>, {assetId: AssetControllerPushAssetEventPathParams["assetId"], data: AssetControllerPushAssetEventMutationRequest, params: AssetControllerPushAssetEventQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AssetControllerPushAssetEventMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? assetControllerPushAssetEventMutationKey()

          const baseOptions = assetControllerPushAssetEventMutationOptions(config) as UseMutationOptions<AssetControllerPushAssetEventMutationResponse, ResponseErrorConfig<AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404>, {assetId: AssetControllerPushAssetEventPathParams["assetId"], data: AssetControllerPushAssetEventMutationRequest, params: AssetControllerPushAssetEventQueryParams}, TContext>
          

          return useMutation<AssetControllerPushAssetEventMutationResponse, ResponseErrorConfig<AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404>, {assetId: AssetControllerPushAssetEventPathParams["assetId"], data: AssetControllerPushAssetEventMutationRequest, params: AssetControllerPushAssetEventQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AssetControllerPushAssetEventMutationResponse, ResponseErrorConfig<AssetControllerPushAssetEvent400 | AssetControllerPushAssetEvent404>, {assetId: AssetControllerPushAssetEventPathParams["assetId"], data: AssetControllerPushAssetEventMutationRequest, params: AssetControllerPushAssetEventQueryParams}, TContext>
      
}

export const billingControllerListInvoicesMutationKey = () => [{ url: '/billing/debug/list-by-metadata' }] as const

export type BillingControllerListInvoicesMutationKey = ReturnType<typeof billingControllerListInvoicesMutationKey>

export function billingControllerListInvoicesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BillingControllerListInvoicesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = billingControllerListInvoicesMutationKey()
        return mutationOptions<BillingControllerListInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerListInvoicesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return billingControllerListInvoices(data, config)
          },
        })

}

/**
 * @description Returns a paginated list of invoices filtered by issuance date range, statuses and failure flag. Accepts metadata filters as defined by the shared list filter DTO.
 * @summary DEBUG: List invoice by metadata
 * {@link /billing/debug/list-by-metadata}
 */
export function useBillingControllerListInvoices<TContext>(options: 
{
  mutation?: UseMutationOptions<BillingControllerListInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerListInvoicesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BillingControllerListInvoicesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? billingControllerListInvoicesMutationKey()

          const baseOptions = billingControllerListInvoicesMutationOptions(config) as UseMutationOptions<BillingControllerListInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerListInvoicesMutationRequest}, TContext>
          

          return useMutation<BillingControllerListInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerListInvoicesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BillingControllerListInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerListInvoicesMutationRequest}, TContext>
      
}

export const billingControllerCreateManualInvoiceMutationKey = () => [{ url: '/billing/debug/create-manual-invoice' }] as const

export type BillingControllerCreateManualInvoiceMutationKey = ReturnType<typeof billingControllerCreateManualInvoiceMutationKey>

export function billingControllerCreateManualInvoiceMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BillingControllerCreateManualInvoiceMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = billingControllerCreateManualInvoiceMutationKey()
        return mutationOptions<BillingControllerCreateManualInvoiceMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerCreateManualInvoiceMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return billingControllerCreateManualInvoice(data, config)
          },
        })

}

/**
 * @summary DEBUG: Create manual invoice
 * {@link /billing/debug/create-manual-invoice}
 */
export function useBillingControllerCreateManualInvoice<TContext>(options: 
{
  mutation?: UseMutationOptions<BillingControllerCreateManualInvoiceMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerCreateManualInvoiceMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BillingControllerCreateManualInvoiceMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? billingControllerCreateManualInvoiceMutationKey()

          const baseOptions = billingControllerCreateManualInvoiceMutationOptions(config) as UseMutationOptions<BillingControllerCreateManualInvoiceMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerCreateManualInvoiceMutationRequest}, TContext>
          

          return useMutation<BillingControllerCreateManualInvoiceMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerCreateManualInvoiceMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BillingControllerCreateManualInvoiceMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerCreateManualInvoiceMutationRequest}, TContext>
      
}

export const billingControllerSetInvoiceCleanupMutationKey = () => [{ url: '/billing/debug/set-invoice-cleanup' }] as const

export type BillingControllerSetInvoiceCleanupMutationKey = ReturnType<typeof billingControllerSetInvoiceCleanupMutationKey>

export function billingControllerSetInvoiceCleanupMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BillingControllerSetInvoiceCleanupMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = billingControllerSetInvoiceCleanupMutationKey()
        return mutationOptions<BillingControllerSetInvoiceCleanupMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerSetInvoiceCleanupMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return billingControllerSetInvoiceCleanup(data, config)
          },
        })

}

/**
 * @summary DEBUG: Set or unset the cleanup flag on an invoice and rebuild it
 * {@link /billing/debug/set-invoice-cleanup}
 */
export function useBillingControllerSetInvoiceCleanup<TContext>(options: 
{
  mutation?: UseMutationOptions<BillingControllerSetInvoiceCleanupMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerSetInvoiceCleanupMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BillingControllerSetInvoiceCleanupMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? billingControllerSetInvoiceCleanupMutationKey()

          const baseOptions = billingControllerSetInvoiceCleanupMutationOptions(config) as UseMutationOptions<BillingControllerSetInvoiceCleanupMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerSetInvoiceCleanupMutationRequest}, TContext>
          

          return useMutation<BillingControllerSetInvoiceCleanupMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerSetInvoiceCleanupMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BillingControllerSetInvoiceCleanupMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerSetInvoiceCleanupMutationRequest}, TContext>
      
}

export const billingControllerIssueInvoicesMutationKey = () => [{ url: '/billing/debug/issue-invoices' }] as const

export type BillingControllerIssueInvoicesMutationKey = ReturnType<typeof billingControllerIssueInvoicesMutationKey>

export function billingControllerIssueInvoicesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BillingControllerIssueInvoicesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = billingControllerIssueInvoicesMutationKey()
        return mutationOptions<BillingControllerIssueInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerIssueInvoicesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return billingControllerIssueInvoices(data, config)
          },
        })

}

/**
 * @summary DEBUG: Issue invoices
 * {@link /billing/debug/issue-invoices}
 */
export function useBillingControllerIssueInvoices<TContext>(options: 
{
  mutation?: UseMutationOptions<BillingControllerIssueInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerIssueInvoicesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BillingControllerIssueInvoicesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? billingControllerIssueInvoicesMutationKey()

          const baseOptions = billingControllerIssueInvoicesMutationOptions(config) as UseMutationOptions<BillingControllerIssueInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerIssueInvoicesMutationRequest}, TContext>
          

          return useMutation<BillingControllerIssueInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerIssueInvoicesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BillingControllerIssueInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerIssueInvoicesMutationRequest}, TContext>
      
}

export const billingControllerDeleteInvoicesMutationKey = () => [{ url: '/billing/debug/delete-invoices' }] as const

export type BillingControllerDeleteInvoicesMutationKey = ReturnType<typeof billingControllerDeleteInvoicesMutationKey>

export function billingControllerDeleteInvoicesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BillingControllerDeleteInvoicesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = billingControllerDeleteInvoicesMutationKey()
        return mutationOptions<BillingControllerDeleteInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerDeleteInvoicesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return billingControllerDeleteInvoices(data, config)
          },
        })

}

/**
 * @summary DEBUG: Delete invoices
 * {@link /billing/debug/delete-invoices}
 */
export function useBillingControllerDeleteInvoices<TContext>(options: 
{
  mutation?: UseMutationOptions<BillingControllerDeleteInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerDeleteInvoicesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BillingControllerDeleteInvoicesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? billingControllerDeleteInvoicesMutationKey()

          const baseOptions = billingControllerDeleteInvoicesMutationOptions(config) as UseMutationOptions<BillingControllerDeleteInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerDeleteInvoicesMutationRequest}, TContext>
          

          return useMutation<BillingControllerDeleteInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerDeleteInvoicesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BillingControllerDeleteInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: BillingControllerDeleteInvoicesMutationRequest}, TContext>
      
}

export const branchControllerEditBranchMutationKey = () => [{ url: '/branches/:branchId' }] as const

export type BranchControllerEditBranchMutationKey = ReturnType<typeof branchControllerEditBranchMutationKey>

export function branchControllerEditBranchMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BranchControllerEditBranchMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = branchControllerEditBranchMutationKey()
        return mutationOptions<BranchControllerEditBranchMutationResponse, ResponseErrorConfig<BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409>, {branchId: BranchControllerEditBranchPathParams["branchId"], data: BranchControllerEditBranchMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ branchId, data }) => {
            return branchControllerEditBranch(branchId, data, config)
          },
        })

}

/**
 * @description Edits only the name of an open MTA branch and requires the BRANCH_EDITOR role. Names are trimmed; blank names are rejected. An unchanged name succeeds without modification. Returns an empty object. Other branch and policy data remain unchanged.
 * @summary Edit an open MTA project
 * {@link /branches/:branchId}
 */
export function useBranchControllerEditBranch<TContext>(options: 
{
  mutation?: UseMutationOptions<BranchControllerEditBranchMutationResponse, ResponseErrorConfig<BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409>, {branchId: BranchControllerEditBranchPathParams["branchId"], data: BranchControllerEditBranchMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BranchControllerEditBranchMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? branchControllerEditBranchMutationKey()

          const baseOptions = branchControllerEditBranchMutationOptions(config) as UseMutationOptions<BranchControllerEditBranchMutationResponse, ResponseErrorConfig<BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409>, {branchId: BranchControllerEditBranchPathParams["branchId"], data: BranchControllerEditBranchMutationRequest}, TContext>
          

          return useMutation<BranchControllerEditBranchMutationResponse, ResponseErrorConfig<BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409>, {branchId: BranchControllerEditBranchPathParams["branchId"], data: BranchControllerEditBranchMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BranchControllerEditBranchMutationResponse, ResponseErrorConfig<BranchControllerEditBranch400 | BranchControllerEditBranch404 | BranchControllerEditBranch409>, {branchId: BranchControllerEditBranchPathParams["branchId"], data: BranchControllerEditBranchMutationRequest}, TContext>
      
}

export const branchControllerCreateBranchMutationKey = () => [{ url: '/policies/:policyId/branches' }] as const

export type BranchControllerCreateBranchMutationKey = ReturnType<typeof branchControllerCreateBranchMutationKey>

export function branchControllerCreateBranchMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BranchControllerCreateBranchMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = branchControllerCreateBranchMutationKey()
        return mutationOptions<BranchControllerCreateBranchMutationResponse, ResponseErrorConfig<BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409>, {policyId: BranchControllerCreateBranchPathParams["policyId"], data: BranchControllerCreateBranchMutationRequest, params?: BranchControllerCreateBranchQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return branchControllerCreateBranch(policyId, data, params, config)
          },
        })

}

/**
 * @description A mid-term adjustment needs the policy in `POLICY_CONFIRMED`, `POLICY_SIGNED` or `POLICY_STARTED`; other statuses are refused with `CONFLICTING_POLICY_STATUS`. Keep the returned branch id — every later call on that draft carries it, including the signature request.
 * @summary Create a branch
 * {@link /policies/:policyId/branches}
 */
export function useBranchControllerCreateBranch<TContext>(options: 
{
  mutation?: UseMutationOptions<BranchControllerCreateBranchMutationResponse, ResponseErrorConfig<BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409>, {policyId: BranchControllerCreateBranchPathParams["policyId"], data: BranchControllerCreateBranchMutationRequest, params?: BranchControllerCreateBranchQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BranchControllerCreateBranchMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? branchControllerCreateBranchMutationKey()

          const baseOptions = branchControllerCreateBranchMutationOptions(config) as UseMutationOptions<BranchControllerCreateBranchMutationResponse, ResponseErrorConfig<BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409>, {policyId: BranchControllerCreateBranchPathParams["policyId"], data: BranchControllerCreateBranchMutationRequest, params?: BranchControllerCreateBranchQueryParams}, TContext>
          

          return useMutation<BranchControllerCreateBranchMutationResponse, ResponseErrorConfig<BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409>, {policyId: BranchControllerCreateBranchPathParams["policyId"], data: BranchControllerCreateBranchMutationRequest, params?: BranchControllerCreateBranchQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BranchControllerCreateBranchMutationResponse, ResponseErrorConfig<BranchControllerCreateBranch400 | BranchControllerCreateBranch404 | BranchControllerCreateBranch409>, {policyId: BranchControllerCreateBranchPathParams["policyId"], data: BranchControllerCreateBranchMutationRequest, params?: BranchControllerCreateBranchQueryParams}, TContext>
      
}

export const branchControllerForkBranchMutationKey = () => [{ url: '/policies/:policyId/branches/:branchId/fork' }] as const

export type BranchControllerForkBranchMutationKey = ReturnType<typeof branchControllerForkBranchMutationKey>

export function branchControllerForkBranchMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BranchControllerForkBranchMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = branchControllerForkBranchMutationKey()
        return mutationOptions<BranchControllerForkBranchMutationResponse, ResponseErrorConfig<BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409>, {policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"], data: BranchControllerForkBranchMutationRequest, params?: BranchControllerForkBranchQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, branchId, data, params }) => {
            return branchControllerForkBranch(policyId, branchId, data, params, config)
          },
        })

}

/**
 * @summary Fork a branch until its XXX_QUOTED events
 * {@link /policies/:policyId/branches/:branchId/fork}
 * @deprecated
 */
export function useBranchControllerForkBranch<TContext>(options: 
{
  mutation?: UseMutationOptions<BranchControllerForkBranchMutationResponse, ResponseErrorConfig<BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409>, {policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"], data: BranchControllerForkBranchMutationRequest, params?: BranchControllerForkBranchQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BranchControllerForkBranchMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? branchControllerForkBranchMutationKey()

          const baseOptions = branchControllerForkBranchMutationOptions(config) as UseMutationOptions<BranchControllerForkBranchMutationResponse, ResponseErrorConfig<BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409>, {policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"], data: BranchControllerForkBranchMutationRequest, params?: BranchControllerForkBranchQueryParams}, TContext>
          

          return useMutation<BranchControllerForkBranchMutationResponse, ResponseErrorConfig<BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409>, {policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"], data: BranchControllerForkBranchMutationRequest, params?: BranchControllerForkBranchQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BranchControllerForkBranchMutationResponse, ResponseErrorConfig<BranchControllerForkBranch400 | BranchControllerForkBranch404 | BranchControllerForkBranch409>, {policyId: BranchControllerForkBranchPathParams["policyId"], branchId: BranchControllerForkBranchPathParams["branchId"], data: BranchControllerForkBranchMutationRequest, params?: BranchControllerForkBranchQueryParams}, TContext>
      
}

export const branchControllerForkBranchWithoutPolicyMutationKey = () => [{ url: '/branches/:branchId/fork' }] as const

export type BranchControllerForkBranchWithoutPolicyMutationKey = ReturnType<typeof branchControllerForkBranchWithoutPolicyMutationKey>

export function branchControllerForkBranchWithoutPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BranchControllerForkBranchWithoutPolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = branchControllerForkBranchWithoutPolicyMutationKey()
        return mutationOptions<BranchControllerForkBranchWithoutPolicyMutationResponse, ResponseErrorConfig<BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409>, {branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"], data: BranchControllerForkBranchWithoutPolicyMutationRequest, params?: BranchControllerForkBranchWithoutPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ branchId, data, params }) => {
            return branchControllerForkBranchWithoutPolicy(branchId, data, params, config)
          },
        })

}

/**
 * @summary Fork a branch until its XXX_QUOTED events
 * {@link /branches/:branchId/fork}
 */
export function useBranchControllerForkBranchWithoutPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<BranchControllerForkBranchWithoutPolicyMutationResponse, ResponseErrorConfig<BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409>, {branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"], data: BranchControllerForkBranchWithoutPolicyMutationRequest, params?: BranchControllerForkBranchWithoutPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BranchControllerForkBranchWithoutPolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? branchControllerForkBranchWithoutPolicyMutationKey()

          const baseOptions = branchControllerForkBranchWithoutPolicyMutationOptions(config) as UseMutationOptions<BranchControllerForkBranchWithoutPolicyMutationResponse, ResponseErrorConfig<BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409>, {branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"], data: BranchControllerForkBranchWithoutPolicyMutationRequest, params?: BranchControllerForkBranchWithoutPolicyQueryParams}, TContext>
          

          return useMutation<BranchControllerForkBranchWithoutPolicyMutationResponse, ResponseErrorConfig<BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409>, {branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"], data: BranchControllerForkBranchWithoutPolicyMutationRequest, params?: BranchControllerForkBranchWithoutPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BranchControllerForkBranchWithoutPolicyMutationResponse, ResponseErrorConfig<BranchControllerForkBranchWithoutPolicy400 | BranchControllerForkBranchWithoutPolicy404 | BranchControllerForkBranchWithoutPolicy409>, {branchId: BranchControllerForkBranchWithoutPolicyPathParams["branchId"], data: BranchControllerForkBranchWithoutPolicyMutationRequest, params?: BranchControllerForkBranchWithoutPolicyQueryParams}, TContext>
      
}

export const branchControllerInvalidateBranchMutationKey = () => [{ url: '/policies/:policyId/branches/:branchId/invalidate' }] as const

export type BranchControllerInvalidateBranchMutationKey = ReturnType<typeof branchControllerInvalidateBranchMutationKey>

export function branchControllerInvalidateBranchMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BranchControllerInvalidateBranchMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = branchControllerInvalidateBranchMutationKey()
        return mutationOptions<BranchControllerInvalidateBranchMutationResponse, ResponseErrorConfig<BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409>, {policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"], data: BranchControllerInvalidateBranchMutationRequest, params?: BranchControllerInvalidateBranchQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, branchId, data, params }) => {
            return branchControllerInvalidateBranch(policyId, branchId, data, params, config)
          },
        })

}

/**
 * @description Closes a draft without applying it; the live contract is untouched. Signing one draft closes the competing ones automatically, so this is only for drafts you abandon. On a termination branch this is also how a stop is called off, drafted or already scheduled: the policy stays in force with no coverage gap. Whoever may request that stop reason may call it off, and so may the brokers of the wholesale firm the policy is distributed for.
 * @summary Invalidate a branch
 * {@link /policies/:policyId/branches/:branchId/invalidate}
 */
export function useBranchControllerInvalidateBranch<TContext>(options: 
{
  mutation?: UseMutationOptions<BranchControllerInvalidateBranchMutationResponse, ResponseErrorConfig<BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409>, {policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"], data: BranchControllerInvalidateBranchMutationRequest, params?: BranchControllerInvalidateBranchQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BranchControllerInvalidateBranchMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? branchControllerInvalidateBranchMutationKey()

          const baseOptions = branchControllerInvalidateBranchMutationOptions(config) as UseMutationOptions<BranchControllerInvalidateBranchMutationResponse, ResponseErrorConfig<BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409>, {policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"], data: BranchControllerInvalidateBranchMutationRequest, params?: BranchControllerInvalidateBranchQueryParams}, TContext>
          

          return useMutation<BranchControllerInvalidateBranchMutationResponse, ResponseErrorConfig<BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409>, {policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"], data: BranchControllerInvalidateBranchMutationRequest, params?: BranchControllerInvalidateBranchQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BranchControllerInvalidateBranchMutationResponse, ResponseErrorConfig<BranchControllerInvalidateBranch403 | BranchControllerInvalidateBranch404 | BranchControllerInvalidateBranch409>, {policyId: BranchControllerInvalidateBranchPathParams["policyId"], branchId: BranchControllerInvalidateBranchPathParams["branchId"], data: BranchControllerInvalidateBranchMutationRequest, params?: BranchControllerInvalidateBranchQueryParams}, TContext>
      
}

export const brokerControllerCreateBrokerMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/brokers' }] as const

export type BrokerControllerCreateBrokerMutationKey = ReturnType<typeof brokerControllerCreateBrokerMutationKey>

export function brokerControllerCreateBrokerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerControllerCreateBrokerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerControllerCreateBrokerMutationKey()
        return mutationOptions<BrokerControllerCreateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerCreateBroker404>, {brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"], data: BrokerControllerCreateBrokerMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerControllerCreateBroker(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Creates a broker within the specified brokerage firm. You must provide the target brokerage firm id in the path and the broker details in the request body. The caller must have sufficient permissions within the brokerage firm.
 * @summary Create broker
 * {@link /brokerage-firms/:brokerageFirmId/brokers}
 */
export function useBrokerControllerCreateBroker<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerControllerCreateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerCreateBroker404>, {brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"], data: BrokerControllerCreateBrokerMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerControllerCreateBrokerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerControllerCreateBrokerMutationKey()

          const baseOptions = brokerControllerCreateBrokerMutationOptions(config) as UseMutationOptions<BrokerControllerCreateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerCreateBroker404>, {brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"], data: BrokerControllerCreateBrokerMutationRequest}, TContext>
          

          return useMutation<BrokerControllerCreateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerCreateBroker404>, {brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"], data: BrokerControllerCreateBrokerMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerControllerCreateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerCreateBroker404>, {brokerageFirmId: BrokerControllerCreateBrokerPathParams["brokerageFirmId"], data: BrokerControllerCreateBrokerMutationRequest}, TContext>
      
}

export const brokerControllerUpdateBrokerMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/brokers/:brokerUserId' }] as const

export type BrokerControllerUpdateBrokerMutationKey = ReturnType<typeof brokerControllerUpdateBrokerMutationKey>

export function brokerControllerUpdateBrokerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerControllerUpdateBrokerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerControllerUpdateBrokerMutationKey()
        return mutationOptions<BrokerControllerUpdateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerUpdateBroker404>, {brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"], data: BrokerControllerUpdateBrokerMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerUserId, brokerageFirmId, data }) => {
            return brokerControllerUpdateBroker(brokerUserId, brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Updates a broker profile inside a brokerage firm. Provide the brokerage firm id and the broker user id in the path and the fields to update in the request body. Only allowed for users with edit permissions.
 * @summary Update broker
 * {@link /brokerage-firms/:brokerageFirmId/brokers/:brokerUserId}
 */
export function useBrokerControllerUpdateBroker<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerControllerUpdateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerUpdateBroker404>, {brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"], data: BrokerControllerUpdateBrokerMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerControllerUpdateBrokerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerControllerUpdateBrokerMutationKey()

          const baseOptions = brokerControllerUpdateBrokerMutationOptions(config) as UseMutationOptions<BrokerControllerUpdateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerUpdateBroker404>, {brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"], data: BrokerControllerUpdateBrokerMutationRequest}, TContext>
          

          return useMutation<BrokerControllerUpdateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerUpdateBroker404>, {brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"], data: BrokerControllerUpdateBrokerMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerControllerUpdateBrokerMutationResponse, ResponseErrorConfig<BrokerControllerUpdateBroker404>, {brokerUserId: BrokerControllerUpdateBrokerPathParams["brokerUserId"], brokerageFirmId: BrokerControllerUpdateBrokerPathParams["brokerageFirmId"], data: BrokerControllerUpdateBrokerMutationRequest}, TContext>
      
}

export const brokerControllerDeleteBrokerMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/brokers/:brokerUserId' }] as const

export type BrokerControllerDeleteBrokerMutationKey = ReturnType<typeof brokerControllerDeleteBrokerMutationKey>

export function brokerControllerDeleteBrokerMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerControllerDeleteBrokerMutationKey()
        return mutationOptions<BrokerControllerDeleteBrokerMutationResponse, ResponseErrorConfig<BrokerControllerDeleteBroker404>, {brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, brokerUserId }) => {
            return brokerControllerDeleteBroker(brokerageFirmId, brokerUserId, config)
          },
        })

}

/**
 * @description Removes a broker from the given brokerage firm using the broker user id. Only users with delete permissions within the brokerage firm can perform this action.
 * @summary Delete broker from brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/brokers/:brokerUserId}
 */
export function useBrokerControllerDeleteBroker<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerControllerDeleteBrokerMutationResponse, ResponseErrorConfig<BrokerControllerDeleteBroker404>, {brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerControllerDeleteBrokerMutationKey()

          const baseOptions = brokerControllerDeleteBrokerMutationOptions(config) as UseMutationOptions<BrokerControllerDeleteBrokerMutationResponse, ResponseErrorConfig<BrokerControllerDeleteBroker404>, {brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"]}, TContext>
          

          return useMutation<BrokerControllerDeleteBrokerMutationResponse, ResponseErrorConfig<BrokerControllerDeleteBroker404>, {brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerControllerDeleteBrokerMutationResponse, ResponseErrorConfig<BrokerControllerDeleteBroker404>, {brokerageFirmId: BrokerControllerDeleteBrokerPathParams["brokerageFirmId"], brokerUserId: BrokerControllerDeleteBrokerPathParams["brokerUserId"]}, TContext>
      
}

export const emailAccountControllerConnectMutationKey = () => [{ url: '/email-accounts/connect' }] as const

export type EmailAccountControllerConnectMutationKey = ReturnType<typeof emailAccountControllerConnectMutationKey>

export function emailAccountControllerConnectMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailAccountControllerConnectMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailAccountControllerConnectMutationKey()
        return mutationOptions<EmailAccountControllerConnectMutationResponse, ResponseErrorConfig<Error>, {data: EmailAccountControllerConnectMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return emailAccountControllerConnect(data, config)
          },
        })

}

/**
 * @description Returns a single-use hosted consent URL. The browser must be redirected to it; the provider redirects back to the OAuth callback once consent completes. Connecting a shared mailbox requires the shared-account admin permission. Pass delegatedMailboxAddress to connect a Microsoft 365 shared mailbox through the signing-in user (Outlook only).
 * @summary Start the OAuth consent flow to connect an email account
 * {@link /email-accounts/connect}
 */
export function useEmailAccountControllerConnect<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailAccountControllerConnectMutationResponse, ResponseErrorConfig<Error>, {data: EmailAccountControllerConnectMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailAccountControllerConnectMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailAccountControllerConnectMutationKey()

          const baseOptions = emailAccountControllerConnectMutationOptions(config) as UseMutationOptions<EmailAccountControllerConnectMutationResponse, ResponseErrorConfig<Error>, {data: EmailAccountControllerConnectMutationRequest}, TContext>
          

          return useMutation<EmailAccountControllerConnectMutationResponse, ResponseErrorConfig<Error>, {data: EmailAccountControllerConnectMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailAccountControllerConnectMutationResponse, ResponseErrorConfig<Error>, {data: EmailAccountControllerConnectMutationRequest}, TContext>
      
}

export const emailAccountControllerReconnectMutationKey = () => [{ url: '/email-accounts/:emailAccountId/reconnect' }] as const

export type EmailAccountControllerReconnectMutationKey = ReturnType<typeof emailAccountControllerReconnectMutationKey>

export function emailAccountControllerReconnectMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailAccountControllerReconnectMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailAccountControllerReconnectMutationKey()
        return mutationOptions<EmailAccountControllerReconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"], data: EmailAccountControllerReconnectMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ emailAccountId, data }) => {
            return emailAccountControllerReconnect(emailAccountId, data, config)
          },
        })

}

/**
 * @description Returns a single-use hosted consent URL that reauthorizes the existing vendor account. The browser must be redirected to it; the provider redirects back to the OAuth callback once consent completes.
 * @summary Restart the OAuth consent flow to reconnect an email account in error
 * {@link /email-accounts/:emailAccountId/reconnect}
 */
export function useEmailAccountControllerReconnect<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailAccountControllerReconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"], data: EmailAccountControllerReconnectMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailAccountControllerReconnectMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailAccountControllerReconnectMutationKey()

          const baseOptions = emailAccountControllerReconnectMutationOptions(config) as UseMutationOptions<EmailAccountControllerReconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"], data: EmailAccountControllerReconnectMutationRequest}, TContext>
          

          return useMutation<EmailAccountControllerReconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"], data: EmailAccountControllerReconnectMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailAccountControllerReconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerReconnectPathParams["emailAccountId"], data: EmailAccountControllerReconnectMutationRequest}, TContext>
      
}

export const emailAccountControllerDisconnectMutationKey = () => [{ url: '/email-accounts/:emailAccountId' }] as const

export type EmailAccountControllerDisconnectMutationKey = ReturnType<typeof emailAccountControllerDisconnectMutationKey>

export function emailAccountControllerDisconnectMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = emailAccountControllerDisconnectMutationKey()
        return mutationOptions<EmailAccountControllerDisconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"]}, TContext>({
          mutationKey,
          mutationFn: async({ emailAccountId }) => {
            return emailAccountControllerDisconnect(emailAccountId, config)
          },
        })

}

/**
 * @description Revokes the upstream OAuth grant, removes the account from the email sync provider, and soft-deletes it. A broker may delete their personal accounts; a shared account may only be deleted by a firm admin.
 * @summary Disconnect and delete one of the logged-in broker's email accounts
 * {@link /email-accounts/:emailAccountId}
 */
export function useEmailAccountControllerDisconnect<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailAccountControllerDisconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailAccountControllerDisconnectMutationKey()

          const baseOptions = emailAccountControllerDisconnectMutationOptions(config) as UseMutationOptions<EmailAccountControllerDisconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"]}, TContext>
          

          return useMutation<EmailAccountControllerDisconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailAccountControllerDisconnectMutationResponse, ResponseErrorConfig<Error>, {emailAccountId: EmailAccountControllerDisconnectPathParams["emailAccountId"]}, TContext>
      
}

export const emailControllerAttachPoliciesMutationKey = () => [{ url: '/emails/:emailId/policies' }] as const

export type EmailControllerAttachPoliciesMutationKey = ReturnType<typeof emailControllerAttachPoliciesMutationKey>

export function emailControllerAttachPoliciesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailControllerAttachPoliciesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailControllerAttachPoliciesMutationKey()
        return mutationOptions<EmailControllerAttachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403>, {emailId: EmailControllerAttachPoliciesPathParams["emailId"], data: EmailControllerAttachPoliciesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ emailId, data }) => {
            return emailControllerAttachPolicies(emailId, data, config)
          },
        })

}

/**
 * @description Records manual links on this email and durably requests thread analysis. The caller must see the email and have access to every policy. Preserves the archive and read state. Returns after the decisions commit; automatic thread analysis is asynchronous.
 * @summary Attach an email to policies
 * {@link /emails/:emailId/policies}
 */
export function useEmailControllerAttachPolicies<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailControllerAttachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403>, {emailId: EmailControllerAttachPoliciesPathParams["emailId"], data: EmailControllerAttachPoliciesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailControllerAttachPoliciesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailControllerAttachPoliciesMutationKey()

          const baseOptions = emailControllerAttachPoliciesMutationOptions(config) as UseMutationOptions<EmailControllerAttachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403>, {emailId: EmailControllerAttachPoliciesPathParams["emailId"], data: EmailControllerAttachPoliciesMutationRequest}, TContext>
          

          return useMutation<EmailControllerAttachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403>, {emailId: EmailControllerAttachPoliciesPathParams["emailId"], data: EmailControllerAttachPoliciesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailControllerAttachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerAttachPolicies400 | EmailControllerAttachPolicies401 | EmailControllerAttachPolicies403>, {emailId: EmailControllerAttachPoliciesPathParams["emailId"], data: EmailControllerAttachPoliciesMutationRequest}, TContext>
      
}

export const emailControllerDetachPoliciesMutationKey = () => [{ url: '/emails/policies/detach' }] as const

export type EmailControllerDetachPoliciesMutationKey = ReturnType<typeof emailControllerDetachPoliciesMutationKey>

export function emailControllerDetachPoliciesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailControllerDetachPoliciesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailControllerDetachPoliciesMutationKey()
        return mutationOptions<EmailControllerDetachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403>, {data: EmailControllerDetachPoliciesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return emailControllerDetachPolicies(data, config)
          },
        })

}

/**
 * @description Records a manual exclusion for every email and policy pair in one transaction, then durably requests the analysis of each affected thread. Other policy links, archive state and read state are preserved. The caller must see every email and have access to every policy.
 * @summary Detach emails from policies
 * {@link /emails/policies/detach}
 */
export function useEmailControllerDetachPolicies<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailControllerDetachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403>, {data: EmailControllerDetachPoliciesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailControllerDetachPoliciesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailControllerDetachPoliciesMutationKey()

          const baseOptions = emailControllerDetachPoliciesMutationOptions(config) as UseMutationOptions<EmailControllerDetachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403>, {data: EmailControllerDetachPoliciesMutationRequest}, TContext>
          

          return useMutation<EmailControllerDetachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403>, {data: EmailControllerDetachPoliciesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailControllerDetachPoliciesMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicies400 | EmailControllerDetachPolicies401 | EmailControllerDetachPolicies403>, {data: EmailControllerDetachPoliciesMutationRequest}, TContext>
      
}

export const emailControllerDetachPolicyMutationKey = () => [{ url: '/emails/:emailId/policies/:policyId' }] as const

export type EmailControllerDetachPolicyMutationKey = ReturnType<typeof emailControllerDetachPolicyMutationKey>

export function emailControllerDetachPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = emailControllerDetachPolicyMutationKey()
        return mutationOptions<EmailControllerDetachPolicyMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403>, {emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"]}, TContext>({
          mutationKey,
          mutationFn: async({ emailId, policyId }) => {
            return emailControllerDetachPolicy(emailId, policyId, config)
          },
        })

}

/**
 * @description Records a manual exclusion for this email and durably requests thread analysis. Other policy links, archive state and read state are preserved. The caller must see the email and have access to the policy.
 * @summary Detach an email from a policy
 * {@link /emails/:emailId/policies/:policyId}
 */
export function useEmailControllerDetachPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailControllerDetachPolicyMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403>, {emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailControllerDetachPolicyMutationKey()

          const baseOptions = emailControllerDetachPolicyMutationOptions(config) as UseMutationOptions<EmailControllerDetachPolicyMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403>, {emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"]}, TContext>
          

          return useMutation<EmailControllerDetachPolicyMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403>, {emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailControllerDetachPolicyMutationResponse, ResponseErrorConfig<EmailControllerDetachPolicy400 | EmailControllerDetachPolicy401 | EmailControllerDetachPolicy403>, {emailId: EmailControllerDetachPolicyPathParams["emailId"], policyId: EmailControllerDetachPolicyPathParams["policyId"]}, TContext>
      
}

export const emailControllerMovePolicyMutationKey = () => [{ url: '/emails/:emailId/policies/move' }] as const

export type EmailControllerMovePolicyMutationKey = ReturnType<typeof emailControllerMovePolicyMutationKey>

export function emailControllerMovePolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailControllerMovePolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailControllerMovePolicyMutationKey()
        return mutationOptions<EmailControllerMovePolicyMutationResponse, ResponseErrorConfig<EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403>, {emailId: EmailControllerMovePolicyPathParams["emailId"], data: EmailControllerMovePolicyMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ emailId, data }) => {
            return emailControllerMovePolicy(emailId, data, config)
          },
        })

}

/**
 * @description Atomically detaches the currently linked source policy and attaches a different target policy, then durably requests thread analysis. The caller must see the email and have access to both policies. Preserves the archive and read state.
 * @summary Move an email link to another policy
 * {@link /emails/:emailId/policies/move}
 */
export function useEmailControllerMovePolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailControllerMovePolicyMutationResponse, ResponseErrorConfig<EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403>, {emailId: EmailControllerMovePolicyPathParams["emailId"], data: EmailControllerMovePolicyMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailControllerMovePolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailControllerMovePolicyMutationKey()

          const baseOptions = emailControllerMovePolicyMutationOptions(config) as UseMutationOptions<EmailControllerMovePolicyMutationResponse, ResponseErrorConfig<EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403>, {emailId: EmailControllerMovePolicyPathParams["emailId"], data: EmailControllerMovePolicyMutationRequest}, TContext>
          

          return useMutation<EmailControllerMovePolicyMutationResponse, ResponseErrorConfig<EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403>, {emailId: EmailControllerMovePolicyPathParams["emailId"], data: EmailControllerMovePolicyMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailControllerMovePolicyMutationResponse, ResponseErrorConfig<EmailControllerMovePolicy400 | EmailControllerMovePolicy401 | EmailControllerMovePolicy403>, {emailId: EmailControllerMovePolicyPathParams["emailId"], data: EmailControllerMovePolicyMutationRequest}, TContext>
      
}

export const emailThreadControllerSetThreadsArchivedMutationKey = () => [{ url: '/email-threads' }] as const

export type EmailThreadControllerSetThreadsArchivedMutationKey = ReturnType<typeof emailThreadControllerSetThreadsArchivedMutationKey>

export function emailThreadControllerSetThreadsArchivedMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailThreadControllerSetThreadsArchivedMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailThreadControllerSetThreadsArchivedMutationKey()
        return mutationOptions<EmailThreadControllerSetThreadsArchivedMutationResponse, ResponseErrorConfig<EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401>, {data: EmailThreadControllerSetThreadsArchivedMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return emailThreadControllerSetThreadsArchived(data, config)
          },
        })

}

/**
 * @description Sets the archive state of every email of the threads, or only of `emailIds`, in one write. Archiving an archived email keeps its first archive date; links are untouched. Returns the emails whose state changed, which an undo sends back with the opposite value. Every thread must belong to one of the broker's personal accounts, or to a firm shared account for shared-account admins; one malformed, unknown or invisible thread rejects the whole request.
 * @summary Archive or unarchive email threads
 * {@link /email-threads}
 */
export function useEmailThreadControllerSetThreadsArchived<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailThreadControllerSetThreadsArchivedMutationResponse, ResponseErrorConfig<EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401>, {data: EmailThreadControllerSetThreadsArchivedMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailThreadControllerSetThreadsArchivedMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailThreadControllerSetThreadsArchivedMutationKey()

          const baseOptions = emailThreadControllerSetThreadsArchivedMutationOptions(config) as UseMutationOptions<EmailThreadControllerSetThreadsArchivedMutationResponse, ResponseErrorConfig<EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401>, {data: EmailThreadControllerSetThreadsArchivedMutationRequest}, TContext>
          

          return useMutation<EmailThreadControllerSetThreadsArchivedMutationResponse, ResponseErrorConfig<EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401>, {data: EmailThreadControllerSetThreadsArchivedMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailThreadControllerSetThreadsArchivedMutationResponse, ResponseErrorConfig<EmailThreadControllerSetThreadsArchived400 | EmailThreadControllerSetThreadsArchived401>, {data: EmailThreadControllerSetThreadsArchivedMutationRequest}, TContext>
      
}

export const emailThreadControllerAttachThreadsPoliciesMutationKey = () => [{ url: '/email-threads/policies' }] as const

export type EmailThreadControllerAttachThreadsPoliciesMutationKey = ReturnType<typeof emailThreadControllerAttachThreadsPoliciesMutationKey>

export function emailThreadControllerAttachThreadsPoliciesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EmailThreadControllerAttachThreadsPoliciesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = emailThreadControllerAttachThreadsPoliciesMutationKey()
        return mutationOptions<EmailThreadControllerAttachThreadsPoliciesMutationResponse, ResponseErrorConfig<EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403>, {data: EmailThreadControllerAttachThreadsPoliciesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return emailThreadControllerAttachThreadsPolicies(data, config)
          },
        })

}

/**
 * @description Records manual links to the policies on every email of the threads still to attach (not archived, no active link), including emails with a manual exclusion, in one transaction, then durably requests the analysis of each thread. Never marks an email as read. Returns the emails now linked, which an undo sends to POST /emails/policies/detach. The caller must see every thread's account and have access to every policy.
 * @summary Attach email threads to policies
 * {@link /email-threads/policies}
 */
export function useEmailThreadControllerAttachThreadsPolicies<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailThreadControllerAttachThreadsPoliciesMutationResponse, ResponseErrorConfig<EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403>, {data: EmailThreadControllerAttachThreadsPoliciesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EmailThreadControllerAttachThreadsPoliciesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailThreadControllerAttachThreadsPoliciesMutationKey()

          const baseOptions = emailThreadControllerAttachThreadsPoliciesMutationOptions(config) as UseMutationOptions<EmailThreadControllerAttachThreadsPoliciesMutationResponse, ResponseErrorConfig<EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403>, {data: EmailThreadControllerAttachThreadsPoliciesMutationRequest}, TContext>
          

          return useMutation<EmailThreadControllerAttachThreadsPoliciesMutationResponse, ResponseErrorConfig<EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403>, {data: EmailThreadControllerAttachThreadsPoliciesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailThreadControllerAttachThreadsPoliciesMutationResponse, ResponseErrorConfig<EmailThreadControllerAttachThreadsPolicies400 | EmailThreadControllerAttachThreadsPolicies401 | EmailThreadControllerAttachThreadsPolicies403>, {data: EmailThreadControllerAttachThreadsPoliciesMutationRequest}, TContext>
      
}

export const claimManagementControllerLookupCustomerMutationKey = () => [{ url: '/claim-management/lookup-customer' }] as const

export type ClaimManagementControllerLookupCustomerMutationKey = ReturnType<typeof claimManagementControllerLookupCustomerMutationKey>

export function claimManagementControllerLookupCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerLookupCustomerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerLookupCustomerMutationKey()
        return mutationOptions<ClaimManagementControllerLookupCustomerMutationResponse, ResponseErrorConfig<ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404>, {data: ClaimManagementControllerLookupCustomerMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return claimManagementControllerLookupCustomer(data, config)
          },
        })

}

/**
 * @description Optional `reference` is forwarded to the partner as a secondary identifier (e.g. CB: `IDENT_2`). When present it also propagates to `/check-coverage` and `/claims` (bootstrap); omitted or empty leaves those calls unchanged.
 * @summary Look up a customer in the partner system (FNOL screen 1)
 * {@link /claim-management/lookup-customer}
 */
export function useClaimManagementControllerLookupCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerLookupCustomerMutationResponse, ResponseErrorConfig<ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404>, {data: ClaimManagementControllerLookupCustomerMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerLookupCustomerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerLookupCustomerMutationKey()

          const baseOptions = claimManagementControllerLookupCustomerMutationOptions(config) as UseMutationOptions<ClaimManagementControllerLookupCustomerMutationResponse, ResponseErrorConfig<ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404>, {data: ClaimManagementControllerLookupCustomerMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerLookupCustomerMutationResponse, ResponseErrorConfig<ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404>, {data: ClaimManagementControllerLookupCustomerMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerLookupCustomerMutationResponse, ResponseErrorConfig<ClaimManagementControllerLookupCustomer400 | ClaimManagementControllerLookupCustomer404>, {data: ClaimManagementControllerLookupCustomerMutationRequest}, TContext>
      
}

export const claimManagementControllerCheckCoverageMutationKey = () => [{ url: '/claim-management/check-coverage' }] as const

export type ClaimManagementControllerCheckCoverageMutationKey = ReturnType<typeof claimManagementControllerCheckCoverageMutationKey>

export function claimManagementControllerCheckCoverageMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerCheckCoverageMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerCheckCoverageMutationKey()
        return mutationOptions<ClaimManagementControllerCheckCoverageMutationResponse, ResponseErrorConfig<ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422>, {data: ClaimManagementControllerCheckCoverageMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return claimManagementControllerCheckCoverage(data, config)
          },
        })

}

/**
 * @description Optional `reference` (CB: `IDENT_2`) — pass the value the customer typed on screen 1. Forwarded to the partner alongside `externalCustomerId` (IDENT_1) on every partner sub-call. Omitted or empty = same payload as before.
 * @summary Check coverage for a claim type (FNOL screen 2)
 * {@link /claim-management/check-coverage}
 */
export function useClaimManagementControllerCheckCoverage<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerCheckCoverageMutationResponse, ResponseErrorConfig<ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422>, {data: ClaimManagementControllerCheckCoverageMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerCheckCoverageMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerCheckCoverageMutationKey()

          const baseOptions = claimManagementControllerCheckCoverageMutationOptions(config) as UseMutationOptions<ClaimManagementControllerCheckCoverageMutationResponse, ResponseErrorConfig<ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422>, {data: ClaimManagementControllerCheckCoverageMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerCheckCoverageMutationResponse, ResponseErrorConfig<ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422>, {data: ClaimManagementControllerCheckCoverageMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerCheckCoverageMutationResponse, ResponseErrorConfig<ClaimManagementControllerCheckCoverage400 | ClaimManagementControllerCheckCoverage422>, {data: ClaimManagementControllerCheckCoverageMutationRequest}, TContext>
      
}

export const claimManagementControllerGenerateFnolUploadUrlMutationKey = () => [{ url: '/claim-management/documents/upload-url' }] as const

export type ClaimManagementControllerGenerateFnolUploadUrlMutationKey = ReturnType<typeof claimManagementControllerGenerateFnolUploadUrlMutationKey>

export function claimManagementControllerGenerateFnolUploadUrlMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerGenerateFnolUploadUrlMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerGenerateFnolUploadUrlMutationKey()
        return mutationOptions<ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413>, {data: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return claimManagementControllerGenerateFnolUploadUrl(data, config)
          },
        })

}

/**
 * @summary Generate a presigned upload URL for an FNOL document (authenticated)
 * {@link /claim-management/documents/upload-url}
 */
export function useClaimManagementControllerGenerateFnolUploadUrl<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413>, {data: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerGenerateFnolUploadUrlMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerGenerateFnolUploadUrlMutationKey()

          const baseOptions = claimManagementControllerGenerateFnolUploadUrlMutationOptions(config) as UseMutationOptions<ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413>, {data: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413>, {data: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerGenerateFnolUploadUrlMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateFnolUploadUrl400 | ClaimManagementControllerGenerateFnolUploadUrl413>, {data: ClaimManagementControllerGenerateFnolUploadUrlMutationRequest}, TContext>
      
}

export const claimManagementControllerBootstrapMutationKey = () => [{ url: '/claim-management/claims' }] as const

export type ClaimManagementControllerBootstrapMutationKey = ReturnType<typeof claimManagementControllerBootstrapMutationKey>

export function claimManagementControllerBootstrapMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerBootstrapMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerBootstrapMutationKey()
        return mutationOptions<ClaimManagementControllerBootstrapMutationResponse, ResponseErrorConfig<ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422>, {data: ClaimManagementControllerBootstrapMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return claimManagementControllerBootstrap(data, config)
          },
        })

}

/**
 * @description Optional `reference` (CB: `IDENT_2`) is persisted onto the claim aggregate and forwarded to the partner at SUBMIT (CB `/creation`). Pass the value collected on screen 1; omitted or empty = no `IDENT_2` is emitted at SUBMIT.
 * @summary Create a new claim (FNOL bootstrap)
 * {@link /claim-management/claims}
 */
export function useClaimManagementControllerBootstrap<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerBootstrapMutationResponse, ResponseErrorConfig<ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422>, {data: ClaimManagementControllerBootstrapMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerBootstrapMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerBootstrapMutationKey()

          const baseOptions = claimManagementControllerBootstrapMutationOptions(config) as UseMutationOptions<ClaimManagementControllerBootstrapMutationResponse, ResponseErrorConfig<ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422>, {data: ClaimManagementControllerBootstrapMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerBootstrapMutationResponse, ResponseErrorConfig<ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422>, {data: ClaimManagementControllerBootstrapMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerBootstrapMutationResponse, ResponseErrorConfig<ClaimManagementControllerBootstrap400 | ClaimManagementControllerBootstrap422>, {data: ClaimManagementControllerBootstrapMutationRequest}, TContext>
      
}

export const claimManagementControllerUpdateDraftMutationKey = () => [{ url: '/claim-management/claims/:id' }] as const

export type ClaimManagementControllerUpdateDraftMutationKey = ReturnType<typeof claimManagementControllerUpdateDraftMutationKey>

export function claimManagementControllerUpdateDraftMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerUpdateDraftMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerUpdateDraftMutationKey()
        return mutationOptions<ClaimManagementControllerUpdateDraftMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409>, {id: ClaimManagementControllerUpdateDraftPathParams["id"], data: ClaimManagementControllerUpdateDraftMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimManagementControllerUpdateDraft(id, data, config)
          },
        })

}

/**
 * @summary Update incident fields / assetId / metadata
 * {@link /claim-management/claims/:id}
 */
export function useClaimManagementControllerUpdateDraft<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerUpdateDraftMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409>, {id: ClaimManagementControllerUpdateDraftPathParams["id"], data: ClaimManagementControllerUpdateDraftMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerUpdateDraftMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerUpdateDraftMutationKey()

          const baseOptions = claimManagementControllerUpdateDraftMutationOptions(config) as UseMutationOptions<ClaimManagementControllerUpdateDraftMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409>, {id: ClaimManagementControllerUpdateDraftPathParams["id"], data: ClaimManagementControllerUpdateDraftMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerUpdateDraftMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409>, {id: ClaimManagementControllerUpdateDraftPathParams["id"], data: ClaimManagementControllerUpdateDraftMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerUpdateDraftMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateDraft400 | ClaimManagementControllerUpdateDraft404 | ClaimManagementControllerUpdateDraft409>, {id: ClaimManagementControllerUpdateDraftPathParams["id"], data: ClaimManagementControllerUpdateDraftMutationRequest}, TContext>
      
}

export const claimManagementControllerUpdateCustomFieldsMutationKey = () => [{ url: '/claim-management/claims/:id/custom-fields' }] as const

export type ClaimManagementControllerUpdateCustomFieldsMutationKey = ReturnType<typeof claimManagementControllerUpdateCustomFieldsMutationKey>

export function claimManagementControllerUpdateCustomFieldsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerUpdateCustomFieldsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerUpdateCustomFieldsMutationKey()
        return mutationOptions<ClaimManagementControllerUpdateCustomFieldsMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409>, {id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"], data: ClaimManagementControllerUpdateCustomFieldsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimManagementControllerUpdateCustomFields(id, data, config)
          },
        })

}

/**
 * @summary Update custom fields (patch, merged + validated)
 * {@link /claim-management/claims/:id/custom-fields}
 */
export function useClaimManagementControllerUpdateCustomFields<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerUpdateCustomFieldsMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409>, {id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"], data: ClaimManagementControllerUpdateCustomFieldsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerUpdateCustomFieldsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerUpdateCustomFieldsMutationKey()

          const baseOptions = claimManagementControllerUpdateCustomFieldsMutationOptions(config) as UseMutationOptions<ClaimManagementControllerUpdateCustomFieldsMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409>, {id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"], data: ClaimManagementControllerUpdateCustomFieldsMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerUpdateCustomFieldsMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409>, {id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"], data: ClaimManagementControllerUpdateCustomFieldsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerUpdateCustomFieldsMutationResponse, ResponseErrorConfig<ClaimManagementControllerUpdateCustomFields400 | ClaimManagementControllerUpdateCustomFields404 | ClaimManagementControllerUpdateCustomFields409>, {id: ClaimManagementControllerUpdateCustomFieldsPathParams["id"], data: ClaimManagementControllerUpdateCustomFieldsMutationRequest}, TContext>
      
}

export const claimManagementControllerAttachDocumentMutationKey = () => [{ url: '/claim-management/claims/:id/documents' }] as const

export type ClaimManagementControllerAttachDocumentMutationKey = ReturnType<typeof claimManagementControllerAttachDocumentMutationKey>

export function claimManagementControllerAttachDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerAttachDocumentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerAttachDocumentMutationKey()
        return mutationOptions<ClaimManagementControllerAttachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409>, {id: ClaimManagementControllerAttachDocumentPathParams["id"], data: ClaimManagementControllerAttachDocumentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimManagementControllerAttachDocument(id, data, config)
          },
        })

}

/**
 * @summary Attach a document to a claim
 * {@link /claim-management/claims/:id/documents}
 */
export function useClaimManagementControllerAttachDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerAttachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409>, {id: ClaimManagementControllerAttachDocumentPathParams["id"], data: ClaimManagementControllerAttachDocumentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerAttachDocumentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerAttachDocumentMutationKey()

          const baseOptions = claimManagementControllerAttachDocumentMutationOptions(config) as UseMutationOptions<ClaimManagementControllerAttachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409>, {id: ClaimManagementControllerAttachDocumentPathParams["id"], data: ClaimManagementControllerAttachDocumentMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerAttachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409>, {id: ClaimManagementControllerAttachDocumentPathParams["id"], data: ClaimManagementControllerAttachDocumentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerAttachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerAttachDocument400 | ClaimManagementControllerAttachDocument404 | ClaimManagementControllerAttachDocument409>, {id: ClaimManagementControllerAttachDocumentPathParams["id"], data: ClaimManagementControllerAttachDocumentMutationRequest}, TContext>
      
}

export const claimManagementControllerGenerateDocumentMutationKey = () => [{ url: '/claim-management/claims/:id/documents/generate' }] as const

export type ClaimManagementControllerGenerateDocumentMutationKey = ReturnType<typeof claimManagementControllerGenerateDocumentMutationKey>

export function claimManagementControllerGenerateDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerGenerateDocumentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerGenerateDocumentMutationKey()
        return mutationOptions<ClaimManagementControllerGenerateDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409>, {id: ClaimManagementControllerGenerateDocumentPathParams["id"], data: ClaimManagementControllerGenerateDocumentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimManagementControllerGenerateDocument(id, data, config)
          },
        })

}

/**
 * @summary Generate a Korint-rendered document for a slot and attach it
 * {@link /claim-management/claims/:id/documents/generate}
 */
export function useClaimManagementControllerGenerateDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerGenerateDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409>, {id: ClaimManagementControllerGenerateDocumentPathParams["id"], data: ClaimManagementControllerGenerateDocumentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerGenerateDocumentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerGenerateDocumentMutationKey()

          const baseOptions = claimManagementControllerGenerateDocumentMutationOptions(config) as UseMutationOptions<ClaimManagementControllerGenerateDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409>, {id: ClaimManagementControllerGenerateDocumentPathParams["id"], data: ClaimManagementControllerGenerateDocumentMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerGenerateDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409>, {id: ClaimManagementControllerGenerateDocumentPathParams["id"], data: ClaimManagementControllerGenerateDocumentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerGenerateDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerGenerateDocument400 | ClaimManagementControllerGenerateDocument404 | ClaimManagementControllerGenerateDocument409>, {id: ClaimManagementControllerGenerateDocumentPathParams["id"], data: ClaimManagementControllerGenerateDocumentMutationRequest}, TContext>
      
}

export const claimManagementControllerGetDocumentGenerationPayloadMutationKey = () => [{ url: '/claim-management/debug/generate-document-payload' }] as const

export type ClaimManagementControllerGetDocumentGenerationPayloadMutationKey = ReturnType<typeof claimManagementControllerGetDocumentGenerationPayloadMutationKey>

export function claimManagementControllerGetDocumentGenerationPayloadMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerGetDocumentGenerationPayloadMutationKey()
        return mutationOptions<ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ResponseErrorConfig<ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409>, {data: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return claimManagementControllerGetDocumentGenerationPayload(data, config)
          },
        })

}

/**
 * @summary Debug: build the Carbone payload for a claim document slot without rendering
 * {@link /claim-management/debug/generate-document-payload}
 */
export function useClaimManagementControllerGetDocumentGenerationPayload<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ResponseErrorConfig<ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409>, {data: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerGetDocumentGenerationPayloadMutationKey()

          const baseOptions = claimManagementControllerGetDocumentGenerationPayloadMutationOptions(config) as UseMutationOptions<ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ResponseErrorConfig<ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409>, {data: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ResponseErrorConfig<ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409>, {data: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerGetDocumentGenerationPayloadMutationResponse, ResponseErrorConfig<ClaimManagementControllerGetDocumentGenerationPayload400 | ClaimManagementControllerGetDocumentGenerationPayload404 | ClaimManagementControllerGetDocumentGenerationPayload409>, {data: ClaimManagementControllerGetDocumentGenerationPayloadMutationRequest}, TContext>
      
}

export const claimManagementControllerDetachDocumentMutationKey = () => [{ url: '/claim-management/claims/:id/documents/:documentId' }] as const

export type ClaimManagementControllerDetachDocumentMutationKey = ReturnType<typeof claimManagementControllerDetachDocumentMutationKey>

export function claimManagementControllerDetachDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerDetachDocumentMutationKey()
        return mutationOptions<ClaimManagementControllerDetachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409>, {id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"]}, TContext>({
          mutationKey,
          mutationFn: async({ id, documentId }) => {
            return claimManagementControllerDetachDocument(id, documentId, config)
          },
        })

}

/**
 * @summary Detach a document from a claim
 * {@link /claim-management/claims/:id/documents/:documentId}
 */
export function useClaimManagementControllerDetachDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerDetachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409>, {id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerDetachDocumentMutationKey()

          const baseOptions = claimManagementControllerDetachDocumentMutationOptions(config) as UseMutationOptions<ClaimManagementControllerDetachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409>, {id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"]}, TContext>
          

          return useMutation<ClaimManagementControllerDetachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409>, {id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerDetachDocumentMutationResponse, ResponseErrorConfig<ClaimManagementControllerDetachDocument400 | ClaimManagementControllerDetachDocument404 | ClaimManagementControllerDetachDocument409>, {id: ClaimManagementControllerDetachDocumentPathParams["id"], documentId: ClaimManagementControllerDetachDocumentPathParams["documentId"]}, TContext>
      
}

export const claimManagementControllerTransitionMutationKey = () => [{ url: '/claim-management/claims/:id/transition' }] as const

export type ClaimManagementControllerTransitionMutationKey = ReturnType<typeof claimManagementControllerTransitionMutationKey>

export function claimManagementControllerTransitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerTransitionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerTransitionMutationKey()
        return mutationOptions<ClaimManagementControllerTransitionMutationResponse, ResponseErrorConfig<ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409>, {id: ClaimManagementControllerTransitionPathParams["id"], data: ClaimManagementControllerTransitionMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimManagementControllerTransition(id, data, config)
          },
        })

}

/**
 * @summary Apply a claim state-machine transition (SUBMIT / DISCARD / FORWARD_EXTERNAL / FLAG_PIECES / SETTLE / CLOSE / REOPEN_*). Partner-facing side effects (forward, re-upload flag) run asynchronously.
 * {@link /claim-management/claims/:id/transition}
 */
export function useClaimManagementControllerTransition<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerTransitionMutationResponse, ResponseErrorConfig<ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409>, {id: ClaimManagementControllerTransitionPathParams["id"], data: ClaimManagementControllerTransitionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerTransitionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerTransitionMutationKey()

          const baseOptions = claimManagementControllerTransitionMutationOptions(config) as UseMutationOptions<ClaimManagementControllerTransitionMutationResponse, ResponseErrorConfig<ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409>, {id: ClaimManagementControllerTransitionPathParams["id"], data: ClaimManagementControllerTransitionMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerTransitionMutationResponse, ResponseErrorConfig<ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409>, {id: ClaimManagementControllerTransitionPathParams["id"], data: ClaimManagementControllerTransitionMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerTransitionMutationResponse, ResponseErrorConfig<ClaimManagementControllerTransition400 | ClaimManagementControllerTransition404 | ClaimManagementControllerTransition409>, {id: ClaimManagementControllerTransitionPathParams["id"], data: ClaimManagementControllerTransitionMutationRequest}, TContext>
      
}

export const claimManagementControllerRetryForwardMutationKey = () => [{ url: '/claim-management/claims/:id/retry-forward' }] as const

export type ClaimManagementControllerRetryForwardMutationKey = ReturnType<typeof claimManagementControllerRetryForwardMutationKey>

export function claimManagementControllerRetryForwardMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerRetryForwardMutationKey()
        return mutationOptions<ClaimManagementControllerRetryForwardMutationResponse, ResponseErrorConfig<ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404>, {id: ClaimManagementControllerRetryForwardPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return claimManagementControllerRetryForward(id, config)
          },
        })

}

/**
 * @summary Retry the partner-API forward for a submitted claim whose forward failed. Super-admin only; the forward itself is asynchronous.
 * {@link /claim-management/claims/:id/retry-forward}
 */
export function useClaimManagementControllerRetryForward<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerRetryForwardMutationResponse, ResponseErrorConfig<ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404>, {id: ClaimManagementControllerRetryForwardPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerRetryForwardMutationKey()

          const baseOptions = claimManagementControllerRetryForwardMutationOptions(config) as UseMutationOptions<ClaimManagementControllerRetryForwardMutationResponse, ResponseErrorConfig<ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404>, {id: ClaimManagementControllerRetryForwardPathParams["id"]}, TContext>
          

          return useMutation<ClaimManagementControllerRetryForwardMutationResponse, ResponseErrorConfig<ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404>, {id: ClaimManagementControllerRetryForwardPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerRetryForwardMutationResponse, ResponseErrorConfig<ClaimManagementControllerRetryForward400 | ClaimManagementControllerRetryForward404>, {id: ClaimManagementControllerRetryForwardPathParams["id"]}, TContext>
      
}

export const claimManagementControllerAddNoteMutationKey = () => [{ url: '/claim-management/claims/:id/notes' }] as const

export type ClaimManagementControllerAddNoteMutationKey = ReturnType<typeof claimManagementControllerAddNoteMutationKey>

export function claimManagementControllerAddNoteMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerAddNoteMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerAddNoteMutationKey()
        return mutationOptions<ClaimManagementControllerAddNoteMutationResponse, ResponseErrorConfig<ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404>, {id: ClaimManagementControllerAddNotePathParams["id"], data: ClaimManagementControllerAddNoteMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimManagementControllerAddNote(id, data, config)
          },
        })

}

/**
 * @summary Append a note to a claim (any state, append-only)
 * {@link /claim-management/claims/:id/notes}
 */
export function useClaimManagementControllerAddNote<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerAddNoteMutationResponse, ResponseErrorConfig<ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404>, {id: ClaimManagementControllerAddNotePathParams["id"], data: ClaimManagementControllerAddNoteMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerAddNoteMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerAddNoteMutationKey()

          const baseOptions = claimManagementControllerAddNoteMutationOptions(config) as UseMutationOptions<ClaimManagementControllerAddNoteMutationResponse, ResponseErrorConfig<ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404>, {id: ClaimManagementControllerAddNotePathParams["id"], data: ClaimManagementControllerAddNoteMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerAddNoteMutationResponse, ResponseErrorConfig<ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404>, {id: ClaimManagementControllerAddNotePathParams["id"], data: ClaimManagementControllerAddNoteMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerAddNoteMutationResponse, ResponseErrorConfig<ClaimManagementControllerAddNote400 | ClaimManagementControllerAddNote404>, {id: ClaimManagementControllerAddNotePathParams["id"], data: ClaimManagementControllerAddNoteMutationRequest}, TContext>
      
}

export const claimManagementControllerStartClaimsExportMutationKey = () => [{ url: '/claim-management/claims/export' }] as const

export type ClaimManagementControllerStartClaimsExportMutationKey = ReturnType<typeof claimManagementControllerStartClaimsExportMutationKey>

export function claimManagementControllerStartClaimsExportMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerStartClaimsExportMutationKey()
        return mutationOptions<ClaimManagementControllerStartClaimsExportMutationResponse, ResponseErrorConfig<ClaimManagementControllerStartClaimsExport400>, {params?: ClaimManagementControllerStartClaimsExportQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ params }) => {
            return claimManagementControllerStartClaimsExport(params, config)
          },
        })

}

/**
 * @description Takes the same filters as `GET /claim-management/claims` but ignores pagination: the CSV covers every claim the filters select. Building it is asynchronous — this enqueues a job and returns its id; poll `GET /claim-management/claims/export/{jobId}` for the presigned URL. The CSV is semicolon-delimited with a UTF-8 BOM (Excel fr-FR opens a comma-delimited one as a single column) and the link expires after an hour.
 * @summary Start a CSV export of the filtered claims list (internal — claim managers only)
 * {@link /claim-management/claims/export}
 */
export function useClaimManagementControllerStartClaimsExport<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerStartClaimsExportMutationResponse, ResponseErrorConfig<ClaimManagementControllerStartClaimsExport400>, {params?: ClaimManagementControllerStartClaimsExportQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerStartClaimsExportMutationKey()

          const baseOptions = claimManagementControllerStartClaimsExportMutationOptions(config) as UseMutationOptions<ClaimManagementControllerStartClaimsExportMutationResponse, ResponseErrorConfig<ClaimManagementControllerStartClaimsExport400>, {params?: ClaimManagementControllerStartClaimsExportQueryParams}, TContext>
          

          return useMutation<ClaimManagementControllerStartClaimsExportMutationResponse, ResponseErrorConfig<ClaimManagementControllerStartClaimsExport400>, {params?: ClaimManagementControllerStartClaimsExportQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerStartClaimsExportMutationResponse, ResponseErrorConfig<ClaimManagementControllerStartClaimsExport400>, {params?: ClaimManagementControllerStartClaimsExportQueryParams}, TContext>
      
}

export const claimManagementControllerCorrectDocumentFraudVerdictMutationKey = () => [{ url: '/claim-management/claims/:id/documents/:documentId/fraud-verdict' }] as const

export type ClaimManagementControllerCorrectDocumentFraudVerdictMutationKey = ReturnType<typeof claimManagementControllerCorrectDocumentFraudVerdictMutationKey>

export function claimManagementControllerCorrectDocumentFraudVerdictMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimManagementControllerCorrectDocumentFraudVerdictMutationKey()
        return mutationOptions<ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ResponseErrorConfig<ClaimManagementControllerCorrectDocumentFraudVerdict400>, {id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"], data: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, documentId, data }) => {
            return claimManagementControllerCorrectDocumentFraudVerdict(id, documentId, data, config)
          },
        })

}

/**
 * @description A claims manager overrides the vendor fraud verdict for a document. Persists the correction, emits a Dash0 feedback event, and records a side-event on the claim stream. Not re-forwarded to the partner.
 * @summary Correct a per-document fraud verdict (internal — claim managers only)
 * {@link /claim-management/claims/:id/documents/:documentId/fraud-verdict}
 */
export function useClaimManagementControllerCorrectDocumentFraudVerdict<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ResponseErrorConfig<ClaimManagementControllerCorrectDocumentFraudVerdict400>, {id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"], data: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimManagementControllerCorrectDocumentFraudVerdictMutationKey()

          const baseOptions = claimManagementControllerCorrectDocumentFraudVerdictMutationOptions(config) as UseMutationOptions<ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ResponseErrorConfig<ClaimManagementControllerCorrectDocumentFraudVerdict400>, {id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"], data: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest}, TContext>
          

          return useMutation<ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ResponseErrorConfig<ClaimManagementControllerCorrectDocumentFraudVerdict400>, {id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"], data: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimManagementControllerCorrectDocumentFraudVerdictMutationResponse, ResponseErrorConfig<ClaimManagementControllerCorrectDocumentFraudVerdict400>, {id: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["id"], documentId: ClaimManagementControllerCorrectDocumentFraudVerdictPathParams["documentId"], data: ClaimManagementControllerCorrectDocumentFraudVerdictMutationRequest}, TContext>
      
}

export const externalClaimsControllerCreateMutationKey = () => [{ url: '/external-claims' }] as const

export type ExternalClaimsControllerCreateMutationKey = ReturnType<typeof externalClaimsControllerCreateMutationKey>

export function externalClaimsControllerCreateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ExternalClaimsControllerCreateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = externalClaimsControllerCreateMutationKey()
        return mutationOptions<ExternalClaimsControllerCreateMutationResponse, ResponseErrorConfig<Error>, {data: ExternalClaimsControllerCreateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return externalClaimsControllerCreate(data, config)
          },
        })

}

/**
 * @summary Declare a claim from an external system
 * {@link /external-claims}
 */
export function useExternalClaimsControllerCreate<TContext>(options: 
{
  mutation?: UseMutationOptions<ExternalClaimsControllerCreateMutationResponse, ResponseErrorConfig<Error>, {data: ExternalClaimsControllerCreateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ExternalClaimsControllerCreateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? externalClaimsControllerCreateMutationKey()

          const baseOptions = externalClaimsControllerCreateMutationOptions(config) as UseMutationOptions<ExternalClaimsControllerCreateMutationResponse, ResponseErrorConfig<Error>, {data: ExternalClaimsControllerCreateMutationRequest}, TContext>
          

          return useMutation<ExternalClaimsControllerCreateMutationResponse, ResponseErrorConfig<Error>, {data: ExternalClaimsControllerCreateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ExternalClaimsControllerCreateMutationResponse, ResponseErrorConfig<Error>, {data: ExternalClaimsControllerCreateMutationRequest}, TContext>
      
}

export const externalClaimsControllerResyncMutationKey = () => [{ url: '/external-claims/:claimId/resync' }] as const

export type ExternalClaimsControllerResyncMutationKey = ReturnType<typeof externalClaimsControllerResyncMutationKey>

export function externalClaimsControllerResyncMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = externalClaimsControllerResyncMutationKey()
        return mutationOptions<ExternalClaimsControllerResyncMutationResponse, ResponseErrorConfig<Error>, {claimId: ExternalClaimsControllerResyncPathParams["claimId"]}, TContext>({
          mutationKey,
          mutationFn: async({ claimId }) => {
            return externalClaimsControllerResync(claimId, config)
          },
        })

}

/**
 * {@link /external-claims/:claimId/resync}
 */
export function useExternalClaimsControllerResync<TContext>(options: 
{
  mutation?: UseMutationOptions<ExternalClaimsControllerResyncMutationResponse, ResponseErrorConfig<Error>, {claimId: ExternalClaimsControllerResyncPathParams["claimId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? externalClaimsControllerResyncMutationKey()

          const baseOptions = externalClaimsControllerResyncMutationOptions(config) as UseMutationOptions<ExternalClaimsControllerResyncMutationResponse, ResponseErrorConfig<Error>, {claimId: ExternalClaimsControllerResyncPathParams["claimId"]}, TContext>
          

          return useMutation<ExternalClaimsControllerResyncMutationResponse, ResponseErrorConfig<Error>, {claimId: ExternalClaimsControllerResyncPathParams["claimId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ExternalClaimsControllerResyncMutationResponse, ResponseErrorConfig<Error>, {claimId: ExternalClaimsControllerResyncPathParams["claimId"]}, TContext>
      
}

export const claimsControllerCreateMutationKey = () => [{ url: '/claims' }] as const

export type ClaimsControllerCreateMutationKey = ReturnType<typeof claimsControllerCreateMutationKey>

export function claimsControllerCreateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimsControllerCreateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimsControllerCreateMutationKey()
        return mutationOptions<ClaimsControllerCreateMutationResponse, ResponseErrorConfig<ClaimsControllerCreate400 | ClaimsControllerCreate409>, {data: ClaimsControllerCreateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return claimsControllerCreate(data, config)
          },
        })

}

/**
 * @summary Create claim
 * {@link /claims}
 */
export function useClaimsControllerCreate<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimsControllerCreateMutationResponse, ResponseErrorConfig<ClaimsControllerCreate400 | ClaimsControllerCreate409>, {data: ClaimsControllerCreateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimsControllerCreateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimsControllerCreateMutationKey()

          const baseOptions = claimsControllerCreateMutationOptions(config) as UseMutationOptions<ClaimsControllerCreateMutationResponse, ResponseErrorConfig<ClaimsControllerCreate400 | ClaimsControllerCreate409>, {data: ClaimsControllerCreateMutationRequest}, TContext>
          

          return useMutation<ClaimsControllerCreateMutationResponse, ResponseErrorConfig<ClaimsControllerCreate400 | ClaimsControllerCreate409>, {data: ClaimsControllerCreateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimsControllerCreateMutationResponse, ResponseErrorConfig<ClaimsControllerCreate400 | ClaimsControllerCreate409>, {data: ClaimsControllerCreateMutationRequest}, TContext>
      
}

export const claimsControllerUpdateMutationKey = () => [{ url: '/claims/:id' }] as const

export type ClaimsControllerUpdateMutationKey = ReturnType<typeof claimsControllerUpdateMutationKey>

export function claimsControllerUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimsControllerUpdateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimsControllerUpdateMutationKey()
        return mutationOptions<ClaimsControllerUpdateMutationResponse, ResponseErrorConfig<ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409>, {id: ClaimsControllerUpdatePathParams["id"], data: ClaimsControllerUpdateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return claimsControllerUpdate(id, data, config)
          },
        })

}

/**
 * @summary Update claim
 * {@link /claims/:id}
 */
export function useClaimsControllerUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimsControllerUpdateMutationResponse, ResponseErrorConfig<ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409>, {id: ClaimsControllerUpdatePathParams["id"], data: ClaimsControllerUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimsControllerUpdateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimsControllerUpdateMutationKey()

          const baseOptions = claimsControllerUpdateMutationOptions(config) as UseMutationOptions<ClaimsControllerUpdateMutationResponse, ResponseErrorConfig<ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409>, {id: ClaimsControllerUpdatePathParams["id"], data: ClaimsControllerUpdateMutationRequest}, TContext>
          

          return useMutation<ClaimsControllerUpdateMutationResponse, ResponseErrorConfig<ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409>, {id: ClaimsControllerUpdatePathParams["id"], data: ClaimsControllerUpdateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimsControllerUpdateMutationResponse, ResponseErrorConfig<ClaimsControllerUpdate400 | ClaimsControllerUpdate404 | ClaimsControllerUpdate409>, {id: ClaimsControllerUpdatePathParams["id"], data: ClaimsControllerUpdateMutationRequest}, TContext>
      
}

export const claimsControllerDeleteMutationKey = () => [{ url: '/claims/:id' }] as const

export type ClaimsControllerDeleteMutationKey = ReturnType<typeof claimsControllerDeleteMutationKey>

export function claimsControllerDeleteMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = claimsControllerDeleteMutationKey()
        return mutationOptions<ClaimsControllerDeleteMutationResponse, ResponseErrorConfig<ClaimsControllerDelete400 | ClaimsControllerDelete404>, {id: ClaimsControllerDeletePathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return claimsControllerDelete(id, config)
          },
        })

}

/**
 * @summary Delete claim
 * {@link /claims/:id}
 */
export function useClaimsControllerDelete<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimsControllerDeleteMutationResponse, ResponseErrorConfig<ClaimsControllerDelete400 | ClaimsControllerDelete404>, {id: ClaimsControllerDeletePathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimsControllerDeleteMutationKey()

          const baseOptions = claimsControllerDeleteMutationOptions(config) as UseMutationOptions<ClaimsControllerDeleteMutationResponse, ResponseErrorConfig<ClaimsControllerDelete400 | ClaimsControllerDelete404>, {id: ClaimsControllerDeletePathParams["id"]}, TContext>
          

          return useMutation<ClaimsControllerDeleteMutationResponse, ResponseErrorConfig<ClaimsControllerDelete400 | ClaimsControllerDelete404>, {id: ClaimsControllerDeletePathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimsControllerDeleteMutationResponse, ResponseErrorConfig<ClaimsControllerDelete400 | ClaimsControllerDelete404>, {id: ClaimsControllerDeletePathParams["id"]}, TContext>
      
}

export const featureFlagControllerUpdateMutationKey = () => [{ url: '/feature-flags' }] as const

export type FeatureFlagControllerUpdateMutationKey = ReturnType<typeof featureFlagControllerUpdateMutationKey>

export function featureFlagControllerUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<FeatureFlagControllerUpdateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = featureFlagControllerUpdateMutationKey()
        return mutationOptions<FeatureFlagControllerUpdateMutationResponse, ResponseErrorConfig<Error>, {data: FeatureFlagControllerUpdateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return featureFlagControllerUpdate(data, config)
          },
        })

}

/**
 * @summary Update a dynamic feature flag
 * {@link /feature-flags}
 */
export function useFeatureFlagControllerUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<FeatureFlagControllerUpdateMutationResponse, ResponseErrorConfig<Error>, {data: FeatureFlagControllerUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<FeatureFlagControllerUpdateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? featureFlagControllerUpdateMutationKey()

          const baseOptions = featureFlagControllerUpdateMutationOptions(config) as UseMutationOptions<FeatureFlagControllerUpdateMutationResponse, ResponseErrorConfig<Error>, {data: FeatureFlagControllerUpdateMutationRequest}, TContext>
          

          return useMutation<FeatureFlagControllerUpdateMutationResponse, ResponseErrorConfig<Error>, {data: FeatureFlagControllerUpdateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<FeatureFlagControllerUpdateMutationResponse, ResponseErrorConfig<Error>, {data: FeatureFlagControllerUpdateMutationRequest}, TContext>
      
}

export const customerControllerEditCustomerMutationKey = () => [{ url: '/customers/:customerId' }] as const

export type CustomerControllerEditCustomerMutationKey = ReturnType<typeof customerControllerEditCustomerMutationKey>

export function customerControllerEditCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerEditCustomerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerEditCustomerMutationKey()
        return mutationOptions<CustomerControllerEditCustomerMutationResponse, ResponseErrorConfig<CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409>, {customerId: CustomerControllerEditCustomerPathParams["customerId"], data: CustomerControllerEditCustomerMutationRequest, params?: CustomerControllerEditCustomerQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, data, params }) => {
            return customerControllerEditCustomer(customerId, data, params, config)
          },
        })

}

/**
 * @description Company identity is not yours to set: supplying the SIRET triggers a registry lookup that overwrites the other company fields, nulls legal statuses the registry omits, and fails the whole request with `COMPANY_NOT_FOUND` on an unknown SIRET.
 * @summary Edit Customer
 * {@link /customers/:customerId}
 */
export function useCustomerControllerEditCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerEditCustomerMutationResponse, ResponseErrorConfig<CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409>, {customerId: CustomerControllerEditCustomerPathParams["customerId"], data: CustomerControllerEditCustomerMutationRequest, params?: CustomerControllerEditCustomerQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerEditCustomerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerEditCustomerMutationKey()

          const baseOptions = customerControllerEditCustomerMutationOptions(config) as UseMutationOptions<CustomerControllerEditCustomerMutationResponse, ResponseErrorConfig<CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409>, {customerId: CustomerControllerEditCustomerPathParams["customerId"], data: CustomerControllerEditCustomerMutationRequest, params?: CustomerControllerEditCustomerQueryParams}, TContext>
          

          return useMutation<CustomerControllerEditCustomerMutationResponse, ResponseErrorConfig<CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409>, {customerId: CustomerControllerEditCustomerPathParams["customerId"], data: CustomerControllerEditCustomerMutationRequest, params?: CustomerControllerEditCustomerQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerEditCustomerMutationResponse, ResponseErrorConfig<CustomerControllerEditCustomer400 | CustomerControllerEditCustomer404 | CustomerControllerEditCustomer409>, {customerId: CustomerControllerEditCustomerPathParams["customerId"], data: CustomerControllerEditCustomerMutationRequest, params?: CustomerControllerEditCustomerQueryParams}, TContext>
      
}

export const customerControllerInitializeCustomerMutationKey = () => [{ url: '/customers' }] as const

export type CustomerControllerInitializeCustomerMutationKey = ReturnType<typeof customerControllerInitializeCustomerMutationKey>

export function customerControllerInitializeCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerInitializeCustomerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerInitializeCustomerMutationKey()
        return mutationOptions<CustomerControllerInitializeCustomerMutationResponse, ResponseErrorConfig<CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409>, {data: CustomerControllerInitializeCustomerMutationRequest, params: CustomerControllerInitializeCustomerQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return customerControllerInitializeCustomer(data, params, config)
          },
        })

}

/**
 * @description Creates the policyholder, a policy and the branch to work on, all three. Keep `initializedWith.branch`: every later call on that draft carries it.
 * @summary Initialize customer
 * {@link /customers}
 */
export function useCustomerControllerInitializeCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerInitializeCustomerMutationResponse, ResponseErrorConfig<CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409>, {data: CustomerControllerInitializeCustomerMutationRequest, params: CustomerControllerInitializeCustomerQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerInitializeCustomerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerInitializeCustomerMutationKey()

          const baseOptions = customerControllerInitializeCustomerMutationOptions(config) as UseMutationOptions<CustomerControllerInitializeCustomerMutationResponse, ResponseErrorConfig<CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409>, {data: CustomerControllerInitializeCustomerMutationRequest, params: CustomerControllerInitializeCustomerQueryParams}, TContext>
          

          return useMutation<CustomerControllerInitializeCustomerMutationResponse, ResponseErrorConfig<CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409>, {data: CustomerControllerInitializeCustomerMutationRequest, params: CustomerControllerInitializeCustomerQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerInitializeCustomerMutationResponse, ResponseErrorConfig<CustomerControllerInitializeCustomer400 | CustomerControllerInitializeCustomer404 | CustomerControllerInitializeCustomer409>, {data: CustomerControllerInitializeCustomerMutationRequest, params: CustomerControllerInitializeCustomerQueryParams}, TContext>
      
}

export const customerControllerPushCustomerEventMutationKey = () => [{ url: '/customers/:customerId/events' }] as const

export type CustomerControllerPushCustomerEventMutationKey = ReturnType<typeof customerControllerPushCustomerEventMutationKey>

export function customerControllerPushCustomerEventMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerPushCustomerEventMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerPushCustomerEventMutationKey()
        return mutationOptions<CustomerControllerPushCustomerEventMutationResponse, ResponseErrorConfig<CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404>, {customerId: CustomerControllerPushCustomerEventPathParams["customerId"], data: CustomerControllerPushCustomerEventMutationRequest, params?: CustomerControllerPushCustomerEventQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, data, params }) => {
            return customerControllerPushCustomerEvent(customerId, data, params, config)
          },
        })

}

/**
 * @summary Push a custom event onto a customer
 * {@link /customers/:customerId/events}
 */
export function useCustomerControllerPushCustomerEvent<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerPushCustomerEventMutationResponse, ResponseErrorConfig<CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404>, {customerId: CustomerControllerPushCustomerEventPathParams["customerId"], data: CustomerControllerPushCustomerEventMutationRequest, params?: CustomerControllerPushCustomerEventQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerPushCustomerEventMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerPushCustomerEventMutationKey()

          const baseOptions = customerControllerPushCustomerEventMutationOptions(config) as UseMutationOptions<CustomerControllerPushCustomerEventMutationResponse, ResponseErrorConfig<CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404>, {customerId: CustomerControllerPushCustomerEventPathParams["customerId"], data: CustomerControllerPushCustomerEventMutationRequest, params?: CustomerControllerPushCustomerEventQueryParams}, TContext>
          

          return useMutation<CustomerControllerPushCustomerEventMutationResponse, ResponseErrorConfig<CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404>, {customerId: CustomerControllerPushCustomerEventPathParams["customerId"], data: CustomerControllerPushCustomerEventMutationRequest, params?: CustomerControllerPushCustomerEventQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerPushCustomerEventMutationResponse, ResponseErrorConfig<CustomerControllerPushCustomerEvent400 | CustomerControllerPushCustomerEvent404>, {customerId: CustomerControllerPushCustomerEventPathParams["customerId"], data: CustomerControllerPushCustomerEventMutationRequest, params?: CustomerControllerPushCustomerEventQueryParams}, TContext>
      
}

export const customerControllerGenerateMandateSignatureRequestMutationKey = () => [{ url: '/customers/:customerId/payment-methods/:paymentMethodId/signature' }] as const

export type CustomerControllerGenerateMandateSignatureRequestMutationKey = ReturnType<typeof customerControllerGenerateMandateSignatureRequestMutationKey>

export function customerControllerGenerateMandateSignatureRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerGenerateMandateSignatureRequestMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerGenerateMandateSignatureRequestMutationKey()
        return mutationOptions<CustomerControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425>, {customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: CustomerControllerGenerateMandateSignatureRequestMutationRequest, params?: CustomerControllerGenerateMandateSignatureRequestQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, paymentMethodId, data, params }) => {
            return customerControllerGenerateMandateSignatureRequest(customerId, paymentMethodId, data, params, config)
          },
        })

}

/**
 * @description The customer must already have a first name, last name and email address, since they identify the signer. If any of the three is missing, the request fails with MISSING_CUSTOMER_CONTACT_FIELDS.
 * @summary Generate mandate signature request
 * {@link /customers/:customerId/payment-methods/:paymentMethodId/signature}
 */
export function useCustomerControllerGenerateMandateSignatureRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425>, {customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: CustomerControllerGenerateMandateSignatureRequestMutationRequest, params?: CustomerControllerGenerateMandateSignatureRequestQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerGenerateMandateSignatureRequestMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerGenerateMandateSignatureRequestMutationKey()

          const baseOptions = customerControllerGenerateMandateSignatureRequestMutationOptions(config) as UseMutationOptions<CustomerControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425>, {customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: CustomerControllerGenerateMandateSignatureRequestMutationRequest, params?: CustomerControllerGenerateMandateSignatureRequestQueryParams}, TContext>
          

          return useMutation<CustomerControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425>, {customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: CustomerControllerGenerateMandateSignatureRequestMutationRequest, params?: CustomerControllerGenerateMandateSignatureRequestQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<CustomerControllerGenerateMandateSignatureRequest400 | CustomerControllerGenerateMandateSignatureRequest404 | CustomerControllerGenerateMandateSignatureRequest409 | CustomerControllerGenerateMandateSignatureRequest425>, {customerId: CustomerControllerGenerateMandateSignatureRequestPathParams["customerId"], paymentMethodId: CustomerControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: CustomerControllerGenerateMandateSignatureRequestMutationRequest, params?: CustomerControllerGenerateMandateSignatureRequestQueryParams}, TContext>
      
}

export const customerControllerUpdatePreferredPaymentMethodMutationKey = () => [{ url: '/customers/:customerId/payment-methods/:paymentMethodId/preferred' }] as const

export type CustomerControllerUpdatePreferredPaymentMethodMutationKey = ReturnType<typeof customerControllerUpdatePreferredPaymentMethodMutationKey>

export function customerControllerUpdatePreferredPaymentMethodMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = customerControllerUpdatePreferredPaymentMethodMutationKey()
        return mutationOptions<CustomerControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409>, {customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], params?: CustomerControllerUpdatePreferredPaymentMethodQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, paymentMethodId, params }) => {
            return customerControllerUpdatePreferredPaymentMethod(customerId, paymentMethodId, params, config)
          },
        })

}

/**
 * @summary Update customer preferred payment method
 * {@link /customers/:customerId/payment-methods/:paymentMethodId/preferred}
 */
export function useCustomerControllerUpdatePreferredPaymentMethod<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409>, {customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], params?: CustomerControllerUpdatePreferredPaymentMethodQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerUpdatePreferredPaymentMethodMutationKey()

          const baseOptions = customerControllerUpdatePreferredPaymentMethodMutationOptions(config) as UseMutationOptions<CustomerControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409>, {customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], params?: CustomerControllerUpdatePreferredPaymentMethodQueryParams}, TContext>
          

          return useMutation<CustomerControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409>, {customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], params?: CustomerControllerUpdatePreferredPaymentMethodQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePreferredPaymentMethod400 | CustomerControllerUpdatePreferredPaymentMethod404 | CustomerControllerUpdatePreferredPaymentMethod409>, {customerId: CustomerControllerUpdatePreferredPaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"], params?: CustomerControllerUpdatePreferredPaymentMethodQueryParams}, TContext>
      
}

export const customerControllerDeletePaymentMethodMutationKey = () => [{ url: '/customers/:customerId/payment-methods/:paymentMethodId' }] as const

export type CustomerControllerDeletePaymentMethodMutationKey = ReturnType<typeof customerControllerDeletePaymentMethodMutationKey>

export function customerControllerDeletePaymentMethodMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = customerControllerDeletePaymentMethodMutationKey()
        return mutationOptions<CustomerControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409>, {customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, paymentMethodId }) => {
            return customerControllerDeletePaymentMethod(customerId, paymentMethodId, config)
          },
        })

}

/**
 * @summary Remove a customer payment method (excludes it from billing)
 * {@link /customers/:customerId/payment-methods/:paymentMethodId}
 */
export function useCustomerControllerDeletePaymentMethod<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409>, {customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerDeletePaymentMethodMutationKey()

          const baseOptions = customerControllerDeletePaymentMethodMutationOptions(config) as UseMutationOptions<CustomerControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409>, {customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>
          

          return useMutation<CustomerControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409>, {customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<CustomerControllerDeletePaymentMethod404 | CustomerControllerDeletePaymentMethod409>, {customerId: CustomerControllerDeletePaymentMethodPathParams["customerId"], paymentMethodId: CustomerControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>
      
}

export const customerControllerUpdatePaymentModeMutationKey = () => [{ url: '/customers/:customerId/payment-mode' }] as const

export type CustomerControllerUpdatePaymentModeMutationKey = ReturnType<typeof customerControllerUpdatePaymentModeMutationKey>

export function customerControllerUpdatePaymentModeMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerUpdatePaymentModeMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerUpdatePaymentModeMutationKey()
        return mutationOptions<CustomerControllerUpdatePaymentModeMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409>, {customerId: CustomerControllerUpdatePaymentModePathParams["customerId"], data: CustomerControllerUpdatePaymentModeMutationRequest, params?: CustomerControllerUpdatePaymentModeQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, data, params }) => {
            return customerControllerUpdatePaymentMode(customerId, data, params, config)
          },
        })

}

/**
 * @description A new customer defaults to the first automatic mode of the product's `allowedPaymentModes` — `OFFLINE` is only a default when it is the only allowed mode, and is only accepted on single-payer policies. Switching to `OFFLINE` stops automatic collection — an in-flight payment still settles through its webhook. Switching back to `DIRECT_DEBIT` requires a usable payment method, and already-issued invoices are not charged retroactively.
 * @summary Update customer payment mode
 * {@link /customers/:customerId/payment-mode}
 */
export function useCustomerControllerUpdatePaymentMode<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerUpdatePaymentModeMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409>, {customerId: CustomerControllerUpdatePaymentModePathParams["customerId"], data: CustomerControllerUpdatePaymentModeMutationRequest, params?: CustomerControllerUpdatePaymentModeQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerUpdatePaymentModeMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerUpdatePaymentModeMutationKey()

          const baseOptions = customerControllerUpdatePaymentModeMutationOptions(config) as UseMutationOptions<CustomerControllerUpdatePaymentModeMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409>, {customerId: CustomerControllerUpdatePaymentModePathParams["customerId"], data: CustomerControllerUpdatePaymentModeMutationRequest, params?: CustomerControllerUpdatePaymentModeQueryParams}, TContext>
          

          return useMutation<CustomerControllerUpdatePaymentModeMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409>, {customerId: CustomerControllerUpdatePaymentModePathParams["customerId"], data: CustomerControllerUpdatePaymentModeMutationRequest, params?: CustomerControllerUpdatePaymentModeQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerUpdatePaymentModeMutationResponse, ResponseErrorConfig<CustomerControllerUpdatePaymentMode400 | CustomerControllerUpdatePaymentMode404 | CustomerControllerUpdatePaymentMode409>, {customerId: CustomerControllerUpdatePaymentModePathParams["customerId"], data: CustomerControllerUpdatePaymentModeMutationRequest, params?: CustomerControllerUpdatePaymentModeQueryParams}, TContext>
      
}

export const customerControllerChargeMutationKey = () => [{ url: '/customers/:customerId/retry-charge' }] as const

export type CustomerControllerChargeMutationKey = ReturnType<typeof customerControllerChargeMutationKey>

export function customerControllerChargeMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerChargeMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerChargeMutationKey()
        return mutationOptions<CustomerControllerChargeMutationResponse, ResponseErrorConfig<CustomerControllerCharge400 | CustomerControllerCharge404>, {customerId: CustomerControllerChargePathParams["customerId"], data: CustomerControllerChargeMutationRequest, params?: CustomerControllerChargeQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, data, params }) => {
            return customerControllerCharge(customerId, data, params, config)
          },
        })

}

/**
 * @summary Attempt a charge for an invoice
 * {@link /customers/:customerId/retry-charge}
 */
export function useCustomerControllerCharge<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerChargeMutationResponse, ResponseErrorConfig<CustomerControllerCharge400 | CustomerControllerCharge404>, {customerId: CustomerControllerChargePathParams["customerId"], data: CustomerControllerChargeMutationRequest, params?: CustomerControllerChargeQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerChargeMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerChargeMutationKey()

          const baseOptions = customerControllerChargeMutationOptions(config) as UseMutationOptions<CustomerControllerChargeMutationResponse, ResponseErrorConfig<CustomerControllerCharge400 | CustomerControllerCharge404>, {customerId: CustomerControllerChargePathParams["customerId"], data: CustomerControllerChargeMutationRequest, params?: CustomerControllerChargeQueryParams}, TContext>
          

          return useMutation<CustomerControllerChargeMutationResponse, ResponseErrorConfig<CustomerControllerCharge400 | CustomerControllerCharge404>, {customerId: CustomerControllerChargePathParams["customerId"], data: CustomerControllerChargeMutationRequest, params?: CustomerControllerChargeQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerChargeMutationResponse, ResponseErrorConfig<CustomerControllerCharge400 | CustomerControllerCharge404>, {customerId: CustomerControllerChargePathParams["customerId"], data: CustomerControllerChargeMutationRequest, params?: CustomerControllerChargeQueryParams}, TContext>
      
}

export const customerControllerManuallyMarkInvoiceMutationKey = () => [{ url: '/customers/:customerId/manually-mark-invoice' }] as const

export type CustomerControllerManuallyMarkInvoiceMutationKey = ReturnType<typeof customerControllerManuallyMarkInvoiceMutationKey>

export function customerControllerManuallyMarkInvoiceMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerManuallyMarkInvoiceMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerManuallyMarkInvoiceMutationKey()
        return mutationOptions<CustomerControllerManuallyMarkInvoiceMutationResponse, ResponseErrorConfig<CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500>, {customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"], data: CustomerControllerManuallyMarkInvoiceMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, data }) => {
            return customerControllerManuallyMarkInvoice(customerId, data, config)
          },
        })

}

/**
 * @summary Mark an invoice as settled outside the platform
 * {@link /customers/:customerId/manually-mark-invoice}
 */
export function useCustomerControllerManuallyMarkInvoice<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerManuallyMarkInvoiceMutationResponse, ResponseErrorConfig<CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500>, {customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"], data: CustomerControllerManuallyMarkInvoiceMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerManuallyMarkInvoiceMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerManuallyMarkInvoiceMutationKey()

          const baseOptions = customerControllerManuallyMarkInvoiceMutationOptions(config) as UseMutationOptions<CustomerControllerManuallyMarkInvoiceMutationResponse, ResponseErrorConfig<CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500>, {customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"], data: CustomerControllerManuallyMarkInvoiceMutationRequest}, TContext>
          

          return useMutation<CustomerControllerManuallyMarkInvoiceMutationResponse, ResponseErrorConfig<CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500>, {customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"], data: CustomerControllerManuallyMarkInvoiceMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerManuallyMarkInvoiceMutationResponse, ResponseErrorConfig<CustomerControllerManuallyMarkInvoice400 | CustomerControllerManuallyMarkInvoice404 | CustomerControllerManuallyMarkInvoice409 | CustomerControllerManuallyMarkInvoice500>, {customerId: CustomerControllerManuallyMarkInvoicePathParams["customerId"], data: CustomerControllerManuallyMarkInvoiceMutationRequest}, TContext>
      
}

export const customerControllerSetMigratedBillingTakeoverMutationKey = () => [{ url: '/customers/:customerId/migrated-billing-takeover/:policyId' }] as const

export type CustomerControllerSetMigratedBillingTakeoverMutationKey = ReturnType<typeof customerControllerSetMigratedBillingTakeoverMutationKey>

export function customerControllerSetMigratedBillingTakeoverMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerSetMigratedBillingTakeoverMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerSetMigratedBillingTakeoverMutationKey()
        return mutationOptions<CustomerControllerSetMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"], data: CustomerControllerSetMigratedBillingTakeoverMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, policyId, data }) => {
            return customerControllerSetMigratedBillingTakeover(customerId, policyId, data, config)
          },
        })

}

/**
 * @description Changes which invoices the platform bills. The row is frozen against the recomputing projection until it is unlocked.
 * @summary Override and freeze a migrated billing takeover date
 * {@link /customers/:customerId/migrated-billing-takeover/:policyId}
 */
export function useCustomerControllerSetMigratedBillingTakeover<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerSetMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"], data: CustomerControllerSetMigratedBillingTakeoverMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerSetMigratedBillingTakeoverMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerSetMigratedBillingTakeoverMutationKey()

          const baseOptions = customerControllerSetMigratedBillingTakeoverMutationOptions(config) as UseMutationOptions<CustomerControllerSetMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"], data: CustomerControllerSetMigratedBillingTakeoverMutationRequest}, TContext>
          

          return useMutation<CustomerControllerSetMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"], data: CustomerControllerSetMigratedBillingTakeoverMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerSetMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerSetMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerSetMigratedBillingTakeoverPathParams["policyId"], data: CustomerControllerSetMigratedBillingTakeoverMutationRequest}, TContext>
      
}

export const customerControllerUnlockMigratedBillingTakeoverMutationKey = () => [{ url: '/customers/:customerId/migrated-billing-takeover/:policyId' }] as const

export type CustomerControllerUnlockMigratedBillingTakeoverMutationKey = ReturnType<typeof customerControllerUnlockMigratedBillingTakeoverMutationKey>

export function customerControllerUnlockMigratedBillingTakeoverMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = customerControllerUnlockMigratedBillingTakeoverMutationKey()
        return mutationOptions<CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"]}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, policyId }) => {
            return customerControllerUnlockMigratedBillingTakeover(customerId, policyId, config)
          },
        })

}

/**
 * @description Clears the freeze and recomputes the date immediately.
 * @summary Hand a migrated billing takeover date back to the projection
 * {@link /customers/:customerId/migrated-billing-takeover/:policyId}
 */
export function useCustomerControllerUnlockMigratedBillingTakeover<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerUnlockMigratedBillingTakeoverMutationKey()

          const baseOptions = customerControllerUnlockMigratedBillingTakeoverMutationOptions(config) as UseMutationOptions<CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"]}, TContext>
          

          return useMutation<CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerUnlockMigratedBillingTakeoverMutationResponse, ResponseErrorConfig<Error>, {customerId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["customerId"], policyId: CustomerControllerUnlockMigratedBillingTakeoverPathParams["policyId"]}, TContext>
      
}

export const customerControllerCreateCustomerForPolicyMutationKey = () => [{ url: '/customers/policies/:policyId' }] as const

export type CustomerControllerCreateCustomerForPolicyMutationKey = ReturnType<typeof customerControllerCreateCustomerForPolicyMutationKey>

export function customerControllerCreateCustomerForPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CustomerControllerCreateCustomerForPolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = customerControllerCreateCustomerForPolicyMutationKey()
        return mutationOptions<CustomerControllerCreateCustomerForPolicyMutationResponse, ResponseErrorConfig<CustomerControllerCreateCustomerForPolicy404>, {policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"], data: CustomerControllerCreateCustomerForPolicyMutationRequest, params?: CustomerControllerCreateCustomerForPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return customerControllerCreateCustomerForPolicy(policyId, data, params, config)
          },
        })

}

/**
 * @summary Create a customer on an existing policy
 * {@link /customers/policies/:policyId}
 */
export function useCustomerControllerCreateCustomerForPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerCreateCustomerForPolicyMutationResponse, ResponseErrorConfig<CustomerControllerCreateCustomerForPolicy404>, {policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"], data: CustomerControllerCreateCustomerForPolicyMutationRequest, params?: CustomerControllerCreateCustomerForPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CustomerControllerCreateCustomerForPolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerCreateCustomerForPolicyMutationKey()

          const baseOptions = customerControllerCreateCustomerForPolicyMutationOptions(config) as UseMutationOptions<CustomerControllerCreateCustomerForPolicyMutationResponse, ResponseErrorConfig<CustomerControllerCreateCustomerForPolicy404>, {policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"], data: CustomerControllerCreateCustomerForPolicyMutationRequest, params?: CustomerControllerCreateCustomerForPolicyQueryParams}, TContext>
          

          return useMutation<CustomerControllerCreateCustomerForPolicyMutationResponse, ResponseErrorConfig<CustomerControllerCreateCustomerForPolicy404>, {policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"], data: CustomerControllerCreateCustomerForPolicyMutationRequest, params?: CustomerControllerCreateCustomerForPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerCreateCustomerForPolicyMutationResponse, ResponseErrorConfig<CustomerControllerCreateCustomerForPolicy404>, {policyId: CustomerControllerCreateCustomerForPolicyPathParams["policyId"], data: CustomerControllerCreateCustomerForPolicyMutationRequest, params?: CustomerControllerCreateCustomerForPolicyQueryParams}, TContext>
      
}

export const customerControllerDeleteCustomerFromPolicyMutationKey = () => [{ url: '/customers/:customerId/policies/:policyId' }] as const

export type CustomerControllerDeleteCustomerFromPolicyMutationKey = ReturnType<typeof customerControllerDeleteCustomerFromPolicyMutationKey>

export function customerControllerDeleteCustomerFromPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = customerControllerDeleteCustomerFromPolicyMutationKey()
        return mutationOptions<CustomerControllerDeleteCustomerFromPolicyMutationResponse, ResponseErrorConfig<CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409>, {policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"], params?: CustomerControllerDeleteCustomerFromPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, customerId, params }) => {
            return customerControllerDeleteCustomerFromPolicy(policyId, customerId, params, config)
          },
        })

}

/**
 * @summary Delete customer from policy
 * {@link /customers/:customerId/policies/:policyId}
 */
export function useCustomerControllerDeleteCustomerFromPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<CustomerControllerDeleteCustomerFromPolicyMutationResponse, ResponseErrorConfig<CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409>, {policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"], params?: CustomerControllerDeleteCustomerFromPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? customerControllerDeleteCustomerFromPolicyMutationKey()

          const baseOptions = customerControllerDeleteCustomerFromPolicyMutationOptions(config) as UseMutationOptions<CustomerControllerDeleteCustomerFromPolicyMutationResponse, ResponseErrorConfig<CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409>, {policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"], params?: CustomerControllerDeleteCustomerFromPolicyQueryParams}, TContext>
          

          return useMutation<CustomerControllerDeleteCustomerFromPolicyMutationResponse, ResponseErrorConfig<CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409>, {policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"], params?: CustomerControllerDeleteCustomerFromPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CustomerControllerDeleteCustomerFromPolicyMutationResponse, ResponseErrorConfig<CustomerControllerDeleteCustomerFromPolicy403 | CustomerControllerDeleteCustomerFromPolicy404 | CustomerControllerDeleteCustomerFromPolicy409>, {policyId: CustomerControllerDeleteCustomerFromPolicyPathParams["policyId"], customerId: CustomerControllerDeleteCustomerFromPolicyPathParams["customerId"], params?: CustomerControllerDeleteCustomerFromPolicyQueryParams}, TContext>
      
}

export const debugControllerClearTestDataMutationKey = () => [{ url: '/debug/clear-test-data' }] as const

export type DebugControllerClearTestDataMutationKey = ReturnType<typeof debugControllerClearTestDataMutationKey>

export function debugControllerClearTestDataMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = debugControllerClearTestDataMutationKey()
        return mutationOptions<DebugControllerClearTestDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return debugControllerClearTestData(config)
          },
        })

}

/**
 * {@link /debug/clear-test-data}
 */
export function useDebugControllerClearTestData<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerClearTestDataMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerClearTestDataMutationKey()

          const baseOptions = debugControllerClearTestDataMutationOptions(config) as UseMutationOptions<DebugControllerClearTestDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<DebugControllerClearTestDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerClearTestDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const debugControllerClearProjectionsDataMutationKey = () => [{ url: '/debug/clear-projections-data' }] as const

export type DebugControllerClearProjectionsDataMutationKey = ReturnType<typeof debugControllerClearProjectionsDataMutationKey>

export function debugControllerClearProjectionsDataMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = debugControllerClearProjectionsDataMutationKey()
        return mutationOptions<DebugControllerClearProjectionsDataMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearProjectionsDataQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ params }) => {
            return debugControllerClearProjectionsData(params, config)
          },
        })

}

/**
 * {@link /debug/clear-projections-data}
 */
export function useDebugControllerClearProjectionsData<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerClearProjectionsDataMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearProjectionsDataQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerClearProjectionsDataMutationKey()

          const baseOptions = debugControllerClearProjectionsDataMutationOptions(config) as UseMutationOptions<DebugControllerClearProjectionsDataMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearProjectionsDataQueryParams}, TContext>
          

          return useMutation<DebugControllerClearProjectionsDataMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearProjectionsDataQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerClearProjectionsDataMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearProjectionsDataQueryParams}, TContext>
      
}

export const debugControllerClearLegacyCacheMutationKey = () => [{ url: '/debug/clear-cache' }] as const

export type DebugControllerClearLegacyCacheMutationKey = ReturnType<typeof debugControllerClearLegacyCacheMutationKey>

export function debugControllerClearLegacyCacheMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = debugControllerClearLegacyCacheMutationKey()
        return mutationOptions<DebugControllerClearLegacyCacheMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearLegacyCacheQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ params }) => {
            return debugControllerClearLegacyCache(params, config)
          },
        })

}

/**
 * {@link /debug/clear-cache}
 */
export function useDebugControllerClearLegacyCache<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerClearLegacyCacheMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearLegacyCacheQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerClearLegacyCacheMutationKey()

          const baseOptions = debugControllerClearLegacyCacheMutationOptions(config) as UseMutationOptions<DebugControllerClearLegacyCacheMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearLegacyCacheQueryParams}, TContext>
          

          return useMutation<DebugControllerClearLegacyCacheMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearLegacyCacheQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerClearLegacyCacheMutationResponse, ResponseErrorConfig<Error>, {params?: DebugControllerClearLegacyCacheQueryParams}, TContext>
      
}

export const debugControllerToggleIgnoreCoreEventsMutationKey = () => [{ url: '/debug/core/events/toggle-ignore' }] as const

export type DebugControllerToggleIgnoreCoreEventsMutationKey = ReturnType<typeof debugControllerToggleIgnoreCoreEventsMutationKey>

export function debugControllerToggleIgnoreCoreEventsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerToggleIgnoreCoreEventsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerToggleIgnoreCoreEventsMutationKey()
        return mutationOptions<DebugControllerToggleIgnoreCoreEventsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerToggleIgnoreCoreEventsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerToggleIgnoreCoreEvents(data, config)
          },
        })

}

/**
 * {@link /debug/core/events/toggle-ignore}
 */
export function useDebugControllerToggleIgnoreCoreEvents<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerToggleIgnoreCoreEventsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerToggleIgnoreCoreEventsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerToggleIgnoreCoreEventsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerToggleIgnoreCoreEventsMutationKey()

          const baseOptions = debugControllerToggleIgnoreCoreEventsMutationOptions(config) as UseMutationOptions<DebugControllerToggleIgnoreCoreEventsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerToggleIgnoreCoreEventsMutationRequest}, TContext>
          

          return useMutation<DebugControllerToggleIgnoreCoreEventsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerToggleIgnoreCoreEventsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerToggleIgnoreCoreEventsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerToggleIgnoreCoreEventsMutationRequest}, TContext>
      
}

export const debugControllerBillCustomerMutationKey = () => [{ url: '/debug/customers/:customerId/bill' }] as const

export type DebugControllerBillCustomerMutationKey = ReturnType<typeof debugControllerBillCustomerMutationKey>

export function debugControllerBillCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = debugControllerBillCustomerMutationKey()
        return mutationOptions<DebugControllerBillCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: DebugControllerBillCustomerPathParams["customerId"], params?: DebugControllerBillCustomerQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, params }) => {
            return debugControllerBillCustomer(customerId, params, config)
          },
        })

}

/**
 * {@link /debug/customers/:customerId/bill}
 */
export function useDebugControllerBillCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerBillCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: DebugControllerBillCustomerPathParams["customerId"], params?: DebugControllerBillCustomerQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerBillCustomerMutationKey()

          const baseOptions = debugControllerBillCustomerMutationOptions(config) as UseMutationOptions<DebugControllerBillCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: DebugControllerBillCustomerPathParams["customerId"], params?: DebugControllerBillCustomerQueryParams}, TContext>
          

          return useMutation<DebugControllerBillCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: DebugControllerBillCustomerPathParams["customerId"], params?: DebugControllerBillCustomerQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerBillCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: DebugControllerBillCustomerPathParams["customerId"], params?: DebugControllerBillCustomerQueryParams}, TContext>
      
}

export const debugControllerBatchBillCustomersMutationKey = () => [{ url: '/debug/customers/batch-bill' }] as const

export type DebugControllerBatchBillCustomersMutationKey = ReturnType<typeof debugControllerBatchBillCustomersMutationKey>

export function debugControllerBatchBillCustomersMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerBatchBillCustomersMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerBatchBillCustomersMutationKey()
        return mutationOptions<DebugControllerBatchBillCustomersMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchBillCustomersMutationRequest, params?: DebugControllerBatchBillCustomersQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return debugControllerBatchBillCustomers(data, params, config)
          },
        })

}

/**
 * {@link /debug/customers/batch-bill}
 */
export function useDebugControllerBatchBillCustomers<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerBatchBillCustomersMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchBillCustomersMutationRequest, params?: DebugControllerBatchBillCustomersQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerBatchBillCustomersMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerBatchBillCustomersMutationKey()

          const baseOptions = debugControllerBatchBillCustomersMutationOptions(config) as UseMutationOptions<DebugControllerBatchBillCustomersMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchBillCustomersMutationRequest, params?: DebugControllerBatchBillCustomersQueryParams}, TContext>
          

          return useMutation<DebugControllerBatchBillCustomersMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchBillCustomersMutationRequest, params?: DebugControllerBatchBillCustomersQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerBatchBillCustomersMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchBillCustomersMutationRequest, params?: DebugControllerBatchBillCustomersQueryParams}, TContext>
      
}

export const debugControllerBatchChargeInvoicesMutationKey = () => [{ url: '/debug/invoices/batch-charge' }] as const

export type DebugControllerBatchChargeInvoicesMutationKey = ReturnType<typeof debugControllerBatchChargeInvoicesMutationKey>

export function debugControllerBatchChargeInvoicesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerBatchChargeInvoicesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerBatchChargeInvoicesMutationKey()
        return mutationOptions<DebugControllerBatchChargeInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchChargeInvoicesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerBatchChargeInvoices(data, config)
          },
        })

}

/**
 * {@link /debug/invoices/batch-charge}
 */
export function useDebugControllerBatchChargeInvoices<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerBatchChargeInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchChargeInvoicesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerBatchChargeInvoicesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerBatchChargeInvoicesMutationKey()

          const baseOptions = debugControllerBatchChargeInvoicesMutationOptions(config) as UseMutationOptions<DebugControllerBatchChargeInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchChargeInvoicesMutationRequest}, TContext>
          

          return useMutation<DebugControllerBatchChargeInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchChargeInvoicesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerBatchChargeInvoicesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchChargeInvoicesMutationRequest}, TContext>
      
}

export const debugControllerStartDailyStagingCleanupMutationKey = () => [{ url: '/debug/start-daily-staging-cleanup' }] as const

export type DebugControllerStartDailyStagingCleanupMutationKey = ReturnType<typeof debugControllerStartDailyStagingCleanupMutationKey>

export function debugControllerStartDailyStagingCleanupMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = debugControllerStartDailyStagingCleanupMutationKey()
        return mutationOptions<DebugControllerStartDailyStagingCleanupMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return debugControllerStartDailyStagingCleanup(config)
          },
        })

}

/**
 * {@link /debug/start-daily-staging-cleanup}
 */
export function useDebugControllerStartDailyStagingCleanup<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerStartDailyStagingCleanupMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerStartDailyStagingCleanupMutationKey()

          const baseOptions = debugControllerStartDailyStagingCleanupMutationOptions(config) as UseMutationOptions<DebugControllerStartDailyStagingCleanupMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<DebugControllerStartDailyStagingCleanupMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerStartDailyStagingCleanupMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const debugControllerCreateDistributionRequestsAndFeesMutationKey = () => [{ url: '/debug/add-new-product-to-distribution-requests' }] as const

export type DebugControllerCreateDistributionRequestsAndFeesMutationKey = ReturnType<typeof debugControllerCreateDistributionRequestsAndFeesMutationKey>

export function debugControllerCreateDistributionRequestsAndFeesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerCreateDistributionRequestsAndFeesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerCreateDistributionRequestsAndFeesMutationKey()
        return mutationOptions<DebugControllerCreateDistributionRequestsAndFeesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreateDistributionRequestsAndFeesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerCreateDistributionRequestsAndFees(data, config)
          },
        })

}

/**
 * {@link /debug/add-new-product-to-distribution-requests}
 */
export function useDebugControllerCreateDistributionRequestsAndFees<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerCreateDistributionRequestsAndFeesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreateDistributionRequestsAndFeesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerCreateDistributionRequestsAndFeesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerCreateDistributionRequestsAndFeesMutationKey()

          const baseOptions = debugControllerCreateDistributionRequestsAndFeesMutationOptions(config) as UseMutationOptions<DebugControllerCreateDistributionRequestsAndFeesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreateDistributionRequestsAndFeesMutationRequest}, TContext>
          

          return useMutation<DebugControllerCreateDistributionRequestsAndFeesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreateDistributionRequestsAndFeesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerCreateDistributionRequestsAndFeesMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreateDistributionRequestsAndFeesMutationRequest}, TContext>
      
}

export const debugControllerCreatePaymentFromStripeMutationKey = () => [{ url: '/debug/create-payment-from-stripe' }] as const

export type DebugControllerCreatePaymentFromStripeMutationKey = ReturnType<typeof debugControllerCreatePaymentFromStripeMutationKey>

export function debugControllerCreatePaymentFromStripeMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerCreatePaymentFromStripeMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerCreatePaymentFromStripeMutationKey()
        return mutationOptions<DebugControllerCreatePaymentFromStripeMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreatePaymentFromStripeMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerCreatePaymentFromStripe(data, config)
          },
        })

}

/**
 * {@link /debug/create-payment-from-stripe}
 */
export function useDebugControllerCreatePaymentFromStripe<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerCreatePaymentFromStripeMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreatePaymentFromStripeMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerCreatePaymentFromStripeMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerCreatePaymentFromStripeMutationKey()

          const baseOptions = debugControllerCreatePaymentFromStripeMutationOptions(config) as UseMutationOptions<DebugControllerCreatePaymentFromStripeMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreatePaymentFromStripeMutationRequest}, TContext>
          

          return useMutation<DebugControllerCreatePaymentFromStripeMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreatePaymentFromStripeMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerCreatePaymentFromStripeMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCreatePaymentFromStripeMutationRequest}, TContext>
      
}

export const debugControllerUpdatePaymentStatusMutationKey = () => [{ url: '/debug/update-payment-status' }] as const

export type DebugControllerUpdatePaymentStatusMutationKey = ReturnType<typeof debugControllerUpdatePaymentStatusMutationKey>

export function debugControllerUpdatePaymentStatusMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerUpdatePaymentStatusMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerUpdatePaymentStatusMutationKey()
        return mutationOptions<DebugControllerUpdatePaymentStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerUpdatePaymentStatusMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerUpdatePaymentStatus(data, config)
          },
        })

}

/**
 * {@link /debug/update-payment-status}
 */
export function useDebugControllerUpdatePaymentStatus<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerUpdatePaymentStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerUpdatePaymentStatusMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerUpdatePaymentStatusMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerUpdatePaymentStatusMutationKey()

          const baseOptions = debugControllerUpdatePaymentStatusMutationOptions(config) as UseMutationOptions<DebugControllerUpdatePaymentStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerUpdatePaymentStatusMutationRequest}, TContext>
          

          return useMutation<DebugControllerUpdatePaymentStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerUpdatePaymentStatusMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerUpdatePaymentStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerUpdatePaymentStatusMutationRequest}, TContext>
      
}

export const debugControllerRefreshInvoiceStatusMutationKey = () => [{ url: '/debug/refresh-invoice-status' }] as const

export type DebugControllerRefreshInvoiceStatusMutationKey = ReturnType<typeof debugControllerRefreshInvoiceStatusMutationKey>

export function debugControllerRefreshInvoiceStatusMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerRefreshInvoiceStatusMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerRefreshInvoiceStatusMutationKey()
        return mutationOptions<DebugControllerRefreshInvoiceStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRefreshInvoiceStatusMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerRefreshInvoiceStatus(data, config)
          },
        })

}

/**
 * {@link /debug/refresh-invoice-status}
 */
export function useDebugControllerRefreshInvoiceStatus<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerRefreshInvoiceStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRefreshInvoiceStatusMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerRefreshInvoiceStatusMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerRefreshInvoiceStatusMutationKey()

          const baseOptions = debugControllerRefreshInvoiceStatusMutationOptions(config) as UseMutationOptions<DebugControllerRefreshInvoiceStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRefreshInvoiceStatusMutationRequest}, TContext>
          

          return useMutation<DebugControllerRefreshInvoiceStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRefreshInvoiceStatusMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerRefreshInvoiceStatusMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRefreshInvoiceStatusMutationRequest}, TContext>
      
}

export const debugControllerBatchGenerateDocumentsMutationKey = () => [{ url: '/debug/batch-generate-documents' }] as const

export type DebugControllerBatchGenerateDocumentsMutationKey = ReturnType<typeof debugControllerBatchGenerateDocumentsMutationKey>

export function debugControllerBatchGenerateDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerBatchGenerateDocumentsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerBatchGenerateDocumentsMutationKey()
        return mutationOptions<DebugControllerBatchGenerateDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchGenerateDocumentsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerBatchGenerateDocuments(data, config)
          },
        })

}

/**
 * {@link /debug/batch-generate-documents}
 */
export function useDebugControllerBatchGenerateDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerBatchGenerateDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchGenerateDocumentsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerBatchGenerateDocumentsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerBatchGenerateDocumentsMutationKey()

          const baseOptions = debugControllerBatchGenerateDocumentsMutationOptions(config) as UseMutationOptions<DebugControllerBatchGenerateDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchGenerateDocumentsMutationRequest}, TContext>
          

          return useMutation<DebugControllerBatchGenerateDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchGenerateDocumentsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerBatchGenerateDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchGenerateDocumentsMutationRequest}, TContext>
      
}

export const debugControllerBatchCreateUserRelationsMutationKey = () => [{ url: '/debug/batch-create-user-relations' }] as const

export type DebugControllerBatchCreateUserRelationsMutationKey = ReturnType<typeof debugControllerBatchCreateUserRelationsMutationKey>

export function debugControllerBatchCreateUserRelationsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerBatchCreateUserRelationsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerBatchCreateUserRelationsMutationKey()
        return mutationOptions<DebugControllerBatchCreateUserRelationsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchCreateUserRelationsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerBatchCreateUserRelations(data, config)
          },
        })

}

/**
 * {@link /debug/batch-create-user-relations}
 */
export function useDebugControllerBatchCreateUserRelations<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerBatchCreateUserRelationsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchCreateUserRelationsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerBatchCreateUserRelationsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerBatchCreateUserRelationsMutationKey()

          const baseOptions = debugControllerBatchCreateUserRelationsMutationOptions(config) as UseMutationOptions<DebugControllerBatchCreateUserRelationsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchCreateUserRelationsMutationRequest}, TContext>
          

          return useMutation<DebugControllerBatchCreateUserRelationsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchCreateUserRelationsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerBatchCreateUserRelationsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerBatchCreateUserRelationsMutationRequest}, TContext>
      
}

export const debugControllerCheckAllDocumentsMutationKey = () => [{ url: '/debug/check-all-documents' }] as const

export type DebugControllerCheckAllDocumentsMutationKey = ReturnType<typeof debugControllerCheckAllDocumentsMutationKey>

export function debugControllerCheckAllDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerCheckAllDocumentsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerCheckAllDocumentsMutationKey()
        return mutationOptions<DebugControllerCheckAllDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCheckAllDocumentsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerCheckAllDocuments(data, config)
          },
        })

}

/**
 * {@link /debug/check-all-documents}
 */
export function useDebugControllerCheckAllDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerCheckAllDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCheckAllDocumentsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerCheckAllDocumentsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerCheckAllDocumentsMutationKey()

          const baseOptions = debugControllerCheckAllDocumentsMutationOptions(config) as UseMutationOptions<DebugControllerCheckAllDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCheckAllDocumentsMutationRequest}, TContext>
          

          return useMutation<DebugControllerCheckAllDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCheckAllDocumentsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerCheckAllDocumentsMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerCheckAllDocumentsMutationRequest}, TContext>
      
}

export const debugControllerRetriggerClaimDocumentFraudCheckMutationKey = () => [{ url: '/debug/retrigger-claim-document-fraud-check' }] as const

export type DebugControllerRetriggerClaimDocumentFraudCheckMutationKey = ReturnType<typeof debugControllerRetriggerClaimDocumentFraudCheckMutationKey>

export function debugControllerRetriggerClaimDocumentFraudCheckMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = debugControllerRetriggerClaimDocumentFraudCheckMutationKey()
        return mutationOptions<DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return debugControllerRetriggerClaimDocumentFraudCheck(data, config)
          },
        })

}

/**
 * {@link /debug/retrigger-claim-document-fraud-check}
 */
export function useDebugControllerRetriggerClaimDocumentFraudCheck<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerRetriggerClaimDocumentFraudCheckMutationKey()

          const baseOptions = debugControllerRetriggerClaimDocumentFraudCheckMutationOptions(config) as UseMutationOptions<DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest}, TContext>
          

          return useMutation<DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerRetriggerClaimDocumentFraudCheckMutationResponse, ResponseErrorConfig<Error>, {data: DebugControllerRetriggerClaimDocumentFraudCheckMutationRequest}, TContext>
      
}

export const debugControllerSuperDeletePoliciesMutationKey = () => [{ url: '/debug/policies/:policyId' }] as const

export type DebugControllerSuperDeletePoliciesMutationKey = ReturnType<typeof debugControllerSuperDeletePoliciesMutationKey>

export function debugControllerSuperDeletePoliciesMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = debugControllerSuperDeletePoliciesMutationKey()
        return mutationOptions<DebugControllerSuperDeletePoliciesMutationResponse, ResponseErrorConfig<Error>, {policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"]}, TContext>({
          mutationKey,
          mutationFn: async({ policyId }) => {
            return debugControllerSuperDeletePolicies(policyId, config)
          },
        })

}

/**
 * {@link /debug/policies/:policyId}
 */
export function useDebugControllerSuperDeletePolicies<TContext>(options: 
{
  mutation?: UseMutationOptions<DebugControllerSuperDeletePoliciesMutationResponse, ResponseErrorConfig<Error>, {policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? debugControllerSuperDeletePoliciesMutationKey()

          const baseOptions = debugControllerSuperDeletePoliciesMutationOptions(config) as UseMutationOptions<DebugControllerSuperDeletePoliciesMutationResponse, ResponseErrorConfig<Error>, {policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"]}, TContext>
          

          return useMutation<DebugControllerSuperDeletePoliciesMutationResponse, ResponseErrorConfig<Error>, {policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DebugControllerSuperDeletePoliciesMutationResponse, ResponseErrorConfig<Error>, {policyId: DebugControllerSuperDeletePoliciesPathParams["policyId"]}, TContext>
      
}

export const documentsControllerGenerateDocumentUploadUrlsMutationKey = () => [{ url: '/documents' }] as const

export type DocumentsControllerGenerateDocumentUploadUrlsMutationKey = ReturnType<typeof documentsControllerGenerateDocumentUploadUrlsMutationKey>

export function documentsControllerGenerateDocumentUploadUrlsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerGenerateDocumentUploadUrlsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerGenerateDocumentUploadUrlsMutationKey()
        return mutationOptions<DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentsControllerGenerateDocumentUploadUrls(data, config)
          },
        })

}

/**
 * @summary Generate upload URL
 * {@link /documents}
 */
export function useDocumentsControllerGenerateDocumentUploadUrls<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerGenerateDocumentUploadUrlsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerGenerateDocumentUploadUrlsMutationKey()

          const baseOptions = documentsControllerGenerateDocumentUploadUrlsMutationOptions(config) as UseMutationOptions<DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerGenerateDocumentUploadUrlsMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerGenerateDocumentUploadUrlsMutationRequest}, TContext>
      
}

export const documentsControllerDeleteDocumentsMutationKey = () => [{ url: '/documents' }] as const

export type DocumentsControllerDeleteDocumentsMutationKey = ReturnType<typeof documentsControllerDeleteDocumentsMutationKey>

export function documentsControllerDeleteDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = documentsControllerDeleteDocumentsMutationKey()
        return mutationOptions<DocumentsControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<Error>, {params: DocumentsControllerDeleteDocumentsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ params }) => {
            return documentsControllerDeleteDocuments(params, config)
          },
        })

}

/**
 * @summary Delete documents by IDs
 * {@link /documents}
 */
export function useDocumentsControllerDeleteDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<Error>, {params: DocumentsControllerDeleteDocumentsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerDeleteDocumentsMutationKey()

          const baseOptions = documentsControllerDeleteDocumentsMutationOptions(config) as UseMutationOptions<DocumentsControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<Error>, {params: DocumentsControllerDeleteDocumentsQueryParams}, TContext>
          

          return useMutation<DocumentsControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<Error>, {params: DocumentsControllerDeleteDocumentsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<Error>, {params: DocumentsControllerDeleteDocumentsQueryParams}, TContext>
      
}

export const documentsControllerArchiveDocumentsMutationKey = () => [{ url: '/documents/archive' }] as const

export type DocumentsControllerArchiveDocumentsMutationKey = ReturnType<typeof documentsControllerArchiveDocumentsMutationKey>

export function documentsControllerArchiveDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerArchiveDocumentsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerArchiveDocumentsMutationKey()
        return mutationOptions<DocumentsControllerArchiveDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404>, {data: DocumentsControllerArchiveDocumentsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentsControllerArchiveDocuments(data, config)
          },
        })

}

/**
 * @summary Archive documents (Super admin only)
 * {@link /documents/archive}
 */
export function useDocumentsControllerArchiveDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerArchiveDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404>, {data: DocumentsControllerArchiveDocumentsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerArchiveDocumentsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerArchiveDocumentsMutationKey()

          const baseOptions = documentsControllerArchiveDocumentsMutationOptions(config) as UseMutationOptions<DocumentsControllerArchiveDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404>, {data: DocumentsControllerArchiveDocumentsMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerArchiveDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404>, {data: DocumentsControllerArchiveDocumentsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerArchiveDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerArchiveDocuments403 | DocumentsControllerArchiveDocuments404>, {data: DocumentsControllerArchiveDocumentsMutationRequest}, TContext>
      
}

export const documentsControllerRestoreDocumentsMutationKey = () => [{ url: '/documents/restore' }] as const

export type DocumentsControllerRestoreDocumentsMutationKey = ReturnType<typeof documentsControllerRestoreDocumentsMutationKey>

export function documentsControllerRestoreDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerRestoreDocumentsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerRestoreDocumentsMutationKey()
        return mutationOptions<DocumentsControllerRestoreDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404>, {data: DocumentsControllerRestoreDocumentsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentsControllerRestoreDocuments(data, config)
          },
        })

}

/**
 * @summary Restore documents (Super admin only)
 * {@link /documents/restore}
 */
export function useDocumentsControllerRestoreDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerRestoreDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404>, {data: DocumentsControllerRestoreDocumentsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerRestoreDocumentsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerRestoreDocumentsMutationKey()

          const baseOptions = documentsControllerRestoreDocumentsMutationOptions(config) as UseMutationOptions<DocumentsControllerRestoreDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404>, {data: DocumentsControllerRestoreDocumentsMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerRestoreDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404>, {data: DocumentsControllerRestoreDocumentsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerRestoreDocumentsMutationResponse, ResponseErrorConfig<DocumentsControllerRestoreDocuments403 | DocumentsControllerRestoreDocuments404>, {data: DocumentsControllerRestoreDocumentsMutationRequest}, TContext>
      
}

export const documentsControllerSetDocumentCategoryMutationKey = () => [{ url: '/documents/:documentId' }] as const

export type DocumentsControllerSetDocumentCategoryMutationKey = ReturnType<typeof documentsControllerSetDocumentCategoryMutationKey>

export function documentsControllerSetDocumentCategoryMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerSetDocumentCategoryMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerSetDocumentCategoryMutationKey()
        return mutationOptions<DocumentsControllerSetDocumentCategoryMutationResponse, ResponseErrorConfig<DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404>, {documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"], data: DocumentsControllerSetDocumentCategoryMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ documentId, data }) => {
            return documentsControllerSetDocumentCategory(documentId, data, config)
          },
        })

}

/**
 * @description Updates the category metadata of a document. Requires SET_DOCUMENT_CATEGORY permission.
 * @summary Set document category
 * {@link /documents/:documentId}
 */
export function useDocumentsControllerSetDocumentCategory<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerSetDocumentCategoryMutationResponse, ResponseErrorConfig<DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404>, {documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"], data: DocumentsControllerSetDocumentCategoryMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerSetDocumentCategoryMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerSetDocumentCategoryMutationKey()

          const baseOptions = documentsControllerSetDocumentCategoryMutationOptions(config) as UseMutationOptions<DocumentsControllerSetDocumentCategoryMutationResponse, ResponseErrorConfig<DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404>, {documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"], data: DocumentsControllerSetDocumentCategoryMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerSetDocumentCategoryMutationResponse, ResponseErrorConfig<DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404>, {documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"], data: DocumentsControllerSetDocumentCategoryMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerSetDocumentCategoryMutationResponse, ResponseErrorConfig<DocumentsControllerSetDocumentCategory400 | DocumentsControllerSetDocumentCategory403 | DocumentsControllerSetDocumentCategory404>, {documentId: DocumentsControllerSetDocumentCategoryPathParams["documentId"], data: DocumentsControllerSetDocumentCategoryMutationRequest}, TContext>
      
}

export const documentsControllerListDocumentsWithPresignedUrlMutationKey = () => [{ url: '/documents/debug/list-by-metadata' }] as const

export type DocumentsControllerListDocumentsWithPresignedUrlMutationKey = ReturnType<typeof documentsControllerListDocumentsWithPresignedUrlMutationKey>

export function documentsControllerListDocumentsWithPresignedUrlMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerListDocumentsWithPresignedUrlMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerListDocumentsWithPresignedUrlMutationKey()
        return mutationOptions<DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentsControllerListDocumentsWithPresignedUrl(data, config)
          },
        })

}

/**
 * @summary DEBUG: List documents by metadata
 * {@link /documents/debug/list-by-metadata}
 */
export function useDocumentsControllerListDocumentsWithPresignedUrl<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerListDocumentsWithPresignedUrlMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerListDocumentsWithPresignedUrlMutationKey()

          const baseOptions = documentsControllerListDocumentsWithPresignedUrlMutationOptions(config) as UseMutationOptions<DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerListDocumentsWithPresignedUrlMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerListDocumentsWithPresignedUrlMutationRequest}, TContext>
      
}

export const documentsControllerCreatePdfMutationKey = () => [{ url: '/documents/debug/generate-pdf' }] as const

export type DocumentsControllerCreatePdfMutationKey = ReturnType<typeof documentsControllerCreatePdfMutationKey>

export function documentsControllerCreatePdfMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerCreatePdfMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerCreatePdfMutationKey()
        return mutationOptions<DocumentsControllerCreatePdfMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerCreatePdfMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentsControllerCreatePdf(data, config)
          },
        })

}

/**
 * @summary DEBUG: Create pdf
 * {@link /documents/debug/generate-pdf}
 */
export function useDocumentsControllerCreatePdf<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerCreatePdfMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerCreatePdfMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerCreatePdfMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerCreatePdfMutationKey()

          const baseOptions = documentsControllerCreatePdfMutationOptions(config) as UseMutationOptions<DocumentsControllerCreatePdfMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerCreatePdfMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerCreatePdfMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerCreatePdfMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerCreatePdfMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerCreatePdfMutationRequest}, TContext>
      
}

export const documentsControllerScheduleHandleMalwareProtectionScanResultMutationKey = () => [{ url: '/documents/schedule-handle-malware-protection-scan-result' }] as const

export type DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationKey = ReturnType<typeof documentsControllerScheduleHandleMalwareProtectionScanResultMutationKey>

export function documentsControllerScheduleHandleMalwareProtectionScanResultMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentsControllerScheduleHandleMalwareProtectionScanResultMutationKey()
        return mutationOptions<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentsControllerScheduleHandleMalwareProtectionScanResult(data, config)
          },
        })

}

/**
 * {@link /documents/schedule-handle-malware-protection-scan-result}
 */
export function useDocumentsControllerScheduleHandleMalwareProtectionScanResult<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentsControllerScheduleHandleMalwareProtectionScanResultMutationKey()

          const baseOptions = documentsControllerScheduleHandleMalwareProtectionScanResultMutationOptions(config) as UseMutationOptions<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest}, TContext>
          

          return useMutation<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationResponse, ResponseErrorConfig<Error>, {data: DocumentsControllerScheduleHandleMalwareProtectionScanResultMutationRequest}, TContext>
      
}

export const invitationControllerInviteMutationKey = () => [{ url: '/invite' }] as const

export type InvitationControllerInviteMutationKey = ReturnType<typeof invitationControllerInviteMutationKey>

export function invitationControllerInviteMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InvitationControllerInviteMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = invitationControllerInviteMutationKey()
        return mutationOptions<InvitationControllerInviteMutationResponse, ResponseErrorConfig<InvitationControllerInvite400>, {data: InvitationControllerInviteMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return invitationControllerInvite(data, config)
          },
        })

}

/**
 * @description Sends the customer an email inviting them to create their account.
 * @summary Invite a customer
 * {@link /invite}
 */
export function useInvitationControllerInvite<TContext>(options: 
{
  mutation?: UseMutationOptions<InvitationControllerInviteMutationResponse, ResponseErrorConfig<InvitationControllerInvite400>, {data: InvitationControllerInviteMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InvitationControllerInviteMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? invitationControllerInviteMutationKey()

          const baseOptions = invitationControllerInviteMutationOptions(config) as UseMutationOptions<InvitationControllerInviteMutationResponse, ResponseErrorConfig<InvitationControllerInvite400>, {data: InvitationControllerInviteMutationRequest}, TContext>
          

          return useMutation<InvitationControllerInviteMutationResponse, ResponseErrorConfig<InvitationControllerInvite400>, {data: InvitationControllerInviteMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InvitationControllerInviteMutationResponse, ResponseErrorConfig<InvitationControllerInvite400>, {data: InvitationControllerInviteMutationRequest}, TContext>
      
}

export const invitationControllerAdminInviteMutationKey = () => [{ url: '/debug/admin-invite' }] as const

export type InvitationControllerAdminInviteMutationKey = ReturnType<typeof invitationControllerAdminInviteMutationKey>

export function invitationControllerAdminInviteMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InvitationControllerAdminInviteMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = invitationControllerAdminInviteMutationKey()
        return mutationOptions<InvitationControllerAdminInviteMutationResponse, ResponseErrorConfig<InvitationControllerAdminInvite400>, {data: InvitationControllerAdminInviteMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return invitationControllerAdminInvite(data, config)
          },
        })

}

/**
 * {@link /debug/admin-invite}
 */
export function useInvitationControllerAdminInvite<TContext>(options: 
{
  mutation?: UseMutationOptions<InvitationControllerAdminInviteMutationResponse, ResponseErrorConfig<InvitationControllerAdminInvite400>, {data: InvitationControllerAdminInviteMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InvitationControllerAdminInviteMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? invitationControllerAdminInviteMutationKey()

          const baseOptions = invitationControllerAdminInviteMutationOptions(config) as UseMutationOptions<InvitationControllerAdminInviteMutationResponse, ResponseErrorConfig<InvitationControllerAdminInvite400>, {data: InvitationControllerAdminInviteMutationRequest}, TContext>
          

          return useMutation<InvitationControllerAdminInviteMutationResponse, ResponseErrorConfig<InvitationControllerAdminInvite400>, {data: InvitationControllerAdminInviteMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InvitationControllerAdminInviteMutationResponse, ResponseErrorConfig<InvitationControllerAdminInvite400>, {data: InvitationControllerAdminInviteMutationRequest}, TContext>
      
}

export const invitationControllerBrokerInviteMutationKey = () => [{ url: '/broker-invite' }] as const

export type InvitationControllerBrokerInviteMutationKey = ReturnType<typeof invitationControllerBrokerInviteMutationKey>

export function invitationControllerBrokerInviteMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InvitationControllerBrokerInviteMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = invitationControllerBrokerInviteMutationKey()
        return mutationOptions<InvitationControllerBrokerInviteMutationResponse, ResponseErrorConfig<InvitationControllerBrokerInvite400>, {data: InvitationControllerBrokerInviteMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return invitationControllerBrokerInvite(data, config)
          },
        })

}

/**
 * @description Sends the broker an email inviting them to join the brokerage firm.
 * @summary Invite a broker
 * {@link /broker-invite}
 */
export function useInvitationControllerBrokerInvite<TContext>(options: 
{
  mutation?: UseMutationOptions<InvitationControllerBrokerInviteMutationResponse, ResponseErrorConfig<InvitationControllerBrokerInvite400>, {data: InvitationControllerBrokerInviteMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InvitationControllerBrokerInviteMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? invitationControllerBrokerInviteMutationKey()

          const baseOptions = invitationControllerBrokerInviteMutationOptions(config) as UseMutationOptions<InvitationControllerBrokerInviteMutationResponse, ResponseErrorConfig<InvitationControllerBrokerInvite400>, {data: InvitationControllerBrokerInviteMutationRequest}, TContext>
          

          return useMutation<InvitationControllerBrokerInviteMutationResponse, ResponseErrorConfig<InvitationControllerBrokerInvite400>, {data: InvitationControllerBrokerInviteMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InvitationControllerBrokerInviteMutationResponse, ResponseErrorConfig<InvitationControllerBrokerInvite400>, {data: InvitationControllerBrokerInviteMutationRequest}, TContext>
      
}

export const invitationControllerCreateAnonymousSessionMutationKey = () => [{ url: '/anonymous-session' }] as const

export type InvitationControllerCreateAnonymousSessionMutationKey = ReturnType<typeof invitationControllerCreateAnonymousSessionMutationKey>

export function invitationControllerCreateAnonymousSessionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = invitationControllerCreateAnonymousSessionMutationKey()
        return mutationOptions<InvitationControllerCreateAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {params?: InvitationControllerCreateAnonymousSessionQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ params }) => {
            return invitationControllerCreateAnonymousSession(params, config)
          },
        })

}

/**
 * @description Issues a temporary session so a visitor can quote without an account. Rate limited to 100 sessions per hour.
 * @summary Start an anonymous session
 * {@link /anonymous-session}
 */
export function useInvitationControllerCreateAnonymousSession<TContext>(options: 
{
  mutation?: UseMutationOptions<InvitationControllerCreateAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {params?: InvitationControllerCreateAnonymousSessionQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? invitationControllerCreateAnonymousSessionMutationKey()

          const baseOptions = invitationControllerCreateAnonymousSessionMutationOptions(config) as UseMutationOptions<InvitationControllerCreateAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {params?: InvitationControllerCreateAnonymousSessionQueryParams}, TContext>
          

          return useMutation<InvitationControllerCreateAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {params?: InvitationControllerCreateAnonymousSessionQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InvitationControllerCreateAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {params?: InvitationControllerCreateAnonymousSessionQueryParams}, TContext>
      
}

export const invitationControllerHandoffAnonymousSessionMutationKey = () => [{ url: '/anonymous-session/handoff' }] as const

export type InvitationControllerHandoffAnonymousSessionMutationKey = ReturnType<typeof invitationControllerHandoffAnonymousSessionMutationKey>

export function invitationControllerHandoffAnonymousSessionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InvitationControllerHandoffAnonymousSessionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = invitationControllerHandoffAnonymousSessionMutationKey()
        return mutationOptions<InvitationControllerHandoffAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {data: InvitationControllerHandoffAnonymousSessionMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return invitationControllerHandoffAnonymousSession(data, config)
          },
        })

}

/**
 * @description Transfers everything captured during the anonymous session to the signed-in user.
 * @summary Hand an anonymous session over to an account
 * {@link /anonymous-session/handoff}
 */
export function useInvitationControllerHandoffAnonymousSession<TContext>(options: 
{
  mutation?: UseMutationOptions<InvitationControllerHandoffAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {data: InvitationControllerHandoffAnonymousSessionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InvitationControllerHandoffAnonymousSessionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? invitationControllerHandoffAnonymousSessionMutationKey()

          const baseOptions = invitationControllerHandoffAnonymousSessionMutationOptions(config) as UseMutationOptions<InvitationControllerHandoffAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {data: InvitationControllerHandoffAnonymousSessionMutationRequest}, TContext>
          

          return useMutation<InvitationControllerHandoffAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {data: InvitationControllerHandoffAnonymousSessionMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InvitationControllerHandoffAnonymousSessionMutationResponse, ResponseErrorConfig<Error>, {data: InvitationControllerHandoffAnonymousSessionMutationRequest}, TContext>
      
}

export const jobSchedulersControllerListMutationKey = () => [{ url: '/job-schedulers/list' }] as const

export type JobSchedulersControllerListMutationKey = ReturnType<typeof jobSchedulersControllerListMutationKey>

export function jobSchedulersControllerListMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobSchedulersControllerListMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobSchedulersControllerListMutationKey()
        return mutationOptions<JobSchedulersControllerListMutationResponse, ResponseErrorConfig<Error>, {data: JobSchedulersControllerListMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return jobSchedulersControllerList(data, config)
          },
        })

}

/**
 * @summary List current job schedulers
 * {@link /job-schedulers/list}
 */
export function useJobSchedulersControllerList<TContext>(options: 
{
  mutation?: UseMutationOptions<JobSchedulersControllerListMutationResponse, ResponseErrorConfig<Error>, {data: JobSchedulersControllerListMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobSchedulersControllerListMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobSchedulersControllerListMutationKey()

          const baseOptions = jobSchedulersControllerListMutationOptions(config) as UseMutationOptions<JobSchedulersControllerListMutationResponse, ResponseErrorConfig<Error>, {data: JobSchedulersControllerListMutationRequest}, TContext>
          

          return useMutation<JobSchedulersControllerListMutationResponse, ResponseErrorConfig<Error>, {data: JobSchedulersControllerListMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobSchedulersControllerListMutationResponse, ResponseErrorConfig<Error>, {data: JobSchedulersControllerListMutationRequest}, TContext>
      
}

export const jobSchedulersControllerUpsertMutationKey = () => [{ url: '/job-schedulers/:id' }] as const

export type JobSchedulersControllerUpsertMutationKey = ReturnType<typeof jobSchedulersControllerUpsertMutationKey>

export function jobSchedulersControllerUpsertMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobSchedulersControllerUpsertMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobSchedulersControllerUpsertMutationKey()
        return mutationOptions<JobSchedulersControllerUpsertMutationResponse, ResponseErrorConfig<Error>, {id: JobSchedulersControllerUpsertPathParams["id"], data: JobSchedulersControllerUpsertMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return jobSchedulersControllerUpsert(id, data, config)
          },
        })

}

/**
 * @summary Upsert a job scheduler
 * {@link /job-schedulers/:id}
 */
export function useJobSchedulersControllerUpsert<TContext>(options: 
{
  mutation?: UseMutationOptions<JobSchedulersControllerUpsertMutationResponse, ResponseErrorConfig<Error>, {id: JobSchedulersControllerUpsertPathParams["id"], data: JobSchedulersControllerUpsertMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobSchedulersControllerUpsertMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobSchedulersControllerUpsertMutationKey()

          const baseOptions = jobSchedulersControllerUpsertMutationOptions(config) as UseMutationOptions<JobSchedulersControllerUpsertMutationResponse, ResponseErrorConfig<Error>, {id: JobSchedulersControllerUpsertPathParams["id"], data: JobSchedulersControllerUpsertMutationRequest}, TContext>
          

          return useMutation<JobSchedulersControllerUpsertMutationResponse, ResponseErrorConfig<Error>, {id: JobSchedulersControllerUpsertPathParams["id"], data: JobSchedulersControllerUpsertMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobSchedulersControllerUpsertMutationResponse, ResponseErrorConfig<Error>, {id: JobSchedulersControllerUpsertPathParams["id"], data: JobSchedulersControllerUpsertMutationRequest}, TContext>
      
}

export const jobSchedulersControllerUpdateMutationKey = () => [{ url: '/job-schedulers/:id' }] as const

export type JobSchedulersControllerUpdateMutationKey = ReturnType<typeof jobSchedulersControllerUpdateMutationKey>

export function jobSchedulersControllerUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobSchedulersControllerUpdateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobSchedulersControllerUpdateMutationKey()
        return mutationOptions<JobSchedulersControllerUpdateMutationResponse, ResponseErrorConfig<JobSchedulersControllerUpdate404>, {id: JobSchedulersControllerUpdatePathParams["id"], data: JobSchedulersControllerUpdateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return jobSchedulersControllerUpdate(id, data, config)
          },
        })

}

/**
 * @summary Update a job scheduler
 * {@link /job-schedulers/:id}
 */
export function useJobSchedulersControllerUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<JobSchedulersControllerUpdateMutationResponse, ResponseErrorConfig<JobSchedulersControllerUpdate404>, {id: JobSchedulersControllerUpdatePathParams["id"], data: JobSchedulersControllerUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobSchedulersControllerUpdateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobSchedulersControllerUpdateMutationKey()

          const baseOptions = jobSchedulersControllerUpdateMutationOptions(config) as UseMutationOptions<JobSchedulersControllerUpdateMutationResponse, ResponseErrorConfig<JobSchedulersControllerUpdate404>, {id: JobSchedulersControllerUpdatePathParams["id"], data: JobSchedulersControllerUpdateMutationRequest}, TContext>
          

          return useMutation<JobSchedulersControllerUpdateMutationResponse, ResponseErrorConfig<JobSchedulersControllerUpdate404>, {id: JobSchedulersControllerUpdatePathParams["id"], data: JobSchedulersControllerUpdateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobSchedulersControllerUpdateMutationResponse, ResponseErrorConfig<JobSchedulersControllerUpdate404>, {id: JobSchedulersControllerUpdatePathParams["id"], data: JobSchedulersControllerUpdateMutationRequest}, TContext>
      
}

export const jobSchedulersControllerDeleteMutationKey = () => [{ url: '/job-schedulers/:id' }] as const

export type JobSchedulersControllerDeleteMutationKey = ReturnType<typeof jobSchedulersControllerDeleteMutationKey>

export function jobSchedulersControllerDeleteMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = jobSchedulersControllerDeleteMutationKey()
        return mutationOptions<JobSchedulersControllerDeleteMutationResponse, ResponseErrorConfig<JobSchedulersControllerDelete404>, {id: JobSchedulersControllerDeletePathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return jobSchedulersControllerDelete(id, config)
          },
        })

}

/**
 * @summary Delete a job scheduler
 * {@link /job-schedulers/:id}
 */
export function useJobSchedulersControllerDelete<TContext>(options: 
{
  mutation?: UseMutationOptions<JobSchedulersControllerDeleteMutationResponse, ResponseErrorConfig<JobSchedulersControllerDelete404>, {id: JobSchedulersControllerDeletePathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobSchedulersControllerDeleteMutationKey()

          const baseOptions = jobSchedulersControllerDeleteMutationOptions(config) as UseMutationOptions<JobSchedulersControllerDeleteMutationResponse, ResponseErrorConfig<JobSchedulersControllerDelete404>, {id: JobSchedulersControllerDeletePathParams["id"]}, TContext>
          

          return useMutation<JobSchedulersControllerDeleteMutationResponse, ResponseErrorConfig<JobSchedulersControllerDelete404>, {id: JobSchedulersControllerDeletePathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobSchedulersControllerDeleteMutationResponse, ResponseErrorConfig<JobSchedulersControllerDelete404>, {id: JobSchedulersControllerDeletePathParams["id"]}, TContext>
      
}

export const jobsControllerCreateJobMutationKey = () => [{ url: '/jobs' }] as const

export type JobsControllerCreateJobMutationKey = ReturnType<typeof jobsControllerCreateJobMutationKey>

export function jobsControllerCreateJobMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobsControllerCreateJobMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobsControllerCreateJobMutationKey()
        return mutationOptions<JobsControllerCreateJobMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return jobsControllerCreateJob(data, config)
          },
        })

}

/**
 * @summary Create new job
 * {@link /jobs}
 */
export function useJobsControllerCreateJob<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerCreateJobMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerCreateJobMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerCreateJobMutationKey()

          const baseOptions = jobsControllerCreateJobMutationOptions(config) as UseMutationOptions<JobsControllerCreateJobMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobMutationRequest}, TContext>
          

          return useMutation<JobsControllerCreateJobMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerCreateJobMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobMutationRequest}, TContext>
      
}

export const jobsControllerCreateJobsMutationKey = () => [{ url: '/jobs/batch' }] as const

export type JobsControllerCreateJobsMutationKey = ReturnType<typeof jobsControllerCreateJobsMutationKey>

export function jobsControllerCreateJobsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobsControllerCreateJobsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobsControllerCreateJobsMutationKey()
        return mutationOptions<JobsControllerCreateJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return jobsControllerCreateJobs(data, config)
          },
        })

}

/**
 * @summary Batch create jobs sharing the same service, command and options
 * {@link /jobs/batch}
 */
export function useJobsControllerCreateJobs<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerCreateJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerCreateJobsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerCreateJobsMutationKey()

          const baseOptions = jobsControllerCreateJobsMutationOptions(config) as UseMutationOptions<JobsControllerCreateJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobsMutationRequest}, TContext>
          

          return useMutation<JobsControllerCreateJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerCreateJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCreateJobsMutationRequest}, TContext>
      
}

export const jobsControllerUpdateJobMutationKey = () => [{ url: '/jobs/:id' }] as const

export type JobsControllerUpdateJobMutationKey = ReturnType<typeof jobsControllerUpdateJobMutationKey>

export function jobsControllerUpdateJobMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobsControllerUpdateJobMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobsControllerUpdateJobMutationKey()
        return mutationOptions<JobsControllerUpdateJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerUpdateJobPathParams["id"], data: JobsControllerUpdateJobMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return jobsControllerUpdateJob(id, data, config)
          },
        })

}

/**
 * @summary Update job
 * {@link /jobs/:id}
 */
export function useJobsControllerUpdateJob<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerUpdateJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerUpdateJobPathParams["id"], data: JobsControllerUpdateJobMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerUpdateJobMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerUpdateJobMutationKey()

          const baseOptions = jobsControllerUpdateJobMutationOptions(config) as UseMutationOptions<JobsControllerUpdateJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerUpdateJobPathParams["id"], data: JobsControllerUpdateJobMutationRequest}, TContext>
          

          return useMutation<JobsControllerUpdateJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerUpdateJobPathParams["id"], data: JobsControllerUpdateJobMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerUpdateJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerUpdateJobPathParams["id"], data: JobsControllerUpdateJobMutationRequest}, TContext>
      
}

export const jobsControllerCancelJobMutationKey = () => [{ url: '/jobs/:id' }] as const

export type JobsControllerCancelJobMutationKey = ReturnType<typeof jobsControllerCancelJobMutationKey>

export function jobsControllerCancelJobMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = jobsControllerCancelJobMutationKey()
        return mutationOptions<JobsControllerCancelJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerCancelJobPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return jobsControllerCancelJob(id, config)
          },
        })

}

/**
 * @summary Cancel job
 * {@link /jobs/:id}
 */
export function useJobsControllerCancelJob<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerCancelJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerCancelJobPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerCancelJobMutationKey()

          const baseOptions = jobsControllerCancelJobMutationOptions(config) as UseMutationOptions<JobsControllerCancelJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerCancelJobPathParams["id"]}, TContext>
          

          return useMutation<JobsControllerCancelJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerCancelJobPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerCancelJobMutationResponse, ResponseErrorConfig<Error>, {id: JobsControllerCancelJobPathParams["id"]}, TContext>
      
}

export const jobsControllerCancelJobsMutationKey = () => [{ url: '/jobs/cancel' }] as const

export type JobsControllerCancelJobsMutationKey = ReturnType<typeof jobsControllerCancelJobsMutationKey>

export function jobsControllerCancelJobsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobsControllerCancelJobsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobsControllerCancelJobsMutationKey()
        return mutationOptions<JobsControllerCancelJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCancelJobsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return jobsControllerCancelJobs(data, config)
          },
        })

}

/**
 * @summary Cancel multiple jobs
 * {@link /jobs/cancel}
 */
export function useJobsControllerCancelJobs<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerCancelJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCancelJobsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerCancelJobsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerCancelJobsMutationKey()

          const baseOptions = jobsControllerCancelJobsMutationOptions(config) as UseMutationOptions<JobsControllerCancelJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCancelJobsMutationRequest}, TContext>
          

          return useMutation<JobsControllerCancelJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCancelJobsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerCancelJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerCancelJobsMutationRequest}, TContext>
      
}

export const jobsControllerRetryJobsMutationKey = () => [{ url: '/jobs/retry' }] as const

export type JobsControllerRetryJobsMutationKey = ReturnType<typeof jobsControllerRetryJobsMutationKey>

export function jobsControllerRetryJobsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<JobsControllerRetryJobsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = jobsControllerRetryJobsMutationKey()
        return mutationOptions<JobsControllerRetryJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerRetryJobsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return jobsControllerRetryJobs(data, config)
          },
        })

}

/**
 * @summary Retry jobs
 * {@link /jobs/retry}
 */
export function useJobsControllerRetryJobs<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerRetryJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerRetryJobsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<JobsControllerRetryJobsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerRetryJobsMutationKey()

          const baseOptions = jobsControllerRetryJobsMutationOptions(config) as UseMutationOptions<JobsControllerRetryJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerRetryJobsMutationRequest}, TContext>
          

          return useMutation<JobsControllerRetryJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerRetryJobsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerRetryJobsMutationResponse, ResponseErrorConfig<Error>, {data: JobsControllerRetryJobsMutationRequest}, TContext>
      
}

export const jobsControllerClearJobsDataMutationKey = () => [{ url: '/jobs/clear-jobs-data' }] as const

export type JobsControllerClearJobsDataMutationKey = ReturnType<typeof jobsControllerClearJobsDataMutationKey>

export function jobsControllerClearJobsDataMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = jobsControllerClearJobsDataMutationKey()
        return mutationOptions<JobsControllerClearJobsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return jobsControllerClearJobsData(config)
          },
        })

}

/**
 * @summary Clear jobs data
 * {@link /jobs/clear-jobs-data}
 */
export function useJobsControllerClearJobsData<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerClearJobsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerClearJobsDataMutationKey()

          const baseOptions = jobsControllerClearJobsDataMutationOptions(config) as UseMutationOptions<JobsControllerClearJobsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<JobsControllerClearJobsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerClearJobsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const jobsControllerClearWorkflowsDataMutationKey = () => [{ url: '/jobs/clear-workflows-data' }] as const

export type JobsControllerClearWorkflowsDataMutationKey = ReturnType<typeof jobsControllerClearWorkflowsDataMutationKey>

export function jobsControllerClearWorkflowsDataMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = jobsControllerClearWorkflowsDataMutationKey()
        return mutationOptions<JobsControllerClearWorkflowsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return jobsControllerClearWorkflowsData(config)
          },
        })

}

/**
 * @summary Clear workflows data
 * {@link /jobs/clear-workflows-data}
 */
export function useJobsControllerClearWorkflowsData<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerClearWorkflowsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerClearWorkflowsDataMutationKey()

          const baseOptions = jobsControllerClearWorkflowsDataMutationOptions(config) as UseMutationOptions<JobsControllerClearWorkflowsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<JobsControllerClearWorkflowsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerClearWorkflowsDataMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const jobsControllerCancelPushProjectionJobsMutationKey = () => [{ url: '/jobs/cancel-push-projection-jobs' }] as const

export type JobsControllerCancelPushProjectionJobsMutationKey = ReturnType<typeof jobsControllerCancelPushProjectionJobsMutationKey>

export function jobsControllerCancelPushProjectionJobsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = jobsControllerCancelPushProjectionJobsMutationKey()
        return mutationOptions<JobsControllerCancelPushProjectionJobsMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return jobsControllerCancelPushProjectionJobs(config)
          },
        })

}

/**
 * @summary Hotfix: cancel all projection jobs
 * {@link /jobs/cancel-push-projection-jobs}
 */
export function useJobsControllerCancelPushProjectionJobs<TContext>(options: 
{
  mutation?: UseMutationOptions<JobsControllerCancelPushProjectionJobsMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? jobsControllerCancelPushProjectionJobsMutationKey()

          const baseOptions = jobsControllerCancelPushProjectionJobsMutationOptions(config) as UseMutationOptions<JobsControllerCancelPushProjectionJobsMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<JobsControllerCancelPushProjectionJobsMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<JobsControllerCancelPushProjectionJobsMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const queueManagementControllerPauseMutationKey = () => [{ url: '/queues/pause' }] as const

export type QueueManagementControllerPauseMutationKey = ReturnType<typeof queueManagementControllerPauseMutationKey>

export function queueManagementControllerPauseMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = queueManagementControllerPauseMutationKey()
        return mutationOptions<QueueManagementControllerPauseMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return queueManagementControllerPause(config)
          },
        })

}

/**
 * @summary Pause all BullMQ queues
 * {@link /queues/pause}
 */
export function useQueueManagementControllerPause<TContext>(options: 
{
  mutation?: UseMutationOptions<QueueManagementControllerPauseMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? queueManagementControllerPauseMutationKey()

          const baseOptions = queueManagementControllerPauseMutationOptions(config) as UseMutationOptions<QueueManagementControllerPauseMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<QueueManagementControllerPauseMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<QueueManagementControllerPauseMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const queueManagementControllerResumeMutationKey = () => [{ url: '/queues/resume' }] as const

export type QueueManagementControllerResumeMutationKey = ReturnType<typeof queueManagementControllerResumeMutationKey>

export function queueManagementControllerResumeMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = queueManagementControllerResumeMutationKey()
        return mutationOptions<QueueManagementControllerResumeMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return queueManagementControllerResume(config)
          },
        })

}

/**
 * @summary Resume all BullMQ queues
 * {@link /queues/resume}
 */
export function useQueueManagementControllerResume<TContext>(options: 
{
  mutation?: UseMutationOptions<QueueManagementControllerResumeMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? queueManagementControllerResumeMutationKey()

          const baseOptions = queueManagementControllerResumeMutationOptions(config) as UseMutationOptions<QueueManagementControllerResumeMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<QueueManagementControllerResumeMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<QueueManagementControllerResumeMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const queueManagementControllerPauseSingleMutationKey = () => [{ url: '/queues/:queueName/pause' }] as const

export type QueueManagementControllerPauseSingleMutationKey = ReturnType<typeof queueManagementControllerPauseSingleMutationKey>

export function queueManagementControllerPauseSingleMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = queueManagementControllerPauseSingleMutationKey()
        return mutationOptions<QueueManagementControllerPauseSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerPauseSinglePathParams["queueName"]}, TContext>({
          mutationKey,
          mutationFn: async({ queueName }) => {
            return queueManagementControllerPauseSingle(queueName, config)
          },
        })

}

/**
 * @summary Pause a single BullMQ queue by name
 * {@link /queues/:queueName/pause}
 */
export function useQueueManagementControllerPauseSingle<TContext>(options: 
{
  mutation?: UseMutationOptions<QueueManagementControllerPauseSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerPauseSinglePathParams["queueName"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? queueManagementControllerPauseSingleMutationKey()

          const baseOptions = queueManagementControllerPauseSingleMutationOptions(config) as UseMutationOptions<QueueManagementControllerPauseSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerPauseSinglePathParams["queueName"]}, TContext>
          

          return useMutation<QueueManagementControllerPauseSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerPauseSinglePathParams["queueName"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<QueueManagementControllerPauseSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerPauseSinglePathParams["queueName"]}, TContext>
      
}

export const queueManagementControllerResumeSingleMutationKey = () => [{ url: '/queues/:queueName/resume' }] as const

export type QueueManagementControllerResumeSingleMutationKey = ReturnType<typeof queueManagementControllerResumeSingleMutationKey>

export function queueManagementControllerResumeSingleMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = queueManagementControllerResumeSingleMutationKey()
        return mutationOptions<QueueManagementControllerResumeSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerResumeSinglePathParams["queueName"]}, TContext>({
          mutationKey,
          mutationFn: async({ queueName }) => {
            return queueManagementControllerResumeSingle(queueName, config)
          },
        })

}

/**
 * @summary Resume a single BullMQ queue by name
 * {@link /queues/:queueName/resume}
 */
export function useQueueManagementControllerResumeSingle<TContext>(options: 
{
  mutation?: UseMutationOptions<QueueManagementControllerResumeSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerResumeSinglePathParams["queueName"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? queueManagementControllerResumeSingleMutationKey()

          const baseOptions = queueManagementControllerResumeSingleMutationOptions(config) as UseMutationOptions<QueueManagementControllerResumeSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerResumeSinglePathParams["queueName"]}, TContext>
          

          return useMutation<QueueManagementControllerResumeSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerResumeSinglePathParams["queueName"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<QueueManagementControllerResumeSingleMutationResponse, ResponseErrorConfig<Error>, {queueName: QueueManagementControllerResumeSinglePathParams["queueName"]}, TContext>
      
}

export const legacyDocumentsControllerGenerateDocumentOnDemandMutationKey = () => [{ url: '/generate-document-on-demand' }] as const

export type LegacyDocumentsControllerGenerateDocumentOnDemandMutationKey = ReturnType<typeof legacyDocumentsControllerGenerateDocumentOnDemandMutationKey>

export function legacyDocumentsControllerGenerateDocumentOnDemandMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = legacyDocumentsControllerGenerateDocumentOnDemandMutationKey()
        return mutationOptions<LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404>, {data: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return legacyDocumentsControllerGenerateDocumentOnDemand(data, config)
          },
        })

}

/**
 * @description A policyholder reaches only the configs flagged `generateOnDemandByPolicyholder`. The audience follows the role the caller was authorized on, never the body.
 * @summary Generate an on-demand document
 * {@link /generate-document-on-demand}
 */
export function useLegacyDocumentsControllerGenerateDocumentOnDemand<TContext>(options: 
{
  mutation?: UseMutationOptions<LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404>, {data: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? legacyDocumentsControllerGenerateDocumentOnDemandMutationKey()

          const baseOptions = legacyDocumentsControllerGenerateDocumentOnDemandMutationOptions(config) as UseMutationOptions<LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404>, {data: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest}, TContext>
          

          return useMutation<LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404>, {data: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LegacyDocumentsControllerGenerateDocumentOnDemandMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGenerateDocumentOnDemand400 | LegacyDocumentsControllerGenerateDocumentOnDemand404>, {data: LegacyDocumentsControllerGenerateDocumentOnDemandMutationRequest}, TContext>
      
}

export const legacyDocumentsControllerGetGenerationPayloadMutationKey = () => [{ url: '/debug/generate-document-payload' }] as const

export type LegacyDocumentsControllerGetGenerationPayloadMutationKey = ReturnType<typeof legacyDocumentsControllerGetGenerationPayloadMutationKey>

export function legacyDocumentsControllerGetGenerationPayloadMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LegacyDocumentsControllerGetGenerationPayloadMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = legacyDocumentsControllerGetGenerationPayloadMutationKey()
        return mutationOptions<LegacyDocumentsControllerGetGenerationPayloadMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404>, {data: LegacyDocumentsControllerGetGenerationPayloadMutationRequest, params: LegacyDocumentsControllerGetGenerationPayloadQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return legacyDocumentsControllerGetGenerationPayload(data, params, config)
          },
        })

}

/**
 * {@link /debug/generate-document-payload}
 */
export function useLegacyDocumentsControllerGetGenerationPayload<TContext>(options: 
{
  mutation?: UseMutationOptions<LegacyDocumentsControllerGetGenerationPayloadMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404>, {data: LegacyDocumentsControllerGetGenerationPayloadMutationRequest, params: LegacyDocumentsControllerGetGenerationPayloadQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LegacyDocumentsControllerGetGenerationPayloadMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? legacyDocumentsControllerGetGenerationPayloadMutationKey()

          const baseOptions = legacyDocumentsControllerGetGenerationPayloadMutationOptions(config) as UseMutationOptions<LegacyDocumentsControllerGetGenerationPayloadMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404>, {data: LegacyDocumentsControllerGetGenerationPayloadMutationRequest, params: LegacyDocumentsControllerGetGenerationPayloadQueryParams}, TContext>
          

          return useMutation<LegacyDocumentsControllerGetGenerationPayloadMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404>, {data: LegacyDocumentsControllerGetGenerationPayloadMutationRequest, params: LegacyDocumentsControllerGetGenerationPayloadQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LegacyDocumentsControllerGetGenerationPayloadMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerGetGenerationPayload400 | LegacyDocumentsControllerGetGenerationPayload404>, {data: LegacyDocumentsControllerGetGenerationPayloadMutationRequest, params: LegacyDocumentsControllerGetGenerationPayloadQueryParams}, TContext>
      
}

export const legacyDocumentsControllerRegenerateDocumentMutationKey = () => [{ url: '/admin/regenerate-document' }] as const

export type LegacyDocumentsControllerRegenerateDocumentMutationKey = ReturnType<typeof legacyDocumentsControllerRegenerateDocumentMutationKey>

export function legacyDocumentsControllerRegenerateDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LegacyDocumentsControllerRegenerateDocumentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = legacyDocumentsControllerRegenerateDocumentMutationKey()
        return mutationOptions<LegacyDocumentsControllerRegenerateDocumentMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500>, {data: LegacyDocumentsControllerRegenerateDocumentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return legacyDocumentsControllerRegenerateDocument(data, config)
          },
        })

}

/**
 * @summary Regenerate a corrupted document (Super admin only)
 * {@link /admin/regenerate-document}
 */
export function useLegacyDocumentsControllerRegenerateDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<LegacyDocumentsControllerRegenerateDocumentMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500>, {data: LegacyDocumentsControllerRegenerateDocumentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LegacyDocumentsControllerRegenerateDocumentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? legacyDocumentsControllerRegenerateDocumentMutationKey()

          const baseOptions = legacyDocumentsControllerRegenerateDocumentMutationOptions(config) as UseMutationOptions<LegacyDocumentsControllerRegenerateDocumentMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500>, {data: LegacyDocumentsControllerRegenerateDocumentMutationRequest}, TContext>
          

          return useMutation<LegacyDocumentsControllerRegenerateDocumentMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500>, {data: LegacyDocumentsControllerRegenerateDocumentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LegacyDocumentsControllerRegenerateDocumentMutationResponse, ResponseErrorConfig<LegacyDocumentsControllerRegenerateDocument404 | LegacyDocumentsControllerRegenerateDocument500>, {data: LegacyDocumentsControllerRegenerateDocumentMutationRequest}, TContext>
      
}

export const lockControllerDeleteLockMutationKey = () => [{ url: '/locks/:id' }] as const

export type LockControllerDeleteLockMutationKey = ReturnType<typeof lockControllerDeleteLockMutationKey>

export function lockControllerDeleteLockMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = lockControllerDeleteLockMutationKey()
        return mutationOptions<LockControllerDeleteLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerDeleteLockPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return lockControllerDeleteLock(id, config)
          },
        })

}

/**
 * {@link /locks/:id}
 */
export function useLockControllerDeleteLock<TContext>(options: 
{
  mutation?: UseMutationOptions<LockControllerDeleteLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerDeleteLockPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? lockControllerDeleteLockMutationKey()

          const baseOptions = lockControllerDeleteLockMutationOptions(config) as UseMutationOptions<LockControllerDeleteLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerDeleteLockPathParams["id"]}, TContext>
          

          return useMutation<LockControllerDeleteLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerDeleteLockPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LockControllerDeleteLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerDeleteLockPathParams["id"]}, TContext>
      
}

export const lockControllerCreateLockMutationKey = () => [{ url: '/locks/:id' }] as const

export type LockControllerCreateLockMutationKey = ReturnType<typeof lockControllerCreateLockMutationKey>

export function lockControllerCreateLockMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LockControllerCreateLockMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = lockControllerCreateLockMutationKey()
        return mutationOptions<LockControllerCreateLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerCreateLockPathParams["id"], data?: LockControllerCreateLockMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return lockControllerCreateLock(id, data, config)
          },
        })

}

/**
 * {@link /locks/:id}
 */
export function useLockControllerCreateLock<TContext>(options: 
{
  mutation?: UseMutationOptions<LockControllerCreateLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerCreateLockPathParams["id"], data?: LockControllerCreateLockMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LockControllerCreateLockMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? lockControllerCreateLockMutationKey()

          const baseOptions = lockControllerCreateLockMutationOptions(config) as UseMutationOptions<LockControllerCreateLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerCreateLockPathParams["id"], data?: LockControllerCreateLockMutationRequest}, TContext>
          

          return useMutation<LockControllerCreateLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerCreateLockPathParams["id"], data?: LockControllerCreateLockMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LockControllerCreateLockMutationResponse, ResponseErrorConfig<Error>, {id: LockControllerCreateLockPathParams["id"], data?: LockControllerCreateLockMutationRequest}, TContext>
      
}

export const lockControllerBatchCreateLocksMutationKey = () => [{ url: '/locks/batch' }] as const

export type LockControllerBatchCreateLocksMutationKey = ReturnType<typeof lockControllerBatchCreateLocksMutationKey>

export function lockControllerBatchCreateLocksMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LockControllerBatchCreateLocksMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = lockControllerBatchCreateLocksMutationKey()
        return mutationOptions<LockControllerBatchCreateLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchCreateLocksMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return lockControllerBatchCreateLocks(data, config)
          },
        })

}

/**
 * @description Generic over what is held: the caller composes each `<entityId>:BILLING` or `<entityId>:PAYMENT` id, exactly as for the single-lock route. Every lock records the same reason. An id already held is reported as `ALREADY_LOCKED` and left untouched rather than failing the batch.
 * @summary Take several locks at once
 * {@link /locks/batch}
 */
export function useLockControllerBatchCreateLocks<TContext>(options: 
{
  mutation?: UseMutationOptions<LockControllerBatchCreateLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchCreateLocksMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LockControllerBatchCreateLocksMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? lockControllerBatchCreateLocksMutationKey()

          const baseOptions = lockControllerBatchCreateLocksMutationOptions(config) as UseMutationOptions<LockControllerBatchCreateLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchCreateLocksMutationRequest}, TContext>
          

          return useMutation<LockControllerBatchCreateLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchCreateLocksMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LockControllerBatchCreateLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchCreateLocksMutationRequest}, TContext>
      
}

export const lockControllerBatchGetLocksMutationKey = () => [{ url: '/locks/batch/get' }] as const

export type LockControllerBatchGetLocksMutationKey = ReturnType<typeof lockControllerBatchGetLocksMutationKey>

export function lockControllerBatchGetLocksMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LockControllerBatchGetLocksMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = lockControllerBatchGetLocksMutationKey()
        return mutationOptions<LockControllerBatchGetLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchGetLocksMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return lockControllerBatchGetLocks(data, config)
          },
        })

}

/**
 * @description What is holding each id, so a caller can show an operator the reasons before releasing them. Only held ids come back: anything absent from the response is free.
 * @summary Read several locks by id
 * {@link /locks/batch/get}
 */
export function useLockControllerBatchGetLocks<TContext>(options: 
{
  mutation?: UseMutationOptions<LockControllerBatchGetLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchGetLocksMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LockControllerBatchGetLocksMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? lockControllerBatchGetLocksMutationKey()

          const baseOptions = lockControllerBatchGetLocksMutationOptions(config) as UseMutationOptions<LockControllerBatchGetLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchGetLocksMutationRequest}, TContext>
          

          return useMutation<LockControllerBatchGetLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchGetLocksMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LockControllerBatchGetLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchGetLocksMutationRequest}, TContext>
      
}

export const lockControllerBatchDeleteLocksMutationKey = () => [{ url: '/locks/batch/delete' }] as const

export type LockControllerBatchDeleteLocksMutationKey = ReturnType<typeof lockControllerBatchDeleteLocksMutationKey>

export function lockControllerBatchDeleteLocksMutationOptions<TContext = unknown>(config: Partial<RequestConfig<LockControllerBatchDeleteLocksMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = lockControllerBatchDeleteLocksMutationKey()
        return mutationOptions<LockControllerBatchDeleteLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchDeleteLocksMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return lockControllerBatchDeleteLocks(data, config)
          },
        })

}

/**
 * @description The mirror of the batch-lock route. Each entry names the hold to release and when it was taken, from the batch-get that preceded it, so a hold released and retaken meanwhile comes back `STALE` rather than being released out from under whoever took it. An id nothing is holding is `NOT_LOCKED` and left alone rather than failing the batch.
 * @summary Release several locks at once
 * {@link /locks/batch/delete}
 */
export function useLockControllerBatchDeleteLocks<TContext>(options: 
{
  mutation?: UseMutationOptions<LockControllerBatchDeleteLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchDeleteLocksMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<LockControllerBatchDeleteLocksMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? lockControllerBatchDeleteLocksMutationKey()

          const baseOptions = lockControllerBatchDeleteLocksMutationOptions(config) as UseMutationOptions<LockControllerBatchDeleteLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchDeleteLocksMutationRequest}, TContext>
          

          return useMutation<LockControllerBatchDeleteLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchDeleteLocksMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<LockControllerBatchDeleteLocksMutationResponse, ResponseErrorConfig<Error>, {data: LockControllerBatchDeleteLocksMutationRequest}, TContext>
      
}

export const notificationControllerSendEmailMutationKey = () => [{ url: '/notifications/emails/send' }] as const

export type NotificationControllerSendEmailMutationKey = ReturnType<typeof notificationControllerSendEmailMutationKey>

export function notificationControllerSendEmailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<NotificationControllerSendEmailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = notificationControllerSendEmailMutationKey()
        return mutationOptions<NotificationControllerSendEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendEmail400>, {data: NotificationControllerSendEmailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return notificationControllerSendEmail(data, config)
          },
        })

}

/**
 * @summary Send transactional email
 * {@link /notifications/emails/send}
 */
export function useNotificationControllerSendEmail<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerSendEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendEmail400>, {data: NotificationControllerSendEmailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<NotificationControllerSendEmailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerSendEmailMutationKey()

          const baseOptions = notificationControllerSendEmailMutationOptions(config) as UseMutationOptions<NotificationControllerSendEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendEmail400>, {data: NotificationControllerSendEmailMutationRequest}, TContext>
          

          return useMutation<NotificationControllerSendEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendEmail400>, {data: NotificationControllerSendEmailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerSendEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendEmail400>, {data: NotificationControllerSendEmailMutationRequest}, TContext>
      
}

export const notificationControllerRenderEmailTemplateMutationKey = () => [{ url: '/notifications/email-templates/:key/render' }] as const

export type NotificationControllerRenderEmailTemplateMutationKey = ReturnType<typeof notificationControllerRenderEmailTemplateMutationKey>

export function notificationControllerRenderEmailTemplateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<NotificationControllerRenderEmailTemplateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = notificationControllerRenderEmailTemplateMutationKey()
        return mutationOptions<NotificationControllerRenderEmailTemplateMutationResponse, ResponseErrorConfig<NotificationControllerRenderEmailTemplate404>, {key: NotificationControllerRenderEmailTemplatePathParams["key"], data: NotificationControllerRenderEmailTemplateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ key, data }) => {
            return notificationControllerRenderEmailTemplate(key, data, config)
          },
        })

}

/**
 * @summary Render an in-repo email template
 * {@link /notifications/email-templates/:key/render}
 */
export function useNotificationControllerRenderEmailTemplate<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerRenderEmailTemplateMutationResponse, ResponseErrorConfig<NotificationControllerRenderEmailTemplate404>, {key: NotificationControllerRenderEmailTemplatePathParams["key"], data: NotificationControllerRenderEmailTemplateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<NotificationControllerRenderEmailTemplateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerRenderEmailTemplateMutationKey()

          const baseOptions = notificationControllerRenderEmailTemplateMutationOptions(config) as UseMutationOptions<NotificationControllerRenderEmailTemplateMutationResponse, ResponseErrorConfig<NotificationControllerRenderEmailTemplate404>, {key: NotificationControllerRenderEmailTemplatePathParams["key"], data: NotificationControllerRenderEmailTemplateMutationRequest}, TContext>
          

          return useMutation<NotificationControllerRenderEmailTemplateMutationResponse, ResponseErrorConfig<NotificationControllerRenderEmailTemplate404>, {key: NotificationControllerRenderEmailTemplatePathParams["key"], data: NotificationControllerRenderEmailTemplateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerRenderEmailTemplateMutationResponse, ResponseErrorConfig<NotificationControllerRenderEmailTemplate404>, {key: NotificationControllerRenderEmailTemplatePathParams["key"], data: NotificationControllerRenderEmailTemplateMutationRequest}, TContext>
      
}

export const notificationControllerSendTestEmailMutationKey = () => [{ url: '/notifications/email-templates/:key/send-test' }] as const

export type NotificationControllerSendTestEmailMutationKey = ReturnType<typeof notificationControllerSendTestEmailMutationKey>

export function notificationControllerSendTestEmailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<NotificationControllerSendTestEmailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = notificationControllerSendTestEmailMutationKey()
        return mutationOptions<NotificationControllerSendTestEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendTestEmail404>, {key: NotificationControllerSendTestEmailPathParams["key"], data: NotificationControllerSendTestEmailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ key, data }) => {
            return notificationControllerSendTestEmail(key, data, config)
          },
        })

}

/**
 * @description Renders the template and delivers it to the caller's own address, resolved from the request principal — the recipient is never taken from the body.
 * @summary Send an in-repo email template to yourself
 * {@link /notifications/email-templates/:key/send-test}
 */
export function useNotificationControllerSendTestEmail<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerSendTestEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendTestEmail404>, {key: NotificationControllerSendTestEmailPathParams["key"], data: NotificationControllerSendTestEmailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<NotificationControllerSendTestEmailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerSendTestEmailMutationKey()

          const baseOptions = notificationControllerSendTestEmailMutationOptions(config) as UseMutationOptions<NotificationControllerSendTestEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendTestEmail404>, {key: NotificationControllerSendTestEmailPathParams["key"], data: NotificationControllerSendTestEmailMutationRequest}, TContext>
          

          return useMutation<NotificationControllerSendTestEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendTestEmail404>, {key: NotificationControllerSendTestEmailPathParams["key"], data: NotificationControllerSendTestEmailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerSendTestEmailMutationResponse, ResponseErrorConfig<NotificationControllerSendTestEmail404>, {key: NotificationControllerSendTestEmailPathParams["key"], data: NotificationControllerSendTestEmailMutationRequest}, TContext>
      
}

export const notificationControllerCreateNotificationMutationKey = () => [{ url: '/notifications' }] as const

export type NotificationControllerCreateNotificationMutationKey = ReturnType<typeof notificationControllerCreateNotificationMutationKey>

export function notificationControllerCreateNotificationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<NotificationControllerCreateNotificationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = notificationControllerCreateNotificationMutationKey()
        return mutationOptions<NotificationControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, {data: NotificationControllerCreateNotificationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return notificationControllerCreateNotification(data, config)
          },
        })

}

/**
 * {@link /notifications}
 */
export function useNotificationControllerCreateNotification<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, {data: NotificationControllerCreateNotificationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<NotificationControllerCreateNotificationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerCreateNotificationMutationKey()

          const baseOptions = notificationControllerCreateNotificationMutationOptions(config) as UseMutationOptions<NotificationControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, {data: NotificationControllerCreateNotificationMutationRequest}, TContext>
          

          return useMutation<NotificationControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, {data: NotificationControllerCreateNotificationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerCreateNotificationMutationResponse, ResponseErrorConfig<Error>, {data: NotificationControllerCreateNotificationMutationRequest}, TContext>
      
}

export const notificationControllerPatchNotificationMutationKey = () => [{ url: '/notifications/:id' }] as const

export type NotificationControllerPatchNotificationMutationKey = ReturnType<typeof notificationControllerPatchNotificationMutationKey>

export function notificationControllerPatchNotificationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<NotificationControllerPatchNotificationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = notificationControllerPatchNotificationMutationKey()
        return mutationOptions<NotificationControllerPatchNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerPatchNotificationPathParams["id"], data: NotificationControllerPatchNotificationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return notificationControllerPatchNotification(id, data, config)
          },
        })

}

/**
 * {@link /notifications/:id}
 */
export function useNotificationControllerPatchNotification<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerPatchNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerPatchNotificationPathParams["id"], data: NotificationControllerPatchNotificationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<NotificationControllerPatchNotificationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerPatchNotificationMutationKey()

          const baseOptions = notificationControllerPatchNotificationMutationOptions(config) as UseMutationOptions<NotificationControllerPatchNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerPatchNotificationPathParams["id"], data: NotificationControllerPatchNotificationMutationRequest}, TContext>
          

          return useMutation<NotificationControllerPatchNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerPatchNotificationPathParams["id"], data: NotificationControllerPatchNotificationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerPatchNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerPatchNotificationPathParams["id"], data: NotificationControllerPatchNotificationMutationRequest}, TContext>
      
}

export const notificationControllerDeleteNotificationMutationKey = () => [{ url: '/notifications/:id' }] as const

export type NotificationControllerDeleteNotificationMutationKey = ReturnType<typeof notificationControllerDeleteNotificationMutationKey>

export function notificationControllerDeleteNotificationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = notificationControllerDeleteNotificationMutationKey()
        return mutationOptions<NotificationControllerDeleteNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerDeleteNotificationPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return notificationControllerDeleteNotification(id, config)
          },
        })

}

/**
 * {@link /notifications/:id}
 */
export function useNotificationControllerDeleteNotification<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerDeleteNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerDeleteNotificationPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerDeleteNotificationMutationKey()

          const baseOptions = notificationControllerDeleteNotificationMutationOptions(config) as UseMutationOptions<NotificationControllerDeleteNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerDeleteNotificationPathParams["id"]}, TContext>
          

          return useMutation<NotificationControllerDeleteNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerDeleteNotificationPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerDeleteNotificationMutationResponse, ResponseErrorConfig<Error>, {id: NotificationControllerDeleteNotificationPathParams["id"]}, TContext>
      
}

export const notificationControllerSendNotificationMutationKey = () => [{ url: '/notifications/send' }] as const

export type NotificationControllerSendNotificationMutationKey = ReturnType<typeof notificationControllerSendNotificationMutationKey>

export function notificationControllerSendNotificationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<NotificationControllerSendNotificationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = notificationControllerSendNotificationMutationKey()
        return mutationOptions<NotificationControllerSendNotificationMutationResponse, ResponseErrorConfig<NotificationControllerSendNotification400>, {data: NotificationControllerSendNotificationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return notificationControllerSendNotification(data, config)
          },
        })

}

/**
 * @description Sends an electronic registered letter (ERE) about a policy, to the policy's customer or an explicit recipient. To resend one, call it again with the same reason and a corrected recipient. Asynchronous: the notification appears once the letter is sent.
 * @summary Send a notification
 * {@link /notifications/send}
 */
export function useNotificationControllerSendNotification<TContext>(options: 
{
  mutation?: UseMutationOptions<NotificationControllerSendNotificationMutationResponse, ResponseErrorConfig<NotificationControllerSendNotification400>, {data: NotificationControllerSendNotificationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<NotificationControllerSendNotificationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? notificationControllerSendNotificationMutationKey()

          const baseOptions = notificationControllerSendNotificationMutationOptions(config) as UseMutationOptions<NotificationControllerSendNotificationMutationResponse, ResponseErrorConfig<NotificationControllerSendNotification400>, {data: NotificationControllerSendNotificationMutationRequest}, TContext>
          

          return useMutation<NotificationControllerSendNotificationMutationResponse, ResponseErrorConfig<NotificationControllerSendNotification400>, {data: NotificationControllerSendNotificationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<NotificationControllerSendNotificationMutationResponse, ResponseErrorConfig<NotificationControllerSendNotification400>, {data: NotificationControllerSendNotificationMutationRequest}, TContext>
      
}

export const paymentsControllerCreateCustomerMutationKey = () => [{ url: '/payments/customers' }] as const

export type PaymentsControllerCreateCustomerMutationKey = ReturnType<typeof paymentsControllerCreateCustomerMutationKey>

export function paymentsControllerCreateCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PaymentsControllerCreateCustomerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = paymentsControllerCreateCustomerMutationKey()
        return mutationOptions<PaymentsControllerCreateCustomerMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerCreateCustomerMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return paymentsControllerCreateCustomer(data, config)
          },
        })

}

/**
 * {@link /payments/customers}
 */
export function usePaymentsControllerCreateCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentsControllerCreateCustomerMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerCreateCustomerMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PaymentsControllerCreateCustomerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentsControllerCreateCustomerMutationKey()

          const baseOptions = paymentsControllerCreateCustomerMutationOptions(config) as UseMutationOptions<PaymentsControllerCreateCustomerMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerCreateCustomerMutationRequest}, TContext>
          

          return useMutation<PaymentsControllerCreateCustomerMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerCreateCustomerMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentsControllerCreateCustomerMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerCreateCustomerMutationRequest}, TContext>
      
}

export const paymentsControllerListCustomersMutationKey = () => [{ url: '/payments/customers/list-by-metadata' }] as const

export type PaymentsControllerListCustomersMutationKey = ReturnType<typeof paymentsControllerListCustomersMutationKey>

export function paymentsControllerListCustomersMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PaymentsControllerListCustomersMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = paymentsControllerListCustomersMutationKey()
        return mutationOptions<PaymentsControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerListCustomersMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return paymentsControllerListCustomers(data, config)
          },
        })

}

/**
 * @summary List payment customers
 * {@link /payments/customers/list-by-metadata}
 */
export function usePaymentsControllerListCustomers<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentsControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerListCustomersMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PaymentsControllerListCustomersMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentsControllerListCustomersMutationKey()

          const baseOptions = paymentsControllerListCustomersMutationOptions(config) as UseMutationOptions<PaymentsControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerListCustomersMutationRequest}, TContext>
          

          return useMutation<PaymentsControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerListCustomersMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentsControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: PaymentsControllerListCustomersMutationRequest}, TContext>
      
}

export const paymentsControllerCreatePaymentMutationKey = () => [{ url: '/payments' }] as const

export type PaymentsControllerCreatePaymentMutationKey = ReturnType<typeof paymentsControllerCreatePaymentMutationKey>

export function paymentsControllerCreatePaymentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PaymentsControllerCreatePaymentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = paymentsControllerCreatePaymentMutationKey()
        return mutationOptions<PaymentsControllerCreatePaymentMutationResponse, ResponseErrorConfig<PaymentsControllerCreatePayment404>, {data: PaymentsControllerCreatePaymentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return paymentsControllerCreatePayment(data, config)
          },
        })

}

/**
 * {@link /payments}
 */
export function usePaymentsControllerCreatePayment<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentsControllerCreatePaymentMutationResponse, ResponseErrorConfig<PaymentsControllerCreatePayment404>, {data: PaymentsControllerCreatePaymentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PaymentsControllerCreatePaymentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentsControllerCreatePaymentMutationKey()

          const baseOptions = paymentsControllerCreatePaymentMutationOptions(config) as UseMutationOptions<PaymentsControllerCreatePaymentMutationResponse, ResponseErrorConfig<PaymentsControllerCreatePayment404>, {data: PaymentsControllerCreatePaymentMutationRequest}, TContext>
          

          return useMutation<PaymentsControllerCreatePaymentMutationResponse, ResponseErrorConfig<PaymentsControllerCreatePayment404>, {data: PaymentsControllerCreatePaymentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentsControllerCreatePaymentMutationResponse, ResponseErrorConfig<PaymentsControllerCreatePayment404>, {data: PaymentsControllerCreatePaymentMutationRequest}, TContext>
      
}

export const paymentsControllerSetupIntentMutationKey = () => [{ url: '/payments/setup-payment-method' }] as const

export type PaymentsControllerSetupIntentMutationKey = ReturnType<typeof paymentsControllerSetupIntentMutationKey>

export function paymentsControllerSetupIntentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PaymentsControllerSetupIntentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = paymentsControllerSetupIntentMutationKey()
        return mutationOptions<PaymentsControllerSetupIntentMutationResponse, ResponseErrorConfig<PaymentsControllerSetupIntent404>, {data: PaymentsControllerSetupIntentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return paymentsControllerSetupIntent(data, config)
          },
        })

}

/**
 * {@link /payments/setup-payment-method}
 */
export function usePaymentsControllerSetupIntent<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentsControllerSetupIntentMutationResponse, ResponseErrorConfig<PaymentsControllerSetupIntent404>, {data: PaymentsControllerSetupIntentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PaymentsControllerSetupIntentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentsControllerSetupIntentMutationKey()

          const baseOptions = paymentsControllerSetupIntentMutationOptions(config) as UseMutationOptions<PaymentsControllerSetupIntentMutationResponse, ResponseErrorConfig<PaymentsControllerSetupIntent404>, {data: PaymentsControllerSetupIntentMutationRequest}, TContext>
          

          return useMutation<PaymentsControllerSetupIntentMutationResponse, ResponseErrorConfig<PaymentsControllerSetupIntent404>, {data: PaymentsControllerSetupIntentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentsControllerSetupIntentMutationResponse, ResponseErrorConfig<PaymentsControllerSetupIntent404>, {data: PaymentsControllerSetupIntentMutationRequest}, TContext>
      
}

export const paymentsControllerCancelPaymentMutationKey = () => [{ url: '/payments/:paymentId/cancel' }] as const

export type PaymentsControllerCancelPaymentMutationKey = ReturnType<typeof paymentsControllerCancelPaymentMutationKey>

export function paymentsControllerCancelPaymentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PaymentsControllerCancelPaymentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = paymentsControllerCancelPaymentMutationKey()
        return mutationOptions<PaymentsControllerCancelPaymentMutationResponse, ResponseErrorConfig<Error>, {paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"], data: PaymentsControllerCancelPaymentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ paymentId, data }) => {
            return paymentsControllerCancelPayment(paymentId, data, config)
          },
        })

}

/**
 * @summary Cancel a payment
 * {@link /payments/:paymentId/cancel}
 */
export function usePaymentsControllerCancelPayment<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentsControllerCancelPaymentMutationResponse, ResponseErrorConfig<Error>, {paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"], data: PaymentsControllerCancelPaymentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PaymentsControllerCancelPaymentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentsControllerCancelPaymentMutationKey()

          const baseOptions = paymentsControllerCancelPaymentMutationOptions(config) as UseMutationOptions<PaymentsControllerCancelPaymentMutationResponse, ResponseErrorConfig<Error>, {paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"], data: PaymentsControllerCancelPaymentMutationRequest}, TContext>
          

          return useMutation<PaymentsControllerCancelPaymentMutationResponse, ResponseErrorConfig<Error>, {paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"], data: PaymentsControllerCancelPaymentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentsControllerCancelPaymentMutationResponse, ResponseErrorConfig<Error>, {paymentId: PaymentsControllerCancelPaymentPathParams["paymentId"], data: PaymentsControllerCancelPaymentMutationRequest}, TContext>
      
}

export const paymentsControllerSoftDeletePaymentMethodMutationKey = () => [{ url: '/payments/payment-methods/:paymentMethodId' }] as const

export type PaymentsControllerSoftDeletePaymentMethodMutationKey = ReturnType<typeof paymentsControllerSoftDeletePaymentMethodMutationKey>

export function paymentsControllerSoftDeletePaymentMethodMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = paymentsControllerSoftDeletePaymentMethodMutationKey()
        return mutationOptions<PaymentsControllerSoftDeletePaymentMethodMutationResponse, ResponseErrorConfig<Error>, {paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>({
          mutationKey,
          mutationFn: async({ paymentMethodId }) => {
            return paymentsControllerSoftDeletePaymentMethod(paymentMethodId, config)
          },
        })

}

/**
 * @summary Soft-delete a payment method (excludes it from billing)
 * {@link /payments/payment-methods/:paymentMethodId}
 */
export function usePaymentsControllerSoftDeletePaymentMethod<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentsControllerSoftDeletePaymentMethodMutationResponse, ResponseErrorConfig<Error>, {paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentsControllerSoftDeletePaymentMethodMutationKey()

          const baseOptions = paymentsControllerSoftDeletePaymentMethodMutationOptions(config) as UseMutationOptions<PaymentsControllerSoftDeletePaymentMethodMutationResponse, ResponseErrorConfig<Error>, {paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>
          

          return useMutation<PaymentsControllerSoftDeletePaymentMethodMutationResponse, ResponseErrorConfig<Error>, {paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentsControllerSoftDeletePaymentMethodMutationResponse, ResponseErrorConfig<Error>, {paymentMethodId: PaymentsControllerSoftDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>
      
}

export const policyControllerEditPolicyMutationKey = () => [{ url: '/policies/:policyId' }] as const

export type PolicyControllerEditPolicyMutationKey = ReturnType<typeof policyControllerEditPolicyMutationKey>

export function policyControllerEditPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerEditPolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerEditPolicyMutationKey()
        return mutationOptions<PolicyControllerEditPolicyMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409>, {policyId: PolicyControllerEditPolicyPathParams["policyId"], data: PolicyControllerEditPolicyMutationRequest, params?: PolicyControllerEditPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerEditPolicy(policyId, data, params, config)
          },
        })

}

/**
 * @description `invoicingConfig` comes from the product's `billing.defaultConfig` rather than being invented. These are terms you decide, not customer input, and a product may require them before quoting or confirming.
 * @summary Edit Policy
 * {@link /policies/:policyId}
 */
export function usePolicyControllerEditPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerEditPolicyMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409>, {policyId: PolicyControllerEditPolicyPathParams["policyId"], data: PolicyControllerEditPolicyMutationRequest, params?: PolicyControllerEditPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerEditPolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerEditPolicyMutationKey()

          const baseOptions = policyControllerEditPolicyMutationOptions(config) as UseMutationOptions<PolicyControllerEditPolicyMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409>, {policyId: PolicyControllerEditPolicyPathParams["policyId"], data: PolicyControllerEditPolicyMutationRequest, params?: PolicyControllerEditPolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerEditPolicyMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409>, {policyId: PolicyControllerEditPolicyPathParams["policyId"], data: PolicyControllerEditPolicyMutationRequest, params?: PolicyControllerEditPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerEditPolicyMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicy400 | PolicyControllerEditPolicy403 | PolicyControllerEditPolicy404 | PolicyControllerEditPolicy409>, {policyId: PolicyControllerEditPolicyPathParams["policyId"], data: PolicyControllerEditPolicyMutationRequest, params?: PolicyControllerEditPolicyQueryParams}, TContext>
      
}

export const policyControllerGenerateIncrementalIdMutationKey = () => [{ url: '/policies/:policyId/generate-incremental-id' }] as const

export type PolicyControllerGenerateIncrementalIdMutationKey = ReturnType<typeof policyControllerGenerateIncrementalIdMutationKey>

export function policyControllerGenerateIncrementalIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = policyControllerGenerateIncrementalIdMutationKey()
        return mutationOptions<PolicyControllerGenerateIncrementalIdMutationResponse, ResponseErrorConfig<PolicyControllerGenerateIncrementalId400>, {policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"]}, TContext>({
          mutationKey,
          mutationFn: async({ policyId }) => {
            return policyControllerGenerateIncrementalId(policyId, config)
          },
        })

}

/**
 * @summary TEST Calculate invoices
 * {@link /policies/:policyId/generate-incremental-id}
 */
export function usePolicyControllerGenerateIncrementalId<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerGenerateIncrementalIdMutationResponse, ResponseErrorConfig<PolicyControllerGenerateIncrementalId400>, {policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerGenerateIncrementalIdMutationKey()

          const baseOptions = policyControllerGenerateIncrementalIdMutationOptions(config) as UseMutationOptions<PolicyControllerGenerateIncrementalIdMutationResponse, ResponseErrorConfig<PolicyControllerGenerateIncrementalId400>, {policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"]}, TContext>
          

          return useMutation<PolicyControllerGenerateIncrementalIdMutationResponse, ResponseErrorConfig<PolicyControllerGenerateIncrementalId400>, {policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerGenerateIncrementalIdMutationResponse, ResponseErrorConfig<PolicyControllerGenerateIncrementalId400>, {policyId: PolicyControllerGenerateIncrementalIdPathParams["policyId"]}, TContext>
      
}

export const policyControllerGenerateDocumentUploadUrlMutationKey = () => [{ url: '/policies/:policyId/documents' }] as const

export type PolicyControllerGenerateDocumentUploadUrlMutationKey = ReturnType<typeof policyControllerGenerateDocumentUploadUrlMutationKey>

export function policyControllerGenerateDocumentUploadUrlMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerGenerateDocumentUploadUrlMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerGenerateDocumentUploadUrlMutationKey()
        return mutationOptions<PolicyControllerGenerateDocumentUploadUrlMutationResponse, ResponseErrorConfig<PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404>, {policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"], data: PolicyControllerGenerateDocumentUploadUrlMutationRequest, params?: PolicyControllerGenerateDocumentUploadUrlQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerGenerateDocumentUploadUrl(policyId, data, params, config)
          },
        })

}

/**
 * @summary Generate Upload Document Url
 * {@link /policies/:policyId/documents}
 */
export function usePolicyControllerGenerateDocumentUploadUrl<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerGenerateDocumentUploadUrlMutationResponse, ResponseErrorConfig<PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404>, {policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"], data: PolicyControllerGenerateDocumentUploadUrlMutationRequest, params?: PolicyControllerGenerateDocumentUploadUrlQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerGenerateDocumentUploadUrlMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerGenerateDocumentUploadUrlMutationKey()

          const baseOptions = policyControllerGenerateDocumentUploadUrlMutationOptions(config) as UseMutationOptions<PolicyControllerGenerateDocumentUploadUrlMutationResponse, ResponseErrorConfig<PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404>, {policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"], data: PolicyControllerGenerateDocumentUploadUrlMutationRequest, params?: PolicyControllerGenerateDocumentUploadUrlQueryParams}, TContext>
          

          return useMutation<PolicyControllerGenerateDocumentUploadUrlMutationResponse, ResponseErrorConfig<PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404>, {policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"], data: PolicyControllerGenerateDocumentUploadUrlMutationRequest, params?: PolicyControllerGenerateDocumentUploadUrlQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerGenerateDocumentUploadUrlMutationResponse, ResponseErrorConfig<PolicyControllerGenerateDocumentUploadUrl400 | PolicyControllerGenerateDocumentUploadUrl403 | PolicyControllerGenerateDocumentUploadUrl404>, {policyId: PolicyControllerGenerateDocumentUploadUrlPathParams["policyId"], data: PolicyControllerGenerateDocumentUploadUrlMutationRequest, params?: PolicyControllerGenerateDocumentUploadUrlQueryParams}, TContext>
      
}

export const policyControllerDeletePolicyDocumentsMutationKey = () => [{ url: '/policies/:policyId/documents' }] as const

export type PolicyControllerDeletePolicyDocumentsMutationKey = ReturnType<typeof policyControllerDeletePolicyDocumentsMutationKey>

export function policyControllerDeletePolicyDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = policyControllerDeletePolicyDocumentsMutationKey()
        return mutationOptions<PolicyControllerDeletePolicyDocumentsMutationResponse, ResponseErrorConfig<PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404>, {policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"], params: PolicyControllerDeletePolicyDocumentsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, params }) => {
            return policyControllerDeletePolicyDocuments(policyId, params, config)
          },
        })

}

/**
 * @summary Delete policy documents by id
 * {@link /policies/:policyId/documents}
 */
export function usePolicyControllerDeletePolicyDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerDeletePolicyDocumentsMutationResponse, ResponseErrorConfig<PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404>, {policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"], params: PolicyControllerDeletePolicyDocumentsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerDeletePolicyDocumentsMutationKey()

          const baseOptions = policyControllerDeletePolicyDocumentsMutationOptions(config) as UseMutationOptions<PolicyControllerDeletePolicyDocumentsMutationResponse, ResponseErrorConfig<PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404>, {policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"], params: PolicyControllerDeletePolicyDocumentsQueryParams}, TContext>
          

          return useMutation<PolicyControllerDeletePolicyDocumentsMutationResponse, ResponseErrorConfig<PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404>, {policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"], params: PolicyControllerDeletePolicyDocumentsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerDeletePolicyDocumentsMutationResponse, ResponseErrorConfig<PolicyControllerDeletePolicyDocuments403 | PolicyControllerDeletePolicyDocuments404>, {policyId: PolicyControllerDeletePolicyDocumentsPathParams["policyId"], params: PolicyControllerDeletePolicyDocumentsQueryParams}, TContext>
      
}

export const policyControllerEditPolicyExternalIdMutationKey = () => [{ url: '/policies/:policyId/external-id' }] as const

export type PolicyControllerEditPolicyExternalIdMutationKey = ReturnType<typeof policyControllerEditPolicyExternalIdMutationKey>

export function policyControllerEditPolicyExternalIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerEditPolicyExternalIdMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerEditPolicyExternalIdMutationKey()
        return mutationOptions<PolicyControllerEditPolicyExternalIdMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicyExternalId409>, {policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"], data: PolicyControllerEditPolicyExternalIdMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data }) => {
            return policyControllerEditPolicyExternalId(policyId, data, config)
          },
        })

}

/**
 * @summary Edit Policy external ID
 * {@link /policies/:policyId/external-id}
 */
export function usePolicyControllerEditPolicyExternalId<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerEditPolicyExternalIdMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicyExternalId409>, {policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"], data: PolicyControllerEditPolicyExternalIdMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerEditPolicyExternalIdMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerEditPolicyExternalIdMutationKey()

          const baseOptions = policyControllerEditPolicyExternalIdMutationOptions(config) as UseMutationOptions<PolicyControllerEditPolicyExternalIdMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicyExternalId409>, {policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"], data: PolicyControllerEditPolicyExternalIdMutationRequest}, TContext>
          

          return useMutation<PolicyControllerEditPolicyExternalIdMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicyExternalId409>, {policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"], data: PolicyControllerEditPolicyExternalIdMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerEditPolicyExternalIdMutationResponse, ResponseErrorConfig<PolicyControllerEditPolicyExternalId409>, {policyId: PolicyControllerEditPolicyExternalIdPathParams["policyId"], data: PolicyControllerEditPolicyExternalIdMutationRequest}, TContext>
      
}

export const policyControllerConfirmPolicyMutationKey = () => [{ url: '/policies/:policyId/confirm' }] as const

export type PolicyControllerConfirmPolicyMutationKey = ReturnType<typeof policyControllerConfirmPolicyMutationKey>

export function policyControllerConfirmPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = policyControllerConfirmPolicyMutationKey()
        return mutationOptions<PolicyControllerConfirmPolicyMutationResponse, ResponseErrorConfig<PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409>, {policyId: PolicyControllerConfirmPolicyPathParams["policyId"], params: PolicyControllerConfirmPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, params }) => {
            return policyControllerConfirmPolicy(policyId, params, config)
          },
        })

}

/**
 * @description The policy and its assets all become [CONFIRMED](/concepts/core-lifecycle/core-entities/policies#policy-statuses) and can no longer be modified in the New Business flow.
 * @summary Confirm a policy
 * {@link /policies/:policyId/confirm}
 */
export function usePolicyControllerConfirmPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerConfirmPolicyMutationResponse, ResponseErrorConfig<PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409>, {policyId: PolicyControllerConfirmPolicyPathParams["policyId"], params: PolicyControllerConfirmPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerConfirmPolicyMutationKey()

          const baseOptions = policyControllerConfirmPolicyMutationOptions(config) as UseMutationOptions<PolicyControllerConfirmPolicyMutationResponse, ResponseErrorConfig<PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409>, {policyId: PolicyControllerConfirmPolicyPathParams["policyId"], params: PolicyControllerConfirmPolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerConfirmPolicyMutationResponse, ResponseErrorConfig<PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409>, {policyId: PolicyControllerConfirmPolicyPathParams["policyId"], params: PolicyControllerConfirmPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerConfirmPolicyMutationResponse, ResponseErrorConfig<PolicyControllerConfirmPolicy400 | PolicyControllerConfirmPolicy403 | PolicyControllerConfirmPolicy404 | PolicyControllerConfirmPolicy409>, {policyId: PolicyControllerConfirmPolicyPathParams["policyId"], params: PolicyControllerConfirmPolicyQueryParams}, TContext>
      
}

export const policyControllerGeneratePolicySignatureRequestMutationKey = () => [{ url: '/policies/:policyId/signature' }] as const

export type PolicyControllerGeneratePolicySignatureRequestMutationKey = ReturnType<typeof policyControllerGeneratePolicySignatureRequestMutationKey>

export function policyControllerGeneratePolicySignatureRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerGeneratePolicySignatureRequestMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerGeneratePolicySignatureRequestMutationKey()
        return mutationOptions<PolicyControllerGeneratePolicySignatureRequestMutationResponse, ResponseErrorConfig<PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425>, {policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"], data: PolicyControllerGeneratePolicySignatureRequestMutationRequest, params?: PolicyControllerGeneratePolicySignatureRequestQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerGeneratePolicySignatureRequest(policyId, data, params, config)
          },
        })

}

/**
 * @description Pass `branchId`: the documents offered are the unsigned ones on that branch, so omitting it looks at the base contract and fails with `NO_UNIQUE_DOCUMENT_TYPE_READY_TO_BE_SIGNED` and `documentNumber: 0`. Signing is a human action you then observe by polling — never by re-issuing this call, which creates a second request. On direct debit it is also refused with `NO_VALID_PAYMENT_METHODS` until a usable payment method exists.
 * @summary Generate a signature request for a policy
 * {@link /policies/:policyId/signature}
 */
export function usePolicyControllerGeneratePolicySignatureRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerGeneratePolicySignatureRequestMutationResponse, ResponseErrorConfig<PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425>, {policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"], data: PolicyControllerGeneratePolicySignatureRequestMutationRequest, params?: PolicyControllerGeneratePolicySignatureRequestQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerGeneratePolicySignatureRequestMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerGeneratePolicySignatureRequestMutationKey()

          const baseOptions = policyControllerGeneratePolicySignatureRequestMutationOptions(config) as UseMutationOptions<PolicyControllerGeneratePolicySignatureRequestMutationResponse, ResponseErrorConfig<PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425>, {policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"], data: PolicyControllerGeneratePolicySignatureRequestMutationRequest, params?: PolicyControllerGeneratePolicySignatureRequestQueryParams}, TContext>
          

          return useMutation<PolicyControllerGeneratePolicySignatureRequestMutationResponse, ResponseErrorConfig<PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425>, {policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"], data: PolicyControllerGeneratePolicySignatureRequestMutationRequest, params?: PolicyControllerGeneratePolicySignatureRequestQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerGeneratePolicySignatureRequestMutationResponse, ResponseErrorConfig<PolicyControllerGeneratePolicySignatureRequest400 | PolicyControllerGeneratePolicySignatureRequest403 | PolicyControllerGeneratePolicySignatureRequest404 | PolicyControllerGeneratePolicySignatureRequest409 | PolicyControllerGeneratePolicySignatureRequest425>, {policyId: PolicyControllerGeneratePolicySignatureRequestPathParams["policyId"], data: PolicyControllerGeneratePolicySignatureRequestMutationRequest, params?: PolicyControllerGeneratePolicySignatureRequestQueryParams}, TContext>
      
}

export const policyControllerPushPolicyEventMutationKey = () => [{ url: '/policies/:policyId/events' }] as const

export type PolicyControllerPushPolicyEventMutationKey = ReturnType<typeof policyControllerPushPolicyEventMutationKey>

export function policyControllerPushPolicyEventMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerPushPolicyEventMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerPushPolicyEventMutationKey()
        return mutationOptions<PolicyControllerPushPolicyEventMutationResponse, ResponseErrorConfig<PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404>, {policyId: PolicyControllerPushPolicyEventPathParams["policyId"], data: PolicyControllerPushPolicyEventMutationRequest, params?: PolicyControllerPushPolicyEventQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerPushPolicyEvent(policyId, data, params, config)
          },
        })

}

/**
 * @summary Push a custom event onto a policy
 * {@link /policies/:policyId/events}
 */
export function usePolicyControllerPushPolicyEvent<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerPushPolicyEventMutationResponse, ResponseErrorConfig<PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404>, {policyId: PolicyControllerPushPolicyEventPathParams["policyId"], data: PolicyControllerPushPolicyEventMutationRequest, params?: PolicyControllerPushPolicyEventQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerPushPolicyEventMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerPushPolicyEventMutationKey()

          const baseOptions = policyControllerPushPolicyEventMutationOptions(config) as UseMutationOptions<PolicyControllerPushPolicyEventMutationResponse, ResponseErrorConfig<PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404>, {policyId: PolicyControllerPushPolicyEventPathParams["policyId"], data: PolicyControllerPushPolicyEventMutationRequest, params?: PolicyControllerPushPolicyEventQueryParams}, TContext>
          

          return useMutation<PolicyControllerPushPolicyEventMutationResponse, ResponseErrorConfig<PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404>, {policyId: PolicyControllerPushPolicyEventPathParams["policyId"], data: PolicyControllerPushPolicyEventMutationRequest, params?: PolicyControllerPushPolicyEventQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerPushPolicyEventMutationResponse, ResponseErrorConfig<PolicyControllerPushPolicyEvent400 | PolicyControllerPushPolicyEvent404>, {policyId: PolicyControllerPushPolicyEventPathParams["policyId"], data: PolicyControllerPushPolicyEventMutationRequest, params?: PolicyControllerPushPolicyEventQueryParams}, TContext>
      
}

export const policyControllerQuotePolicyMutationKey = () => [{ url: '/policies/:policyId/quote' }] as const

export type PolicyControllerQuotePolicyMutationKey = ReturnType<typeof policyControllerQuotePolicyMutationKey>

export function policyControllerQuotePolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerQuotePolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerQuotePolicyMutationKey()
        return mutationOptions<PolicyControllerQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409>, {policyId: PolicyControllerQuotePolicyPathParams["policyId"], data: PolicyControllerQuotePolicyMutationRequest, params: PolicyControllerQuotePolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerQuotePolicy(policyId, data, params, config)
          },
        })

}

/**
 * @description Persists the price and moves the policy to `POLICY_QUOTED`, the status confirmation requires; `calculate-quote` persists nothing. Permitted tiers, excesses and perils come from the config's `quote` object, not from `publicQuoteConfig`. On a mid-term adjustment the branch must contain at least one change that affects pricing, or it is refused with `NO_CHANGES_TO_QUOTE`. The response body is empty — read the quote back from the policy.
 * @summary Quote the policy
 * {@link /policies/:policyId/quote}
 */
export function usePolicyControllerQuotePolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409>, {policyId: PolicyControllerQuotePolicyPathParams["policyId"], data: PolicyControllerQuotePolicyMutationRequest, params: PolicyControllerQuotePolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerQuotePolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerQuotePolicyMutationKey()

          const baseOptions = policyControllerQuotePolicyMutationOptions(config) as UseMutationOptions<PolicyControllerQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409>, {policyId: PolicyControllerQuotePolicyPathParams["policyId"], data: PolicyControllerQuotePolicyMutationRequest, params: PolicyControllerQuotePolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409>, {policyId: PolicyControllerQuotePolicyPathParams["policyId"], data: PolicyControllerQuotePolicyMutationRequest, params: PolicyControllerQuotePolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerQuotePolicy400 | PolicyControllerQuotePolicy403 | PolicyControllerQuotePolicy404 | PolicyControllerQuotePolicy409>, {policyId: PolicyControllerQuotePolicyPathParams["policyId"], data: PolicyControllerQuotePolicyMutationRequest, params: PolicyControllerQuotePolicyQueryParams}, TContext>
      
}

export const policyControllerStopPolicyMutationKey = () => [{ url: '/policies/:policyId/stop' }] as const

export type PolicyControllerStopPolicyMutationKey = ReturnType<typeof policyControllerStopPolicyMutationKey>

export function policyControllerStopPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerStopPolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerStopPolicyMutationKey()
        return mutationOptions<PolicyControllerStopPolicyMutationResponse, ResponseErrorConfig<PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501>, {policyId: PolicyControllerStopPolicyPathParams["policyId"], data: PolicyControllerStopPolicyMutationRequest, params?: PolicyControllerStopPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerStopPolicy(policyId, data, params, config)
          },
        })

}

/**
 * @description The policy becomes [STOPPED](/concepts/core-lifecycle/core-entities/policies#policy-statuses) and can no longer be modified; assets that had started stop, and assets that never started are cancelled. On a tenant running the scheduled stop model the request is instead recorded on its own branch and takes effect on its effective date, so the policy keeps its status, its coverage and its billing until then. Pass `draft=true` to save a request the user has started but not committed to: nothing is scheduled and nothing reaches the policy, so it can be resumed from any device while everything carries on untouched. Either way, call the request off by invalidating that branch.
 * @summary Stop a policy
 * {@link /policies/:policyId/stop}
 */
export function usePolicyControllerStopPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerStopPolicyMutationResponse, ResponseErrorConfig<PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501>, {policyId: PolicyControllerStopPolicyPathParams["policyId"], data: PolicyControllerStopPolicyMutationRequest, params?: PolicyControllerStopPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerStopPolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerStopPolicyMutationKey()

          const baseOptions = policyControllerStopPolicyMutationOptions(config) as UseMutationOptions<PolicyControllerStopPolicyMutationResponse, ResponseErrorConfig<PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501>, {policyId: PolicyControllerStopPolicyPathParams["policyId"], data: PolicyControllerStopPolicyMutationRequest, params?: PolicyControllerStopPolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerStopPolicyMutationResponse, ResponseErrorConfig<PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501>, {policyId: PolicyControllerStopPolicyPathParams["policyId"], data: PolicyControllerStopPolicyMutationRequest, params?: PolicyControllerStopPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerStopPolicyMutationResponse, ResponseErrorConfig<PolicyControllerStopPolicy400 | PolicyControllerStopPolicy403 | PolicyControllerStopPolicy404 | PolicyControllerStopPolicy409 | PolicyControllerStopPolicy501>, {policyId: PolicyControllerStopPolicyPathParams["policyId"], data: PolicyControllerStopPolicyMutationRequest, params?: PolicyControllerStopPolicyQueryParams}, TContext>
      
}

export const policyControllerRegisterAdditionalQuoteComponentsMutationKey = () => [{ url: '/policies/debug/:policyId/register-additional-quote-components' }] as const

export type PolicyControllerRegisterAdditionalQuoteComponentsMutationKey = ReturnType<typeof policyControllerRegisterAdditionalQuoteComponentsMutationKey>

export function policyControllerRegisterAdditionalQuoteComponentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerRegisterAdditionalQuoteComponentsMutationKey()
        return mutationOptions<PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, ResponseErrorConfig<Error>, {policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"], data: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, params?: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerRegisterAdditionalQuoteComponents(policyId, data, params, config)
          },
        })

}

/**
 * @summary Register additional quote components for a policy
 * {@link /policies/debug/:policyId/register-additional-quote-components}
 */
export function usePolicyControllerRegisterAdditionalQuoteComponents<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, ResponseErrorConfig<Error>, {policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"], data: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, params?: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerRegisterAdditionalQuoteComponentsMutationKey()

          const baseOptions = policyControllerRegisterAdditionalQuoteComponentsMutationOptions(config) as UseMutationOptions<PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, ResponseErrorConfig<Error>, {policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"], data: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, params?: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams}, TContext>
          

          return useMutation<PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, ResponseErrorConfig<Error>, {policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"], data: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, params?: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerRegisterAdditionalQuoteComponentsMutationResponse, ResponseErrorConfig<Error>, {policyId: PolicyControllerRegisterAdditionalQuoteComponentsPathParams["policyId"], data: PolicyControllerRegisterAdditionalQuoteComponentsMutationRequest, params?: PolicyControllerRegisterAdditionalQuoteComponentsQueryParams}, TContext>
      
}

export const policyControllerUpdatePolicyQuoteMutationKey = () => [{ url: '/policies/:policyId/update-policy-quote' }] as const

export type PolicyControllerUpdatePolicyQuoteMutationKey = ReturnType<typeof policyControllerUpdatePolicyQuoteMutationKey>

export function policyControllerUpdatePolicyQuoteMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerUpdatePolicyQuoteMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerUpdatePolicyQuoteMutationKey()
        return mutationOptions<PolicyControllerUpdatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409>, {policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"], data: PolicyControllerUpdatePolicyQuoteMutationRequest, params: PolicyControllerUpdatePolicyQuoteQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerUpdatePolicyQuote(policyId, data, params, config)
          },
        })

}

/**
 * @summary Update policy quote components
 * {@link /policies/:policyId/update-policy-quote}
 */
export function usePolicyControllerUpdatePolicyQuote<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerUpdatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409>, {policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"], data: PolicyControllerUpdatePolicyQuoteMutationRequest, params: PolicyControllerUpdatePolicyQuoteQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerUpdatePolicyQuoteMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerUpdatePolicyQuoteMutationKey()

          const baseOptions = policyControllerUpdatePolicyQuoteMutationOptions(config) as UseMutationOptions<PolicyControllerUpdatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409>, {policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"], data: PolicyControllerUpdatePolicyQuoteMutationRequest, params: PolicyControllerUpdatePolicyQuoteQueryParams}, TContext>
          

          return useMutation<PolicyControllerUpdatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409>, {policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"], data: PolicyControllerUpdatePolicyQuoteMutationRequest, params: PolicyControllerUpdatePolicyQuoteQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerUpdatePolicyQuoteMutationResponse, ResponseErrorConfig<PolicyControllerUpdatePolicyQuote404 | PolicyControllerUpdatePolicyQuote409>, {policyId: PolicyControllerUpdatePolicyQuotePathParams["policyId"], data: PolicyControllerUpdatePolicyQuoteMutationRequest, params: PolicyControllerUpdatePolicyQuoteQueryParams}, TContext>
      
}

export const policyControllerSuspendPolicyMutationKey = () => [{ url: '/policies/:policyId/suspend' }] as const

export type PolicyControllerSuspendPolicyMutationKey = ReturnType<typeof policyControllerSuspendPolicyMutationKey>

export function policyControllerSuspendPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = policyControllerSuspendPolicyMutationKey()
        return mutationOptions<PolicyControllerSuspendPolicyMutationResponse, ResponseErrorConfig<PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409>, {policyId: PolicyControllerSuspendPolicyPathParams["policyId"], params?: PolicyControllerSuspendPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, params }) => {
            return policyControllerSuspendPolicy(policyId, params, config)
          },
        })

}

/**
 * @summary Suspend the policy
 * {@link /policies/:policyId/suspend}
 */
export function usePolicyControllerSuspendPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerSuspendPolicyMutationResponse, ResponseErrorConfig<PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409>, {policyId: PolicyControllerSuspendPolicyPathParams["policyId"], params?: PolicyControllerSuspendPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerSuspendPolicyMutationKey()

          const baseOptions = policyControllerSuspendPolicyMutationOptions(config) as UseMutationOptions<PolicyControllerSuspendPolicyMutationResponse, ResponseErrorConfig<PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409>, {policyId: PolicyControllerSuspendPolicyPathParams["policyId"], params?: PolicyControllerSuspendPolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerSuspendPolicyMutationResponse, ResponseErrorConfig<PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409>, {policyId: PolicyControllerSuspendPolicyPathParams["policyId"], params?: PolicyControllerSuspendPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerSuspendPolicyMutationResponse, ResponseErrorConfig<PolicyControllerSuspendPolicy404 | PolicyControllerSuspendPolicy409>, {policyId: PolicyControllerSuspendPolicyPathParams["policyId"], params?: PolicyControllerSuspendPolicyQueryParams}, TContext>
      
}

export const policyControllerActivatePolicyMutationKey = () => [{ url: '/policies/:policyId/activate' }] as const

export type PolicyControllerActivatePolicyMutationKey = ReturnType<typeof policyControllerActivatePolicyMutationKey>

export function policyControllerActivatePolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerActivatePolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerActivatePolicyMutationKey()
        return mutationOptions<PolicyControllerActivatePolicyMutationResponse, ResponseErrorConfig<PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409>, {policyId: PolicyControllerActivatePolicyPathParams["policyId"], data: PolicyControllerActivatePolicyMutationRequest, params?: PolicyControllerActivatePolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerActivatePolicy(policyId, data, params, config)
          },
        })

}

/**
 * @description Brings a **suspended** contract back into force, and nothing else — any other status is refused with `CONFLICTING_POLICY_STATUS`. It is not how a new contract starts: a signed one comes into force on its own at its start date, and on products setting `requireFirstPaymentToActivate`, once the first premium is collected. `appliedAt` is when activation takes effect and must not precede `whenAt`; the call schedules the change for that date rather than applying it immediately.
 * @summary Activate the policy
 * {@link /policies/:policyId/activate}
 */
export function usePolicyControllerActivatePolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerActivatePolicyMutationResponse, ResponseErrorConfig<PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409>, {policyId: PolicyControllerActivatePolicyPathParams["policyId"], data: PolicyControllerActivatePolicyMutationRequest, params?: PolicyControllerActivatePolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerActivatePolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerActivatePolicyMutationKey()

          const baseOptions = policyControllerActivatePolicyMutationOptions(config) as UseMutationOptions<PolicyControllerActivatePolicyMutationResponse, ResponseErrorConfig<PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409>, {policyId: PolicyControllerActivatePolicyPathParams["policyId"], data: PolicyControllerActivatePolicyMutationRequest, params?: PolicyControllerActivatePolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerActivatePolicyMutationResponse, ResponseErrorConfig<PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409>, {policyId: PolicyControllerActivatePolicyPathParams["policyId"], data: PolicyControllerActivatePolicyMutationRequest, params?: PolicyControllerActivatePolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerActivatePolicyMutationResponse, ResponseErrorConfig<PolicyControllerActivatePolicy400 | PolicyControllerActivatePolicy404 | PolicyControllerActivatePolicy409>, {policyId: PolicyControllerActivatePolicyPathParams["policyId"], data: PolicyControllerActivatePolicyMutationRequest, params?: PolicyControllerActivatePolicyQueryParams}, TContext>
      
}

export const policyControllerSetPolicyFeesMutationKey = () => [{ url: '/policies/:policyId/fees' }] as const

export type PolicyControllerSetPolicyFeesMutationKey = ReturnType<typeof policyControllerSetPolicyFeesMutationKey>

export function policyControllerSetPolicyFeesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerSetPolicyFeesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerSetPolicyFeesMutationKey()
        return mutationOptions<PolicyControllerSetPolicyFeesMutationResponse, ResponseErrorConfig<PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404>, {policyId: PolicyControllerSetPolicyFeesPathParams["policyId"], data: PolicyControllerSetPolicyFeesMutationRequest, params?: PolicyControllerSetPolicyFeesQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerSetPolicyFees(policyId, data, params, config)
          },
        })

}

/**
 * @summary Set policy brokerage fees
 * {@link /policies/:policyId/fees}
 */
export function usePolicyControllerSetPolicyFees<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerSetPolicyFeesMutationResponse, ResponseErrorConfig<PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404>, {policyId: PolicyControllerSetPolicyFeesPathParams["policyId"], data: PolicyControllerSetPolicyFeesMutationRequest, params?: PolicyControllerSetPolicyFeesQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerSetPolicyFeesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerSetPolicyFeesMutationKey()

          const baseOptions = policyControllerSetPolicyFeesMutationOptions(config) as UseMutationOptions<PolicyControllerSetPolicyFeesMutationResponse, ResponseErrorConfig<PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404>, {policyId: PolicyControllerSetPolicyFeesPathParams["policyId"], data: PolicyControllerSetPolicyFeesMutationRequest, params?: PolicyControllerSetPolicyFeesQueryParams}, TContext>
          

          return useMutation<PolicyControllerSetPolicyFeesMutationResponse, ResponseErrorConfig<PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404>, {policyId: PolicyControllerSetPolicyFeesPathParams["policyId"], data: PolicyControllerSetPolicyFeesMutationRequest, params?: PolicyControllerSetPolicyFeesQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerSetPolicyFeesMutationResponse, ResponseErrorConfig<PolicyControllerSetPolicyFees400 | PolicyControllerSetPolicyFees404>, {policyId: PolicyControllerSetPolicyFeesPathParams["policyId"], data: PolicyControllerSetPolicyFeesMutationRequest, params?: PolicyControllerSetPolicyFeesQueryParams}, TContext>
      
}

export const policyControllerManualQuotePolicyMutationKey = () => [{ url: '/policies/:policyId/manual-quote' }] as const

export type PolicyControllerManualQuotePolicyMutationKey = ReturnType<typeof policyControllerManualQuotePolicyMutationKey>

export function policyControllerManualQuotePolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyControllerManualQuotePolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyControllerManualQuotePolicyMutationKey()
        return mutationOptions<PolicyControllerManualQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409>, {policyId: PolicyControllerManualQuotePolicyPathParams["policyId"], data: PolicyControllerManualQuotePolicyMutationRequest, params: PolicyControllerManualQuotePolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return policyControllerManualQuotePolicy(policyId, data, params, config)
          },
        })

}

/**
 * @summary Manual quote policy
 * {@link /policies/:policyId/manual-quote}
 * @deprecated
 */
export function usePolicyControllerManualQuotePolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyControllerManualQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409>, {policyId: PolicyControllerManualQuotePolicyPathParams["policyId"], data: PolicyControllerManualQuotePolicyMutationRequest, params: PolicyControllerManualQuotePolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyControllerManualQuotePolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyControllerManualQuotePolicyMutationKey()

          const baseOptions = policyControllerManualQuotePolicyMutationOptions(config) as UseMutationOptions<PolicyControllerManualQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409>, {policyId: PolicyControllerManualQuotePolicyPathParams["policyId"], data: PolicyControllerManualQuotePolicyMutationRequest, params: PolicyControllerManualQuotePolicyQueryParams}, TContext>
          

          return useMutation<PolicyControllerManualQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409>, {policyId: PolicyControllerManualQuotePolicyPathParams["policyId"], data: PolicyControllerManualQuotePolicyMutationRequest, params: PolicyControllerManualQuotePolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyControllerManualQuotePolicyMutationResponse, ResponseErrorConfig<PolicyControllerManualQuotePolicy400 | PolicyControllerManualQuotePolicy404 | PolicyControllerManualQuotePolicy409>, {policyId: PolicyControllerManualQuotePolicyPathParams["policyId"], data: PolicyControllerManualQuotePolicyMutationRequest, params: PolicyControllerManualQuotePolicyQueryParams}, TContext>
      
}

export const pricingControllerSavePricingSelectionMutationKey = () => [{ url: '/pricing/:policyId/selection' }] as const

export type PricingControllerSavePricingSelectionMutationKey = ReturnType<typeof pricingControllerSavePricingSelectionMutationKey>

export function pricingControllerSavePricingSelectionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PricingControllerSavePricingSelectionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = pricingControllerSavePricingSelectionMutationKey()
        return mutationOptions<PricingControllerSavePricingSelectionMutationResponse, ResponseErrorConfig<PricingControllerSavePricingSelection404>, {policyId: PricingControllerSavePricingSelectionPathParams["policyId"], data: PricingControllerSavePricingSelectionMutationRequest, params?: PricingControllerSavePricingSelectionQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return pricingControllerSavePricingSelection(policyId, data, params, config)
          },
        })

}

/**
 * @summary Save pricing tier and peril selection
 * {@link /pricing/:policyId/selection}
 */
export function usePricingControllerSavePricingSelection<TContext>(options: 
{
  mutation?: UseMutationOptions<PricingControllerSavePricingSelectionMutationResponse, ResponseErrorConfig<PricingControllerSavePricingSelection404>, {policyId: PricingControllerSavePricingSelectionPathParams["policyId"], data: PricingControllerSavePricingSelectionMutationRequest, params?: PricingControllerSavePricingSelectionQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PricingControllerSavePricingSelectionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? pricingControllerSavePricingSelectionMutationKey()

          const baseOptions = pricingControllerSavePricingSelectionMutationOptions(config) as UseMutationOptions<PricingControllerSavePricingSelectionMutationResponse, ResponseErrorConfig<PricingControllerSavePricingSelection404>, {policyId: PricingControllerSavePricingSelectionPathParams["policyId"], data: PricingControllerSavePricingSelectionMutationRequest, params?: PricingControllerSavePricingSelectionQueryParams}, TContext>
          

          return useMutation<PricingControllerSavePricingSelectionMutationResponse, ResponseErrorConfig<PricingControllerSavePricingSelection404>, {policyId: PricingControllerSavePricingSelectionPathParams["policyId"], data: PricingControllerSavePricingSelectionMutationRequest, params?: PricingControllerSavePricingSelectionQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PricingControllerSavePricingSelectionMutationResponse, ResponseErrorConfig<PricingControllerSavePricingSelection404>, {policyId: PricingControllerSavePricingSelectionPathParams["policyId"], data: PricingControllerSavePricingSelectionMutationRequest, params?: PricingControllerSavePricingSelectionQueryParams}, TContext>
      
}

export const quoteControllerGetQuoteMutationKey = () => [{ url: '/quote/debug/:productId' }] as const

export type QuoteControllerGetQuoteMutationKey = ReturnType<typeof quoteControllerGetQuoteMutationKey>

export function quoteControllerGetQuoteMutationOptions<TContext = unknown>(config: Partial<RequestConfig<QuoteControllerGetQuoteMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = quoteControllerGetQuoteMutationKey()
        return mutationOptions<QuoteControllerGetQuoteMutationResponse, ResponseErrorConfig<QuoteControllerGetQuote400 | QuoteControllerGetQuote404>, {productId: QuoteControllerGetQuotePathParams["productId"], data: QuoteControllerGetQuoteMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ productId, data }) => {
            return quoteControllerGetQuote(productId, data, config)
          },
        })

}

/**
 * @description Computes a quote for the given `productId` using the provided customer, policy, branch, assets and options. The endpoint aggregates pricing and returns a policy-and-assets quote. Intended for internal/debug usage.
 * @summary DEBUG: Get quote for a product
 * {@link /quote/debug/:productId}
 */
export function useQuoteControllerGetQuote<TContext>(options: 
{
  mutation?: UseMutationOptions<QuoteControllerGetQuoteMutationResponse, ResponseErrorConfig<QuoteControllerGetQuote400 | QuoteControllerGetQuote404>, {productId: QuoteControllerGetQuotePathParams["productId"], data: QuoteControllerGetQuoteMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<QuoteControllerGetQuoteMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? quoteControllerGetQuoteMutationKey()

          const baseOptions = quoteControllerGetQuoteMutationOptions(config) as UseMutationOptions<QuoteControllerGetQuoteMutationResponse, ResponseErrorConfig<QuoteControllerGetQuote400 | QuoteControllerGetQuote404>, {productId: QuoteControllerGetQuotePathParams["productId"], data: QuoteControllerGetQuoteMutationRequest}, TContext>
          

          return useMutation<QuoteControllerGetQuoteMutationResponse, ResponseErrorConfig<QuoteControllerGetQuote400 | QuoteControllerGetQuote404>, {productId: QuoteControllerGetQuotePathParams["productId"], data: QuoteControllerGetQuoteMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<QuoteControllerGetQuoteMutationResponse, ResponseErrorConfig<QuoteControllerGetQuote400 | QuoteControllerGetQuote404>, {productId: QuoteControllerGetQuotePathParams["productId"], data: QuoteControllerGetQuoteMutationRequest}, TContext>
      
}

export const renewalControllerFinalizeRenewalBranchMutationKey = () => [{ url: '/renewal/policies/:policyId/branches/:branchId/finalize-renewal' }] as const

export type RenewalControllerFinalizeRenewalBranchMutationKey = ReturnType<typeof renewalControllerFinalizeRenewalBranchMutationKey>

export function renewalControllerFinalizeRenewalBranchMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = renewalControllerFinalizeRenewalBranchMutationKey()
        return mutationOptions<RenewalControllerFinalizeRenewalBranchMutationResponse, ResponseErrorConfig<RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409>, {policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"], params: RenewalControllerFinalizeRenewalBranchQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, branchId, params }) => {
            return renewalControllerFinalizeRenewalBranch(policyId, branchId, params, config)
          },
        })

}

/**
 * @summary Finalize the renewal proposition : accept or refuse it
 * {@link /renewal/policies/:policyId/branches/:branchId/finalize-renewal}
 */
export function useRenewalControllerFinalizeRenewalBranch<TContext>(options: 
{
  mutation?: UseMutationOptions<RenewalControllerFinalizeRenewalBranchMutationResponse, ResponseErrorConfig<RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409>, {policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"], params: RenewalControllerFinalizeRenewalBranchQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? renewalControllerFinalizeRenewalBranchMutationKey()

          const baseOptions = renewalControllerFinalizeRenewalBranchMutationOptions(config) as UseMutationOptions<RenewalControllerFinalizeRenewalBranchMutationResponse, ResponseErrorConfig<RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409>, {policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"], params: RenewalControllerFinalizeRenewalBranchQueryParams}, TContext>
          

          return useMutation<RenewalControllerFinalizeRenewalBranchMutationResponse, ResponseErrorConfig<RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409>, {policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"], params: RenewalControllerFinalizeRenewalBranchQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RenewalControllerFinalizeRenewalBranchMutationResponse, ResponseErrorConfig<RenewalControllerFinalizeRenewalBranch404 | RenewalControllerFinalizeRenewalBranch409>, {policyId: RenewalControllerFinalizeRenewalBranchPathParams["policyId"], branchId: RenewalControllerFinalizeRenewalBranchPathParams["branchId"], params: RenewalControllerFinalizeRenewalBranchQueryParams}, TContext>
      
}

export const reportingControllerGenerateReportMutationKey = () => [{ url: '/reporting' }] as const

export type ReportingControllerGenerateReportMutationKey = ReturnType<typeof reportingControllerGenerateReportMutationKey>

export function reportingControllerGenerateReportMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ReportingControllerGenerateReportMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = reportingControllerGenerateReportMutationKey()
        return mutationOptions<ReportingControllerGenerateReportMutationResponse, ResponseErrorConfig<ReportingControllerGenerateReport400>, {data: ReportingControllerGenerateReportMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return reportingControllerGenerateReport(data, config)
          },
        })

}

/**
 * @summary Generate a report
 * {@link /reporting}
 */
export function useReportingControllerGenerateReport<TContext>(options: 
{
  mutation?: UseMutationOptions<ReportingControllerGenerateReportMutationResponse, ResponseErrorConfig<ReportingControllerGenerateReport400>, {data: ReportingControllerGenerateReportMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ReportingControllerGenerateReportMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? reportingControllerGenerateReportMutationKey()

          const baseOptions = reportingControllerGenerateReportMutationOptions(config) as UseMutationOptions<ReportingControllerGenerateReportMutationResponse, ResponseErrorConfig<ReportingControllerGenerateReport400>, {data: ReportingControllerGenerateReportMutationRequest}, TContext>
          

          return useMutation<ReportingControllerGenerateReportMutationResponse, ResponseErrorConfig<ReportingControllerGenerateReport400>, {data: ReportingControllerGenerateReportMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ReportingControllerGenerateReportMutationResponse, ResponseErrorConfig<ReportingControllerGenerateReport400>, {data: ReportingControllerGenerateReportMutationRequest}, TContext>
      
}

export const reportingControllerGenerateCustomReportMutationKey = () => [{ url: '/reporting/custom' }] as const

export type ReportingControllerGenerateCustomReportMutationKey = ReturnType<typeof reportingControllerGenerateCustomReportMutationKey>

export function reportingControllerGenerateCustomReportMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ReportingControllerGenerateCustomReportMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = reportingControllerGenerateCustomReportMutationKey()
        return mutationOptions<ReportingControllerGenerateCustomReportMutationResponse, ResponseErrorConfig<Error>, {data: ReportingControllerGenerateCustomReportMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return reportingControllerGenerateCustomReport(data, config)
          },
        })

}

/**
 * @summary Export a search query as CSV
 * {@link /reporting/custom}
 */
export function useReportingControllerGenerateCustomReport<TContext>(options: 
{
  mutation?: UseMutationOptions<ReportingControllerGenerateCustomReportMutationResponse, ResponseErrorConfig<Error>, {data: ReportingControllerGenerateCustomReportMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ReportingControllerGenerateCustomReportMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? reportingControllerGenerateCustomReportMutationKey()

          const baseOptions = reportingControllerGenerateCustomReportMutationOptions(config) as UseMutationOptions<ReportingControllerGenerateCustomReportMutationResponse, ResponseErrorConfig<Error>, {data: ReportingControllerGenerateCustomReportMutationRequest}, TContext>
          

          return useMutation<ReportingControllerGenerateCustomReportMutationResponse, ResponseErrorConfig<Error>, {data: ReportingControllerGenerateCustomReportMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ReportingControllerGenerateCustomReportMutationResponse, ResponseErrorConfig<Error>, {data: ReportingControllerGenerateCustomReportMutationRequest}, TContext>
      
}

export const repricingControllerExecuteRepricingForPolicyMutationKey = () => [{ url: '/repricing/:policyId' }] as const

export type RepricingControllerExecuteRepricingForPolicyMutationKey = ReturnType<typeof repricingControllerExecuteRepricingForPolicyMutationKey>

export function repricingControllerExecuteRepricingForPolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = repricingControllerExecuteRepricingForPolicyMutationKey()
        return mutationOptions<RepricingControllerExecuteRepricingForPolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"], params?: RepricingControllerExecuteRepricingForPolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, params }) => {
            return repricingControllerExecuteRepricingForPolicy(policyId, params, config)
          },
        })

}

/**
 * {@link /repricing/:policyId}
 */
export function useRepricingControllerExecuteRepricingForPolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<RepricingControllerExecuteRepricingForPolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"], params?: RepricingControllerExecuteRepricingForPolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? repricingControllerExecuteRepricingForPolicyMutationKey()

          const baseOptions = repricingControllerExecuteRepricingForPolicyMutationOptions(config) as UseMutationOptions<RepricingControllerExecuteRepricingForPolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"], params?: RepricingControllerExecuteRepricingForPolicyQueryParams}, TContext>
          

          return useMutation<RepricingControllerExecuteRepricingForPolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"], params?: RepricingControllerExecuteRepricingForPolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RepricingControllerExecuteRepricingForPolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: RepricingControllerExecuteRepricingForPolicyPathParams["policyId"], params?: RepricingControllerExecuteRepricingForPolicyQueryParams}, TContext>
      
}

export const signatureControllerFakeMutationKey = () => [{ url: '/signature/fake/:signature_id' }] as const

export type SignatureControllerFakeMutationKey = ReturnType<typeof signatureControllerFakeMutationKey>

export function signatureControllerFakeMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = signatureControllerFakeMutationKey()
        return mutationOptions<SignatureControllerFakeMutationResponse, ResponseErrorConfig<Error>, {signature_id: SignatureControllerFakePathParams["signature_id"]}, TContext>({
          mutationKey,
          mutationFn: async({ signature_id }) => {
            return signatureControllerFake(signature_id, config)
          },
        })

}

/**
 * @description Requires M2M_{app_name}_TOKEN
 * @summary Fake a signature done event
 * {@link /signature/fake/:signature_id}
 */
export function useSignatureControllerFake<TContext>(options: 
{
  mutation?: UseMutationOptions<SignatureControllerFakeMutationResponse, ResponseErrorConfig<Error>, {signature_id: SignatureControllerFakePathParams["signature_id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? signatureControllerFakeMutationKey()

          const baseOptions = signatureControllerFakeMutationOptions(config) as UseMutationOptions<SignatureControllerFakeMutationResponse, ResponseErrorConfig<Error>, {signature_id: SignatureControllerFakePathParams["signature_id"]}, TContext>
          

          return useMutation<SignatureControllerFakeMutationResponse, ResponseErrorConfig<Error>, {signature_id: SignatureControllerFakePathParams["signature_id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SignatureControllerFakeMutationResponse, ResponseErrorConfig<Error>, {signature_id: SignatureControllerFakePathParams["signature_id"]}, TContext>
      
}

export const signatureControllerResendSignatureReminderMutationKey = () => [{ url: '/signature/:signatureId/policy/:policyId/signers/:signerCustomerId/resend' }] as const

export type SignatureControllerResendSignatureReminderMutationKey = ReturnType<typeof signatureControllerResendSignatureReminderMutationKey>

export function signatureControllerResendSignatureReminderMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = signatureControllerResendSignatureReminderMutationKey()
        return mutationOptions<SignatureControllerResendSignatureReminderMutationResponse, ResponseErrorConfig<Error>, {policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"]}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, signatureId, signerCustomerId }) => {
            return signatureControllerResendSignatureReminder(policyId, signatureId, signerCustomerId, config)
          },
        })

}

/**
 * @summary Resend signature reminder to a specific signer
 * {@link /signature/:signatureId/policy/:policyId/signers/:signerCustomerId/resend}
 */
export function useSignatureControllerResendSignatureReminder<TContext>(options: 
{
  mutation?: UseMutationOptions<SignatureControllerResendSignatureReminderMutationResponse, ResponseErrorConfig<Error>, {policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? signatureControllerResendSignatureReminderMutationKey()

          const baseOptions = signatureControllerResendSignatureReminderMutationOptions(config) as UseMutationOptions<SignatureControllerResendSignatureReminderMutationResponse, ResponseErrorConfig<Error>, {policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"]}, TContext>
          

          return useMutation<SignatureControllerResendSignatureReminderMutationResponse, ResponseErrorConfig<Error>, {policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SignatureControllerResendSignatureReminderMutationResponse, ResponseErrorConfig<Error>, {policyId: SignatureControllerResendSignatureReminderPathParams["policyId"], signatureId: SignatureControllerResendSignatureReminderPathParams["signatureId"], signerCustomerId: SignatureControllerResendSignatureReminderPathParams["signerCustomerId"]}, TContext>
      
}

export const derogationControllerCreateDerogationMutationKey = () => [{ url: '/derogations/branches/:branchId' }] as const

export type DerogationControllerCreateDerogationMutationKey = ReturnType<typeof derogationControllerCreateDerogationMutationKey>

export function derogationControllerCreateDerogationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = derogationControllerCreateDerogationMutationKey()
        return mutationOptions<DerogationControllerCreateDerogationMutationResponse, ResponseErrorConfig<DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409>, {branchId: DerogationControllerCreateDerogationPathParams["branchId"], params: DerogationControllerCreateDerogationQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ branchId, params }) => {
            return derogationControllerCreateDerogation(branchId, params, config)
          },
        })

}

/**
 * @summary Create derogation
 * {@link /derogations/branches/:branchId}
 */
export function useDerogationControllerCreateDerogation<TContext>(options: 
{
  mutation?: UseMutationOptions<DerogationControllerCreateDerogationMutationResponse, ResponseErrorConfig<DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409>, {branchId: DerogationControllerCreateDerogationPathParams["branchId"], params: DerogationControllerCreateDerogationQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? derogationControllerCreateDerogationMutationKey()

          const baseOptions = derogationControllerCreateDerogationMutationOptions(config) as UseMutationOptions<DerogationControllerCreateDerogationMutationResponse, ResponseErrorConfig<DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409>, {branchId: DerogationControllerCreateDerogationPathParams["branchId"], params: DerogationControllerCreateDerogationQueryParams}, TContext>
          

          return useMutation<DerogationControllerCreateDerogationMutationResponse, ResponseErrorConfig<DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409>, {branchId: DerogationControllerCreateDerogationPathParams["branchId"], params: DerogationControllerCreateDerogationQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DerogationControllerCreateDerogationMutationResponse, ResponseErrorConfig<DerogationControllerCreateDerogation404 | DerogationControllerCreateDerogation409>, {branchId: DerogationControllerCreateDerogationPathParams["branchId"], params: DerogationControllerCreateDerogationQueryParams}, TContext>
      
}

export const derogationControllerApproveDerogationMutationKey = () => [{ url: '/derogations/:derogationId/branches/:branchId/approve' }] as const

export type DerogationControllerApproveDerogationMutationKey = ReturnType<typeof derogationControllerApproveDerogationMutationKey>

export function derogationControllerApproveDerogationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = derogationControllerApproveDerogationMutationKey()
        return mutationOptions<DerogationControllerApproveDerogationMutationResponse, ResponseErrorConfig<DerogationControllerApproveDerogation404>, {branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ branchId, derogationId }) => {
            return derogationControllerApproveDerogation(branchId, derogationId, config)
          },
        })

}

/**
 * @summary Approve derogation
 * {@link /derogations/:derogationId/branches/:branchId/approve}
 */
export function useDerogationControllerApproveDerogation<TContext>(options: 
{
  mutation?: UseMutationOptions<DerogationControllerApproveDerogationMutationResponse, ResponseErrorConfig<DerogationControllerApproveDerogation404>, {branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? derogationControllerApproveDerogationMutationKey()

          const baseOptions = derogationControllerApproveDerogationMutationOptions(config) as UseMutationOptions<DerogationControllerApproveDerogationMutationResponse, ResponseErrorConfig<DerogationControllerApproveDerogation404>, {branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"]}, TContext>
          

          return useMutation<DerogationControllerApproveDerogationMutationResponse, ResponseErrorConfig<DerogationControllerApproveDerogation404>, {branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DerogationControllerApproveDerogationMutationResponse, ResponseErrorConfig<DerogationControllerApproveDerogation404>, {branchId: DerogationControllerApproveDerogationPathParams["branchId"], derogationId: DerogationControllerApproveDerogationPathParams["derogationId"]}, TContext>
      
}

export const derogationControllerDenyDerogationMutationKey = () => [{ url: '/derogations/:derogationId/branches/:branchId/deny' }] as const

export type DerogationControllerDenyDerogationMutationKey = ReturnType<typeof derogationControllerDenyDerogationMutationKey>

export function derogationControllerDenyDerogationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DerogationControllerDenyDerogationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = derogationControllerDenyDerogationMutationKey()
        return mutationOptions<DerogationControllerDenyDerogationMutationResponse, ResponseErrorConfig<DerogationControllerDenyDerogation404>, {derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"], data: DerogationControllerDenyDerogationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ derogationId, branchId, data }) => {
            return derogationControllerDenyDerogation(derogationId, branchId, data, config)
          },
        })

}

/**
 * @summary Deny derogation
 * {@link /derogations/:derogationId/branches/:branchId/deny}
 */
export function useDerogationControllerDenyDerogation<TContext>(options: 
{
  mutation?: UseMutationOptions<DerogationControllerDenyDerogationMutationResponse, ResponseErrorConfig<DerogationControllerDenyDerogation404>, {derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"], data: DerogationControllerDenyDerogationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DerogationControllerDenyDerogationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? derogationControllerDenyDerogationMutationKey()

          const baseOptions = derogationControllerDenyDerogationMutationOptions(config) as UseMutationOptions<DerogationControllerDenyDerogationMutationResponse, ResponseErrorConfig<DerogationControllerDenyDerogation404>, {derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"], data: DerogationControllerDenyDerogationMutationRequest}, TContext>
          

          return useMutation<DerogationControllerDenyDerogationMutationResponse, ResponseErrorConfig<DerogationControllerDenyDerogation404>, {derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"], data: DerogationControllerDenyDerogationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DerogationControllerDenyDerogationMutationResponse, ResponseErrorConfig<DerogationControllerDenyDerogation404>, {derogationId: DerogationControllerDenyDerogationPathParams["derogationId"], branchId: DerogationControllerDenyDerogationPathParams["branchId"], data: DerogationControllerDenyDerogationMutationRequest}, TContext>
      
}

export const commentsControllerCreateCommentMutationKey = () => [{ url: '/comments/:entityId' }] as const

export type CommentsControllerCreateCommentMutationKey = ReturnType<typeof commentsControllerCreateCommentMutationKey>

export function commentsControllerCreateCommentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CommentsControllerCreateCommentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = commentsControllerCreateCommentMutationKey()
        return mutationOptions<CommentsControllerCreateCommentMutationResponse, ResponseErrorConfig<CommentsControllerCreateComment409>, {entityId: CommentsControllerCreateCommentPathParams["entityId"], data: CommentsControllerCreateCommentMutationRequest, params?: CommentsControllerCreateCommentQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ entityId, data, params }) => {
            return commentsControllerCreateComment(entityId, data, params, config)
          },
        })

}

/**
 * @summary Create a comment for an entity and branch
 * {@link /comments/:entityId}
 */
export function useCommentsControllerCreateComment<TContext>(options: 
{
  mutation?: UseMutationOptions<CommentsControllerCreateCommentMutationResponse, ResponseErrorConfig<CommentsControllerCreateComment409>, {entityId: CommentsControllerCreateCommentPathParams["entityId"], data: CommentsControllerCreateCommentMutationRequest, params?: CommentsControllerCreateCommentQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CommentsControllerCreateCommentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? commentsControllerCreateCommentMutationKey()

          const baseOptions = commentsControllerCreateCommentMutationOptions(config) as UseMutationOptions<CommentsControllerCreateCommentMutationResponse, ResponseErrorConfig<CommentsControllerCreateComment409>, {entityId: CommentsControllerCreateCommentPathParams["entityId"], data: CommentsControllerCreateCommentMutationRequest, params?: CommentsControllerCreateCommentQueryParams}, TContext>
          

          return useMutation<CommentsControllerCreateCommentMutationResponse, ResponseErrorConfig<CommentsControllerCreateComment409>, {entityId: CommentsControllerCreateCommentPathParams["entityId"], data: CommentsControllerCreateCommentMutationRequest, params?: CommentsControllerCreateCommentQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CommentsControllerCreateCommentMutationResponse, ResponseErrorConfig<CommentsControllerCreateComment409>, {entityId: CommentsControllerCreateCommentPathParams["entityId"], data: CommentsControllerCreateCommentMutationRequest, params?: CommentsControllerCreateCommentQueryParams}, TContext>
      
}

export const commentsControllerUpdateCommentMutationKey = () => [{ url: '/comments/:commentId' }] as const

export type CommentsControllerUpdateCommentMutationKey = ReturnType<typeof commentsControllerUpdateCommentMutationKey>

export function commentsControllerUpdateCommentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CommentsControllerUpdateCommentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = commentsControllerUpdateCommentMutationKey()
        return mutationOptions<CommentsControllerUpdateCommentMutationResponse, ResponseErrorConfig<CommentsControllerUpdateComment404>, {commentId: CommentsControllerUpdateCommentPathParams["commentId"], data: CommentsControllerUpdateCommentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ commentId, data }) => {
            return commentsControllerUpdateComment(commentId, data, config)
          },
        })

}

/**
 * @summary Update a comment for an entity and branch
 * {@link /comments/:commentId}
 */
export function useCommentsControllerUpdateComment<TContext>(options: 
{
  mutation?: UseMutationOptions<CommentsControllerUpdateCommentMutationResponse, ResponseErrorConfig<CommentsControllerUpdateComment404>, {commentId: CommentsControllerUpdateCommentPathParams["commentId"], data: CommentsControllerUpdateCommentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CommentsControllerUpdateCommentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? commentsControllerUpdateCommentMutationKey()

          const baseOptions = commentsControllerUpdateCommentMutationOptions(config) as UseMutationOptions<CommentsControllerUpdateCommentMutationResponse, ResponseErrorConfig<CommentsControllerUpdateComment404>, {commentId: CommentsControllerUpdateCommentPathParams["commentId"], data: CommentsControllerUpdateCommentMutationRequest}, TContext>
          

          return useMutation<CommentsControllerUpdateCommentMutationResponse, ResponseErrorConfig<CommentsControllerUpdateComment404>, {commentId: CommentsControllerUpdateCommentPathParams["commentId"], data: CommentsControllerUpdateCommentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CommentsControllerUpdateCommentMutationResponse, ResponseErrorConfig<CommentsControllerUpdateComment404>, {commentId: CommentsControllerUpdateCommentPathParams["commentId"], data: CommentsControllerUpdateCommentMutationRequest}, TContext>
      
}

export const commentsControllerDeleteCommentMutationKey = () => [{ url: '/comments/:commentId' }] as const

export type CommentsControllerDeleteCommentMutationKey = ReturnType<typeof commentsControllerDeleteCommentMutationKey>

export function commentsControllerDeleteCommentMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = commentsControllerDeleteCommentMutationKey()
        return mutationOptions<CommentsControllerDeleteCommentMutationResponse, ResponseErrorConfig<CommentsControllerDeleteComment404>, {commentId: CommentsControllerDeleteCommentPathParams["commentId"]}, TContext>({
          mutationKey,
          mutationFn: async({ commentId }) => {
            return commentsControllerDeleteComment(commentId, config)
          },
        })

}

/**
 * @summary Delete a comment for an entity and branch
 * {@link /comments/:commentId}
 */
export function useCommentsControllerDeleteComment<TContext>(options: 
{
  mutation?: UseMutationOptions<CommentsControllerDeleteCommentMutationResponse, ResponseErrorConfig<CommentsControllerDeleteComment404>, {commentId: CommentsControllerDeleteCommentPathParams["commentId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? commentsControllerDeleteCommentMutationKey()

          const baseOptions = commentsControllerDeleteCommentMutationOptions(config) as UseMutationOptions<CommentsControllerDeleteCommentMutationResponse, ResponseErrorConfig<CommentsControllerDeleteComment404>, {commentId: CommentsControllerDeleteCommentPathParams["commentId"]}, TContext>
          

          return useMutation<CommentsControllerDeleteCommentMutationResponse, ResponseErrorConfig<CommentsControllerDeleteComment404>, {commentId: CommentsControllerDeleteCommentPathParams["commentId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CommentsControllerDeleteCommentMutationResponse, ResponseErrorConfig<CommentsControllerDeleteComment404>, {commentId: CommentsControllerDeleteCommentPathParams["commentId"]}, TContext>
      
}

export const internalNotesControllerCreateMutationKey = () => [{ url: '/policies/:policyId/internal-notes' }] as const

export type InternalNotesControllerCreateMutationKey = ReturnType<typeof internalNotesControllerCreateMutationKey>

export function internalNotesControllerCreateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InternalNotesControllerCreateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = internalNotesControllerCreateMutationKey()
        return mutationOptions<InternalNotesControllerCreateMutationResponse, ResponseErrorConfig<InternalNotesControllerCreate400>, {policyId: InternalNotesControllerCreatePathParams["policyId"], data: InternalNotesControllerCreateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data }) => {
            return internalNotesControllerCreate(policyId, data, config)
          },
        })

}

/**
 * @summary Create an internal note on a policy
 * {@link /policies/:policyId/internal-notes}
 */
export function useInternalNotesControllerCreate<TContext>(options: 
{
  mutation?: UseMutationOptions<InternalNotesControllerCreateMutationResponse, ResponseErrorConfig<InternalNotesControllerCreate400>, {policyId: InternalNotesControllerCreatePathParams["policyId"], data: InternalNotesControllerCreateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InternalNotesControllerCreateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? internalNotesControllerCreateMutationKey()

          const baseOptions = internalNotesControllerCreateMutationOptions(config) as UseMutationOptions<InternalNotesControllerCreateMutationResponse, ResponseErrorConfig<InternalNotesControllerCreate400>, {policyId: InternalNotesControllerCreatePathParams["policyId"], data: InternalNotesControllerCreateMutationRequest}, TContext>
          

          return useMutation<InternalNotesControllerCreateMutationResponse, ResponseErrorConfig<InternalNotesControllerCreate400>, {policyId: InternalNotesControllerCreatePathParams["policyId"], data: InternalNotesControllerCreateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InternalNotesControllerCreateMutationResponse, ResponseErrorConfig<InternalNotesControllerCreate400>, {policyId: InternalNotesControllerCreatePathParams["policyId"], data: InternalNotesControllerCreateMutationRequest}, TContext>
      
}

export const internalNotesControllerUpdateMutationKey = () => [{ url: '/policies/:policyId/internal-notes/:noteId' }] as const

export type InternalNotesControllerUpdateMutationKey = ReturnType<typeof internalNotesControllerUpdateMutationKey>

export function internalNotesControllerUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<InternalNotesControllerUpdateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = internalNotesControllerUpdateMutationKey()
        return mutationOptions<InternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404>, {policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"], data: InternalNotesControllerUpdateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, noteId, data }) => {
            return internalNotesControllerUpdate(policyId, noteId, data, config)
          },
        })

}

/**
 * @summary Update an internal note (author only)
 * {@link /policies/:policyId/internal-notes/:noteId}
 */
export function useInternalNotesControllerUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<InternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404>, {policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"], data: InternalNotesControllerUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<InternalNotesControllerUpdateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? internalNotesControllerUpdateMutationKey()

          const baseOptions = internalNotesControllerUpdateMutationOptions(config) as UseMutationOptions<InternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404>, {policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"], data: InternalNotesControllerUpdateMutationRequest}, TContext>
          

          return useMutation<InternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404>, {policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"], data: InternalNotesControllerUpdateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<InternalNotesControllerUpdate403 | InternalNotesControllerUpdate404>, {policyId: InternalNotesControllerUpdatePathParams["policyId"], noteId: InternalNotesControllerUpdatePathParams["noteId"], data: InternalNotesControllerUpdateMutationRequest}, TContext>
      
}

export const internalNotesControllerDeleteMutationKey = () => [{ url: '/policies/:policyId/internal-notes/:noteId' }] as const

export type InternalNotesControllerDeleteMutationKey = ReturnType<typeof internalNotesControllerDeleteMutationKey>

export function internalNotesControllerDeleteMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = internalNotesControllerDeleteMutationKey()
        return mutationOptions<InternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<InternalNotesControllerDelete403 | InternalNotesControllerDelete404>, {policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"], params: InternalNotesControllerDeleteQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, noteId, params }) => {
            return internalNotesControllerDelete(policyId, noteId, params, config)
          },
        })

}

/**
 * @description Soft-deletes the note by default. Super admins can delete it permanently with `?hard=true`.
 * @summary Delete an internal note
 * {@link /policies/:policyId/internal-notes/:noteId}
 */
export function useInternalNotesControllerDelete<TContext>(options: 
{
  mutation?: UseMutationOptions<InternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<InternalNotesControllerDelete403 | InternalNotesControllerDelete404>, {policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"], params: InternalNotesControllerDeleteQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? internalNotesControllerDeleteMutationKey()

          const baseOptions = internalNotesControllerDeleteMutationOptions(config) as UseMutationOptions<InternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<InternalNotesControllerDelete403 | InternalNotesControllerDelete404>, {policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"], params: InternalNotesControllerDeleteQueryParams}, TContext>
          

          return useMutation<InternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<InternalNotesControllerDelete403 | InternalNotesControllerDelete404>, {policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"], params: InternalNotesControllerDeleteQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<InternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<InternalNotesControllerDelete403 | InternalNotesControllerDelete404>, {policyId: InternalNotesControllerDeletePathParams["policyId"], noteId: InternalNotesControllerDeletePathParams["noteId"], params: InternalNotesControllerDeleteQueryParams}, TContext>
      
}

export const claimInternalNotesControllerCreateMutationKey = () => [{ url: '/claim-management/claims/:claimId/internal-notes' }] as const

export type ClaimInternalNotesControllerCreateMutationKey = ReturnType<typeof claimInternalNotesControllerCreateMutationKey>

export function claimInternalNotesControllerCreateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimInternalNotesControllerCreateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimInternalNotesControllerCreateMutationKey()
        return mutationOptions<ClaimInternalNotesControllerCreateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerCreate400>, {claimId: ClaimInternalNotesControllerCreatePathParams["claimId"], data: ClaimInternalNotesControllerCreateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ claimId, data }) => {
            return claimInternalNotesControllerCreate(claimId, data, config)
          },
        })

}

/**
 * @summary Create an internal note on a claim
 * {@link /claim-management/claims/:claimId/internal-notes}
 */
export function useClaimInternalNotesControllerCreate<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimInternalNotesControllerCreateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerCreate400>, {claimId: ClaimInternalNotesControllerCreatePathParams["claimId"], data: ClaimInternalNotesControllerCreateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimInternalNotesControllerCreateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimInternalNotesControllerCreateMutationKey()

          const baseOptions = claimInternalNotesControllerCreateMutationOptions(config) as UseMutationOptions<ClaimInternalNotesControllerCreateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerCreate400>, {claimId: ClaimInternalNotesControllerCreatePathParams["claimId"], data: ClaimInternalNotesControllerCreateMutationRequest}, TContext>
          

          return useMutation<ClaimInternalNotesControllerCreateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerCreate400>, {claimId: ClaimInternalNotesControllerCreatePathParams["claimId"], data: ClaimInternalNotesControllerCreateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimInternalNotesControllerCreateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerCreate400>, {claimId: ClaimInternalNotesControllerCreatePathParams["claimId"], data: ClaimInternalNotesControllerCreateMutationRequest}, TContext>
      
}

export const claimInternalNotesControllerUpdateMutationKey = () => [{ url: '/claim-management/claims/:claimId/internal-notes/:noteId' }] as const

export type ClaimInternalNotesControllerUpdateMutationKey = ReturnType<typeof claimInternalNotesControllerUpdateMutationKey>

export function claimInternalNotesControllerUpdateMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ClaimInternalNotesControllerUpdateMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = claimInternalNotesControllerUpdateMutationKey()
        return mutationOptions<ClaimInternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404>, {claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"], data: ClaimInternalNotesControllerUpdateMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ claimId, noteId, data }) => {
            return claimInternalNotesControllerUpdate(claimId, noteId, data, config)
          },
        })

}

/**
 * @summary Update an internal note on a claim (author only)
 * {@link /claim-management/claims/:claimId/internal-notes/:noteId}
 */
export function useClaimInternalNotesControllerUpdate<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimInternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404>, {claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"], data: ClaimInternalNotesControllerUpdateMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ClaimInternalNotesControllerUpdateMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimInternalNotesControllerUpdateMutationKey()

          const baseOptions = claimInternalNotesControllerUpdateMutationOptions(config) as UseMutationOptions<ClaimInternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404>, {claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"], data: ClaimInternalNotesControllerUpdateMutationRequest}, TContext>
          

          return useMutation<ClaimInternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404>, {claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"], data: ClaimInternalNotesControllerUpdateMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimInternalNotesControllerUpdateMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerUpdate403 | ClaimInternalNotesControllerUpdate404>, {claimId: ClaimInternalNotesControllerUpdatePathParams["claimId"], noteId: ClaimInternalNotesControllerUpdatePathParams["noteId"], data: ClaimInternalNotesControllerUpdateMutationRequest}, TContext>
      
}

export const claimInternalNotesControllerDeleteMutationKey = () => [{ url: '/claim-management/claims/:claimId/internal-notes/:noteId' }] as const

export type ClaimInternalNotesControllerDeleteMutationKey = ReturnType<typeof claimInternalNotesControllerDeleteMutationKey>

export function claimInternalNotesControllerDeleteMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = claimInternalNotesControllerDeleteMutationKey()
        return mutationOptions<ClaimInternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404>, {claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"], params: ClaimInternalNotesControllerDeleteQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ claimId, noteId, params }) => {
            return claimInternalNotesControllerDelete(claimId, noteId, params, config)
          },
        })

}

/**
 * @description Soft-deletes the note by default. Super admins can delete it permanently with `?hard=true`.
 * @summary Delete an internal note on a claim
 * {@link /claim-management/claims/:claimId/internal-notes/:noteId}
 */
export function useClaimInternalNotesControllerDelete<TContext>(options: 
{
  mutation?: UseMutationOptions<ClaimInternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404>, {claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"], params: ClaimInternalNotesControllerDeleteQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? claimInternalNotesControllerDeleteMutationKey()

          const baseOptions = claimInternalNotesControllerDeleteMutationOptions(config) as UseMutationOptions<ClaimInternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404>, {claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"], params: ClaimInternalNotesControllerDeleteQueryParams}, TContext>
          

          return useMutation<ClaimInternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404>, {claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"], params: ClaimInternalNotesControllerDeleteQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ClaimInternalNotesControllerDeleteMutationResponse, ResponseErrorConfig<ClaimInternalNotesControllerDelete403 | ClaimInternalNotesControllerDelete404>, {claimId: ClaimInternalNotesControllerDeletePathParams["claimId"], noteId: ClaimInternalNotesControllerDeletePathParams["noteId"], params: ClaimInternalNotesControllerDeleteQueryParams}, TContext>
      
}

export const conversationControllerCreateConversationMutationKey = () => [{ url: '/conversations' }] as const

export type ConversationControllerCreateConversationMutationKey = ReturnType<typeof conversationControllerCreateConversationMutationKey>

export function conversationControllerCreateConversationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ConversationControllerCreateConversationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = conversationControllerCreateConversationMutationKey()
        return mutationOptions<ConversationControllerCreateConversationMutationResponse, ResponseErrorConfig<Error>, {data: ConversationControllerCreateConversationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return conversationControllerCreateConversation(data, config)
          },
        })

}

/**
 * @summary Create a new conversation
 * {@link /conversations}
 */
export function useConversationControllerCreateConversation<TContext>(options: 
{
  mutation?: UseMutationOptions<ConversationControllerCreateConversationMutationResponse, ResponseErrorConfig<Error>, {data: ConversationControllerCreateConversationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ConversationControllerCreateConversationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? conversationControllerCreateConversationMutationKey()

          const baseOptions = conversationControllerCreateConversationMutationOptions(config) as UseMutationOptions<ConversationControllerCreateConversationMutationResponse, ResponseErrorConfig<Error>, {data: ConversationControllerCreateConversationMutationRequest}, TContext>
          

          return useMutation<ConversationControllerCreateConversationMutationResponse, ResponseErrorConfig<Error>, {data: ConversationControllerCreateConversationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ConversationControllerCreateConversationMutationResponse, ResponseErrorConfig<Error>, {data: ConversationControllerCreateConversationMutationRequest}, TContext>
      
}

export const conversationControllerDeleteConversationMutationKey = () => [{ url: '/conversations/:conversationId' }] as const

export type ConversationControllerDeleteConversationMutationKey = ReturnType<typeof conversationControllerDeleteConversationMutationKey>

export function conversationControllerDeleteConversationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = conversationControllerDeleteConversationMutationKey()
        return mutationOptions<ConversationControllerDeleteConversationMutationResponse, ResponseErrorConfig<ConversationControllerDeleteConversation404>, {conversationId: ConversationControllerDeleteConversationPathParams["conversationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ conversationId }) => {
            return conversationControllerDeleteConversation(conversationId, config)
          },
        })

}

/**
 * @summary Soft delete a conversation
 * {@link /conversations/:conversationId}
 */
export function useConversationControllerDeleteConversation<TContext>(options: 
{
  mutation?: UseMutationOptions<ConversationControllerDeleteConversationMutationResponse, ResponseErrorConfig<ConversationControllerDeleteConversation404>, {conversationId: ConversationControllerDeleteConversationPathParams["conversationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? conversationControllerDeleteConversationMutationKey()

          const baseOptions = conversationControllerDeleteConversationMutationOptions(config) as UseMutationOptions<ConversationControllerDeleteConversationMutationResponse, ResponseErrorConfig<ConversationControllerDeleteConversation404>, {conversationId: ConversationControllerDeleteConversationPathParams["conversationId"]}, TContext>
          

          return useMutation<ConversationControllerDeleteConversationMutationResponse, ResponseErrorConfig<ConversationControllerDeleteConversation404>, {conversationId: ConversationControllerDeleteConversationPathParams["conversationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ConversationControllerDeleteConversationMutationResponse, ResponseErrorConfig<ConversationControllerDeleteConversation404>, {conversationId: ConversationControllerDeleteConversationPathParams["conversationId"]}, TContext>
      
}

export const conversationControllerSendConversationMessageMutationKey = () => [{ url: '/conversations/:conversationId/messages' }] as const

export type ConversationControllerSendConversationMessageMutationKey = ReturnType<typeof conversationControllerSendConversationMessageMutationKey>

export function conversationControllerSendConversationMessageMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ConversationControllerSendConversationMessageMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = conversationControllerSendConversationMessageMutationKey()
        return mutationOptions<ConversationControllerSendConversationMessageMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationMessage404>, {conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"], data: ConversationControllerSendConversationMessageMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ conversationId, data }) => {
            return conversationControllerSendConversationMessage(conversationId, data, config)
          },
        })

}

/**
 * @summary Send a message in a conversation
 * {@link /conversations/:conversationId/messages}
 */
export function useConversationControllerSendConversationMessage<TContext>(options: 
{
  mutation?: UseMutationOptions<ConversationControllerSendConversationMessageMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationMessage404>, {conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"], data: ConversationControllerSendConversationMessageMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ConversationControllerSendConversationMessageMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? conversationControllerSendConversationMessageMutationKey()

          const baseOptions = conversationControllerSendConversationMessageMutationOptions(config) as UseMutationOptions<ConversationControllerSendConversationMessageMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationMessage404>, {conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"], data: ConversationControllerSendConversationMessageMutationRequest}, TContext>
          

          return useMutation<ConversationControllerSendConversationMessageMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationMessage404>, {conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"], data: ConversationControllerSendConversationMessageMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ConversationControllerSendConversationMessageMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationMessage404>, {conversationId: ConversationControllerSendConversationMessagePathParams["conversationId"], data: ConversationControllerSendConversationMessageMutationRequest}, TContext>
      
}

export const conversationControllerSendConversationMessageStreamMutationKey = () => [{ url: '/conversations/:conversationId/messages/stream' }] as const

export type ConversationControllerSendConversationMessageStreamMutationKey = ReturnType<typeof conversationControllerSendConversationMessageStreamMutationKey>

export function conversationControllerSendConversationMessageStreamMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ConversationControllerSendConversationMessageStreamMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = conversationControllerSendConversationMessageStreamMutationKey()
        return mutationOptions<ConversationControllerSendConversationMessageStreamMutationResponse, ResponseErrorConfig<Error>, {conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"], data: ConversationControllerSendConversationMessageStreamMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ conversationId, data }) => {
            return conversationControllerSendConversationMessageStream(conversationId, data, config)
          },
        })

}

/**
 * @summary Stream a message response in a conversation via SSE
 * {@link /conversations/:conversationId/messages/stream}
 */
export function useConversationControllerSendConversationMessageStream<TContext>(options: 
{
  mutation?: UseMutationOptions<ConversationControllerSendConversationMessageStreamMutationResponse, ResponseErrorConfig<Error>, {conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"], data: ConversationControllerSendConversationMessageStreamMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ConversationControllerSendConversationMessageStreamMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? conversationControllerSendConversationMessageStreamMutationKey()

          const baseOptions = conversationControllerSendConversationMessageStreamMutationOptions(config) as UseMutationOptions<ConversationControllerSendConversationMessageStreamMutationResponse, ResponseErrorConfig<Error>, {conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"], data: ConversationControllerSendConversationMessageStreamMutationRequest}, TContext>
          

          return useMutation<ConversationControllerSendConversationMessageStreamMutationResponse, ResponseErrorConfig<Error>, {conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"], data: ConversationControllerSendConversationMessageStreamMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ConversationControllerSendConversationMessageStreamMutationResponse, ResponseErrorConfig<Error>, {conversationId: ConversationControllerSendConversationMessageStreamPathParams["conversationId"], data: ConversationControllerSendConversationMessageStreamMutationRequest}, TContext>
      
}

export const conversationControllerSendConversationFeedbackMutationKey = () => [{ url: '/conversations/:conversationId/messages/:messageId/feedback' }] as const

export type ConversationControllerSendConversationFeedbackMutationKey = ReturnType<typeof conversationControllerSendConversationFeedbackMutationKey>

export function conversationControllerSendConversationFeedbackMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ConversationControllerSendConversationFeedbackMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = conversationControllerSendConversationFeedbackMutationKey()
        return mutationOptions<ConversationControllerSendConversationFeedbackMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationFeedback404>, {conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"], data: ConversationControllerSendConversationFeedbackMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ conversationId, messageId, data }) => {
            return conversationControllerSendConversationFeedback(conversationId, messageId, data, config)
          },
        })

}

/**
 * @summary Send feedback on a conversation message
 * {@link /conversations/:conversationId/messages/:messageId/feedback}
 */
export function useConversationControllerSendConversationFeedback<TContext>(options: 
{
  mutation?: UseMutationOptions<ConversationControllerSendConversationFeedbackMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationFeedback404>, {conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"], data: ConversationControllerSendConversationFeedbackMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ConversationControllerSendConversationFeedbackMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? conversationControllerSendConversationFeedbackMutationKey()

          const baseOptions = conversationControllerSendConversationFeedbackMutationOptions(config) as UseMutationOptions<ConversationControllerSendConversationFeedbackMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationFeedback404>, {conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"], data: ConversationControllerSendConversationFeedbackMutationRequest}, TContext>
          

          return useMutation<ConversationControllerSendConversationFeedbackMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationFeedback404>, {conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"], data: ConversationControllerSendConversationFeedbackMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ConversationControllerSendConversationFeedbackMutationResponse, ResponseErrorConfig<ConversationControllerSendConversationFeedback404>, {conversationId: ConversationControllerSendConversationFeedbackPathParams["conversationId"], messageId: ConversationControllerSendConversationFeedbackPathParams["messageId"], data: ConversationControllerSendConversationFeedbackMutationRequest}, TContext>
      
}

export const stripeWebhookControllerWebhookMutationKey = () => [{ url: '/stripe/webhook' }] as const

export type StripeWebhookControllerWebhookMutationKey = ReturnType<typeof stripeWebhookControllerWebhookMutationKey>

export function stripeWebhookControllerWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = stripeWebhookControllerWebhookMutationKey()
        return mutationOptions<StripeWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerWebhookHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ headers }) => {
            return stripeWebhookControllerWebhook(headers, config)
          },
        })

}

/**
 * {@link /stripe/webhook}
 */
export function useStripeWebhookControllerWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<StripeWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerWebhookHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? stripeWebhookControllerWebhookMutationKey()

          const baseOptions = stripeWebhookControllerWebhookMutationOptions(config) as UseMutationOptions<StripeWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerWebhookHeaderParams}, TContext>
          

          return useMutation<StripeWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerWebhookHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<StripeWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerWebhookHeaderParams}, TContext>
      
}

export const stripeWebhookControllerConnectWebhookMutationKey = () => [{ url: '/stripe/webhook/connect' }] as const

export type StripeWebhookControllerConnectWebhookMutationKey = ReturnType<typeof stripeWebhookControllerConnectWebhookMutationKey>

export function stripeWebhookControllerConnectWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = stripeWebhookControllerConnectWebhookMutationKey()
        return mutationOptions<StripeWebhookControllerConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerConnectWebhookHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ headers }) => {
            return stripeWebhookControllerConnectWebhook(headers, config)
          },
        })

}

/**
 * {@link /stripe/webhook/connect}
 */
export function useStripeWebhookControllerConnectWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<StripeWebhookControllerConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerConnectWebhookHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? stripeWebhookControllerConnectWebhookMutationKey()

          const baseOptions = stripeWebhookControllerConnectWebhookMutationOptions(config) as UseMutationOptions<StripeWebhookControllerConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerConnectWebhookHeaderParams}, TContext>
          

          return useMutation<StripeWebhookControllerConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerConnectWebhookHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<StripeWebhookControllerConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {headers: StripeWebhookControllerConnectWebhookHeaderParams}, TContext>
      
}

export const stripeWebhookControllerTestWebhookMutationKey = () => [{ url: '/stripe/webhook/test' }] as const

export type StripeWebhookControllerTestWebhookMutationKey = ReturnType<typeof stripeWebhookControllerTestWebhookMutationKey>

export function stripeWebhookControllerTestWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = stripeWebhookControllerTestWebhookMutationKey()
        return mutationOptions<StripeWebhookControllerTestWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return stripeWebhookControllerTestWebhook(config)
          },
        })

}

/**
 * {@link /stripe/webhook/test}
 */
export function useStripeWebhookControllerTestWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<StripeWebhookControllerTestWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? stripeWebhookControllerTestWebhookMutationKey()

          const baseOptions = stripeWebhookControllerTestWebhookMutationOptions(config) as UseMutationOptions<StripeWebhookControllerTestWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<StripeWebhookControllerTestWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<StripeWebhookControllerTestWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const stripeWebhookControllerTenantWebhookMutationKey = () => [{ url: '/stripe/webhook/:tenant' }] as const

export type StripeWebhookControllerTenantWebhookMutationKey = ReturnType<typeof stripeWebhookControllerTenantWebhookMutationKey>

export function stripeWebhookControllerTenantWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = stripeWebhookControllerTenantWebhookMutationKey()
        return mutationOptions<StripeWebhookControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantWebhookHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ tenant, headers }) => {
            return stripeWebhookControllerTenantWebhook(tenant, headers, config)
          },
        })

}

/**
 * {@link /stripe/webhook/:tenant}
 */
export function useStripeWebhookControllerTenantWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<StripeWebhookControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantWebhookHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? stripeWebhookControllerTenantWebhookMutationKey()

          const baseOptions = stripeWebhookControllerTenantWebhookMutationOptions(config) as UseMutationOptions<StripeWebhookControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantWebhookHeaderParams}, TContext>
          

          return useMutation<StripeWebhookControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantWebhookHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<StripeWebhookControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantWebhookHeaderParams}, TContext>
      
}

export const stripeWebhookControllerTenantConnectWebhookMutationKey = () => [{ url: '/stripe/webhook/connect/:tenant' }] as const

export type StripeWebhookControllerTenantConnectWebhookMutationKey = ReturnType<typeof stripeWebhookControllerTenantConnectWebhookMutationKey>

export function stripeWebhookControllerTenantConnectWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = stripeWebhookControllerTenantConnectWebhookMutationKey()
        return mutationOptions<StripeWebhookControllerTenantConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantConnectWebhookHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ tenant, headers }) => {
            return stripeWebhookControllerTenantConnectWebhook(tenant, headers, config)
          },
        })

}

/**
 * {@link /stripe/webhook/connect/:tenant}
 */
export function useStripeWebhookControllerTenantConnectWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<StripeWebhookControllerTenantConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantConnectWebhookHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? stripeWebhookControllerTenantConnectWebhookMutationKey()

          const baseOptions = stripeWebhookControllerTenantConnectWebhookMutationOptions(config) as UseMutationOptions<StripeWebhookControllerTenantConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantConnectWebhookHeaderParams}, TContext>
          

          return useMutation<StripeWebhookControllerTenantConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantConnectWebhookHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<StripeWebhookControllerTenantConnectWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: StripeWebhookControllerTenantConnectWebhookPathParams["tenant"], headers: StripeWebhookControllerTenantConnectWebhookHeaderParams}, TContext>
      
}

export const sydiaControllerListClaimsMutationKey = () => [{ url: '/sydia/claims/list' }] as const

export type SydiaControllerListClaimsMutationKey = ReturnType<typeof sydiaControllerListClaimsMutationKey>

export function sydiaControllerListClaimsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SydiaControllerListClaimsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = sydiaControllerListClaimsMutationKey()
        return mutationOptions<SydiaControllerListClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListClaimsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return sydiaControllerListClaims(data, config)
          },
        })

}

/**
 * @summary Fetch list of claims
 * {@link /sydia/claims/list}
 */
export function useSydiaControllerListClaims<TContext>(options: 
{
  mutation?: UseMutationOptions<SydiaControllerListClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListClaimsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SydiaControllerListClaimsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sydiaControllerListClaimsMutationKey()

          const baseOptions = sydiaControllerListClaimsMutationOptions(config) as UseMutationOptions<SydiaControllerListClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListClaimsMutationRequest}, TContext>
          

          return useMutation<SydiaControllerListClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListClaimsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SydiaControllerListClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListClaimsMutationRequest}, TContext>
      
}

export const sydiaControllerGetClaimMutationKey = () => [{ url: '/sydia/claims' }] as const

export type SydiaControllerGetClaimMutationKey = ReturnType<typeof sydiaControllerGetClaimMutationKey>

export function sydiaControllerGetClaimMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SydiaControllerGetClaimMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = sydiaControllerGetClaimMutationKey()
        return mutationOptions<SydiaControllerGetClaimMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetClaimMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return sydiaControllerGetClaim(data, config)
          },
        })

}

/**
 * @summary Fetch a claim with claimId
 * {@link /sydia/claims}
 */
export function useSydiaControllerGetClaim<TContext>(options: 
{
  mutation?: UseMutationOptions<SydiaControllerGetClaimMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetClaimMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SydiaControllerGetClaimMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sydiaControllerGetClaimMutationKey()

          const baseOptions = sydiaControllerGetClaimMutationOptions(config) as UseMutationOptions<SydiaControllerGetClaimMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetClaimMutationRequest}, TContext>
          

          return useMutation<SydiaControllerGetClaimMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetClaimMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SydiaControllerGetClaimMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetClaimMutationRequest}, TContext>
      
}

export const sydiaControllerUpsertPolicyClaimsMutationKey = () => [{ url: '/sydia/claims' }] as const

export type SydiaControllerUpsertPolicyClaimsMutationKey = ReturnType<typeof sydiaControllerUpsertPolicyClaimsMutationKey>

export function sydiaControllerUpsertPolicyClaimsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SydiaControllerUpsertPolicyClaimsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = sydiaControllerUpsertPolicyClaimsMutationKey()
        return mutationOptions<SydiaControllerUpsertPolicyClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerUpsertPolicyClaimsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return sydiaControllerUpsertPolicyClaims(data, config)
          },
        })

}

/**
 * @summary Upsert Sydia claim in our database
 * {@link /sydia/claims}
 */
export function useSydiaControllerUpsertPolicyClaims<TContext>(options: 
{
  mutation?: UseMutationOptions<SydiaControllerUpsertPolicyClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerUpsertPolicyClaimsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SydiaControllerUpsertPolicyClaimsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sydiaControllerUpsertPolicyClaimsMutationKey()

          const baseOptions = sydiaControllerUpsertPolicyClaimsMutationOptions(config) as UseMutationOptions<SydiaControllerUpsertPolicyClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerUpsertPolicyClaimsMutationRequest}, TContext>
          

          return useMutation<SydiaControllerUpsertPolicyClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerUpsertPolicyClaimsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SydiaControllerUpsertPolicyClaimsMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerUpsertPolicyClaimsMutationRequest}, TContext>
      
}

export const sydiaControllerGetCustomerMutationKey = () => [{ url: '/sydia/customers' }] as const

export type SydiaControllerGetCustomerMutationKey = ReturnType<typeof sydiaControllerGetCustomerMutationKey>

export function sydiaControllerGetCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SydiaControllerGetCustomerMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = sydiaControllerGetCustomerMutationKey()
        return mutationOptions<SydiaControllerGetCustomerMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetCustomerMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return sydiaControllerGetCustomer(data, config)
          },
        })

}

/**
 * @summary Fetch a customer with policyId and claimId
 * {@link /sydia/customers}
 */
export function useSydiaControllerGetCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<SydiaControllerGetCustomerMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetCustomerMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SydiaControllerGetCustomerMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sydiaControllerGetCustomerMutationKey()

          const baseOptions = sydiaControllerGetCustomerMutationOptions(config) as UseMutationOptions<SydiaControllerGetCustomerMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetCustomerMutationRequest}, TContext>
          

          return useMutation<SydiaControllerGetCustomerMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetCustomerMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SydiaControllerGetCustomerMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerGetCustomerMutationRequest}, TContext>
      
}

export const sydiaControllerListCustomersMutationKey = () => [{ url: '/sydia/customers/list' }] as const

export type SydiaControllerListCustomersMutationKey = ReturnType<typeof sydiaControllerListCustomersMutationKey>

export function sydiaControllerListCustomersMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SydiaControllerListCustomersMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = sydiaControllerListCustomersMutationKey()
        return mutationOptions<SydiaControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListCustomersMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return sydiaControllerListCustomers(data, config)
          },
        })

}

/**
 * @summary Fetch list of customers
 * {@link /sydia/customers/list}
 */
export function useSydiaControllerListCustomers<TContext>(options: 
{
  mutation?: UseMutationOptions<SydiaControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListCustomersMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SydiaControllerListCustomersMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sydiaControllerListCustomersMutationKey()

          const baseOptions = sydiaControllerListCustomersMutationOptions(config) as UseMutationOptions<SydiaControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListCustomersMutationRequest}, TContext>
          

          return useMutation<SydiaControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListCustomersMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SydiaControllerListCustomersMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListCustomersMutationRequest}, TContext>
      
}

export const sydiaControllerListPoliciesMutationKey = () => [{ url: '/sydia/policy/list' }] as const

export type SydiaControllerListPoliciesMutationKey = ReturnType<typeof sydiaControllerListPoliciesMutationKey>

export function sydiaControllerListPoliciesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SydiaControllerListPoliciesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = sydiaControllerListPoliciesMutationKey()
        return mutationOptions<SydiaControllerListPoliciesMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListPoliciesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return sydiaControllerListPolicies(data, config)
          },
        })

}

/**
 * @summary Fetch list of sydia policies
 * {@link /sydia/policy/list}
 */
export function useSydiaControllerListPolicies<TContext>(options: 
{
  mutation?: UseMutationOptions<SydiaControllerListPoliciesMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListPoliciesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SydiaControllerListPoliciesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sydiaControllerListPoliciesMutationKey()

          const baseOptions = sydiaControllerListPoliciesMutationOptions(config) as UseMutationOptions<SydiaControllerListPoliciesMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListPoliciesMutationRequest}, TContext>
          

          return useMutation<SydiaControllerListPoliciesMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListPoliciesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SydiaControllerListPoliciesMutationResponse, ResponseErrorConfig<Error>, {data: SydiaControllerListPoliciesMutationRequest}, TContext>
      
}

export const workflowsControllerStartWorkflowMutationKey = () => [{ url: '/workflows' }] as const

export type WorkflowsControllerStartWorkflowMutationKey = ReturnType<typeof workflowsControllerStartWorkflowMutationKey>

export function workflowsControllerStartWorkflowMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WorkflowsControllerStartWorkflowMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = workflowsControllerStartWorkflowMutationKey()
        return mutationOptions<WorkflowsControllerStartWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerStartWorkflowMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return workflowsControllerStartWorkflow(data, config)
          },
        })

}

/**
 * @summary Schedule workflow execution
 * {@link /workflows}
 */
export function useWorkflowsControllerStartWorkflow<TContext>(options: 
{
  mutation?: UseMutationOptions<WorkflowsControllerStartWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerStartWorkflowMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WorkflowsControllerStartWorkflowMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? workflowsControllerStartWorkflowMutationKey()

          const baseOptions = workflowsControllerStartWorkflowMutationOptions(config) as UseMutationOptions<WorkflowsControllerStartWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerStartWorkflowMutationRequest}, TContext>
          

          return useMutation<WorkflowsControllerStartWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerStartWorkflowMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WorkflowsControllerStartWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerStartWorkflowMutationRequest}, TContext>
      
}

export const workflowsControllerCancelWorkflowRunsMutationKey = () => [{ url: '/workflows/cancel' }] as const

export type WorkflowsControllerCancelWorkflowRunsMutationKey = ReturnType<typeof workflowsControllerCancelWorkflowRunsMutationKey>

export function workflowsControllerCancelWorkflowRunsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WorkflowsControllerCancelWorkflowRunsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = workflowsControllerCancelWorkflowRunsMutationKey()
        return mutationOptions<WorkflowsControllerCancelWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerCancelWorkflowRunsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return workflowsControllerCancelWorkflowRuns(data, config)
          },
        })

}

/**
 * @summary Cancel multiple workflow runs
 * {@link /workflows/cancel}
 */
export function useWorkflowsControllerCancelWorkflowRuns<TContext>(options: 
{
  mutation?: UseMutationOptions<WorkflowsControllerCancelWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerCancelWorkflowRunsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WorkflowsControllerCancelWorkflowRunsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? workflowsControllerCancelWorkflowRunsMutationKey()

          const baseOptions = workflowsControllerCancelWorkflowRunsMutationOptions(config) as UseMutationOptions<WorkflowsControllerCancelWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerCancelWorkflowRunsMutationRequest}, TContext>
          

          return useMutation<WorkflowsControllerCancelWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerCancelWorkflowRunsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WorkflowsControllerCancelWorkflowRunsMutationResponse, ResponseErrorConfig<Error>, {data: WorkflowsControllerCancelWorkflowRunsMutationRequest}, TContext>
      
}

export const workflowsControllerRetryWorkflowRunMutationKey = () => [{ url: '/workflows/:id/retry' }] as const

export type WorkflowsControllerRetryWorkflowRunMutationKey = ReturnType<typeof workflowsControllerRetryWorkflowRunMutationKey>

export function workflowsControllerRetryWorkflowRunMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WorkflowsControllerRetryWorkflowRunMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = workflowsControllerRetryWorkflowRunMutationKey()
        return mutationOptions<WorkflowsControllerRetryWorkflowRunMutationResponse, ResponseErrorConfig<Error>, {id: WorkflowsControllerRetryWorkflowRunPathParams["id"], data: WorkflowsControllerRetryWorkflowRunMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return workflowsControllerRetryWorkflowRun(id, data, config)
          },
        })

}

/**
 * @summary Retry workflow run
 * {@link /workflows/:id/retry}
 */
export function useWorkflowsControllerRetryWorkflowRun<TContext>(options: 
{
  mutation?: UseMutationOptions<WorkflowsControllerRetryWorkflowRunMutationResponse, ResponseErrorConfig<Error>, {id: WorkflowsControllerRetryWorkflowRunPathParams["id"], data: WorkflowsControllerRetryWorkflowRunMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WorkflowsControllerRetryWorkflowRunMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? workflowsControllerRetryWorkflowRunMutationKey()

          const baseOptions = workflowsControllerRetryWorkflowRunMutationOptions(config) as UseMutationOptions<WorkflowsControllerRetryWorkflowRunMutationResponse, ResponseErrorConfig<Error>, {id: WorkflowsControllerRetryWorkflowRunPathParams["id"], data: WorkflowsControllerRetryWorkflowRunMutationRequest}, TContext>
          

          return useMutation<WorkflowsControllerRetryWorkflowRunMutationResponse, ResponseErrorConfig<Error>, {id: WorkflowsControllerRetryWorkflowRunPathParams["id"], data: WorkflowsControllerRetryWorkflowRunMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WorkflowsControllerRetryWorkflowRunMutationResponse, ResponseErrorConfig<Error>, {id: WorkflowsControllerRetryWorkflowRunPathParams["id"], data: WorkflowsControllerRetryWorkflowRunMutationRequest}, TContext>
      
}

export const yeetControllerSurchargePolicyMutationKey = () => [{ url: '/yeet/surcharge/:policyId' }] as const

export type YeetControllerSurchargePolicyMutationKey = ReturnType<typeof yeetControllerSurchargePolicyMutationKey>

export function yeetControllerSurchargePolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<YeetControllerSurchargePolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = yeetControllerSurchargePolicyMutationKey()
        return mutationOptions<YeetControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: YeetControllerSurchargePolicyPathParams["policyId"], data: YeetControllerSurchargePolicyMutationRequest, params?: YeetControllerSurchargePolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return yeetControllerSurchargePolicy(policyId, data, params, config)
          },
        })

}

/**
 * @summary Surcharge the policy
 * {@link /yeet/surcharge/:policyId}
 */
export function useYeetControllerSurchargePolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<YeetControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: YeetControllerSurchargePolicyPathParams["policyId"], data: YeetControllerSurchargePolicyMutationRequest, params?: YeetControllerSurchargePolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<YeetControllerSurchargePolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? yeetControllerSurchargePolicyMutationKey()

          const baseOptions = yeetControllerSurchargePolicyMutationOptions(config) as UseMutationOptions<YeetControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: YeetControllerSurchargePolicyPathParams["policyId"], data: YeetControllerSurchargePolicyMutationRequest, params?: YeetControllerSurchargePolicyQueryParams}, TContext>
          

          return useMutation<YeetControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: YeetControllerSurchargePolicyPathParams["policyId"], data: YeetControllerSurchargePolicyMutationRequest, params?: YeetControllerSurchargePolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<YeetControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: YeetControllerSurchargePolicyPathParams["policyId"], data: YeetControllerSurchargePolicyMutationRequest, params?: YeetControllerSurchargePolicyQueryParams}, TContext>
      
}

export const yeetControllerAttachDrivequantUserIdToCustomerMutationKey = () => [{ url: '/yeet/:customerId/attach-drivequant-user-id/:drivequantUserId' }] as const

export type YeetControllerAttachDrivequantUserIdToCustomerMutationKey = ReturnType<typeof yeetControllerAttachDrivequantUserIdToCustomerMutationKey>

export function yeetControllerAttachDrivequantUserIdToCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = yeetControllerAttachDrivequantUserIdToCustomerMutationKey()
        return mutationOptions<YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, drivequantUserId }) => {
            return yeetControllerAttachDrivequantUserIdToCustomer(customerId, drivequantUserId, config)
          },
        })

}

/**
 * @summary Attach Drivequant user id to customer
 * {@link /yeet/:customerId/attach-drivequant-user-id/:drivequantUserId}
 */
export function useYeetControllerAttachDrivequantUserIdToCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? yeetControllerAttachDrivequantUserIdToCustomerMutationKey()

          const baseOptions = yeetControllerAttachDrivequantUserIdToCustomerMutationOptions(config) as UseMutationOptions<YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>
          

          return useMutation<YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<YeetControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: YeetControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>
      
}

export const axeceControllerSurchargePolicyMutationKey = () => [{ url: '/axece/surcharge/:policyId' }] as const

export type AxeceControllerSurchargePolicyMutationKey = ReturnType<typeof axeceControllerSurchargePolicyMutationKey>

export function axeceControllerSurchargePolicyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AxeceControllerSurchargePolicyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = axeceControllerSurchargePolicyMutationKey()
        return mutationOptions<AxeceControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: AxeceControllerSurchargePolicyPathParams["policyId"], data: AxeceControllerSurchargePolicyMutationRequest, params?: AxeceControllerSurchargePolicyQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data, params }) => {
            return axeceControllerSurchargePolicy(policyId, data, params, config)
          },
        })

}

/**
 * @summary Surcharge the policy
 * {@link /axece/surcharge/:policyId}
 */
export function useAxeceControllerSurchargePolicy<TContext>(options: 
{
  mutation?: UseMutationOptions<AxeceControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: AxeceControllerSurchargePolicyPathParams["policyId"], data: AxeceControllerSurchargePolicyMutationRequest, params?: AxeceControllerSurchargePolicyQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AxeceControllerSurchargePolicyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? axeceControllerSurchargePolicyMutationKey()

          const baseOptions = axeceControllerSurchargePolicyMutationOptions(config) as UseMutationOptions<AxeceControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: AxeceControllerSurchargePolicyPathParams["policyId"], data: AxeceControllerSurchargePolicyMutationRequest, params?: AxeceControllerSurchargePolicyQueryParams}, TContext>
          

          return useMutation<AxeceControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: AxeceControllerSurchargePolicyPathParams["policyId"], data: AxeceControllerSurchargePolicyMutationRequest, params?: AxeceControllerSurchargePolicyQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AxeceControllerSurchargePolicyMutationResponse, ResponseErrorConfig<Error>, {policyId: AxeceControllerSurchargePolicyPathParams["policyId"], data: AxeceControllerSurchargePolicyMutationRequest, params?: AxeceControllerSurchargePolicyQueryParams}, TContext>
      
}

export const axeceControllerAttachDrivequantUserIdToCustomerMutationKey = () => [{ url: '/axece/:customerId/attach-drivequant-user-id/:drivequantUserId' }] as const

export type AxeceControllerAttachDrivequantUserIdToCustomerMutationKey = ReturnType<typeof axeceControllerAttachDrivequantUserIdToCustomerMutationKey>

export function axeceControllerAttachDrivequantUserIdToCustomerMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = axeceControllerAttachDrivequantUserIdToCustomerMutationKey()
        return mutationOptions<AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>({
          mutationKey,
          mutationFn: async({ customerId, drivequantUserId }) => {
            return axeceControllerAttachDrivequantUserIdToCustomer(customerId, drivequantUserId, config)
          },
        })

}

/**
 * @summary Attach Drivequant user id to customer
 * {@link /axece/:customerId/attach-drivequant-user-id/:drivequantUserId}
 */
export function useAxeceControllerAttachDrivequantUserIdToCustomer<TContext>(options: 
{
  mutation?: UseMutationOptions<AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? axeceControllerAttachDrivequantUserIdToCustomerMutationKey()

          const baseOptions = axeceControllerAttachDrivequantUserIdToCustomerMutationOptions(config) as UseMutationOptions<AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>
          

          return useMutation<AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AxeceControllerAttachDrivequantUserIdToCustomerMutationResponse, ResponseErrorConfig<Error>, {customerId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["customerId"], drivequantUserId: AxeceControllerAttachDrivequantUserIdToCustomerPathParams["drivequantUserId"]}, TContext>
      
}

export const yousignControllerWebhookMutationKey = () => [{ url: '/yousign/webhook' }] as const

export type YousignControllerWebhookMutationKey = ReturnType<typeof yousignControllerWebhookMutationKey>

export function yousignControllerWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = yousignControllerWebhookMutationKey()
        return mutationOptions<YousignControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return yousignControllerWebhook(config)
          },
        })

}

/**
 * {@link /yousign/webhook}
 */
export function useYousignControllerWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<YousignControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? yousignControllerWebhookMutationKey()

          const baseOptions = yousignControllerWebhookMutationOptions(config) as UseMutationOptions<YousignControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<YousignControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<YousignControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const yousignControllerTenantWebhookMutationKey = () => [{ url: '/yousign/webhook/:tenant' }] as const

export type YousignControllerTenantWebhookMutationKey = ReturnType<typeof yousignControllerTenantWebhookMutationKey>

export function yousignControllerTenantWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = yousignControllerTenantWebhookMutationKey()
        return mutationOptions<YousignControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: YousignControllerTenantWebhookPathParams["tenant"]}, TContext>({
          mutationKey,
          mutationFn: async({ tenant }) => {
            return yousignControllerTenantWebhook(tenant, config)
          },
        })

}

/**
 * {@link /yousign/webhook/:tenant}
 */
export function useYousignControllerTenantWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<YousignControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: YousignControllerTenantWebhookPathParams["tenant"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? yousignControllerTenantWebhookMutationKey()

          const baseOptions = yousignControllerTenantWebhookMutationOptions(config) as UseMutationOptions<YousignControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: YousignControllerTenantWebhookPathParams["tenant"]}, TContext>
          

          return useMutation<YousignControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: YousignControllerTenantWebhookPathParams["tenant"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<YousignControllerTenantWebhookMutationResponse, ResponseErrorConfig<Error>, {tenant: YousignControllerTenantWebhookPathParams["tenant"]}, TContext>
      
}

export const emailEngineWebhookControllerWebhookMutationKey = () => [{ url: '/emailengine/webhook' }] as const

export type EmailEngineWebhookControllerWebhookMutationKey = ReturnType<typeof emailEngineWebhookControllerWebhookMutationKey>

export function emailEngineWebhookControllerWebhookMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = emailEngineWebhookControllerWebhookMutationKey()
        return mutationOptions<EmailEngineWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return emailEngineWebhookControllerWebhook(config)
          },
        })

}

/**
 * {@link /emailengine/webhook}
 */
export function useEmailEngineWebhookControllerWebhook<TContext>(options: 
{
  mutation?: UseMutationOptions<EmailEngineWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? emailEngineWebhookControllerWebhookMutationKey()

          const baseOptions = emailEngineWebhookControllerWebhookMutationOptions(config) as UseMutationOptions<EmailEngineWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<EmailEngineWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EmailEngineWebhookControllerWebhookMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const ar24ControllerRegisteredLetterMutationKey = () => [{ url: '/ar24/webhook' }] as const

export type Ar24ControllerRegisteredLetterMutationKey = ReturnType<typeof ar24ControllerRegisteredLetterMutationKey>

export function ar24ControllerRegisteredLetterMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = ar24ControllerRegisteredLetterMutationKey()
        return mutationOptions<Ar24ControllerRegisteredLetterMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return ar24ControllerRegisteredLetter(config)
          },
        })

}

/**
 * @summary Receive AR24 webhook for registered letter
 * {@link /ar24/webhook}
 */
export function useAr24ControllerRegisteredLetter<TContext>(options: 
{
  mutation?: UseMutationOptions<Ar24ControllerRegisteredLetterMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? ar24ControllerRegisteredLetterMutationKey()

          const baseOptions = ar24ControllerRegisteredLetterMutationOptions(config) as UseMutationOptions<Ar24ControllerRegisteredLetterMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<Ar24ControllerRegisteredLetterMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<Ar24ControllerRegisteredLetterMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const adminAr24ControllerCreateUserMutationKey = () => [{ url: '/ar24/users' }] as const

export type AdminAr24ControllerCreateUserMutationKey = ReturnType<typeof adminAr24ControllerCreateUserMutationKey>

export function adminAr24ControllerCreateUserMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AdminAr24ControllerCreateUserMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = adminAr24ControllerCreateUserMutationKey()
        return mutationOptions<AdminAr24ControllerCreateUserMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerCreateUserMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return adminAr24ControllerCreateUser(data, config)
          },
        })

}

/**
 * @summary Create an AR24 account
 * {@link /ar24/users}
 */
export function useAdminAr24ControllerCreateUser<TContext>(options: 
{
  mutation?: UseMutationOptions<AdminAr24ControllerCreateUserMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerCreateUserMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AdminAr24ControllerCreateUserMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? adminAr24ControllerCreateUserMutationKey()

          const baseOptions = adminAr24ControllerCreateUserMutationOptions(config) as UseMutationOptions<AdminAr24ControllerCreateUserMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerCreateUserMutationRequest}, TContext>
          

          return useMutation<AdminAr24ControllerCreateUserMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerCreateUserMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AdminAr24ControllerCreateUserMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerCreateUserMutationRequest}, TContext>
      
}

export const adminAr24ControllerRequestUserAccessMutationKey = () => [{ url: '/ar24/users/request-access' }] as const

export type AdminAr24ControllerRequestUserAccessMutationKey = ReturnType<typeof adminAr24ControllerRequestUserAccessMutationKey>

export function adminAr24ControllerRequestUserAccessMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AdminAr24ControllerRequestUserAccessMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = adminAr24ControllerRequestUserAccessMutationKey()
        return mutationOptions<AdminAr24ControllerRequestUserAccessMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerRequestUserAccessMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return adminAr24ControllerRequestUserAccess(data, config)
          },
        })

}

/**
 * @summary Invite an existing AR24 account to attach itself to our API account
 * {@link /ar24/users/request-access}
 */
export function useAdminAr24ControllerRequestUserAccess<TContext>(options: 
{
  mutation?: UseMutationOptions<AdminAr24ControllerRequestUserAccessMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerRequestUserAccessMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AdminAr24ControllerRequestUserAccessMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? adminAr24ControllerRequestUserAccessMutationKey()

          const baseOptions = adminAr24ControllerRequestUserAccessMutationOptions(config) as UseMutationOptions<AdminAr24ControllerRequestUserAccessMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerRequestUserAccessMutationRequest}, TContext>
          

          return useMutation<AdminAr24ControllerRequestUserAccessMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerRequestUserAccessMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AdminAr24ControllerRequestUserAccessMutationResponse, ResponseErrorConfig<Error>, {data: AdminAr24ControllerRequestUserAccessMutationRequest}, TContext>
      
}

export const adminAr24ControllerUpdateUserMutationKey = () => [{ url: '/ar24/users/:userId' }] as const

export type AdminAr24ControllerUpdateUserMutationKey = ReturnType<typeof adminAr24ControllerUpdateUserMutationKey>

export function adminAr24ControllerUpdateUserMutationOptions<TContext = unknown>(config: Partial<RequestConfig<AdminAr24ControllerUpdateUserMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = adminAr24ControllerUpdateUserMutationKey()
        return mutationOptions<AdminAr24ControllerUpdateUserMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerUpdateUserPathParams["userId"], data: AdminAr24ControllerUpdateUserMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ userId, data }) => {
            return adminAr24ControllerUpdateUser(userId, data, config)
          },
        })

}

/**
 * @summary Update an AR24 account
 * {@link /ar24/users/:userId}
 */
export function useAdminAr24ControllerUpdateUser<TContext>(options: 
{
  mutation?: UseMutationOptions<AdminAr24ControllerUpdateUserMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerUpdateUserPathParams["userId"], data: AdminAr24ControllerUpdateUserMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<AdminAr24ControllerUpdateUserMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? adminAr24ControllerUpdateUserMutationKey()

          const baseOptions = adminAr24ControllerUpdateUserMutationOptions(config) as UseMutationOptions<AdminAr24ControllerUpdateUserMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerUpdateUserPathParams["userId"], data: AdminAr24ControllerUpdateUserMutationRequest}, TContext>
          

          return useMutation<AdminAr24ControllerUpdateUserMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerUpdateUserPathParams["userId"], data: AdminAr24ControllerUpdateUserMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AdminAr24ControllerUpdateUserMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerUpdateUserPathParams["userId"], data: AdminAr24ControllerUpdateUserMutationRequest}, TContext>
      
}

export const adminAr24ControllerRequestUserEulaMutationKey = () => [{ url: '/ar24/users/:userId/request-eula' }] as const

export type AdminAr24ControllerRequestUserEulaMutationKey = ReturnType<typeof adminAr24ControllerRequestUserEulaMutationKey>

export function adminAr24ControllerRequestUserEulaMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = adminAr24ControllerRequestUserEulaMutationKey()
        return mutationOptions<AdminAr24ControllerRequestUserEulaMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerRequestUserEulaPathParams["userId"]}, TContext>({
          mutationKey,
          mutationFn: async({ userId }) => {
            return adminAr24ControllerRequestUserEula(userId, config)
          },
        })

}

/**
 * @summary Ask an AR24 account to accept the EULA
 * {@link /ar24/users/:userId/request-eula}
 */
export function useAdminAr24ControllerRequestUserEula<TContext>(options: 
{
  mutation?: UseMutationOptions<AdminAr24ControllerRequestUserEulaMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerRequestUserEulaPathParams["userId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? adminAr24ControllerRequestUserEulaMutationKey()

          const baseOptions = adminAr24ControllerRequestUserEulaMutationOptions(config) as UseMutationOptions<AdminAr24ControllerRequestUserEulaMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerRequestUserEulaPathParams["userId"]}, TContext>
          

          return useMutation<AdminAr24ControllerRequestUserEulaMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerRequestUserEulaPathParams["userId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AdminAr24ControllerRequestUserEulaMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerRequestUserEulaPathParams["userId"]}, TContext>
      
}

export const adminAr24ControllerResendUserConfirmationMutationKey = () => [{ url: '/ar24/users/:userId/resend-confirmation' }] as const

export type AdminAr24ControllerResendUserConfirmationMutationKey = ReturnType<typeof adminAr24ControllerResendUserConfirmationMutationKey>

export function adminAr24ControllerResendUserConfirmationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = adminAr24ControllerResendUserConfirmationMutationKey()
        return mutationOptions<AdminAr24ControllerResendUserConfirmationMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"]}, TContext>({
          mutationKey,
          mutationFn: async({ userId }) => {
            return adminAr24ControllerResendUserConfirmation(userId, config)
          },
        })

}

/**
 * @summary Resend the address-confirmation email to an AR24 account
 * {@link /ar24/users/:userId/resend-confirmation}
 */
export function useAdminAr24ControllerResendUserConfirmation<TContext>(options: 
{
  mutation?: UseMutationOptions<AdminAr24ControllerResendUserConfirmationMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? adminAr24ControllerResendUserConfirmationMutationKey()

          const baseOptions = adminAr24ControllerResendUserConfirmationMutationOptions(config) as UseMutationOptions<AdminAr24ControllerResendUserConfirmationMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"]}, TContext>
          

          return useMutation<AdminAr24ControllerResendUserConfirmationMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AdminAr24ControllerResendUserConfirmationMutationResponse, ResponseErrorConfig<Error>, {userId: AdminAr24ControllerResendUserConfirmationPathParams["userId"]}, TContext>
      
}

export const sesControllerSesEventMutationKey = () => [{ url: '/ses/webhook' }] as const

export type SesControllerSesEventMutationKey = ReturnType<typeof sesControllerSesEventMutationKey>

export function sesControllerSesEventMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = sesControllerSesEventMutationKey()
        return mutationOptions<SesControllerSesEventMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return sesControllerSesEvent(config)
          },
        })

}

/**
 * @summary Receive SES delivery, bounce and complaint events via SNS
 * {@link /ses/webhook}
 */
export function useSesControllerSesEvent<TContext>(options: 
{
  mutation?: UseMutationOptions<SesControllerSesEventMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? sesControllerSesEventMutationKey()

          const baseOptions = sesControllerSesEventMutationOptions(config) as UseMutationOptions<SesControllerSesEventMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<SesControllerSesEventMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SesControllerSesEventMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const viewSpecificControllerAcknowledgeComplianceAlertMutationKey = () => [{ url: '/view-specific/compliance/:alertId/acknowledge' }] as const

export type ViewSpecificControllerAcknowledgeComplianceAlertMutationKey = ReturnType<typeof viewSpecificControllerAcknowledgeComplianceAlertMutationKey>

export function viewSpecificControllerAcknowledgeComplianceAlertMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = viewSpecificControllerAcknowledgeComplianceAlertMutationKey()
        return mutationOptions<ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>({
          mutationKey,
          mutationFn: async({ alertId }) => {
            return viewSpecificControllerAcknowledgeComplianceAlert(alertId, config)
          },
        })

}

/**
 * @summary Acknowledge compliance alert
 * {@link /view-specific/compliance/:alertId/acknowledge}
 */
export function useViewSpecificControllerAcknowledgeComplianceAlert<TContext>(options: 
{
  mutation?: UseMutationOptions<ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? viewSpecificControllerAcknowledgeComplianceAlertMutationKey()

          const baseOptions = viewSpecificControllerAcknowledgeComplianceAlertMutationOptions(config) as UseMutationOptions<ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>
          

          return useMutation<ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ViewSpecificControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ViewSpecificControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>
      
}

export const viewSpecificControllerCreateActiveTeamMutationKey = () => [{ url: '/view-specific/:brokerageFirmId/create-active-team' }] as const

export type ViewSpecificControllerCreateActiveTeamMutationKey = ReturnType<typeof viewSpecificControllerCreateActiveTeamMutationKey>

export function viewSpecificControllerCreateActiveTeamMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ViewSpecificControllerCreateActiveTeamMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = viewSpecificControllerCreateActiveTeamMutationKey()
        return mutationOptions<ViewSpecificControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"], data: ViewSpecificControllerCreateActiveTeamMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return viewSpecificControllerCreateActiveTeam(brokerageFirmId, data, config)
          },
        })

}

/**
 * @summary Create a new active team (brokerage firm with approved distribution requests)
 * {@link /view-specific/:brokerageFirmId/create-active-team}
 */
export function useViewSpecificControllerCreateActiveTeam<TContext>(options: 
{
  mutation?: UseMutationOptions<ViewSpecificControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"], data: ViewSpecificControllerCreateActiveTeamMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ViewSpecificControllerCreateActiveTeamMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? viewSpecificControllerCreateActiveTeamMutationKey()

          const baseOptions = viewSpecificControllerCreateActiveTeamMutationOptions(config) as UseMutationOptions<ViewSpecificControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"], data: ViewSpecificControllerCreateActiveTeamMutationRequest}, TContext>
          

          return useMutation<ViewSpecificControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"], data: ViewSpecificControllerCreateActiveTeamMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ViewSpecificControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: ViewSpecificControllerCreateActiveTeamPathParams["brokerageFirmId"], data: ViewSpecificControllerCreateActiveTeamMutationRequest}, TContext>
      
}

export const complianceReadsControllerAcknowledgeComplianceAlertMutationKey = () => [{ url: '/compliance/alerts/:alertId/acknowledge' }] as const

export type ComplianceReadsControllerAcknowledgeComplianceAlertMutationKey = ReturnType<typeof complianceReadsControllerAcknowledgeComplianceAlertMutationKey>

export function complianceReadsControllerAcknowledgeComplianceAlertMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = complianceReadsControllerAcknowledgeComplianceAlertMutationKey()
        return mutationOptions<ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>({
          mutationKey,
          mutationFn: async({ alertId }) => {
            return complianceReadsControllerAcknowledgeComplianceAlert(alertId, config)
          },
        })

}

/**
 * @summary Acknowledge a compliance alert
 * {@link /compliance/alerts/:alertId/acknowledge}
 */
export function useComplianceReadsControllerAcknowledgeComplianceAlert<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceReadsControllerAcknowledgeComplianceAlertMutationKey()

          const baseOptions = complianceReadsControllerAcknowledgeComplianceAlertMutationOptions(config) as UseMutationOptions<ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>
          

          return useMutation<ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceReadsControllerAcknowledgeComplianceAlertMutationResponse, ResponseErrorConfig<Error>, {alertId: ComplianceReadsControllerAcknowledgeComplianceAlertPathParams["alertId"]}, TContext>
      
}

export const brokerageFirmsReadsControllerCreateActiveTeamMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/active-teams' }] as const

export type BrokerageFirmsReadsControllerCreateActiveTeamMutationKey = ReturnType<typeof brokerageFirmsReadsControllerCreateActiveTeamMutationKey>

export function brokerageFirmsReadsControllerCreateActiveTeamMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmsReadsControllerCreateActiveTeamMutationKey()
        return mutationOptions<BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"], data: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFirmsReadsControllerCreateActiveTeam(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Creates a brokerage firm together with approved distribution requests.
 * @summary Create an active team
 * {@link /brokerage-firms/:brokerageFirmId/active-teams}
 */
export function useBrokerageFirmsReadsControllerCreateActiveTeam<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"], data: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmsReadsControllerCreateActiveTeamMutationKey()

          const baseOptions = brokerageFirmsReadsControllerCreateActiveTeamMutationOptions(config) as UseMutationOptions<BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"], data: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"], data: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmsReadsControllerCreateActiveTeamMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmsReadsControllerCreateActiveTeamPathParams["brokerageFirmId"], data: BrokerageFirmsReadsControllerCreateActiveTeamMutationRequest}, TContext>
      
}

export const mcpServerControllerHandleRequestMutationKey = () => [{ url: '/mcp' }] as const

export type McpServerControllerHandleRequestMutationKey = ReturnType<typeof mcpServerControllerHandleRequestMutationKey>

export function mcpServerControllerHandleRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = mcpServerControllerHandleRequestMutationKey()
        return mutationOptions<McpServerControllerHandleRequestMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return mcpServerControllerHandleRequest(config)
          },
        })

}

/**
 * @summary MCP: Handle Streamable HTTP request
 * {@link /mcp}
 */
export function useMcpServerControllerHandleRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<McpServerControllerHandleRequestMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? mcpServerControllerHandleRequestMutationKey()

          const baseOptions = mcpServerControllerHandleRequestMutationOptions(config) as UseMutationOptions<McpServerControllerHandleRequestMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<McpServerControllerHandleRequestMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<McpServerControllerHandleRequestMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const complianceControllerCreateCheckMutationKey = () => [{ url: '/compliance/checks' }] as const

export type ComplianceControllerCreateCheckMutationKey = ReturnType<typeof complianceControllerCreateCheckMutationKey>

export function complianceControllerCreateCheckMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ComplianceControllerCreateCheckMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = complianceControllerCreateCheckMutationKey()
        return mutationOptions<ComplianceControllerCreateCheckMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerCreateCheckMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return complianceControllerCreateCheck(data, config)
          },
        })

}

/**
 * @summary Create compliance check
 * {@link /compliance/checks}
 */
export function useComplianceControllerCreateCheck<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerCreateCheckMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerCreateCheckMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ComplianceControllerCreateCheckMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerCreateCheckMutationKey()

          const baseOptions = complianceControllerCreateCheckMutationOptions(config) as UseMutationOptions<ComplianceControllerCreateCheckMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerCreateCheckMutationRequest}, TContext>
          

          return useMutation<ComplianceControllerCreateCheckMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerCreateCheckMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerCreateCheckMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerCreateCheckMutationRequest}, TContext>
      
}

export const complianceControllerUpdateCheckMutationKey = () => [{ url: '/compliance/checks/:checkId' }] as const

export type ComplianceControllerUpdateCheckMutationKey = ReturnType<typeof complianceControllerUpdateCheckMutationKey>

export function complianceControllerUpdateCheckMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ComplianceControllerUpdateCheckMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = complianceControllerUpdateCheckMutationKey()
        return mutationOptions<ComplianceControllerUpdateCheckMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateCheck404>, {checkId: ComplianceControllerUpdateCheckPathParams["checkId"], data: ComplianceControllerUpdateCheckMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ checkId, data }) => {
            return complianceControllerUpdateCheck(checkId, data, config)
          },
        })

}

/**
 * @summary Update compliance check
 * {@link /compliance/checks/:checkId}
 */
export function useComplianceControllerUpdateCheck<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerUpdateCheckMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateCheck404>, {checkId: ComplianceControllerUpdateCheckPathParams["checkId"], data: ComplianceControllerUpdateCheckMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ComplianceControllerUpdateCheckMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerUpdateCheckMutationKey()

          const baseOptions = complianceControllerUpdateCheckMutationOptions(config) as UseMutationOptions<ComplianceControllerUpdateCheckMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateCheck404>, {checkId: ComplianceControllerUpdateCheckPathParams["checkId"], data: ComplianceControllerUpdateCheckMutationRequest}, TContext>
          

          return useMutation<ComplianceControllerUpdateCheckMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateCheck404>, {checkId: ComplianceControllerUpdateCheckPathParams["checkId"], data: ComplianceControllerUpdateCheckMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerUpdateCheckMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateCheck404>, {checkId: ComplianceControllerUpdateCheckPathParams["checkId"], data: ComplianceControllerUpdateCheckMutationRequest}, TContext>
      
}

export const complianceControllerDeleteCheckMutationKey = () => [{ url: '/compliance/checks/:checkId' }] as const

export type ComplianceControllerDeleteCheckMutationKey = ReturnType<typeof complianceControllerDeleteCheckMutationKey>

export function complianceControllerDeleteCheckMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = complianceControllerDeleteCheckMutationKey()
        return mutationOptions<ComplianceControllerDeleteCheckMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteCheck404>, {checkId: ComplianceControllerDeleteCheckPathParams["checkId"]}, TContext>({
          mutationKey,
          mutationFn: async({ checkId }) => {
            return complianceControllerDeleteCheck(checkId, config)
          },
        })

}

/**
 * @summary Delete compliance check
 * {@link /compliance/checks/:checkId}
 */
export function useComplianceControllerDeleteCheck<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerDeleteCheckMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteCheck404>, {checkId: ComplianceControllerDeleteCheckPathParams["checkId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerDeleteCheckMutationKey()

          const baseOptions = complianceControllerDeleteCheckMutationOptions(config) as UseMutationOptions<ComplianceControllerDeleteCheckMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteCheck404>, {checkId: ComplianceControllerDeleteCheckPathParams["checkId"]}, TContext>
          

          return useMutation<ComplianceControllerDeleteCheckMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteCheck404>, {checkId: ComplianceControllerDeleteCheckPathParams["checkId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerDeleteCheckMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteCheck404>, {checkId: ComplianceControllerDeleteCheckPathParams["checkId"]}, TContext>
      
}

export const complianceControllerCreateAlertMutationKey = () => [{ url: '/compliance/alerts' }] as const

export type ComplianceControllerCreateAlertMutationKey = ReturnType<typeof complianceControllerCreateAlertMutationKey>

export function complianceControllerCreateAlertMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ComplianceControllerCreateAlertMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = complianceControllerCreateAlertMutationKey()
        return mutationOptions<ComplianceControllerCreateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerCreateAlert404>, {data: ComplianceControllerCreateAlertMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return complianceControllerCreateAlert(data, config)
          },
        })

}

/**
 * @summary Create compliance alert
 * {@link /compliance/alerts}
 */
export function useComplianceControllerCreateAlert<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerCreateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerCreateAlert404>, {data: ComplianceControllerCreateAlertMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ComplianceControllerCreateAlertMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerCreateAlertMutationKey()

          const baseOptions = complianceControllerCreateAlertMutationOptions(config) as UseMutationOptions<ComplianceControllerCreateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerCreateAlert404>, {data: ComplianceControllerCreateAlertMutationRequest}, TContext>
          

          return useMutation<ComplianceControllerCreateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerCreateAlert404>, {data: ComplianceControllerCreateAlertMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerCreateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerCreateAlert404>, {data: ComplianceControllerCreateAlertMutationRequest}, TContext>
      
}

export const complianceControllerAcknowledgeAlertsByEntityMutationKey = () => [{ url: '/compliance/alerts/acknowledge/:entityId' }] as const

export type ComplianceControllerAcknowledgeAlertsByEntityMutationKey = ReturnType<typeof complianceControllerAcknowledgeAlertsByEntityMutationKey>

export function complianceControllerAcknowledgeAlertsByEntityMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = complianceControllerAcknowledgeAlertsByEntityMutationKey()
        return mutationOptions<ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ResponseErrorConfig<Error>, {entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"]}, TContext>({
          mutationKey,
          mutationFn: async({ entityId }) => {
            return complianceControllerAcknowledgeAlertsByEntity(entityId, config)
          },
        })

}

/**
 * @summary Acknowledge all alerts for an entity
 * {@link /compliance/alerts/acknowledge/:entityId}
 */
export function useComplianceControllerAcknowledgeAlertsByEntity<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ResponseErrorConfig<Error>, {entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerAcknowledgeAlertsByEntityMutationKey()

          const baseOptions = complianceControllerAcknowledgeAlertsByEntityMutationOptions(config) as UseMutationOptions<ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ResponseErrorConfig<Error>, {entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"]}, TContext>
          

          return useMutation<ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ResponseErrorConfig<Error>, {entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerAcknowledgeAlertsByEntityMutationResponse, ResponseErrorConfig<Error>, {entityId: ComplianceControllerAcknowledgeAlertsByEntityPathParams["entityId"]}, TContext>
      
}

export const complianceControllerAcknowledgeAlertsByCheckIdsMutationKey = () => [{ url: '/compliance/alerts/acknowledge-by-check-ids' }] as const

export type ComplianceControllerAcknowledgeAlertsByCheckIdsMutationKey = ReturnType<typeof complianceControllerAcknowledgeAlertsByCheckIdsMutationKey>

export function complianceControllerAcknowledgeAlertsByCheckIdsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = complianceControllerAcknowledgeAlertsByCheckIdsMutationKey()
        return mutationOptions<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return complianceControllerAcknowledgeAlertsByCheckIds(data, config)
          },
        })

}

/**
 * @summary Acknowledge all alerts for given check IDs
 * {@link /compliance/alerts/acknowledge-by-check-ids}
 */
export function useComplianceControllerAcknowledgeAlertsByCheckIds<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerAcknowledgeAlertsByCheckIdsMutationKey()

          const baseOptions = complianceControllerAcknowledgeAlertsByCheckIdsMutationOptions(config) as UseMutationOptions<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest}, TContext>
          

          return useMutation<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerAcknowledgeAlertsByCheckIdsMutationResponse, ResponseErrorConfig<Error>, {data: ComplianceControllerAcknowledgeAlertsByCheckIdsMutationRequest}, TContext>
      
}

export const complianceControllerUpdateAlertMutationKey = () => [{ url: '/compliance/alerts/:alertId' }] as const

export type ComplianceControllerUpdateAlertMutationKey = ReturnType<typeof complianceControllerUpdateAlertMutationKey>

export function complianceControllerUpdateAlertMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ComplianceControllerUpdateAlertMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = complianceControllerUpdateAlertMutationKey()
        return mutationOptions<ComplianceControllerUpdateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateAlert404>, {alertId: ComplianceControllerUpdateAlertPathParams["alertId"], data: ComplianceControllerUpdateAlertMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ alertId, data }) => {
            return complianceControllerUpdateAlert(alertId, data, config)
          },
        })

}

/**
 * @summary Update compliance alert
 * {@link /compliance/alerts/:alertId}
 */
export function useComplianceControllerUpdateAlert<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerUpdateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateAlert404>, {alertId: ComplianceControllerUpdateAlertPathParams["alertId"], data: ComplianceControllerUpdateAlertMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ComplianceControllerUpdateAlertMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerUpdateAlertMutationKey()

          const baseOptions = complianceControllerUpdateAlertMutationOptions(config) as UseMutationOptions<ComplianceControllerUpdateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateAlert404>, {alertId: ComplianceControllerUpdateAlertPathParams["alertId"], data: ComplianceControllerUpdateAlertMutationRequest}, TContext>
          

          return useMutation<ComplianceControllerUpdateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateAlert404>, {alertId: ComplianceControllerUpdateAlertPathParams["alertId"], data: ComplianceControllerUpdateAlertMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerUpdateAlertMutationResponse, ResponseErrorConfig<ComplianceControllerUpdateAlert404>, {alertId: ComplianceControllerUpdateAlertPathParams["alertId"], data: ComplianceControllerUpdateAlertMutationRequest}, TContext>
      
}

export const complianceControllerDeleteAlertMutationKey = () => [{ url: '/compliance/alerts/:alertId' }] as const

export type ComplianceControllerDeleteAlertMutationKey = ReturnType<typeof complianceControllerDeleteAlertMutationKey>

export function complianceControllerDeleteAlertMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = complianceControllerDeleteAlertMutationKey()
        return mutationOptions<ComplianceControllerDeleteAlertMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteAlert404>, {alertId: ComplianceControllerDeleteAlertPathParams["alertId"]}, TContext>({
          mutationKey,
          mutationFn: async({ alertId }) => {
            return complianceControllerDeleteAlert(alertId, config)
          },
        })

}

/**
 * @summary Delete compliance alert
 * {@link /compliance/alerts/:alertId}
 */
export function useComplianceControllerDeleteAlert<TContext>(options: 
{
  mutation?: UseMutationOptions<ComplianceControllerDeleteAlertMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteAlert404>, {alertId: ComplianceControllerDeleteAlertPathParams["alertId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? complianceControllerDeleteAlertMutationKey()

          const baseOptions = complianceControllerDeleteAlertMutationOptions(config) as UseMutationOptions<ComplianceControllerDeleteAlertMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteAlert404>, {alertId: ComplianceControllerDeleteAlertPathParams["alertId"]}, TContext>
          

          return useMutation<ComplianceControllerDeleteAlertMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteAlert404>, {alertId: ComplianceControllerDeleteAlertPathParams["alertId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ComplianceControllerDeleteAlertMutationResponse, ResponseErrorConfig<ComplianceControllerDeleteAlert404>, {alertId: ComplianceControllerDeleteAlertPathParams["alertId"]}, TContext>
      
}

export const relationsControllerCreateRelationMutationKey = () => [{ url: '/relations' }] as const

export type RelationsControllerCreateRelationMutationKey = ReturnType<typeof relationsControllerCreateRelationMutationKey>

export function relationsControllerCreateRelationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<RelationsControllerCreateRelationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = relationsControllerCreateRelationMutationKey()
        return mutationOptions<RelationsControllerCreateRelationMutationResponse, ResponseErrorConfig<Error>, {data: RelationsControllerCreateRelationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return relationsControllerCreateRelation(data, config)
          },
        })

}

/**
 * @summary Create a relation
 * {@link /relations}
 */
export function useRelationsControllerCreateRelation<TContext>(options: 
{
  mutation?: UseMutationOptions<RelationsControllerCreateRelationMutationResponse, ResponseErrorConfig<Error>, {data: RelationsControllerCreateRelationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<RelationsControllerCreateRelationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? relationsControllerCreateRelationMutationKey()

          const baseOptions = relationsControllerCreateRelationMutationOptions(config) as UseMutationOptions<RelationsControllerCreateRelationMutationResponse, ResponseErrorConfig<Error>, {data: RelationsControllerCreateRelationMutationRequest}, TContext>
          

          return useMutation<RelationsControllerCreateRelationMutationResponse, ResponseErrorConfig<Error>, {data: RelationsControllerCreateRelationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RelationsControllerCreateRelationMutationResponse, ResponseErrorConfig<Error>, {data: RelationsControllerCreateRelationMutationRequest}, TContext>
      
}

export const relationsControllerDeleteRelationMutationKey = () => [{ url: '/relations/:relationId' }] as const

export type RelationsControllerDeleteRelationMutationKey = ReturnType<typeof relationsControllerDeleteRelationMutationKey>

export function relationsControllerDeleteRelationMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = relationsControllerDeleteRelationMutationKey()
        return mutationOptions<RelationsControllerDeleteRelationMutationResponse, ResponseErrorConfig<Error>, {relationId: RelationsControllerDeleteRelationPathParams["relationId"]}, TContext>({
          mutationKey,
          mutationFn: async({ relationId }) => {
            return relationsControllerDeleteRelation(relationId, config)
          },
        })

}

/**
 * @summary Delete a relation
 * {@link /relations/:relationId}
 */
export function useRelationsControllerDeleteRelation<TContext>(options: 
{
  mutation?: UseMutationOptions<RelationsControllerDeleteRelationMutationResponse, ResponseErrorConfig<Error>, {relationId: RelationsControllerDeleteRelationPathParams["relationId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? relationsControllerDeleteRelationMutationKey()

          const baseOptions = relationsControllerDeleteRelationMutationOptions(config) as UseMutationOptions<RelationsControllerDeleteRelationMutationResponse, ResponseErrorConfig<Error>, {relationId: RelationsControllerDeleteRelationPathParams["relationId"]}, TContext>
          

          return useMutation<RelationsControllerDeleteRelationMutationResponse, ResponseErrorConfig<Error>, {relationId: RelationsControllerDeleteRelationPathParams["relationId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RelationsControllerDeleteRelationMutationResponse, ResponseErrorConfig<Error>, {relationId: RelationsControllerDeleteRelationPathParams["relationId"]}, TContext>
      
}

export const brokerageFirmControllerCreateBrokerageFirmMutationKey = () => [{ url: '/brokerage-firms' }] as const

export type BrokerageFirmControllerCreateBrokerageFirmMutationKey = ReturnType<typeof brokerageFirmControllerCreateBrokerageFirmMutationKey>

export function brokerageFirmControllerCreateBrokerageFirmMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerCreateBrokerageFirmMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerCreateBrokerageFirmMutationKey()
        return mutationOptions<BrokerageFirmControllerCreateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404>, {data: BrokerageFirmControllerCreateBrokerageFirmMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return brokerageFirmControllerCreateBrokerageFirm(data, config)
          },
        })

}

/**
 * @description Creates a brokerage firm for the tenant using the provided configuration. Requires a valid authenticated user. The body contains company, product, and commission configuration.
 * @summary Create brokerage firm
 * {@link /brokerage-firms}
 */
export function useBrokerageFirmControllerCreateBrokerageFirm<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerCreateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404>, {data: BrokerageFirmControllerCreateBrokerageFirmMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerCreateBrokerageFirmMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerCreateBrokerageFirmMutationKey()

          const baseOptions = brokerageFirmControllerCreateBrokerageFirmMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerCreateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404>, {data: BrokerageFirmControllerCreateBrokerageFirmMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerCreateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404>, {data: BrokerageFirmControllerCreateBrokerageFirmMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerCreateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerCreateBrokerageFirm400 | BrokerageFirmControllerCreateBrokerageFirm404>, {data: BrokerageFirmControllerCreateBrokerageFirmMutationRequest}, TContext>
      
}

export const brokerageFirmControllerUpdateBrokerageFirmMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId' }] as const

export type BrokerageFirmControllerUpdateBrokerageFirmMutationKey = ReturnType<typeof brokerageFirmControllerUpdateBrokerageFirmMutationKey>

export function brokerageFirmControllerUpdateBrokerageFirmMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerUpdateBrokerageFirmMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerUpdateBrokerageFirmMutationKey()
        return mutationOptions<BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404>, {brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"], data: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFirmControllerUpdateBrokerageFirm(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Updates a brokerage firm identified by brokerageFirmId. Provide only the fields that should be changed in the body. Requires edit permissions on the brokerage firm.
 * @summary Update brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId}
 */
export function useBrokerageFirmControllerUpdateBrokerageFirm<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404>, {brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"], data: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerUpdateBrokerageFirmMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerUpdateBrokerageFirmMutationKey()

          const baseOptions = brokerageFirmControllerUpdateBrokerageFirmMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404>, {brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"], data: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404>, {brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"], data: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerUpdateBrokerageFirmMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdateBrokerageFirm400 | BrokerageFirmControllerUpdateBrokerageFirm404>, {brokerageFirmId: BrokerageFirmControllerUpdateBrokerageFirmPathParams["brokerageFirmId"], data: BrokerageFirmControllerUpdateBrokerageFirmMutationRequest}, TContext>
      
}

export const brokerageFirmControllerGenerateUploadDocumentUrlMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents' }] as const

export type BrokerageFirmControllerGenerateUploadDocumentUrlMutationKey = ReturnType<typeof brokerageFirmControllerGenerateUploadDocumentUrlMutationKey>

export function brokerageFirmControllerGenerateUploadDocumentUrlMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerGenerateUploadDocumentUrlMutationKey()
        return mutationOptions<BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404>, {brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, params?: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data, params }) => {
            return brokerageFirmControllerGenerateUploadDocumentUrl(brokerageFirmId, data, params, config)
          },
        })

}

/**
 * @description Generates a presigned URL to upload a document to the brokerage firm. Provide document metadata in the body and any additional parameters in the query.
 * @summary Generate Upload Document Url
 * {@link /brokerage-firms/:brokerageFirmId/documents}
 */
export function useBrokerageFirmControllerGenerateUploadDocumentUrl<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404>, {brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, params?: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerGenerateUploadDocumentUrlMutationKey()

          const baseOptions = brokerageFirmControllerGenerateUploadDocumentUrlMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404>, {brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, params?: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams}, TContext>
          

          return useMutation<BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404>, {brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, params?: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerGenerateUploadDocumentUrlMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateUploadDocumentUrl400 | BrokerageFirmControllerGenerateUploadDocumentUrl403 | BrokerageFirmControllerGenerateUploadDocumentUrl404>, {brokerageFirmId: BrokerageFirmControllerGenerateUploadDocumentUrlPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateUploadDocumentUrlMutationRequest, params?: BrokerageFirmControllerGenerateUploadDocumentUrlQueryParams}, TContext>
      
}

export const brokerageFirmControllerDeleteDocumentsMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents' }] as const

export type BrokerageFirmControllerDeleteDocumentsMutationKey = ReturnType<typeof brokerageFirmControllerDeleteDocumentsMutationKey>

export function brokerageFirmControllerDeleteDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerDeleteDocumentsMutationKey()
        return mutationOptions<BrokerageFirmControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404>, {brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"], params: BrokerageFirmControllerDeleteDocumentsQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, params }) => {
            return brokerageFirmControllerDeleteDocuments(brokerageFirmId, params, config)
          },
        })

}

/**
 * @description Deletes documents belonging to the brokerage firm matching the provided query filter.
 * @summary Delete documents on brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents}
 */
export function useBrokerageFirmControllerDeleteDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404>, {brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"], params: BrokerageFirmControllerDeleteDocumentsQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerDeleteDocumentsMutationKey()

          const baseOptions = brokerageFirmControllerDeleteDocumentsMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404>, {brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"], params: BrokerageFirmControllerDeleteDocumentsQueryParams}, TContext>
          

          return useMutation<BrokerageFirmControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404>, {brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"], params: BrokerageFirmControllerDeleteDocumentsQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerDeleteDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeleteDocuments400 | BrokerageFirmControllerDeleteDocuments403 | BrokerageFirmControllerDeleteDocuments404>, {brokerageFirmId: BrokerageFirmControllerDeleteDocumentsPathParams["brokerageFirmId"], params: BrokerageFirmControllerDeleteDocumentsQueryParams}, TContext>
      
}

export const brokerageFirmControllerGenerateReportMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/reports' }] as const

export type BrokerageFirmControllerGenerateReportMutationKey = ReturnType<typeof brokerageFirmControllerGenerateReportMutationKey>

export function brokerageFirmControllerGenerateReportMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerGenerateReportMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerGenerateReportMutationKey()
        return mutationOptions<BrokerageFirmControllerGenerateReportMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateReportMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFirmControllerGenerateReport(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Generates a report for the specified brokerage firm using the parameters provided in the body.
 * @summary Generate report for brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/reports}
 */
export function useBrokerageFirmControllerGenerateReport<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerGenerateReportMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateReportMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerGenerateReportMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerGenerateReportMutationKey()

          const baseOptions = brokerageFirmControllerGenerateReportMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerGenerateReportMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateReportMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerGenerateReportMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateReportMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerGenerateReportMutationResponse, ResponseErrorConfig<Error>, {brokerageFirmId: BrokerageFirmControllerGenerateReportPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateReportMutationRequest}, TContext>
      
}

export const brokerageFirmControllerGetCommissionStatementDocumentMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/commission-statements/documents' }] as const

export type BrokerageFirmControllerGetCommissionStatementDocumentMutationKey = ReturnType<typeof brokerageFirmControllerGetCommissionStatementDocumentMutationKey>

export function brokerageFirmControllerGetCommissionStatementDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerGetCommissionStatementDocumentMutationKey()
        return mutationOptions<BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404>, {brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"], data: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFirmControllerGetCommissionStatementDocument(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Renders the document of the given type and period the first time it is asked for, then returns that same document. An annual declaration is read from the monthly statements.
 * @summary Get a commission statement document of a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/commission-statements/documents}
 */
export function useBrokerageFirmControllerGetCommissionStatementDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404>, {brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"], data: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerGetCommissionStatementDocumentMutationKey()

          const baseOptions = brokerageFirmControllerGetCommissionStatementDocumentMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404>, {brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"], data: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404>, {brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"], data: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerGetCommissionStatementDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGetCommissionStatementDocument400 | BrokerageFirmControllerGetCommissionStatementDocument403 | BrokerageFirmControllerGetCommissionStatementDocument404>, {brokerageFirmId: BrokerageFirmControllerGetCommissionStatementDocumentPathParams["brokerageFirmId"], data: BrokerageFirmControllerGetCommissionStatementDocumentMutationRequest}, TContext>
      
}

export const brokerageFirmControllerGenerateDocumentsForSignatureMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents-for-signature' }] as const

export type BrokerageFirmControllerGenerateDocumentsForSignatureMutationKey = ReturnType<typeof brokerageFirmControllerGenerateDocumentsForSignatureMutationKey>

export function brokerageFirmControllerGenerateDocumentsForSignatureMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerGenerateDocumentsForSignatureMutationKey()
        return mutationOptions<BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateDocumentsForSignature404>, {brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"], params?: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, params }) => {
            return brokerageFirmControllerGenerateDocumentsForSignature(brokerageFirmId, params, config)
          },
        })

}

/**
 * @description Generates all required documents for a signature request for the brokerage firm based on product configuration.
 * @summary Generate necessary documents for signature request
 * {@link /brokerage-firms/:brokerageFirmId/documents-for-signature}
 */
export function useBrokerageFirmControllerGenerateDocumentsForSignature<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateDocumentsForSignature404>, {brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"], params?: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerGenerateDocumentsForSignatureMutationKey()

          const baseOptions = brokerageFirmControllerGenerateDocumentsForSignatureMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateDocumentsForSignature404>, {brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"], params?: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams}, TContext>
          

          return useMutation<BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateDocumentsForSignature404>, {brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"], params?: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerGenerateDocumentsForSignatureMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateDocumentsForSignature404>, {brokerageFirmId: BrokerageFirmControllerGenerateDocumentsForSignaturePathParams["brokerageFirmId"], params?: BrokerageFirmControllerGenerateDocumentsForSignatureQueryParams}, TContext>
      
}

export const brokerageFirmControllerGenerateSignatureRequestMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/signature' }] as const

export type BrokerageFirmControllerGenerateSignatureRequestMutationKey = ReturnType<typeof brokerageFirmControllerGenerateSignatureRequestMutationKey>

export function brokerageFirmControllerGenerateSignatureRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerGenerateSignatureRequestMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerGenerateSignatureRequestMutationKey()
        return mutationOptions<BrokerageFirmControllerGenerateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateSignatureRequest404>, {brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateSignatureRequestMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFirmControllerGenerateSignatureRequest(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description Creates a signature request for the brokerage firm using the provided payload.
 * @summary Generate signature request
 * {@link /brokerage-firms/:brokerageFirmId/signature}
 */
export function useBrokerageFirmControllerGenerateSignatureRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerGenerateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateSignatureRequest404>, {brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateSignatureRequestMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerGenerateSignatureRequestMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerGenerateSignatureRequestMutationKey()

          const baseOptions = brokerageFirmControllerGenerateSignatureRequestMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerGenerateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateSignatureRequest404>, {brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateSignatureRequestMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerGenerateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateSignatureRequest404>, {brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateSignatureRequestMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerGenerateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateSignatureRequest404>, {brokerageFirmId: BrokerageFirmControllerGenerateSignatureRequestPathParams["brokerageFirmId"], data: BrokerageFirmControllerGenerateSignatureRequestMutationRequest}, TContext>
      
}

export const brokerageFirmControllerGenerateMandateSignatureRequestMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId/signature' }] as const

export type BrokerageFirmControllerGenerateMandateSignatureRequestMutationKey = ReturnType<typeof brokerageFirmControllerGenerateMandateSignatureRequestMutationKey>

export function brokerageFirmControllerGenerateMandateSignatureRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerGenerateMandateSignatureRequestMutationKey()
        return mutationOptions<BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425>, {brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, paymentMethodId, data }) => {
            return brokerageFirmControllerGenerateMandateSignatureRequest(brokerageFirmId, paymentMethodId, data, config)
          },
        })

}

/**
 * @description Creates a signature request for a SEPA mandate document for the brokerage firm payment method. The firm must already have a company name and an email address, since they identify the signer. If either is missing, the request fails with MISSING_BROKERAGE_FIRM_CONTACT_FIELDS.
 * @summary Generate mandate signature request
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId/signature}
 */
export function useBrokerageFirmControllerGenerateMandateSignatureRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425>, {brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerGenerateMandateSignatureRequestMutationKey()

          const baseOptions = brokerageFirmControllerGenerateMandateSignatureRequestMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425>, {brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425>, {brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerGenerateMandateSignatureRequestMutationResponse, ResponseErrorConfig<BrokerageFirmControllerGenerateMandateSignatureRequest400 | BrokerageFirmControllerGenerateMandateSignatureRequest404 | BrokerageFirmControllerGenerateMandateSignatureRequest409 | BrokerageFirmControllerGenerateMandateSignatureRequest425>, {brokerageFirmId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerGenerateMandateSignatureRequestPathParams["paymentMethodId"], data: BrokerageFirmControllerGenerateMandateSignatureRequestMutationRequest}, TContext>
      
}

export const brokerageFirmControllerUpdatePreferredPaymentMethodMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId/preferred' }] as const

export type BrokerageFirmControllerUpdatePreferredPaymentMethodMutationKey = ReturnType<typeof brokerageFirmControllerUpdatePreferredPaymentMethodMutationKey>

export function brokerageFirmControllerUpdatePreferredPaymentMethodMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerUpdatePreferredPaymentMethodMutationKey()
        return mutationOptions<BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, paymentMethodId }) => {
            return brokerageFirmControllerUpdatePreferredPaymentMethod(brokerageFirmId, paymentMethodId, config)
          },
        })

}

/**
 * @summary Update brokerage firm preferred payment method
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId/preferred}
 */
export function useBrokerageFirmControllerUpdatePreferredPaymentMethod<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerUpdatePreferredPaymentMethodMutationKey()

          const baseOptions = brokerageFirmControllerUpdatePreferredPaymentMethodMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]}, TContext>
          

          return useMutation<BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerUpdatePreferredPaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerUpdatePreferredPaymentMethod400 | BrokerageFirmControllerUpdatePreferredPaymentMethod404 | BrokerageFirmControllerUpdatePreferredPaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerUpdatePreferredPaymentMethodPathParams["paymentMethodId"]}, TContext>
      
}

export const brokerageFirmControllerDeletePaymentMethodMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId' }] as const

export type BrokerageFirmControllerDeletePaymentMethodMutationKey = ReturnType<typeof brokerageFirmControllerDeletePaymentMethodMutationKey>

export function brokerageFirmControllerDeletePaymentMethodMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerDeletePaymentMethodMutationKey()
        return mutationOptions<BrokerageFirmControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, paymentMethodId }) => {
            return brokerageFirmControllerDeletePaymentMethod(brokerageFirmId, paymentMethodId, config)
          },
        })

}

/**
 * @description The payment method stops being used for billing.
 * @summary Remove a brokerage firm payment method
 * {@link /brokerage-firms/:brokerageFirmId/payment-methods/:paymentMethodId}
 */
export function useBrokerageFirmControllerDeletePaymentMethod<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerDeletePaymentMethodMutationKey()

          const baseOptions = brokerageFirmControllerDeletePaymentMethodMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>
          

          return useMutation<BrokerageFirmControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerDeletePaymentMethodMutationResponse, ResponseErrorConfig<BrokerageFirmControllerDeletePaymentMethod404 | BrokerageFirmControllerDeletePaymentMethod409>, {brokerageFirmId: BrokerageFirmControllerDeletePaymentMethodPathParams["brokerageFirmId"], paymentMethodId: BrokerageFirmControllerDeletePaymentMethodPathParams["paymentMethodId"]}, TContext>
      
}

export const brokerageFirmControllerTransferPoliciesMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/transfer' }] as const

export type BrokerageFirmControllerTransferPoliciesMutationKey = ReturnType<typeof brokerageFirmControllerTransferPoliciesMutationKey>

export function brokerageFirmControllerTransferPoliciesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmControllerTransferPoliciesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmControllerTransferPoliciesMutationKey()
        return mutationOptions<BrokerageFirmControllerTransferPoliciesMutationResponse, ResponseErrorConfig<BrokerageFirmControllerTransferPolicies404>, {brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"], data: BrokerageFirmControllerTransferPoliciesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFirmControllerTransferPolicies(brokerageFirmId, data, config)
          },
        })

}

/**
 * @description `brokerageFirmId` in the path is the target firm; `policyIds` (max 500) in the body are the policies to move, each moved from whatever firm it is currently on — no shared source is required or checked. Each transfer runs as its own async job: no approved distribution request for the target firm and product fails that job with DISTRIBUTION_REQUEST_CONFLICT. Applies to every branch, open or closed, so brokers on the old firm lose access and brokers on the new firm see the policy immediately. Korint staff only.
 * @summary Transfer policies to a different brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/transfer}
 */
export function useBrokerageFirmControllerTransferPolicies<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmControllerTransferPoliciesMutationResponse, ResponseErrorConfig<BrokerageFirmControllerTransferPolicies404>, {brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"], data: BrokerageFirmControllerTransferPoliciesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmControllerTransferPoliciesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmControllerTransferPoliciesMutationKey()

          const baseOptions = brokerageFirmControllerTransferPoliciesMutationOptions(config) as UseMutationOptions<BrokerageFirmControllerTransferPoliciesMutationResponse, ResponseErrorConfig<BrokerageFirmControllerTransferPolicies404>, {brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"], data: BrokerageFirmControllerTransferPoliciesMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmControllerTransferPoliciesMutationResponse, ResponseErrorConfig<BrokerageFirmControllerTransferPolicies404>, {brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"], data: BrokerageFirmControllerTransferPoliciesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmControllerTransferPoliciesMutationResponse, ResponseErrorConfig<BrokerageFirmControllerTransferPolicies404>, {brokerageFirmId: BrokerageFirmControllerTransferPoliciesPathParams["brokerageFirmId"], data: BrokerageFirmControllerTransferPoliciesMutationRequest}, TContext>
      
}

export const distributionRequestControllerCreateManyDistributionRequestsMutationKey = () => [{ url: '/distribution-requests' }] as const

export type DistributionRequestControllerCreateManyDistributionRequestsMutationKey = ReturnType<typeof distributionRequestControllerCreateManyDistributionRequestsMutationKey>

export function distributionRequestControllerCreateManyDistributionRequestsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DistributionRequestControllerCreateManyDistributionRequestsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = distributionRequestControllerCreateManyDistributionRequestsMutationKey()
        return mutationOptions<DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, ResponseErrorConfig<DistributionRequestControllerCreateManyDistributionRequests409>, {data: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return distributionRequestControllerCreateManyDistributionRequests(data, config)
          },
        })

}

/**
 * @summary Create many distribution requests
 * {@link /distribution-requests}
 */
export function useDistributionRequestControllerCreateManyDistributionRequests<TContext>(options: 
{
  mutation?: UseMutationOptions<DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, ResponseErrorConfig<DistributionRequestControllerCreateManyDistributionRequests409>, {data: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DistributionRequestControllerCreateManyDistributionRequestsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? distributionRequestControllerCreateManyDistributionRequestsMutationKey()

          const baseOptions = distributionRequestControllerCreateManyDistributionRequestsMutationOptions(config) as UseMutationOptions<DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, ResponseErrorConfig<DistributionRequestControllerCreateManyDistributionRequests409>, {data: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest}, TContext>
          

          return useMutation<DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, ResponseErrorConfig<DistributionRequestControllerCreateManyDistributionRequests409>, {data: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DistributionRequestControllerCreateManyDistributionRequestsMutationResponse, ResponseErrorConfig<DistributionRequestControllerCreateManyDistributionRequests409>, {data: DistributionRequestControllerCreateManyDistributionRequestsMutationRequest}, TContext>
      
}

export const distributionRequestControllerApproveDistributionRequestMutationKey = () => [{ url: '/distribution-requests/:id/approve' }] as const

export type DistributionRequestControllerApproveDistributionRequestMutationKey = ReturnType<typeof distributionRequestControllerApproveDistributionRequestMutationKey>

export function distributionRequestControllerApproveDistributionRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = distributionRequestControllerApproveDistributionRequestMutationKey()
        return mutationOptions<DistributionRequestControllerApproveDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409>, {id: DistributionRequestControllerApproveDistributionRequestPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return distributionRequestControllerApproveDistributionRequest(id, config)
          },
        })

}

/**
 * @summary Approve a distribution request
 * {@link /distribution-requests/:id/approve}
 */
export function useDistributionRequestControllerApproveDistributionRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<DistributionRequestControllerApproveDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409>, {id: DistributionRequestControllerApproveDistributionRequestPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? distributionRequestControllerApproveDistributionRequestMutationKey()

          const baseOptions = distributionRequestControllerApproveDistributionRequestMutationOptions(config) as UseMutationOptions<DistributionRequestControllerApproveDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409>, {id: DistributionRequestControllerApproveDistributionRequestPathParams["id"]}, TContext>
          

          return useMutation<DistributionRequestControllerApproveDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409>, {id: DistributionRequestControllerApproveDistributionRequestPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DistributionRequestControllerApproveDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerApproveDistributionRequest404 | DistributionRequestControllerApproveDistributionRequest409>, {id: DistributionRequestControllerApproveDistributionRequestPathParams["id"]}, TContext>
      
}

export const distributionRequestControllerWaitingForSignatureDistributionRequestMutationKey = () => [{ url: '/distribution-requests/:id/waiting-for-signature' }] as const

export type DistributionRequestControllerWaitingForSignatureDistributionRequestMutationKey = ReturnType<typeof distributionRequestControllerWaitingForSignatureDistributionRequestMutationKey>

export function distributionRequestControllerWaitingForSignatureDistributionRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = distributionRequestControllerWaitingForSignatureDistributionRequestMutationKey()
        return mutationOptions<DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, ResponseErrorConfig<Error>, {id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return distributionRequestControllerWaitingForSignatureDistributionRequest(id, config)
          },
        })

}

/**
 * @summary Waiting for signature a distribution request
 * {@link /distribution-requests/:id/waiting-for-signature}
 */
export function useDistributionRequestControllerWaitingForSignatureDistributionRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, ResponseErrorConfig<Error>, {id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? distributionRequestControllerWaitingForSignatureDistributionRequestMutationKey()

          const baseOptions = distributionRequestControllerWaitingForSignatureDistributionRequestMutationOptions(config) as UseMutationOptions<DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, ResponseErrorConfig<Error>, {id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"]}, TContext>
          

          return useMutation<DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, ResponseErrorConfig<Error>, {id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DistributionRequestControllerWaitingForSignatureDistributionRequestMutationResponse, ResponseErrorConfig<Error>, {id: DistributionRequestControllerWaitingForSignatureDistributionRequestPathParams["id"]}, TContext>
      
}

export const distributionRequestControllerDenyDistributionRequestMutationKey = () => [{ url: '/distribution-requests/:id/deny' }] as const

export type DistributionRequestControllerDenyDistributionRequestMutationKey = ReturnType<typeof distributionRequestControllerDenyDistributionRequestMutationKey>

export function distributionRequestControllerDenyDistributionRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = distributionRequestControllerDenyDistributionRequestMutationKey()
        return mutationOptions<DistributionRequestControllerDenyDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409>, {id: DistributionRequestControllerDenyDistributionRequestPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return distributionRequestControllerDenyDistributionRequest(id, config)
          },
        })

}

/**
 * @summary Deny a distribution request
 * {@link /distribution-requests/:id/deny}
 */
export function useDistributionRequestControllerDenyDistributionRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<DistributionRequestControllerDenyDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409>, {id: DistributionRequestControllerDenyDistributionRequestPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? distributionRequestControllerDenyDistributionRequestMutationKey()

          const baseOptions = distributionRequestControllerDenyDistributionRequestMutationOptions(config) as UseMutationOptions<DistributionRequestControllerDenyDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409>, {id: DistributionRequestControllerDenyDistributionRequestPathParams["id"]}, TContext>
          

          return useMutation<DistributionRequestControllerDenyDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409>, {id: DistributionRequestControllerDenyDistributionRequestPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DistributionRequestControllerDenyDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDenyDistributionRequest404 | DistributionRequestControllerDenyDistributionRequest409>, {id: DistributionRequestControllerDenyDistributionRequestPathParams["id"]}, TContext>
      
}

export const distributionRequestControllerRevokeDistributionRequestMutationKey = () => [{ url: '/distribution-requests/:id/revoke' }] as const

export type DistributionRequestControllerRevokeDistributionRequestMutationKey = ReturnType<typeof distributionRequestControllerRevokeDistributionRequestMutationKey>

export function distributionRequestControllerRevokeDistributionRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = distributionRequestControllerRevokeDistributionRequestMutationKey()
        return mutationOptions<DistributionRequestControllerRevokeDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409>, {id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return distributionRequestControllerRevokeDistributionRequest(id, config)
          },
        })

}

/**
 * @summary Revoke a distribution request
 * {@link /distribution-requests/:id/revoke}
 */
export function useDistributionRequestControllerRevokeDistributionRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<DistributionRequestControllerRevokeDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409>, {id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? distributionRequestControllerRevokeDistributionRequestMutationKey()

          const baseOptions = distributionRequestControllerRevokeDistributionRequestMutationOptions(config) as UseMutationOptions<DistributionRequestControllerRevokeDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409>, {id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"]}, TContext>
          

          return useMutation<DistributionRequestControllerRevokeDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409>, {id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DistributionRequestControllerRevokeDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerRevokeDistributionRequest404 | DistributionRequestControllerRevokeDistributionRequest409>, {id: DistributionRequestControllerRevokeDistributionRequestPathParams["id"]}, TContext>
      
}

export const distributionRequestControllerDeleteDistributionRequestMutationKey = () => [{ url: '/distribution-requests/:id' }] as const

export type DistributionRequestControllerDeleteDistributionRequestMutationKey = ReturnType<typeof distributionRequestControllerDeleteDistributionRequestMutationKey>

export function distributionRequestControllerDeleteDistributionRequestMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = distributionRequestControllerDeleteDistributionRequestMutationKey()
        return mutationOptions<DistributionRequestControllerDeleteDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDeleteDistributionRequest404>, {id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return distributionRequestControllerDeleteDistributionRequest(id, config)
          },
        })

}

/**
 * @summary Delete distribution request
 * {@link /distribution-requests/:id}
 */
export function useDistributionRequestControllerDeleteDistributionRequest<TContext>(options: 
{
  mutation?: UseMutationOptions<DistributionRequestControllerDeleteDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDeleteDistributionRequest404>, {id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? distributionRequestControllerDeleteDistributionRequestMutationKey()

          const baseOptions = distributionRequestControllerDeleteDistributionRequestMutationOptions(config) as UseMutationOptions<DistributionRequestControllerDeleteDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDeleteDistributionRequest404>, {id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"]}, TContext>
          

          return useMutation<DistributionRequestControllerDeleteDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDeleteDistributionRequest404>, {id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DistributionRequestControllerDeleteDistributionRequestMutationResponse, ResponseErrorConfig<DistributionRequestControllerDeleteDistributionRequest404>, {id: DistributionRequestControllerDeleteDistributionRequestPathParams["id"]}, TContext>
      
}

export const brokerageFeeControllerCreateBrokerageFeeMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/fees' }] as const

export type BrokerageFeeControllerCreateBrokerageFeeMutationKey = ReturnType<typeof brokerageFeeControllerCreateBrokerageFeeMutationKey>

export function brokerageFeeControllerCreateBrokerageFeeMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFeeControllerCreateBrokerageFeeMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFeeControllerCreateBrokerageFeeMutationKey()
        return mutationOptions<BrokerageFeeControllerCreateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerCreateBrokerageFee404>, {brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"], data: BrokerageFeeControllerCreateBrokerageFeeMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, data }) => {
            return brokerageFeeControllerCreateBrokerageFee(brokerageFirmId, data, config)
          },
        })

}

/**
 * @summary Create brokerage fee
 * {@link /brokerage-firms/:brokerageFirmId/fees}
 */
export function useBrokerageFeeControllerCreateBrokerageFee<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFeeControllerCreateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerCreateBrokerageFee404>, {brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"], data: BrokerageFeeControllerCreateBrokerageFeeMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFeeControllerCreateBrokerageFeeMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFeeControllerCreateBrokerageFeeMutationKey()

          const baseOptions = brokerageFeeControllerCreateBrokerageFeeMutationOptions(config) as UseMutationOptions<BrokerageFeeControllerCreateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerCreateBrokerageFee404>, {brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"], data: BrokerageFeeControllerCreateBrokerageFeeMutationRequest}, TContext>
          

          return useMutation<BrokerageFeeControllerCreateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerCreateBrokerageFee404>, {brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"], data: BrokerageFeeControllerCreateBrokerageFeeMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFeeControllerCreateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerCreateBrokerageFee404>, {brokerageFirmId: BrokerageFeeControllerCreateBrokerageFeePathParams["brokerageFirmId"], data: BrokerageFeeControllerCreateBrokerageFeeMutationRequest}, TContext>
      
}

export const brokerageFeeControllerUpdateBrokerageFeeMutationKey = () => [{ url: '/brokerage-fees/:brokerageFeeId' }] as const

export type BrokerageFeeControllerUpdateBrokerageFeeMutationKey = ReturnType<typeof brokerageFeeControllerUpdateBrokerageFeeMutationKey>

export function brokerageFeeControllerUpdateBrokerageFeeMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFeeControllerUpdateBrokerageFeeMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFeeControllerUpdateBrokerageFeeMutationKey()
        return mutationOptions<BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerUpdateBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"], data: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFeeId, data }) => {
            return brokerageFeeControllerUpdateBrokerageFee(brokerageFeeId, data, config)
          },
        })

}

/**
 * @summary Update brokerage fee
 * {@link /brokerage-fees/:brokerageFeeId}
 */
export function useBrokerageFeeControllerUpdateBrokerageFee<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerUpdateBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"], data: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFeeControllerUpdateBrokerageFeeMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFeeControllerUpdateBrokerageFeeMutationKey()

          const baseOptions = brokerageFeeControllerUpdateBrokerageFeeMutationOptions(config) as UseMutationOptions<BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerUpdateBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"], data: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest}, TContext>
          

          return useMutation<BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerUpdateBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"], data: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFeeControllerUpdateBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerUpdateBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerUpdateBrokerageFeePathParams["brokerageFeeId"], data: BrokerageFeeControllerUpdateBrokerageFeeMutationRequest}, TContext>
      
}

export const brokerageFeeControllerDeleteBrokerageFeeMutationKey = () => [{ url: '/brokerage-fees/:brokerageFeeId' }] as const

export type BrokerageFeeControllerDeleteBrokerageFeeMutationKey = ReturnType<typeof brokerageFeeControllerDeleteBrokerageFeeMutationKey>

export function brokerageFeeControllerDeleteBrokerageFeeMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFeeControllerDeleteBrokerageFeeMutationKey()
        return mutationOptions<BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerDeleteBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFeeId }) => {
            return brokerageFeeControllerDeleteBrokerageFee(brokerageFeeId, config)
          },
        })

}

/**
 * @summary Delete brokerage fee
 * {@link /brokerage-fees/:brokerageFeeId}
 */
export function useBrokerageFeeControllerDeleteBrokerageFee<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerDeleteBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFeeControllerDeleteBrokerageFeeMutationKey()

          const baseOptions = brokerageFeeControllerDeleteBrokerageFeeMutationOptions(config) as UseMutationOptions<BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerDeleteBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"]}, TContext>
          

          return useMutation<BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerDeleteBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFeeControllerDeleteBrokerageFeeMutationResponse, ResponseErrorConfig<BrokerageFeeControllerDeleteBrokerageFee404>, {brokerageFeeId: BrokerageFeeControllerDeleteBrokerageFeePathParams["brokerageFeeId"]}, TContext>
      
}

export const telematicsControllerUpsertExternalServiceUserIdMutationKey = () => [{ url: '/telematics/external-service-user-id' }] as const

export type TelematicsControllerUpsertExternalServiceUserIdMutationKey = ReturnType<typeof telematicsControllerUpsertExternalServiceUserIdMutationKey>

export function telematicsControllerUpsertExternalServiceUserIdMutationOptions<TContext = unknown>(config: Partial<RequestConfig<TelematicsControllerUpsertExternalServiceUserIdMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = telematicsControllerUpsertExternalServiceUserIdMutationKey()
        return mutationOptions<TelematicsControllerUpsertExternalServiceUserIdMutationResponse, ResponseErrorConfig<Error>, {data: TelematicsControllerUpsertExternalServiceUserIdMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return telematicsControllerUpsertExternalServiceUserId(data, config)
          },
        })

}

/**
 * @summary Upsert an external service user id (super admin only)
 * {@link /telematics/external-service-user-id}
 */
export function useTelematicsControllerUpsertExternalServiceUserId<TContext>(options: 
{
  mutation?: UseMutationOptions<TelematicsControllerUpsertExternalServiceUserIdMutationResponse, ResponseErrorConfig<Error>, {data: TelematicsControllerUpsertExternalServiceUserIdMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<TelematicsControllerUpsertExternalServiceUserIdMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? telematicsControllerUpsertExternalServiceUserIdMutationKey()

          const baseOptions = telematicsControllerUpsertExternalServiceUserIdMutationOptions(config) as UseMutationOptions<TelematicsControllerUpsertExternalServiceUserIdMutationResponse, ResponseErrorConfig<Error>, {data: TelematicsControllerUpsertExternalServiceUserIdMutationRequest}, TContext>
          

          return useMutation<TelematicsControllerUpsertExternalServiceUserIdMutationResponse, ResponseErrorConfig<Error>, {data: TelematicsControllerUpsertExternalServiceUserIdMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TelematicsControllerUpsertExternalServiceUserIdMutationResponse, ResponseErrorConfig<Error>, {data: TelematicsControllerUpsertExternalServiceUserIdMutationRequest}, TContext>
      
}

export const tenantOnboardingControllerCreateAccountMutationKey = () => [{ url: '/tenant-onboarding/accounts' }] as const

export type TenantOnboardingControllerCreateAccountMutationKey = ReturnType<typeof tenantOnboardingControllerCreateAccountMutationKey>

export function tenantOnboardingControllerCreateAccountMutationOptions<TContext = unknown>(config: Partial<RequestConfig<TenantOnboardingControllerCreateAccountMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = tenantOnboardingControllerCreateAccountMutationKey()
        return mutationOptions<TenantOnboardingControllerCreateAccountMutationResponse, ResponseErrorConfig<Error>, {data: TenantOnboardingControllerCreateAccountMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return tenantOnboardingControllerCreateAccount(data, config)
          },
        })

}

/**
 * @summary Create a new Stripe account
 * {@link /tenant-onboarding/accounts}
 */
export function useTenantOnboardingControllerCreateAccount<TContext>(options: 
{
  mutation?: UseMutationOptions<TenantOnboardingControllerCreateAccountMutationResponse, ResponseErrorConfig<Error>, {data: TenantOnboardingControllerCreateAccountMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<TenantOnboardingControllerCreateAccountMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? tenantOnboardingControllerCreateAccountMutationKey()

          const baseOptions = tenantOnboardingControllerCreateAccountMutationOptions(config) as UseMutationOptions<TenantOnboardingControllerCreateAccountMutationResponse, ResponseErrorConfig<Error>, {data: TenantOnboardingControllerCreateAccountMutationRequest}, TContext>
          

          return useMutation<TenantOnboardingControllerCreateAccountMutationResponse, ResponseErrorConfig<Error>, {data: TenantOnboardingControllerCreateAccountMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TenantOnboardingControllerCreateAccountMutationResponse, ResponseErrorConfig<Error>, {data: TenantOnboardingControllerCreateAccountMutationRequest}, TContext>
      
}

export const tenantOnboardingControllerCreateAccountLinkMutationKey = () => [{ url: '/tenant-onboarding/accounts/:accountId/link' }] as const

export type TenantOnboardingControllerCreateAccountLinkMutationKey = ReturnType<typeof tenantOnboardingControllerCreateAccountLinkMutationKey>

export function tenantOnboardingControllerCreateAccountLinkMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = tenantOnboardingControllerCreateAccountLinkMutationKey()
        return mutationOptions<TenantOnboardingControllerCreateAccountLinkMutationResponse, ResponseErrorConfig<Error>, {accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"]}, TContext>({
          mutationKey,
          mutationFn: async({ accountId }) => {
            return tenantOnboardingControllerCreateAccountLink(accountId, config)
          },
        })

}

/**
 * @summary Create a Stripe account link
 * {@link /tenant-onboarding/accounts/:accountId/link}
 */
export function useTenantOnboardingControllerCreateAccountLink<TContext>(options: 
{
  mutation?: UseMutationOptions<TenantOnboardingControllerCreateAccountLinkMutationResponse, ResponseErrorConfig<Error>, {accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? tenantOnboardingControllerCreateAccountLinkMutationKey()

          const baseOptions = tenantOnboardingControllerCreateAccountLinkMutationOptions(config) as UseMutationOptions<TenantOnboardingControllerCreateAccountLinkMutationResponse, ResponseErrorConfig<Error>, {accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"]}, TContext>
          

          return useMutation<TenantOnboardingControllerCreateAccountLinkMutationResponse, ResponseErrorConfig<Error>, {accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<TenantOnboardingControllerCreateAccountLinkMutationResponse, ResponseErrorConfig<Error>, {accountId: TenantOnboardingControllerCreateAccountLinkPathParams["accountId"]}, TContext>
      
}

export const portfolioMigrationControllerStartMigrationWorkflowMutationKey = () => [{ url: '/migration/workflow' }] as const

export type PortfolioMigrationControllerStartMigrationWorkflowMutationKey = ReturnType<typeof portfolioMigrationControllerStartMigrationWorkflowMutationKey>

export function portfolioMigrationControllerStartMigrationWorkflowMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PortfolioMigrationControllerStartMigrationWorkflowMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = portfolioMigrationControllerStartMigrationWorkflowMutationKey()
        return mutationOptions<PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return portfolioMigrationControllerStartMigrationWorkflow(data, config)
          },
        })

}

/**
 * @summary Start portfolio migration workflow
 * {@link /migration/workflow}
 */
export function usePortfolioMigrationControllerStartMigrationWorkflow<TContext>(options: 
{
  mutation?: UseMutationOptions<PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PortfolioMigrationControllerStartMigrationWorkflowMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? portfolioMigrationControllerStartMigrationWorkflowMutationKey()

          const baseOptions = portfolioMigrationControllerStartMigrationWorkflowMutationOptions(config) as UseMutationOptions<PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest}, TContext>
          

          return useMutation<PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PortfolioMigrationControllerStartMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PortfolioMigrationControllerStartMigrationWorkflowMutationRequest}, TContext>
      
}

export const paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationKey = () => [{ url: '/migration/payment-methods/workflow' }] as const

export type PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationKey = ReturnType<typeof paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationKey>

export function paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationKey()
        return mutationOptions<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow(data, config)
          },
        })

}

/**
 * @summary Start payment methods migration workflow (reads transformed data from a previously-run main migration dir)
 * {@link /migration/payment-methods/workflow}
 */
export function usePaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflow<TContext>(options: 
{
  mutation?: UseMutationOptions<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationKey()

          const baseOptions = paymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationOptions(config) as UseMutationOptions<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest}, TContext>
          

          return useMutation<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationResponse, ResponseErrorConfig<Error>, {data: PaymentMethodsMigrationControllerStartPaymentMethodsMigrationWorkflowMutationRequest}, TContext>
      
}

export const ellisphereControllerOrderOnlineMutationKey = () => [{ url: '/ellisphere/online-order' }] as const

export type EllisphereControllerOrderOnlineMutationKey = ReturnType<typeof ellisphereControllerOrderOnlineMutationKey>

export function ellisphereControllerOrderOnlineMutationOptions<TContext = unknown>(config: Partial<RequestConfig<EllisphereControllerOrderOnlineMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = ellisphereControllerOrderOnlineMutationKey()
        return mutationOptions<EllisphereControllerOrderOnlineMutationResponse, ResponseErrorConfig<Error>, {data: EllisphereControllerOrderOnlineMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return ellisphereControllerOrderOnline(data, config)
          },
        })

}

/**
 * @summary Get a company information from Ellisphere API
 * {@link /ellisphere/online-order}
 */
export function useEllisphereControllerOrderOnline<TContext>(options: 
{
  mutation?: UseMutationOptions<EllisphereControllerOrderOnlineMutationResponse, ResponseErrorConfig<Error>, {data: EllisphereControllerOrderOnlineMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<EllisphereControllerOrderOnlineMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? ellisphereControllerOrderOnlineMutationKey()

          const baseOptions = ellisphereControllerOrderOnlineMutationOptions(config) as UseMutationOptions<EllisphereControllerOrderOnlineMutationResponse, ResponseErrorConfig<Error>, {data: EllisphereControllerOrderOnlineMutationRequest}, TContext>
          

          return useMutation<EllisphereControllerOrderOnlineMutationResponse, ResponseErrorConfig<Error>, {data: EllisphereControllerOrderOnlineMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<EllisphereControllerOrderOnlineMutationResponse, ResponseErrorConfig<Error>, {data: EllisphereControllerOrderOnlineMutationRequest}, TContext>
      
}

export const solvabilityControllerGetScoreMutationKey = () => [{ url: '/solvability/score' }] as const

export type SolvabilityControllerGetScoreMutationKey = ReturnType<typeof solvabilityControllerGetScoreMutationKey>

export function solvabilityControllerGetScoreMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SolvabilityControllerGetScoreMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = solvabilityControllerGetScoreMutationKey()
        return mutationOptions<SolvabilityControllerGetScoreMutationResponse, ResponseErrorConfig<Error>, {data: SolvabilityControllerGetScoreMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return solvabilityControllerGetScore(data, config)
          },
        })

}

/**
 * @summary Get solvability score for a company
 * {@link /solvability/score}
 */
export function useSolvabilityControllerGetScore<TContext>(options: 
{
  mutation?: UseMutationOptions<SolvabilityControllerGetScoreMutationResponse, ResponseErrorConfig<Error>, {data: SolvabilityControllerGetScoreMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SolvabilityControllerGetScoreMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? solvabilityControllerGetScoreMutationKey()

          const baseOptions = solvabilityControllerGetScoreMutationOptions(config) as UseMutationOptions<SolvabilityControllerGetScoreMutationResponse, ResponseErrorConfig<Error>, {data: SolvabilityControllerGetScoreMutationRequest}, TContext>
          

          return useMutation<SolvabilityControllerGetScoreMutationResponse, ResponseErrorConfig<Error>, {data: SolvabilityControllerGetScoreMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SolvabilityControllerGetScoreMutationResponse, ResponseErrorConfig<Error>, {data: SolvabilityControllerGetScoreMutationRequest}, TContext>
      
}

export const fvaControllerUploadFileMutationKey = () => [{ url: '/fva/upload' }] as const

export type FvaControllerUploadFileMutationKey = ReturnType<typeof fvaControllerUploadFileMutationKey>

export function fvaControllerUploadFileMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = fvaControllerUploadFileMutationKey()
        return mutationOptions<FvaControllerUploadFileMutationResponse, ResponseErrorConfig<Error>, {params: FvaControllerUploadFileQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ params }) => {
            return fvaControllerUploadFile(params, config)
          },
        })

}

/**
 * @summary Upload FVA report
 * {@link /fva/upload}
 */
export function useFvaControllerUploadFile<TContext>(options: 
{
  mutation?: UseMutationOptions<FvaControllerUploadFileMutationResponse, ResponseErrorConfig<Error>, {params: FvaControllerUploadFileQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? fvaControllerUploadFileMutationKey()

          const baseOptions = fvaControllerUploadFileMutationOptions(config) as UseMutationOptions<FvaControllerUploadFileMutationResponse, ResponseErrorConfig<Error>, {params: FvaControllerUploadFileQueryParams}, TContext>
          

          return useMutation<FvaControllerUploadFileMutationResponse, ResponseErrorConfig<Error>, {params: FvaControllerUploadFileQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<FvaControllerUploadFileMutationResponse, ResponseErrorConfig<Error>, {params: FvaControllerUploadFileQueryParams}, TContext>
      
}

export const documentValidityControllerOverrideDocumentValidityMutationKey = () => [{ url: '/policies/:policyId/documents/validity/:documentId/override' }] as const

export type DocumentValidityControllerOverrideDocumentValidityMutationKey = ReturnType<typeof documentValidityControllerOverrideDocumentValidityMutationKey>

export function documentValidityControllerOverrideDocumentValidityMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentValidityControllerOverrideDocumentValidityMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentValidityControllerOverrideDocumentValidityMutationKey()
        return mutationOptions<DocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<DocumentValidityControllerOverrideDocumentValidity500>, {policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: DocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, documentId, data }) => {
            return documentValidityControllerOverrideDocumentValidity(policyId, documentId, data, config)
          },
        })

}

/**
 * @summary Override validity status for a document
 * {@link /policies/:policyId/documents/validity/:documentId/override}
 */
export function useDocumentValidityControllerOverrideDocumentValidity<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<DocumentValidityControllerOverrideDocumentValidity500>, {policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: DocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentValidityControllerOverrideDocumentValidityMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentValidityControllerOverrideDocumentValidityMutationKey()

          const baseOptions = documentValidityControllerOverrideDocumentValidityMutationOptions(config) as UseMutationOptions<DocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<DocumentValidityControllerOverrideDocumentValidity500>, {policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: DocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>
          

          return useMutation<DocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<DocumentValidityControllerOverrideDocumentValidity500>, {policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: DocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<DocumentValidityControllerOverrideDocumentValidity500>, {policyId: DocumentValidityControllerOverrideDocumentValidityPathParams["policyId"], documentId: DocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: DocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>
      
}

export const brokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents/validity/:documentId/override' }] as const

export type BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationKey = ReturnType<typeof brokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationKey>

export function brokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationKey()
        return mutationOptions<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500>, {brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, documentId, data }) => {
            return brokerageFirmDocumentValidityControllerOverrideDocumentValidity(brokerageFirmId, documentId, data, config)
          },
        })

}

/**
 * @summary Override validity status for a brokerage firm document
 * {@link /brokerage-firms/:brokerageFirmId/documents/validity/:documentId/override}
 */
export function useBrokerageFirmDocumentValidityControllerOverrideDocumentValidity<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500>, {brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationKey()

          const baseOptions = brokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationOptions(config) as UseMutationOptions<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500>, {brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500>, {brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentValidityControllerOverrideDocumentValidity500>, {brokerageFirmId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityPathParams["documentId"], data: BrokerageFirmDocumentValidityControllerOverrideDocumentValidityMutationRequest}, TContext>
      
}

export const policyDocumentControllerAcceptMutationKey = () => [{ url: '/policies/:policyId/documents/:documentId/accept' }] as const

export type PolicyDocumentControllerAcceptMutationKey = ReturnType<typeof policyDocumentControllerAcceptMutationKey>

export function policyDocumentControllerAcceptMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyDocumentControllerAcceptMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyDocumentControllerAcceptMutationKey()
        return mutationOptions<PolicyDocumentControllerAcceptMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAccept404>, {policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"], data: PolicyDocumentControllerAcceptMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, documentId, data }) => {
            return policyDocumentControllerAccept(policyId, documentId, data, config)
          },
        })

}

/**
 * @summary Accept a policy document on a branch
 * {@link /policies/:policyId/documents/:documentId/accept}
 */
export function usePolicyDocumentControllerAccept<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyDocumentControllerAcceptMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAccept404>, {policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"], data: PolicyDocumentControllerAcceptMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyDocumentControllerAcceptMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyDocumentControllerAcceptMutationKey()

          const baseOptions = policyDocumentControllerAcceptMutationOptions(config) as UseMutationOptions<PolicyDocumentControllerAcceptMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAccept404>, {policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"], data: PolicyDocumentControllerAcceptMutationRequest}, TContext>
          

          return useMutation<PolicyDocumentControllerAcceptMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAccept404>, {policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"], data: PolicyDocumentControllerAcceptMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyDocumentControllerAcceptMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAccept404>, {policyId: PolicyDocumentControllerAcceptPathParams["policyId"], documentId: PolicyDocumentControllerAcceptPathParams["documentId"], data: PolicyDocumentControllerAcceptMutationRequest}, TContext>
      
}

export const policyDocumentControllerRejectMutationKey = () => [{ url: '/policies/:policyId/documents/:documentId/reject' }] as const

export type PolicyDocumentControllerRejectMutationKey = ReturnType<typeof policyDocumentControllerRejectMutationKey>

export function policyDocumentControllerRejectMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyDocumentControllerRejectMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyDocumentControllerRejectMutationKey()
        return mutationOptions<PolicyDocumentControllerRejectMutationResponse, ResponseErrorConfig<PolicyDocumentControllerReject404>, {policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"], data: PolicyDocumentControllerRejectMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, documentId, data }) => {
            return policyDocumentControllerReject(policyId, documentId, data, config)
          },
        })

}

/**
 * @summary Reject a policy document on a branch
 * {@link /policies/:policyId/documents/:documentId/reject}
 */
export function usePolicyDocumentControllerReject<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyDocumentControllerRejectMutationResponse, ResponseErrorConfig<PolicyDocumentControllerReject404>, {policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"], data: PolicyDocumentControllerRejectMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyDocumentControllerRejectMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyDocumentControllerRejectMutationKey()

          const baseOptions = policyDocumentControllerRejectMutationOptions(config) as UseMutationOptions<PolicyDocumentControllerRejectMutationResponse, ResponseErrorConfig<PolicyDocumentControllerReject404>, {policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"], data: PolicyDocumentControllerRejectMutationRequest}, TContext>
          

          return useMutation<PolicyDocumentControllerRejectMutationResponse, ResponseErrorConfig<PolicyDocumentControllerReject404>, {policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"], data: PolicyDocumentControllerRejectMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyDocumentControllerRejectMutationResponse, ResponseErrorConfig<PolicyDocumentControllerReject404>, {policyId: PolicyDocumentControllerRejectPathParams["policyId"], documentId: PolicyDocumentControllerRejectPathParams["documentId"], data: PolicyDocumentControllerRejectMutationRequest}, TContext>
      
}

export const policyDocumentControllerAcceptAllMutationKey = () => [{ url: '/policies/:policyId/documents/accept-all' }] as const

export type PolicyDocumentControllerAcceptAllMutationKey = ReturnType<typeof policyDocumentControllerAcceptAllMutationKey>

export function policyDocumentControllerAcceptAllMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyDocumentControllerAcceptAllMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyDocumentControllerAcceptAllMutationKey()
        return mutationOptions<PolicyDocumentControllerAcceptAllMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAcceptAll409>, {policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"], data: PolicyDocumentControllerAcceptAllMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, data }) => {
            return policyDocumentControllerAcceptAll(policyId, data, config)
          },
        })

}

/**
 * @description With `onlyConform`, only the undecided documents whose verdict is CONFORM are accepted.
 * @summary Accept every reviewable document on a policy branch
 * {@link /policies/:policyId/documents/accept-all}
 */
export function usePolicyDocumentControllerAcceptAll<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyDocumentControllerAcceptAllMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAcceptAll409>, {policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"], data: PolicyDocumentControllerAcceptAllMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyDocumentControllerAcceptAllMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyDocumentControllerAcceptAllMutationKey()

          const baseOptions = policyDocumentControllerAcceptAllMutationOptions(config) as UseMutationOptions<PolicyDocumentControllerAcceptAllMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAcceptAll409>, {policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"], data: PolicyDocumentControllerAcceptAllMutationRequest}, TContext>
          

          return useMutation<PolicyDocumentControllerAcceptAllMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAcceptAll409>, {policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"], data: PolicyDocumentControllerAcceptAllMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyDocumentControllerAcceptAllMutationResponse, ResponseErrorConfig<PolicyDocumentControllerAcceptAll409>, {policyId: PolicyDocumentControllerAcceptAllPathParams["policyId"], data: PolicyDocumentControllerAcceptAllMutationRequest}, TContext>
      
}

export const policyDocumentControllerCancelMutationKey = () => [{ url: '/policies/:policyId/documents/conformity/:conformityId/cancel' }] as const

export type PolicyDocumentControllerCancelMutationKey = ReturnType<typeof policyDocumentControllerCancelMutationKey>

export function policyDocumentControllerCancelMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = policyDocumentControllerCancelMutationKey()
        return mutationOptions<PolicyDocumentControllerCancelMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCancel404>, {policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"]}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, conformityId }) => {
            return policyDocumentControllerCancel(policyId, conformityId, config)
          },
        })

}

/**
 * @summary Cancel an accept or reject decision
 * {@link /policies/:policyId/documents/conformity/:conformityId/cancel}
 */
export function usePolicyDocumentControllerCancel<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyDocumentControllerCancelMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCancel404>, {policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyDocumentControllerCancelMutationKey()

          const baseOptions = policyDocumentControllerCancelMutationOptions(config) as UseMutationOptions<PolicyDocumentControllerCancelMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCancel404>, {policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"]}, TContext>
          

          return useMutation<PolicyDocumentControllerCancelMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCancel404>, {policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyDocumentControllerCancelMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCancel404>, {policyId: PolicyDocumentControllerCancelPathParams["policyId"], conformityId: PolicyDocumentControllerCancelPathParams["conformityId"]}, TContext>
      
}

export const policyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationKey = () => [{ url: '/policies/:policyId/documents/fraud/:documentId/verdict' }] as const

export type PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationKey = ReturnType<typeof policyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationKey>

export function policyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = policyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationKey()
        return mutationOptions<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409>, {policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"], data: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ policyId, documentId, data }) => {
            return policyDocumentControllerCorrectPolicyDocumentFraudVerdict(policyId, documentId, data, config)
          },
        })

}

/**
 * @summary Set the fraud verdict of a policy document after a human review
 * {@link /policies/:policyId/documents/fraud/:documentId/verdict}
 */
export function usePolicyDocumentControllerCorrectPolicyDocumentFraudVerdict<TContext>(options: 
{
  mutation?: UseMutationOptions<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409>, {policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"], data: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? policyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationKey()

          const baseOptions = policyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationOptions(config) as UseMutationOptions<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409>, {policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"], data: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest}, TContext>
          

          return useMutation<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409>, {policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"], data: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationResponse, ResponseErrorConfig<PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict404 | PolicyDocumentControllerCorrectPolicyDocumentFraudVerdict409>, {policyId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["policyId"], documentId: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictPathParams["documentId"], data: PolicyDocumentControllerCorrectPolicyDocumentFraudVerdictMutationRequest}, TContext>
      
}

export const brokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents/:documentId/accept' }] as const

export type BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationKey = ReturnType<typeof brokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationKey>

export function brokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationKey()
        return mutationOptions<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, documentId }) => {
            return brokerageFirmDocumentControllerAcceptBrokerageFirmDocument(brokerageFirmId, documentId, config)
          },
        })

}

/**
 * @summary Accept a brokerage-firm document
 * {@link /brokerage-firms/:brokerageFirmId/documents/:documentId/accept}
 */
export function useBrokerageFirmDocumentControllerAcceptBrokerageFirmDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationKey()

          const baseOptions = brokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationOptions(config) as UseMutationOptions<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"]}, TContext>
          

          return useMutation<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerAcceptBrokerageFirmDocumentPathParams["documentId"]}, TContext>
      
}

export const brokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents/:documentId/reject' }] as const

export type BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationKey = ReturnType<typeof brokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationKey>

export function brokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationKey()
        return mutationOptions<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"], data: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, documentId, data }) => {
            return brokerageFirmDocumentControllerRejectBrokerageFirmDocument(brokerageFirmId, documentId, data, config)
          },
        })

}

/**
 * @summary Reject a brokerage-firm document
 * {@link /brokerage-firms/:brokerageFirmId/documents/:documentId/reject}
 */
export function useBrokerageFirmDocumentControllerRejectBrokerageFirmDocument<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"], data: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationKey()

          const baseOptions = brokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationOptions(config) as UseMutationOptions<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"], data: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"], data: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerRejectBrokerageFirmDocument404>, {brokerageFirmId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentPathParams["documentId"], data: BrokerageFirmDocumentControllerRejectBrokerageFirmDocumentMutationRequest}, TContext>
      
}

export const brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents/accept-all' }] as const

export type BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationKey = ReturnType<typeof brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationKey>

export function brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationKey()
        return mutationOptions<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId }) => {
            return brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments(brokerageFirmId, config)
          },
        })

}

/**
 * @summary Accept every reviewable document for a brokerage firm
 * {@link /brokerage-firms/:brokerageFirmId/documents/accept-all}
 */
export function useBrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationKey()

          const baseOptions = brokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationOptions(config) as UseMutationOptions<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"]}, TContext>
          

          return useMutation<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocuments409>, {brokerageFirmId: BrokerageFirmDocumentControllerAcceptAllBrokerageFirmDocumentsPathParams["brokerageFirmId"]}, TContext>
      
}

export const brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents/conformity/:conformityId/cancel' }] as const

export type BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationKey = ReturnType<typeof brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationKey>

export function brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationKey()
        return mutationOptions<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404>, {brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"]}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, conformityId }) => {
            return brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity(brokerageFirmId, conformityId, config)
          },
        })

}

/**
 * @summary Cancel a brokerage-firm document conformity decision
 * {@link /brokerage-firms/:brokerageFirmId/documents/conformity/:conformityId/cancel}
 */
export function useBrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404>, {brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationKey()

          const baseOptions = brokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationOptions(config) as UseMutationOptions<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404>, {brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"]}, TContext>
          

          return useMutation<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404>, {brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformity404>, {brokerageFirmId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["brokerageFirmId"], conformityId: BrokerageFirmDocumentControllerCancelBrokerageFirmDocumentConformityPathParams["conformityId"]}, TContext>
      
}

export const brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationKey = () => [{ url: '/brokerage-firms/:brokerageFirmId/documents/fraud/:documentId/verdict' }] as const

export type BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationKey = ReturnType<typeof brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationKey>

export function brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationKey()
        return mutationOptions<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409>, {brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"], data: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ brokerageFirmId, documentId, data }) => {
            return brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict(brokerageFirmId, documentId, data, config)
          },
        })

}

/**
 * @summary Set the fraud verdict of a brokerage-firm document after a human review
 * {@link /brokerage-firms/:brokerageFirmId/documents/fraud/:documentId/verdict}
 */
export function useBrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict<TContext>(options: 
{
  mutation?: UseMutationOptions<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409>, {brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"], data: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationKey()

          const baseOptions = brokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationOptions(config) as UseMutationOptions<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409>, {brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"], data: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest}, TContext>
          

          return useMutation<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409>, {brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"], data: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationResponse, ResponseErrorConfig<BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict404 | BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdict409>, {brokerageFirmId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["brokerageFirmId"], documentId: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictPathParams["documentId"], data: BrokerageFirmDocumentControllerCorrectBrokerageFirmDocumentFraudVerdictMutationRequest}, TContext>
      
}

export const documentExtractionControllerRetryDocumentExtractionMutationKey = () => [{ url: '/document-extractions/:documentId/retry' }] as const

export type DocumentExtractionControllerRetryDocumentExtractionMutationKey = ReturnType<typeof documentExtractionControllerRetryDocumentExtractionMutationKey>

export function documentExtractionControllerRetryDocumentExtractionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = documentExtractionControllerRetryDocumentExtractionMutationKey()
        return mutationOptions<DocumentExtractionControllerRetryDocumentExtractionMutationResponse, ResponseErrorConfig<DocumentExtractionControllerRetryDocumentExtraction404>, {documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"]}, TContext>({
          mutationKey,
          mutationFn: async({ documentId }) => {
            return documentExtractionControllerRetryDocumentExtraction(documentId, config)
          },
        })

}

/**
 * @summary Retry a document extraction
 * {@link /document-extractions/:documentId/retry}
 */
export function useDocumentExtractionControllerRetryDocumentExtraction<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentExtractionControllerRetryDocumentExtractionMutationResponse, ResponseErrorConfig<DocumentExtractionControllerRetryDocumentExtraction404>, {documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentExtractionControllerRetryDocumentExtractionMutationKey()

          const baseOptions = documentExtractionControllerRetryDocumentExtractionMutationOptions(config) as UseMutationOptions<DocumentExtractionControllerRetryDocumentExtractionMutationResponse, ResponseErrorConfig<DocumentExtractionControllerRetryDocumentExtraction404>, {documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"]}, TContext>
          

          return useMutation<DocumentExtractionControllerRetryDocumentExtractionMutationResponse, ResponseErrorConfig<DocumentExtractionControllerRetryDocumentExtraction404>, {documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentExtractionControllerRetryDocumentExtractionMutationResponse, ResponseErrorConfig<DocumentExtractionControllerRetryDocumentExtraction404>, {documentId: DocumentExtractionControllerRetryDocumentExtractionPathParams["documentId"]}, TContext>
      
}

export const documentExtractionControllerSubmitExtractionFeedbackMutationKey = () => [{ url: '/document-extractions/:documentId/feedback' }] as const

export type DocumentExtractionControllerSubmitExtractionFeedbackMutationKey = ReturnType<typeof documentExtractionControllerSubmitExtractionFeedbackMutationKey>

export function documentExtractionControllerSubmitExtractionFeedbackMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentExtractionControllerSubmitExtractionFeedbackMutationKey()
        return mutationOptions<DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, ResponseErrorConfig<Error>, {documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"], data: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ documentId, data }) => {
            return documentExtractionControllerSubmitExtractionFeedback(documentId, data, config)
          },
        })

}

/**
 * @summary Submit feedback for a document extraction
 * {@link /document-extractions/:documentId/feedback}
 */
export function useDocumentExtractionControllerSubmitExtractionFeedback<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, ResponseErrorConfig<Error>, {documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"], data: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentExtractionControllerSubmitExtractionFeedbackMutationKey()

          const baseOptions = documentExtractionControllerSubmitExtractionFeedbackMutationOptions(config) as UseMutationOptions<DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, ResponseErrorConfig<Error>, {documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"], data: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest}, TContext>
          

          return useMutation<DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, ResponseErrorConfig<Error>, {documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"], data: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentExtractionControllerSubmitExtractionFeedbackMutationResponse, ResponseErrorConfig<Error>, {documentId: DocumentExtractionControllerSubmitExtractionFeedbackPathParams["documentId"], data: DocumentExtractionControllerSubmitExtractionFeedbackMutationRequest}, TContext>
      
}

export const documentPrefillControllerRecordOutcomeMutationKey = () => [{ url: '/document-prefill/outcomes' }] as const

export type DocumentPrefillControllerRecordOutcomeMutationKey = ReturnType<typeof documentPrefillControllerRecordOutcomeMutationKey>

export function documentPrefillControllerRecordOutcomeMutationOptions<TContext = unknown>(config: Partial<RequestConfig<DocumentPrefillControllerRecordOutcomeMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = documentPrefillControllerRecordOutcomeMutationKey()
        return mutationOptions<DocumentPrefillControllerRecordOutcomeMutationResponse, ResponseErrorConfig<Error>, {data: DocumentPrefillControllerRecordOutcomeMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return documentPrefillControllerRecordOutcome(data, config)
          },
        })

}

/**
 * @summary Record the outcome of a single prefilled field (kept vs replaced)
 * {@link /document-prefill/outcomes}
 */
export function useDocumentPrefillControllerRecordOutcome<TContext>(options: 
{
  mutation?: UseMutationOptions<DocumentPrefillControllerRecordOutcomeMutationResponse, ResponseErrorConfig<Error>, {data: DocumentPrefillControllerRecordOutcomeMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<DocumentPrefillControllerRecordOutcomeMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? documentPrefillControllerRecordOutcomeMutationKey()

          const baseOptions = documentPrefillControllerRecordOutcomeMutationOptions(config) as UseMutationOptions<DocumentPrefillControllerRecordOutcomeMutationResponse, ResponseErrorConfig<Error>, {data: DocumentPrefillControllerRecordOutcomeMutationRequest}, TContext>
          

          return useMutation<DocumentPrefillControllerRecordOutcomeMutationResponse, ResponseErrorConfig<Error>, {data: DocumentPrefillControllerRecordOutcomeMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DocumentPrefillControllerRecordOutcomeMutationResponse, ResponseErrorConfig<Error>, {data: DocumentPrefillControllerRecordOutcomeMutationRequest}, TContext>
      
}

export const impersonationControllerCreateSessionMutationKey = () => [{ url: '/impersonation/sessions' }] as const

export type ImpersonationControllerCreateSessionMutationKey = ReturnType<typeof impersonationControllerCreateSessionMutationKey>

export function impersonationControllerCreateSessionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ImpersonationControllerCreateSessionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = impersonationControllerCreateSessionMutationKey()
        return mutationOptions<ImpersonationControllerCreateSessionMutationResponse, ResponseErrorConfig<Error>, {data: ImpersonationControllerCreateSessionMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return impersonationControllerCreateSession(data, config)
          },
        })

}

/**
 * @summary Start an impersonation session for a tenant end user
 * {@link /impersonation/sessions}
 */
export function useImpersonationControllerCreateSession<TContext>(options: 
{
  mutation?: UseMutationOptions<ImpersonationControllerCreateSessionMutationResponse, ResponseErrorConfig<Error>, {data: ImpersonationControllerCreateSessionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ImpersonationControllerCreateSessionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? impersonationControllerCreateSessionMutationKey()

          const baseOptions = impersonationControllerCreateSessionMutationOptions(config) as UseMutationOptions<ImpersonationControllerCreateSessionMutationResponse, ResponseErrorConfig<Error>, {data: ImpersonationControllerCreateSessionMutationRequest}, TContext>
          

          return useMutation<ImpersonationControllerCreateSessionMutationResponse, ResponseErrorConfig<Error>, {data: ImpersonationControllerCreateSessionMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ImpersonationControllerCreateSessionMutationResponse, ResponseErrorConfig<Error>, {data: ImpersonationControllerCreateSessionMutationRequest}, TContext>
      
}

export const impersonationControllerRevokeCurrentSessionMutationKey = () => [{ url: '/impersonation/sessions/current' }] as const

export type ImpersonationControllerRevokeCurrentSessionMutationKey = ReturnType<typeof impersonationControllerRevokeCurrentSessionMutationKey>

export function impersonationControllerRevokeCurrentSessionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = impersonationControllerRevokeCurrentSessionMutationKey()
        return mutationOptions<ImpersonationControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return impersonationControllerRevokeCurrentSession(config)
          },
        })

}

/**
 * @summary End the impersonation session presented in the Authorization header
 * {@link /impersonation/sessions/current}
 */
export function useImpersonationControllerRevokeCurrentSession<TContext>(options: 
{
  mutation?: UseMutationOptions<ImpersonationControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? impersonationControllerRevokeCurrentSessionMutationKey()

          const baseOptions = impersonationControllerRevokeCurrentSessionMutationOptions(config) as UseMutationOptions<ImpersonationControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<ImpersonationControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ImpersonationControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const impersonationControllerRevokeSessionMutationKey = () => [{ url: '/impersonation/sessions/:sessionId' }] as const

export type ImpersonationControllerRevokeSessionMutationKey = ReturnType<typeof impersonationControllerRevokeSessionMutationKey>

export function impersonationControllerRevokeSessionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = impersonationControllerRevokeSessionMutationKey()
        return mutationOptions<ImpersonationControllerRevokeSessionMutationResponse, ResponseErrorConfig<Error>, {sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"]}, TContext>({
          mutationKey,
          mutationFn: async({ sessionId }) => {
            return impersonationControllerRevokeSession(sessionId, config)
          },
        })

}

/**
 * @summary Revoke an impersonation session
 * {@link /impersonation/sessions/:sessionId}
 */
export function useImpersonationControllerRevokeSession<TContext>(options: 
{
  mutation?: UseMutationOptions<ImpersonationControllerRevokeSessionMutationResponse, ResponseErrorConfig<Error>, {sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? impersonationControllerRevokeSessionMutationKey()

          const baseOptions = impersonationControllerRevokeSessionMutationOptions(config) as UseMutationOptions<ImpersonationControllerRevokeSessionMutationResponse, ResponseErrorConfig<Error>, {sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"]}, TContext>
          

          return useMutation<ImpersonationControllerRevokeSessionMutationResponse, ResponseErrorConfig<Error>, {sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ImpersonationControllerRevokeSessionMutationResponse, ResponseErrorConfig<Error>, {sessionId: ImpersonationControllerRevokeSessionPathParams["sessionId"]}, TContext>
      
}

export const federatedSessionControllerRevokeCurrentSessionMutationKey = () => [{ url: '/federated-sessions/current' }] as const

export type FederatedSessionControllerRevokeCurrentSessionMutationKey = ReturnType<typeof federatedSessionControllerRevokeCurrentSessionMutationKey>

export function federatedSessionControllerRevokeCurrentSessionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = federatedSessionControllerRevokeCurrentSessionMutationKey()
        return mutationOptions<FederatedSessionControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return federatedSessionControllerRevokeCurrentSession(config)
          },
        })

}

/**
 * @summary End the federated session presented in the Authorization header
 * {@link /federated-sessions/current}
 */
export function useFederatedSessionControllerRevokeCurrentSession<TContext>(options: 
{
  mutation?: UseMutationOptions<FederatedSessionControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? federatedSessionControllerRevokeCurrentSessionMutationKey()

          const baseOptions = federatedSessionControllerRevokeCurrentSessionMutationOptions(config) as UseMutationOptions<FederatedSessionControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>
          

          return useMutation<FederatedSessionControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<FederatedSessionControllerRevokeCurrentSessionMutationResponse, ResponseErrorConfig<Error>, void, TContext>
      
}

export const speechToTextControllerGetCredentialsMutationKey = () => [{ url: '/speech-to-text/credentials' }] as const

export type SpeechToTextControllerGetCredentialsMutationKey = ReturnType<typeof speechToTextControllerGetCredentialsMutationKey>

export function speechToTextControllerGetCredentialsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SpeechToTextControllerGetCredentialsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = speechToTextControllerGetCredentialsMutationKey()
        return mutationOptions<SpeechToTextControllerGetCredentialsMutationResponse, ResponseErrorConfig<Error>, {data: SpeechToTextControllerGetCredentialsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return speechToTextControllerGetCredentials(data, config)
          },
        })

}

/**
 * @summary Get short-lived speech-to-text credentials
 * {@link /speech-to-text/credentials}
 */
export function useSpeechToTextControllerGetCredentials<TContext>(options: 
{
  mutation?: UseMutationOptions<SpeechToTextControllerGetCredentialsMutationResponse, ResponseErrorConfig<Error>, {data: SpeechToTextControllerGetCredentialsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SpeechToTextControllerGetCredentialsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? speechToTextControllerGetCredentialsMutationKey()

          const baseOptions = speechToTextControllerGetCredentialsMutationOptions(config) as UseMutationOptions<SpeechToTextControllerGetCredentialsMutationResponse, ResponseErrorConfig<Error>, {data: SpeechToTextControllerGetCredentialsMutationRequest}, TContext>
          

          return useMutation<SpeechToTextControllerGetCredentialsMutationResponse, ResponseErrorConfig<Error>, {data: SpeechToTextControllerGetCredentialsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SpeechToTextControllerGetCredentialsMutationResponse, ResponseErrorConfig<Error>, {data: SpeechToTextControllerGetCredentialsMutationRequest}, TContext>
      
}

export const fcbWidgetControllerInitWhatsappConversationMutationKey = () => [{ url: '/fcb-widget/whatsapp/init' }] as const

export type FcbWidgetControllerInitWhatsappConversationMutationKey = ReturnType<typeof fcbWidgetControllerInitWhatsappConversationMutationKey>

export function fcbWidgetControllerInitWhatsappConversationMutationOptions<TContext = unknown>(config: Partial<RequestConfig<FcbWidgetControllerInitWhatsappConversationMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = fcbWidgetControllerInitWhatsappConversationMutationKey()
        return mutationOptions<FcbWidgetControllerInitWhatsappConversationMutationResponse, ResponseErrorConfig<Error>, {data: FcbWidgetControllerInitWhatsappConversationMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return fcbWidgetControllerInitWhatsappConversation(data, config)
          },
        })

}

/**
 * @summary Initialise a WhatsApp conversation for the authenticated user via FCB
 * {@link /fcb-widget/whatsapp/init}
 */
export function useFcbWidgetControllerInitWhatsappConversation<TContext>(options: 
{
  mutation?: UseMutationOptions<FcbWidgetControllerInitWhatsappConversationMutationResponse, ResponseErrorConfig<Error>, {data: FcbWidgetControllerInitWhatsappConversationMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<FcbWidgetControllerInitWhatsappConversationMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? fcbWidgetControllerInitWhatsappConversationMutationKey()

          const baseOptions = fcbWidgetControllerInitWhatsappConversationMutationOptions(config) as UseMutationOptions<FcbWidgetControllerInitWhatsappConversationMutationResponse, ResponseErrorConfig<Error>, {data: FcbWidgetControllerInitWhatsappConversationMutationRequest}, TContext>
          

          return useMutation<FcbWidgetControllerInitWhatsappConversationMutationResponse, ResponseErrorConfig<Error>, {data: FcbWidgetControllerInitWhatsappConversationMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<FcbWidgetControllerInitWhatsappConversationMutationResponse, ResponseErrorConfig<Error>, {data: FcbWidgetControllerInitWhatsappConversationMutationRequest}, TContext>
      
}